import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  EmailAddress: any;
  /** MediaURI custom scalar type */
  MediaURI: any;
  /**
   *
   *     Since Zendesk Return type is highly complex and many of the fields are not used in this application.
   *     Therefore by this implementation we will not have to code the graphql type
   */
  ZendeskTicketCommentResponseModel: any;
  /**
   *
   *   Since Zendesk Return type is highly complex and many of the fields are not used in this application.
   *   Therefore by this implementation we will not have to code the graphql type
   */
  ZendeskTicketResponseModel: any;
};






export type Ab_ReleasePanel = {
  __typename?: 'AB_ReleasePanel';
  releaseId?: Maybe<Scalars['String']>;
  featureName?: Maybe<Scalars['String']>;
  userIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  isFeatureLive?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Ab_ReleasePanelOutput = {
  __typename?: 'AB_ReleasePanelOutput';
  AB_ReleasePanelData?: Maybe<Array<Maybe<Ab_ReleasePanel>>>;
  total?: Maybe<Scalars['Int']>;
};

export type AccountSyncV2_OutputType = {
  __typename?: 'AccountSyncV2_OutputType';
  success?: Maybe<Scalars['Boolean']>;
  userDetails?: Maybe<User>;
};

export type AchievementDetailsOutput = {
  __typename?: 'AchievementDetailsOutput';
  badgeDetails?: Maybe<Badges>;
  text1?: Maybe<Scalars['String']>;
  text2?: Maybe<Scalars['String']>;
  text3?: Maybe<Scalars['String']>;
  allowFeedback?: Maybe<Scalars['Boolean']>;
  share?: Maybe<PromotionShareObj>;
};

export type ActionHistoryOutput = {
  __typename?: 'ActionHistoryOutput';
  actions?: Maybe<Array<Maybe<ReportHistory>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ActionInput = {
  ReportId: Scalars['String'];
  ReportStatus: ReportStatus;
  HiddenStatus: HiddenStatus;
  SuspectedStatus: SuspectedStatus;
  SuspendedStatus: SuspendedStatus;
  remark: Scalars['String'];
  media?: Maybe<Array<Maybe<MediaInput>>>;
};

export type ActionInputUserReport = {
  ReportId: Scalars['String'];
  ReportStatus: ReportStatus;
  SuspendedStatus: SuspendedStatus;
  remark: Scalars['String'];
  media?: Maybe<Array<Maybe<MediaInput>>>;
};

export type ActionOutput = {
  ReportId: Scalars['String'];
  ReportStatus: ReportStatus;
  HiddenStatus: HiddenStatus;
  SuspectedStatus: SuspectedStatus;
  SuspendedStatus: SuspendedStatus;
  remark: Scalars['String'];
  media?: Maybe<Array<Maybe<MediaInput>>>;
};

export type ActionOutputUserReport = {
  ReportId: Scalars['String'];
  ReportStatus: ReportStatus;
  SuspendedStatus: SuspendedStatus;
  remark: Scalars['String'];
  media?: Maybe<Array<Maybe<MediaInput>>>;
};

export type ActionState = {
  __typename?: 'ActionState';
  ReportId?: Maybe<Scalars['String']>;
  ReportStatus?: Maybe<ReportStatus>;
  HiddenStatus?: Maybe<HiddenStatus>;
  SuspectedStatus?: Maybe<SuspectedStatus>;
  SuspendedStatus?: Maybe<SuspendedStatus>;
};

export type ActivateOrDeactivatePromotionArgs = {
  promotionId: Scalars['String'];
};

export type Activity = {
  __typename?: 'Activity';
  activityId?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  OwnerOfEntity?: Maybe<User>;
  OwnerOfEntityId?: Maybe<Scalars['String']>;
  club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']>;
  activityType?: Maybe<Scalars['String']>;
  post?: Maybe<Post>;
  postId?: Maybe<Scalars['String']>;
  comment?: Maybe<Comment>;
  commentId?: Maybe<Scalars['String']>;
  reply?: Maybe<Reply>;
  replyId?: Maybe<Scalars['String']>;
  followingHash?: Maybe<Hashtag>;
  followhash?: Maybe<Scalars['String']>;
  followingStock?: Maybe<Stock>;
  followstock?: Maybe<Scalars['Int']>;
  followingUser?: Maybe<User>;
  followuser?: Maybe<Scalars['String']>;
  sharedPost?: Maybe<Post>;
  sharePostId?: Maybe<Scalars['String']>;
  sharedPostUser?: Maybe<User>;
  sharePostUserId?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  chkbnsts?: Maybe<Scalars['String']>;
  chksts?: Maybe<Scalars['String']>;
  clubPostType?: Maybe<Scalars['String']>;
};

export type ActivityFeed = {
  __typename?: 'ActivityFeed';
  activityId?: Maybe<Scalars['Int']>;
  actId?: Maybe<Scalars['String']>;
  activityType?: Maybe<Scalars['String']>;
  post?: Maybe<Post>;
  comment?: Maybe<Post>;
  reply?: Maybe<Post>;
  user?: Maybe<UserFeedOutput>;
  followingUser?: Maybe<UserFeedOutput>;
  club?: Maybe<ClubFeedOutput>;
  followingHashtag?: Maybe<HashtagFeedOutput>;
  followingStocktag?: Maybe<StockFeedOutput>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cover?: Maybe<Scalars['MediaURI']>;
  avatar?: Maybe<Scalars['MediaURI']>;
};

export type ActivityFilterOutput = {
  __typename?: 'ActivityFilterOutput';
  activityList?: Maybe<Array<Maybe<Activity>>>;
  total?: Maybe<Scalars['Int']>;
};

export enum ActivityTypeForAdmin {
  UpvotePost = 'upvotePost',
  UpvoteComment = 'upvoteComment',
  UpvoteReply = 'upvoteReply',
  DownvotePost = 'downvotePost',
  DownvoteComment = 'downvoteComment',
  DownvoteReply = 'downvoteReply',
  Share = 'share',
  Post = 'post',
  Comment = 'comment',
  Reply = 'reply',
  /**
   * changeCover
   * changeAvatar
   * joinClub
   */
  Followuser = 'followuser',
  Followstock = 'followstock',
  Followhash = 'followhash',
  All = 'All'
}

export type Admin = {
  __typename?: 'Admin';
  adminId?: Maybe<Scalars['Int']>;
  User?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['MediaURI']>;
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  adminType?: Maybe<AdminType>;
  email?: Maybe<Scalars['String']>;
  empId?: Maybe<Scalars['String']>;
};

export type AdminArgs = {
  userId: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  lastname?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['MediaURI']>;
  adminType: AdminType;
};

export type AdminCreateClubArgs = {
  clubHandle: Scalars['String'];
  clubName: Scalars['String'];
  clubBio: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  clubCategory?: Maybe<Array<Maybe<ClubCategories>>>;
  clubSettings?: Maybe<Array<Maybe<ClubSettings>>>;
  clubHeadline?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  clubPriority?: Maybe<Scalars['Int']>;
  rule?: Maybe<Scalars['String']>;
  isAutoJoinable?: Maybe<Scalars['Boolean']>;
};

export type AdminLogin = {
  email: Scalars['String'];
  empId?: Maybe<Scalars['String']>;
  password: Scalars['String'];
};

export type AdminSearchOutput = {
  __typename?: 'AdminSearchOutput';
  users?: Maybe<Array<Maybe<User>>>;
  page?: Maybe<Scalars['Int']>;
};

export type AdminSignUp = {
  email?: Maybe<Scalars['String']>;
  empId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  password?: Maybe<Scalars['String']>;
};

export enum AdminUserSearchFilterType {
  GreenTick = 'greenTick',
  BlueTick = 'blueTick',
  YellowTick = 'yellowTick'
}

export type AnalystDetails = {
  __typename?: 'AnalystDetails';
  analystDetailsId?: Maybe<Scalars['String']>;
  User?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  analystBio?: Maybe<Scalars['String']>;
  qualification?: Maybe<Scalars['String']>;
  sebiCertificate?: Maybe<Scalars['String']>;
  experience?: Maybe<Scalars['String']>;
  specializes?: Maybe<Scalars['String']>;
  awards?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  refreshToken?: Maybe<Scalars['String']>;
  accessToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  profileDetails?: Maybe<UserProfileDetailsFromIdp>;
  interimToken?: Maybe<Scalars['String']>;
  isSuccess?: Maybe<IsSuccess>;
  canBeOnboarded?: Maybe<Scalars['Boolean']>;
};

export type AutoFollow = {
  __typename?: 'AutoFollow';
  autoFollowId?: Maybe<Scalars['Int']>;
  User?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  addedBy?: Maybe<User>;
  addedById?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type AutoFollowArgs = {
  userId?: Maybe<Scalars['String']>;
};

export type AutoFollowInputs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};

export type AutoFollowListOutput = {
  __typename?: 'AutoFollowListOutput';
  autoFollowList?: Maybe<Array<Maybe<AutoFollow>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Badges = {
  __typename?: 'Badges';
  badgeId?: Maybe<Scalars['String']>;
  badgeName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  badgeIcon?: Maybe<Scalars['String']>;
  badgeType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  promotionText?: Maybe<Scalars['String']>;
  promotionLink?: Maybe<Scalars['String']>;
  shareText?: Maybe<Scalars['String']>;
  shareImageLink?: Maybe<Scalars['String']>;
};

export type BlueTickListOutput = {
  __typename?: 'BlueTickListOutput';
  blueTickList?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']>;
};

/** GraphQL Output Types */
export type Bookmark = {
  __typename?: 'Bookmark';
  postId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type CheckUserPollResponseArgs = {
  pollId?: Maybe<Scalars['String']>;
};

export type Club = {
  __typename?: 'Club';
  clubId?: Maybe<Scalars['String']>;
  clubHandle?: Maybe<Scalars['String']>;
  clubName?: Maybe<Scalars['String']>;
  clubBio?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['MediaURI']>;
  cover?: Maybe<Scalars['MediaURI']>;
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['String']>;
  clubType?: Maybe<ClubType>;
  clubCategory?: Maybe<Array<Maybe<ClubCategories>>>;
  clubSettings?: Maybe<Array<Maybe<ClubSettings>>>;
  clubHeadline?: Maybe<Scalars['String']>;
  totalMemberCount?: Maybe<Scalars['Int']>;
  ismember?: Maybe<Scalars['String']>;
  memberType?: Maybe<Scalars['String']>;
  issubscribed?: Maybe<Scalars['Int']>;
  createdByAdmin?: Maybe<User>;
  createdByAdminId?: Maybe<Scalars['String']>;
  updatedByAdmin?: Maybe<User>;
  updatedByAdminId?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  rule?: Maybe<Scalars['String']>;
  showDisclaimer?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  canJoinClub?: Maybe<Scalars['Boolean']>;
  viewFeedPermission?: Maybe<ViewFeedPermission>;
  displayCategoryName?: Maybe<Array<Maybe<Scalars['String']>>>;
  isAutoJoinable?: Maybe<Scalars['Boolean']>;
};

export type ClubAndUtilityToFeatureOutput = {
  __typename?: 'ClubAndUtilityToFeatureOutput';
  clubFeatures?: Maybe<Array<Maybe<ClubFeaturesOutput>>>;
  platformFeatures?: Maybe<Array<Maybe<UtilityFeaturesOutput>>>;
};

export enum ClubCategories {
  Biotechnology = 'BIOTECHNOLOGY',
  Trading = 'TRADING',
  Education = 'EDUCATION',
  Energy = 'ENERGY',
  Etfs = 'ETFS',
  Equity = 'EQUITY',
  Forex = 'FOREX',
  Fundamental = 'FUNDAMENTAL',
  Futures = 'FUTURES',
  Investing = 'INVESTING',
  News = 'NEWS',
  Options = 'OPTIONS',
  Finance = 'FINANCE',
  Metals = 'METALS',
  Quant = 'QUANT',
  Swing = 'SWING',
  Technical = 'TECHNICAL',
  Technology = 'TECHNOLOGY'
}

export type ClubCategory = {
  __typename?: 'ClubCategory';
  categoryName?: Maybe<ClubCategories>;
  categoryId?: Maybe<Scalars['Int']>;
};

export type ClubChanges = {
  __typename?: 'ClubChanges';
  addedNew?: Maybe<Array<Maybe<Club>>>;
  updated?: Maybe<Array<Maybe<Club>>>;
};

export type ClubFeedOutput = {
  __typename?: 'ClubFeedOutput';
  clubId?: Maybe<Scalars['String']>;
  clubHandle?: Maybe<Scalars['String']>;
  clubName?: Maybe<Scalars['String']>;
  clubBio?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['MediaURI']>;
  cover?: Maybe<Scalars['MediaURI']>;
  clubType?: Maybe<Scalars['String']>;
  ismember?: Maybe<Scalars['String']>;
};

export type ClubImageArgs = {
  clubId: Scalars['String'];
  imageURL?: Maybe<Scalars['String']>;
  type?: Maybe<ImageType>;
};

export type ClubInput = {
  clubId: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
};

export type ClubListOutputAdmin = {
  __typename?: 'ClubListOutputAdmin';
  clubData?: Maybe<Array<Maybe<ClubWithPermission>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ClubMember = {
  __typename?: 'ClubMember';
  id?: Maybe<Scalars['Int']>;
  club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']>;
  member?: Maybe<User>;
  memberId?: Maybe<Scalars['String']>;
  joiningTime?: Maybe<Scalars['DateTime']>;
  membershipStatus?: Maybe<Status>;
  membershipExpiryDate?: Maybe<Scalars['DateTime']>;
  memberType?: Maybe<ClubMemberType>;
  addedBy?: Maybe<User>;
  addedById?: Maybe<Scalars['String']>;
  banStatus?: Maybe<Status>;
  remarks?: Maybe<Scalars['String']>;
  remarksDoc?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Permissions>>>;
  subscribe?: Maybe<Scalars['Boolean']>;
  unsubscribedTo?: Maybe<Array<Maybe<ClubSubscriptionType>>>;
};

export type ClubMemberArgs = {
  clubId: Scalars['String'];
  memberId: Scalars['String'];
};

export enum ClubMemberType {
  Owner = 'Owner',
  Moderator = 'Moderator',
  Member = 'Member',
  Team = 'Team'
}

export type ClubOutputAdmin = {
  __typename?: 'ClubOutputAdmin';
  clubData?: Maybe<Array<Maybe<ClubWithPermission>>>;
};

export type ClubReport = {
  __typename?: 'ClubReport';
  clubReportId?: Maybe<Scalars['String']>;
  ReportData?: Maybe<Array<Maybe<ReportData>>>;
  reportCount?: Maybe<Scalars['Int']>;
  spamcount?: Maybe<Scalars['Int']>;
  othercount?: Maybe<Scalars['Int']>;
  abusecount?: Maybe<Scalars['Int']>;
  hatefulcount?: Maybe<Scalars['Int']>;
  Club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']>;
  Member?: Maybe<ClubMember>;
  memberId?: Maybe<Scalars['String']>;
  Post?: Maybe<Post>;
  postId?: Maybe<Scalars['String']>;
  Comment?: Maybe<Comment>;
  commentId?: Maybe<Scalars['String']>;
  Reply?: Maybe<Reply>;
  replyId?: Maybe<Scalars['String']>;
  resolvedBy?: Maybe<Scalars['String']>;
  status?: Maybe<ReportStatus>;
  lastReportedTime?: Maybe<Scalars['DateTime']>;
};

export type ClubSettingArgs = {
  clubId: Scalars['String'];
  settings: Array<Maybe<ClubSettings>>;
};

export enum ClubSettings {
  PostDisabled = 'POST_DISABLED',
  TrialEnabled = 'TRIAL_ENABLED',
  InviteEnabled = 'INVITE_ENABLED'
}

export enum ClubType {
  Paid = 'Paid',
  Private = 'Private',
  Public = 'Public'
}

export type ClubWithPermission = {
  __typename?: 'ClubWithPermission';
  clubId?: Maybe<Scalars['String']>;
  clubHandle?: Maybe<Scalars['String']>;
  clubName?: Maybe<Scalars['String']>;
  clubBio?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['MediaURI']>;
  cover?: Maybe<Scalars['MediaURI']>;
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['String']>;
  clubType?: Maybe<ClubType>;
  clubCategory?: Maybe<Array<Maybe<ClubCategories>>>;
  clubSettings?: Maybe<Array<Maybe<ClubSettings>>>;
  clubHeadline?: Maybe<Scalars['String']>;
  totalMemberCount?: Maybe<Scalars['Int']>;
  ismember?: Maybe<Scalars['String']>;
  memberType?: Maybe<Scalars['String']>;
  issubscribed?: Maybe<Scalars['Int']>;
  createdByAdmin?: Maybe<User>;
  createdByAdminId?: Maybe<Scalars['String']>;
  updatedByAdmin?: Maybe<User>;
  updatedByAdminId?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  showDisclaimer?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  canJoinClub?: Maybe<Scalars['Boolean']>;
  permissions?: Maybe<Array<Maybe<MemberTypeClubPermissionData>>>;
  clubPriority?: Maybe<Scalars['Int']>;
  rule?: Maybe<Scalars['String']>;
  isAutoJoinable?: Maybe<Scalars['Boolean']>;
  isClubLive?: Maybe<Scalars['Boolean']>;
  madeLiveBy?: Maybe<User>;
  madeLiveById?: Maybe<Scalars['String']>;
};

export type Comment = {
  __typename?: 'Comment';
  postId?: Maybe<Scalars['String']>;
  post?: Maybe<Post>;
  commentId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textV2?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<Media>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  isUpvoted?: Maybe<Scalars['Int']>;
  isDownvoted?: Maybe<Scalars['Int']>;
  /**
   * upvotes: [String]
   * downvotes: [String]
   */
  upvotecount?: Maybe<Scalars['Int']>;
  downvotecount?: Maybe<Scalars['Int']>;
  replies?: Maybe<Array<Maybe<Reply>>>;
  replycount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  linkPreview?: Maybe<LinkPreview>;
  userId?: Maybe<Scalars['String']>;
  User?: Maybe<User>;
  memberType?: Maybe<ClubMemberType>;
  isSuspected?: Maybe<Scalars['Int']>;
  isCheckedByCM?: Maybe<Scalars['Int']>;
  isEdited?: Maybe<Scalars['Boolean']>;
  editHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  isTopComment?: Maybe<Scalars['Boolean']>;
  hasReplies?: Maybe<Scalars['Boolean']>;
  membershipLevelOfCreator?: Maybe<Scalars['Int']>;
};

export type CommentData = {
  text?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<MediaInput>>>;
  tags?: Maybe<Array<Maybe<TagInput>>>;
  linkPreview?: Maybe<LinkPreviewInput>;
};

export type CommentId = {
  postId: Scalars['String'];
  commentId: Scalars['String'];
};

export type CommentInput = {
  postId: Scalars['String'];
  commentData: CommentData;
};

export type CommentUpvoteDownVoteCountV2 = {
  __typename?: 'CommentUpvoteDownVoteCountV2';
  success?: Maybe<Scalars['Boolean']>;
  upvotes?: Maybe<Scalars['Int']>;
  downvotes?: Maybe<Scalars['Int']>;
  comment?: Maybe<Comment>;
};

export type CommentsByPost = {
  __typename?: 'CommentsByPost';
  comments?: Maybe<Array<Maybe<Comment>>>;
  since?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<ErrorMessage>;
};

export enum ContentMadeByUser {
  TraderContent = 'TraderContent',
  InvestorContent = 'InvestorContent',
  BeginnerContent = 'BeginnerContent',
  AllContent = 'AllContent'
}

/** GraphQL Input Types */
export type CreateBookmark = {
  postId?: Maybe<Scalars['String']>;
};

export type CreateClubArgs = {
  clubHandle: Scalars['String'];
  clubName: Scalars['String'];
  clubBio?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['MediaURI']>;
  cover?: Maybe<Scalars['MediaURI']>;
  clubType: ClubType;
  clubCategory: Array<Maybe<ClubCategories>>;
  clubSettings: Array<Maybe<ClubSettings>>;
  clubHeadline?: Maybe<Scalars['String']>;
};

export type CreateDollarArgs = {
  dollarTagName: Scalars['String'];
  slug: Scalars['String'];
  alias: Scalars['String'];
  dollarTagType: DollarTagEnum;
  sourceEntityId: Scalars['String'];
  sourceEntityIdType: SourceEntityId;
};

export type CreateInterest = {
  sectorId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  categoryId?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type CreateReportInput = {
  reportedOn: ReportedOn;
  reportType: ReportType;
  remark?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  postId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
};

export type Cta = {
  __typename?: 'Cta';
  text?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export enum DateRange {
  Weekly = 'weekly',
  Monthly = 'monthly',
  Yearly = 'yearly',
  Today = 'today',
  Daily = 'daily'
}


export type DeletePostInput = {
  postId: Scalars['String'];
  sharePostId?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum DeviceType {
  Android = 'android',
  Ios = 'ios',
  Mobileweb = 'mobileweb',
  Web = 'web'
}

export enum DeviceTypeEnum {
  Android = 'android',
  Ios = 'ios',
  Mobileweb = 'mobileweb',
  Web = 'web'
}

export type DollarTag = {
  __typename?: 'DollarTag';
  dollarTagId: Scalars['Int'];
  dollarTagName: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  alias?: Maybe<Scalars['String']>;
  dollarTagType: DollarTagEnum;
  sourceEntityId?: Maybe<Scalars['String']>;
  sourceEntityIdType?: Maybe<SourceEntityId>;
  isfollow?: Maybe<Scalars['Int']>;
  issubscribed?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  followers?: Maybe<Scalars['Int']>;
  postCount?: Maybe<Scalars['Int']>;
  viewFeedPermission?: Maybe<ViewFeedPermission>;
};

export type DollarTagSearch = {
  __typename?: 'DollarTagSearch';
  dollarTag?: Maybe<DollarTag>;
  followers?: Maybe<Scalars['Int']>;
};

export type EditHistoryData = {
  __typename?: 'EditHistoryData';
  text?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<Media>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  editedAt?: Maybe<Scalars['DateTime']>;
  User?: Maybe<User>;
};

export type EditPromotionArgs = {
  promotionId: Scalars['String'];
  redirectURL?: Maybe<Scalars['String']>;
  shareableURL?: Maybe<Scalars['String']>;
  imageURL?: Maybe<Scalars['String']>;
};


export type Error = {
  __typename?: 'Error';
  message?: Maybe<Scalars['String']>;
};

export type ErrorMessage = {
  __typename?: 'ErrorMessage';
  errLabel?: Maybe<Scalars['String']>;
  errCode?: Maybe<Scalars['String']>;
  errMessage?: Maybe<Scalars['String']>;
};

export enum ExternalLoginProviderType {
  Apple = 'Apple',
  Google = 'Google',
  Facebook = 'Facebook'
}

export type ExternalResource = {
  __typename?: 'ExternalResource';
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
};

export type ExternalResourceListOutput = {
  __typename?: 'ExternalResourceListOutput';
  resourceList?: Maybe<Array<Maybe<ExternalResource>>>;
  total?: Maybe<Scalars['Int']>;
};

export type FeatureClubCategory = {
  __typename?: 'FeatureClubCategory';
  clubCategoryId?: Maybe<Scalars['String']>;
  clubCategoryName?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
};

export type FeatureClubCategoryInputArgs = {
  clubCategoryName: Scalars['String'];
  icon: Scalars['String'];
  cover: Scalars['String'];
  headline: Scalars['String'];
  description: Scalars['String'];
  priority: Scalars['Int'];
};

export type FeatureClubCategoryUpdateArgs = {
  clubCategoryId: Scalars['String'];
  clubCategoryName: Scalars['String'];
  icon: Scalars['String'];
  cover: Scalars['String'];
  headline: Scalars['String'];
  description: Scalars['String'];
  priority: Scalars['Int'];
};

export type FeatureClubGroup = {
  __typename?: 'FeatureClubGroup';
  featurePlatformRuleId?: Maybe<Scalars['String']>;
  FeatureMap?: Maybe<FeatureMapping>;
  featureId?: Maybe<Scalars['String']>;
  Club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']>;
};

export type FeatureClubGroupData = {
  __typename?: 'FeatureClubGroupData';
  dataList?: Maybe<Array<Maybe<FeatureClubGroup>>>;
  total?: Maybe<Scalars['Int']>;
};

export type FeatureClubRules = {
  __typename?: 'FeatureClubRules';
  clubRuleId?: Maybe<Scalars['String']>;
  Club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']>;
  canPost?: Maybe<Scalars['Boolean']>;
  canView?: Maybe<Scalars['Boolean']>;
  canEngage?: Maybe<Scalars['Boolean']>;
  canReport?: Maybe<Scalars['Boolean']>;
  canBookmark?: Maybe<Scalars['Boolean']>;
};

export type FeatureDataArgs = {
  featureName?: Maybe<Scalars['String']>;
  featureAlias?: Maybe<Scalars['String']>;
};

export type FeatureDataType = {
  __typename?: 'FeatureDataType';
  featureId?: Maybe<Scalars['String']>;
  featureName?: Maybe<Scalars['String']>;
  featureAlias?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
};

export type FeatureMapping = {
  __typename?: 'FeatureMapping';
  featureId?: Maybe<Scalars['String']>;
  feature?: Maybe<Scalars['String']>;
  clubIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  featureName?: Maybe<Scalars['String']>;
  featureAlias?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
};

export type FeatureMappingData = {
  __typename?: 'FeatureMappingData';
  dataList?: Maybe<Array<Maybe<FeatureWithPermissionDataOutput>>>;
  total?: Maybe<Scalars['Int']>;
};

export type FeaturePlatformPermission = {
  __typename?: 'FeaturePlatformPermission';
  featurePlatformRuleId?: Maybe<Scalars['String']>;
  Feature?: Maybe<FeatureMapping>;
  featureId?: Maybe<Scalars['String']>;
  canPost?: Maybe<Scalars['Boolean']>;
  canEngage?: Maybe<Scalars['Boolean']>;
  canViewPost?: Maybe<Scalars['Boolean']>;
  canFollow?: Maybe<Scalars['Boolean']>;
  canBeFollowed?: Maybe<Scalars['Boolean']>;
  canBlock?: Maybe<Scalars['Boolean']>;
  canReport?: Maybe<Scalars['Boolean']>;
  canSeeWatchList?: Maybe<Scalars['Boolean']>;
  canSeeOthersFeedPosts?: Maybe<Scalars['Boolean']>;
  canSeeMarketingPage?: Maybe<Scalars['Boolean']>;
  canAutoJoinBlueTick?: Maybe<Scalars['Boolean']>;
  canAutoJoinGreenTick?: Maybe<Scalars['Boolean']>;
  canAutoJoinYellowTick?: Maybe<Scalars['Boolean']>;
  canFollowPost?: Maybe<Scalars['Boolean']>;
  canShowNps?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
};

export type FeaturePlatformPermissionArgs = {
  featureId?: Maybe<Scalars['String']>;
  canPost?: Maybe<Scalars['Boolean']>;
  canEngage?: Maybe<Scalars['Boolean']>;
  canViewPost?: Maybe<Scalars['Boolean']>;
  canFollow?: Maybe<Scalars['Boolean']>;
  canBeFollowed?: Maybe<Scalars['Boolean']>;
  canBlock?: Maybe<Scalars['Boolean']>;
  canReport?: Maybe<Scalars['Boolean']>;
  canSeeWatchList?: Maybe<Scalars['Boolean']>;
  canSeeOthersFeedPosts?: Maybe<Scalars['Boolean']>;
  canSeeMarketingPage?: Maybe<Scalars['Boolean']>;
  canAutoJoinBlueTick?: Maybe<Scalars['Boolean']>;
  canAutoJoinGreenTick?: Maybe<Scalars['Boolean']>;
  canAutoJoinYellowTick?: Maybe<Scalars['Boolean']>;
  canFollowPost?: Maybe<Scalars['Boolean']>;
  canShowNps?: Maybe<Scalars['Boolean']>;
};

export type FeaturePlatformPermissionData = {
  __typename?: 'FeaturePlatformPermissionData';
  dataList?: Maybe<Array<Maybe<FeaturePlatformPermission>>>;
  total?: Maybe<Scalars['Int']>;
};

export type FeatureWithPermissionDataInput = {
  featureData?: Maybe<FeatureDataArgs>;
  platformPermissionData?: Maybe<PlatformPermissionArgs>;
};

export type FeatureWithPermissionDataOutput = {
  __typename?: 'FeatureWithPermissionDataOutput';
  featureId?: Maybe<Scalars['String']>;
  featureName?: Maybe<Scalars['String']>;
  featureAlias?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  platformPermissionData?: Maybe<PlatformPermissionOutputType>;
};

export type Feedback = {
  __typename?: 'Feedback';
  feedbackId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  type?: Maybe<FeedbackTypeEnum>;
  subject?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  status?: Maybe<FeedbackStatus>;
  attachment?: Maybe<Media>;
  createdDate?: Maybe<Scalars['DateTime']>;
  updateDate?: Maybe<Scalars['DateTime']>;
  replies?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FeedbackInput = {
  Type?: Maybe<FeedbackTypeEnum>;
  subject?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  attachment?: Maybe<MediaInput>;
};

export type FeedbackQuestionResponseInput = {
  questionId?: Maybe<Scalars['String']>;
  badgeId?: Maybe<Scalars['String']>;
  responseText?: Maybe<Scalars['String']>;
};

export type FeedbackQuestions = {
  __typename?: 'FeedbackQuestions';
  questionId?: Maybe<Scalars['String']>;
  questionText?: Maybe<Scalars['String']>;
  Badge?: Maybe<Badges>;
  badgeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export enum FeedbackStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export enum FeedbackTypeEnum {
  Bug = 'BUG',
  Feature = 'FEATURE'
}

export type FilterActivityArgs = {
  activityType: Array<Maybe<ActivityTypeForAdmin>>;
  page: Scalars['Int'];
  limit: Scalars['Int'];
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  userType: Array<Maybe<UserTypeForAdmin>>;
  hashTagIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  securityIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type FilteredPostListSinceDate = {
  __typename?: 'FilteredPostListSinceDate';
  posts?: Maybe<Array<Maybe<Post>>>;
  since?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
};

/** GraphQL Input Types */
export type FollowArgs = {
  id: Scalars['String'];
  entity: FollowEntity;
  limits?: Maybe<Limits>;
  subscribeTo?: Maybe<UserSubscriptionType>;
  unsubscribeTo?: Maybe<UserSubscriptionType>;
};

export enum FollowEntity {
  Stock = 'Stock',
  Hashtag = 'Hashtag',
  User = 'User',
  Dollartag = 'Dollartag'
}

export type FollowOutput = {
  __typename?: 'FollowOutput';
  success: Scalars['Boolean'];
  followStatus?: Maybe<Scalars['String']>;
};

export type FollowPostInput = {
  postId?: Maybe<Scalars['String']>;
};

export enum FollowStatus {
  Resolved = 'Resolved',
  Rejected = 'Rejected'
}

/** Enums */
export enum FollowType {
  Follower = 'Follower',
  Subscriber = 'Subscriber'
}

export type FollowingType = {
  __typename?: 'FollowingType';
  users?: Maybe<Array<Maybe<User>>>;
  stocks?: Maybe<Array<Maybe<Stock>>>;
  hashtags?: Maybe<Array<Maybe<Hashtag>>>;
};

export type FollowingTypeNew = {
  __typename?: 'FollowingTypeNew';
  users?: Maybe<Array<Maybe<User>>>;
  stocks?: Maybe<Array<Maybe<TrendingStocktag>>>;
  hashtags?: Maybe<Array<Maybe<TrendingHashTag>>>;
};

export type FolowPostOutput = {
  __typename?: 'FolowPostOutput';
  post?: Maybe<Post>;
  message?: Maybe<Scalars['String']>;
};

export enum Gender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other'
}

export type GetClubReport = {
  clubId: Scalars['String'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  memberId?: Maybe<Scalars['String']>;
  reportStatus: ReportStatusType;
  type: ReportedOnType;
};

export type GetClubsByTopicsArgs = {
  topics?: Maybe<Array<Maybe<ClubCategories>>>;
  page?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type GetCronJobLogsOutput = {
  __typename?: 'GetCronJobLogsOutput';
  cronJobs?: Maybe<Array<Maybe<CronJobExecutionLogs>>>;
  total?: Maybe<Scalars['Int']>;
};

export enum GetCronJobStatus {
  All = 'All',
  Failed = 'Failed',
  Passed = 'Passed'
}

export enum GetCronJobsStatusType {
  Successful = 'Successful',
  Running = 'Running',
  Failed = 'Failed'
}

export type GetHashtagBySearchTextArgs = {
  searchText: Scalars['String'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type GetInterest = {
  userId: Scalars['String'];
  interestType: InterestType;
};

export type GetMomListArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};

export type GetReportData = {
  type?: Maybe<ReportedOnType>;
  reportType?: Maybe<GetReportType>;
  page: Scalars['Int'];
  limit: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  reportedById?: Maybe<Scalars['String']>;
  reportedByType: ReportedByType;
};

export type GetSectorsArgs = {
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type GetSiteReport = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  reportStatus: ReportStatusType;
  reportedUserId?: Maybe<Scalars['String']>;
  type: ReportedOnType;
  reportedByType: ReportedByType;
};

export type GetStocksBySearchTextArgs = {
  searchText: Scalars['String'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

/** GraphQL Input Types */
export type GetStocksBySectorsArgs = {
  sectorIds?: Maybe<Array<Scalars['Int']>>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type GetTickListArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};

export type GetUserClubsArgs = {
  userId?: Maybe<Scalars['String']>;
  memberType: ClubMemberType;
};

export type GetUserListArgs = {
  searchText: Scalars['String'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type GlobalSearchForPosts = {
  userCreatorId?: Maybe<Scalars['String']>;
  dollarTagMentioned?: Maybe<Scalars['Int']>;
  hashTagMentioned?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
};

export type GlobalSearchPostListSinceDate = {
  __typename?: 'GlobalSearchPostListSinceDate';
  posts?: Maybe<Array<Maybe<Post>>>;
  since?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<ErrorMessage>;
};

export type GreenTickListOutput = {
  __typename?: 'GreenTickListOutput';
  greenTickList?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']>;
};

export type HashTagSearch = {
  __typename?: 'HashTagSearch';
  hashtag?: Maybe<Hashtag>;
  followers?: Maybe<Scalars['Int']>;
};

export type Hashtag = {
  __typename?: 'Hashtag';
  hashtagName?: Maybe<Scalars['String']>;
  TagId?: Maybe<Scalars['String']>;
  hashtagType?: Maybe<HashtagType>;
  postCount?: Maybe<Scalars['Int']>;
  isfollow?: Maybe<Scalars['Int']>;
  issubscribed?: Maybe<Scalars['Int']>;
  followers?: Maybe<Scalars['Int']>;
  viewFeedPermission?: Maybe<ViewFeedPermission>;
};

export type HashtagFeedOutput = {
  __typename?: 'HashtagFeedOutput';
  hashtagId?: Maybe<Scalars['String']>;
  hashtagName?: Maybe<Scalars['String']>;
  hashtagType?: Maybe<Scalars['String']>;
  isfollow?: Maybe<Scalars['Int']>;
};

export enum HashtagType {
  Default = 'Default',
  Exclusive = 'Exclusive'
}

export enum HiddenStatus {
  IsVisible = 'isVisible',
  IsHidden = 'isHidden'
}

export type HighlightedAchievements = {
  __typename?: 'HighlightedAchievements';
  achievementType?: Maybe<Scalars['String']>;
  sourceOfClick?: Maybe<Scalars['String']>;
  promotionImage?: Maybe<Scalars['String']>;
  promotionText?: Maybe<Scalars['String']>;
  badges?: Maybe<Badges>;
};

export enum IdeaType {
  Buy = 'Buy',
  Sell = 'Sell'
}

export enum ImageType {
  Avatar = 'Avatar',
  Cover = 'Cover'
}

export type Interest = {
  __typename?: 'Interest';
  interestId?: Maybe<Scalars['Int']>;
  interestType?: Maybe<InterestType>;
  id?: Maybe<Scalars['String']>;
  sectorId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  categoryId?: Maybe<Array<Maybe<Scalars['Int']>>>;
  date?: Maybe<Scalars['DateTime']>;
};

export enum InterestType {
  ClubCategories = 'ClubCategories',
  Sector = 'Sector'
}

export type Interstitials = {
  __typename?: 'Interstitials';
  interstitialsId?: Maybe<Scalars['String']>;
  componentType?: Maybe<ComponentType>;
  position?: Maybe<Scalars['Int']>;
  platformType?: Maybe<PlatformTypeForInterstitial>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type InterstitialsData = {
  __typename?: 'InterstitialsData';
  interstitialsId?: Maybe<Scalars['String']>;
  componentType?: Maybe<ComponentType>;
  position?: Maybe<Scalars['Int']>;
  data?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type InterstitialsFilterArgs = {
  componentType?: Maybe<FilterComponentType>;
  platformType?: Maybe<FilterPlatformType>;
};

/** GraphQL Output Types */
export type IsFollowed = {
  __typename?: 'IsFollowed';
  success?: Maybe<Scalars['Boolean']>;
  followType?: Maybe<FollowType>;
};

export type IsSuccess = {
  __typename?: 'IsSuccess';
  success?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};

export type IsSuspectedStatus = {
  __typename?: 'IsSuspectedStatus';
  isSuspected?: Maybe<Scalars['Int']>;
};

export type JobsOutput = {
  __typename?: 'JobsOutput';
  jobs?: Maybe<Array<Maybe<ScheduledJobs>>>;
  total?: Maybe<Scalars['Int']>;
};

export type JoinClubArgs = {
  clubId: Scalars['String'];
  memberType?: Maybe<ClubMemberType>;
  agreedToDisclaimer?: Maybe<Scalars['Boolean']>;
};

export type Limits = {
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
};

export type LinkPreview = {
  __typename?: 'LinkPreview';
  url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type LinkPreviewInput = {
  url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ListOfBadges = {
  __typename?: 'ListOfBadges';
  badgesList?: Maybe<Array<Maybe<Badges>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ListOfEvents = {
  __typename?: 'ListOfEvents';
  eventsList?: Maybe<Array<Maybe<UpcomingEvents>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ListOfInterstitials = {
  __typename?: 'ListOfInterstitials';
  interstitialsList?: Maybe<Array<Maybe<Interstitials>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ListOfUserBadges = {
  __typename?: 'ListOfUserBadges';
  userBadgesList?: Maybe<Array<Maybe<UserBadges>>>;
  errorMessage?: Maybe<ErrorMessage>;
};

export type ListOfWhatsNew = {
  __typename?: 'ListOfWhatsNew';
  whatsNewList?: Maybe<Array<Maybe<WhatsNew>>>;
  total?: Maybe<Scalars['Int']>;
};

export type LoginUserInput = {
  email: Scalars['EmailAddress'];
  password: Scalars['String'];
  notificationToken?: Maybe<Scalars['String']>;
  deviceType?: Maybe<DeviceType>;
};

export type MisInput = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  memberType?: Maybe<MemberTypeForMis>;
};

export type MisOutput = {
  __typename?: 'MISOutput';
  date?: Maybe<Scalars['String']>;
  entityCount?: Maybe<Scalars['String']>;
  userCount?: Maybe<Scalars['String']>;
};

export type MisOutputAdminPanel = {
  __typename?: 'MISOutputAdminPanel';
  entityCount?: Maybe<Scalars['String']>;
  userCount?: Maybe<Scalars['String']>;
};

/** #MOMArgs Input */
export type MomArgs = {
  userId: Scalars['String'];
  link: Scalars['String'];
};

/** MOMData Type */
export type MomData = {
  __typename?: 'MOMData';
  momId?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['MediaURI']>;
  User?: Maybe<User>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
};

export type MomListOutput = {
  __typename?: 'MOMListOutput';
  momList?: Maybe<Array<Maybe<MomData>>>;
  total?: Maybe<Scalars['Int']>;
};

export type MomUpdateArgs = {
  userId?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
};

export type Media = {
  __typename?: 'Media';
  type: Scalars['String'];
  uri: Scalars['MediaURI'];
  name: Scalars['String'];
  height?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['String']>;
  rotation?: Maybe<Scalars['String']>;
};

export type MediaInput = {
  type: Scalars['String'];
  uri: Scalars['String'];
  name: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  rotation?: Maybe<Scalars['Int']>;
};

export type MediaPostId = {
  __typename?: 'MediaPostID';
  media?: Maybe<Media>;
  postId: Scalars['String'];
};


export type MediaUrl = {
  __typename?: 'MediaURL';
  key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MemberType = {
  __typename?: 'MemberType';
  memberTypeId?: Maybe<Scalars['String']>;
  MemberType?: Maybe<Scalars['String']>;
};

export type MemberTypeClubPermissionData = {
  __typename?: 'MemberTypeClubPermissionData';
  memberTypeClubPermissionId?: Maybe<Scalars['String']>;
  memberType?: Maybe<MemberType>;
  memberTypeId?: Maybe<Scalars['String']>;
  tickType?: Maybe<TickType>;
  permissions?: Maybe<ClubPermissionType>;
};

export type MemberTypeClubPermissionMap = {
  __typename?: 'MemberTypeClubPermissionMap';
  memberTypeClubPermissionId?: Maybe<Scalars['String']>;
  memberType?: Maybe<MemberType>;
  memberTypeId?: Maybe<Scalars['String']>;
  Club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']>;
  canPost?: Maybe<Scalars['Boolean']>;
  canViewPost?: Maybe<Scalars['Boolean']>;
  canEngage?: Maybe<Scalars['Boolean']>;
  canPropagatePost?: Maybe<Scalars['Boolean']>;
};

export enum MemberTypeForMis {
  All = 'all',
  BlueTick = 'blueTick',
  GreenTick = 'greenTick',
  GoldenTick = 'goldenTick',
  Normal = 'normal'
}

export type MemberTypeListData = {
  __typename?: 'MemberTypeListData';
  dataList?: Maybe<Array<Maybe<MemberType>>>;
  total?: Maybe<Scalars['Int']>;
};

export type MembertypeClubPermissionMapData = {
  __typename?: 'MembertypeClubPermissionMapData';
  dataList?: Maybe<Array<Maybe<MemberTypeClubPermissionMap>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Meta = {
  __typename?: 'Meta';
  isCover?: Maybe<Scalars['Boolean']>;
  isAvatar?: Maybe<Scalars['Boolean']>;
};

export type MilestoneType = {
  __typename?: 'MilestoneType';
  isMilestoneCompleted?: Maybe<Scalars['Boolean']>;
  MilestoneName?: Maybe<Scalars['String']>;
  runningMilestone?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createFeedback?: Maybe<Feedback>;
  ActionToFeedback?: Maybe<Scalars['Boolean']>;
  ReplyToFeedback?: Maybe<Scalars['Boolean']>;
  /** zendesk */
  createZendeskTicket?: Maybe<Scalars['ZendeskTicketResponseModel']>;
  createZendeskTicketComment?: Maybe<Array<Maybe<Scalars['ZendeskTicketCommentResponseModel']>>>;
  /** admin */
  adminLogin: AuthPayload;
  AdminloginWithOIDC?: Maybe<UserInfoFromIdp>;
  addEmail?: Maybe<Scalars['Boolean']>;
  removeEmail?: Maybe<Scalars['Boolean']>;
  ToggleSuspect?: Maybe<IsSuspectedStatus>;
  VerificationToggle?: Maybe<User>;
  GreenVerificationToggle?: Maybe<User>;
  tick3Toggle?: Maybe<User>;
  makeMOM?: Maybe<MomData>;
  deleteMOM?: Maybe<MomData>;
  editMOM?: Maybe<MomData>;
  autoFollowAddVerified?: Maybe<AutoFollow>;
  autoFollowDeleteVerified?: Maybe<IsSuccess>;
  adminClubCreation?: Maybe<ClubWithPermission>;
  editClubDetailsAdmin?: Maybe<ClubWithPermission>;
  updateAnalystDetails?: Maybe<AnalystDetails>;
  updateGreenTickUserImage?: Maybe<User>;
  createPromotion?: Maybe<PromotionData>;
  addExternalResource?: Maybe<ExternalResource>;
  updateExternalResource?: Maybe<ExternalResource>;
  deleteExternalResource?: Maybe<IsSuccess>;
  activatePromotion?: Maybe<PromotionData>;
  deactivatePromotion?: Maybe<PromotionData>;
  editPromotion?: Maybe<PromotionData>;
  addClubFeature?: Maybe<IsSuccess>;
  updateClubFeature?: Maybe<IsSuccess>;
  deleteClubFeature?: Maybe<IsSuccess>;
  adminNotificationToTopic?: Maybe<PushNotificationLog>;
  assignCategoryToClub?: Maybe<FeatureClubCategory>;
  deleteCategoryToClub?: Maybe<IsSuccess>;
  /** FeatureMapping */
  addFeatureMapping?: Maybe<FeatureWithPermissionDataOutput>;
  updateFeatureMapping?: Maybe<FeatureWithPermissionDataOutput>;
  deleteFeatureMapping?: Maybe<IsSuccess>;
  /** FeaturePlatformPermission */
  addFeaturePlatformPermission?: Maybe<FeaturePlatformPermission>;
  updateFeaturePlatformPermission?: Maybe<FeaturePlatformPermission>;
  deleteFeaturePlatformPermission?: Maybe<IsSuccess>;
  addClubCategoryV2?: Maybe<FeatureClubCategory>;
  updateClubCategoryV2?: Maybe<FeatureClubCategory>;
  deleteClubCategory?: Maybe<IsSuccess>;
  /** feature based locking */
  addFeatureDataForClubGroup?: Maybe<FeatureWithPermissionDataOutput>;
  deleteFeatureDataForClubGroup?: Maybe<IsSuccess>;
  addMemberTypeClubPermission?: Maybe<MemberTypeClubPermissionMap>;
  editMemberTypeClubPermission?: Maybe<MemberTypeClubPermissionMap>;
  deleteMemberTypeClubPermission?: Maybe<IsSuccess>;
  addMemberTypeAndPermissionsByClubId?: Maybe<MemberTypeClubPermissionData>;
  updateMemberTypeAndPermissionsByClubId?: Maybe<MemberTypeClubPermissionData>;
  deleteMemberTypeAndPermissionByClubId?: Maybe<IsSuccess>;
  editFeatureDataForClubGroup?: Maybe<FeatureWithPermissionDataOutput>;
  addFeatureClubGroup?: Maybe<FeatureDataType>;
  deleteFeatureClubGroup?: Maybe<IsSuccess>;
  /**
   * admin
   * makeAdmin(data: AdminArgs): Admin
   * adminEligibility(data: AdminSignUp): IsSuccess!
   * adminSignup(data: AdminSignUp): AuthPayload!
   * Users Mutation
   */
  SEsignup: AuthPayload;
  SEsignup_V2: AuthPayload;
  SEsignup_V3: AuthPayload;
  SEsignupViaOIDC: UserInfoFromIdp;
  SEsignupViaOIDC_V2: UserInfoFromIdp;
  SE_LOGIN: AuthPayload;
  SE_LOGIN_V2: AuthPayload;
  SE_LOGIN_V3: AuthPayload;
  SE_SOCIAL_LOGIN: AuthPayload;
  SE_SOCIAL_LOGIN_V2: AuthPayload;
  SE_SOCIAL_LOGIN_V3: AuthPayload;
  loginWithOIDC?: Maybe<UserInfoFromIdp>;
  loginWithOIDC_V2?: Maybe<UserInfoFromIdp>;
  logout: Scalars['Boolean'];
  logoutFromAllDevices: Scalars['Boolean'];
  updateUserImage?: Maybe<IsSuccess>;
  updateUserSettings?: Maybe<ProfileSettings>;
  updateUser?: Maybe<User>;
  addNotificationToken: IsSuccess;
  removeNotificationToken: IsSuccess;
  accountSync?: Maybe<IsSuccess>;
  accountSync_V2?: Maybe<AccountSyncV2_OutputType>;
  /** For Admin - Marking Hashtags contentType for new Onboarding process */
  markHashtagContentType?: Maybe<Hashtag>;
  unmarkHashtagContentType?: Maybe<Hashtag>;
  addUserCreatorTypeOfContentForTickUser?: Maybe<User>;
  /** Dollar Tag */
  dollarFollow?: Maybe<DollarTag>;
  dollarUnfollow?: Maybe<DollarTag>;
  dollarSubscribe?: Maybe<DollarTag>;
  dollarUnsubscribe?: Maybe<DollarTag>;
  /** Block Mutation */
  blockUser: IsSuccess;
  unblockUser: IsSuccess;
  /** Posts Mutation */
  createPost: Post;
  createPostAsync: Post;
  createPostV2: Post;
  /** this contains club based permission token in PostInput */
  createPostV3: Post;
  sharePost: Post;
  sharePostV2: Post;
  sharePostV3: Post;
  updatePost: Post;
  deletePost: IsSuccess;
  createComment: Comment;
  createCommentV2: Comment;
  updateComment: Post;
  deleteComment: IsSuccess;
  createReply: Reply;
  createReplyV2: Reply;
  updateReply: Post;
  deleteReply: IsSuccess;
  upvote: UpvoteDownVoteCount;
  downvote: UpvoteDownVoteCount;
  removeUpvote: UpvoteDownVoteCount;
  removeDownvote: UpvoteDownVoteCount;
  /** Follow Mutation */
  follow: FollowOutput;
  resolveFollow: IsSuccess;
  subscribe: IsSuccess;
  unfollow: IsSuccess;
  cancelFollow: IsSuccess;
  cancelFollowUserV2?: Maybe<User>;
  unsubscribe: IsSuccess;
  /** Club Mutation */
  joinClub?: Maybe<IsSuccess>;
  leaveClub?: Maybe<IsSuccess>;
  subscribeClub: IsSuccess;
  unsubscribeClub: IsSuccess;
  /** Report Mutation */
  createReport?: Maybe<ReportData>;
  performAction?: Maybe<ReportHistory>;
  performActionOnUserReport?: Maybe<ReportHistory>;
  /** Interests Mutation */
  createInterest?: Maybe<Interest>;
  /** Bookmark */
  createBookmark?: Maybe<Bookmark>;
  removeBookmark?: Maybe<IsSuccess>;
  /** Notification */
  deleteNotificationById?: Maybe<IsSuccess>;
  deleteNotificationByUserId?: Maybe<IsSuccess>;
  deleteClubNotificationByUserId?: Maybe<IsSuccess>;
  deleteAlertNotificationByUserId?: Maybe<IsSuccess>;
  readNotification?: Maybe<IsSuccess>;
  unreadNotification?: Maybe<IsSuccess>;
  hideNotification?: Maybe<IsSuccess>;
  readAllNotifications?: Maybe<IsSuccess>;
  markMultipleAsRead?: Maybe<IsSuccess>;
  markMultipleAsUnread?: Maybe<IsSuccess>;
  /** Watchlist */
  addToWatchList?: Maybe<Scalars['Boolean']>;
  removeFromWatchList?: Maybe<Scalars['Boolean']>;
  toggleIsWatchlistVisible?: Maybe<Scalars['Boolean']>;
  /** Poll */
  selectPollOption?: Maybe<Array<Maybe<Option>>>;
  selectPollOptionV2?: Maybe<Poll>;
  /** CRON JOB LOGS */
  createManualCronJob?: Maybe<IsSuccess>;
  cancelManualCronJob?: Maybe<IsSuccess>;
  /** pinnedPosts */
  markAsPinPost?: Maybe<Post>;
  unPinPost?: Maybe<Post>;
  /** NPS RATING */
  addNpsRatingForApp?: Maybe<IsSuccess>;
  ignoreNpsRating?: Maybe<IsSuccess>;
  addNpsRatingForWeb?: Maybe<IsSuccess>;
  /** upcoming events */
  editUpcomingEvent?: Maybe<UpcomingEvents>;
  addUpcomingEvent?: Maybe<UpcomingEvents>;
  deleteUpcomingEvent?: Maybe<IsSuccess>;
  toggleEventActiveStatus?: Maybe<UpcomingEvents>;
  /** post follow */
  followPost?: Maybe<FolowPostOutput>;
  unfollowPost?: Maybe<FolowPostOutput>;
  turnOffNotificationByTypeOfNotification?: Maybe<IsSuccess>;
  /** New Onboarding Flow */
  onboardUser?: Maybe<IsSuccess>;
  /** Interstitials */
  addDataForInterstitials?: Maybe<Interstitials>;
  updateDataForInterstitials?: Maybe<Interstitials>;
  deleteInterstitial?: Maybe<IsSuccess>;
  toggleInterstitialsActiveStatus?: Maybe<Interstitials>;
  /** ADMIN PANEL CELEB SYNC API */
  celebritySyncOfIndividualUserInMongo: IsSuccess;
  /** Club LIVE via Admin Panel */
  makeClubLiveByAdmin?: Maybe<ClubWithPermission>;
  /** Guided Tour */
  addGuidedTourStatusForUser?: Maybe<IsSuccess>;
  /** Guided Tour Admin Panel */
  addGuidedTourDataByAdmin?: Maybe<Array<Maybe<TourKeys>>>;
  editTourComponentDetailsByTourKeyAdmin?: Maybe<TourKeys>;
  deleteGuidedTourDataByAdmin?: Maybe<IsSuccess>;
  /** Admin Panel AB_ReleasePanel */
  addDataForAB_ReleasePanel?: Maybe<Ab_ReleasePanel>;
  removeDataForAB_ReleasePanel?: Maybe<Ab_ReleasePanel>;
  updateDataForAB_ReleasePanel?: Maybe<Ab_ReleasePanel>;
  toggleAB_ReleasePanel?: Maybe<Ab_ReleasePanel>;
  /** Discover Page and Panel Design */
  setProfileAsImportantProfile?: Maybe<User>;
  deleteProfileAsImportantProfile?: Maybe<IsSuccess>;
  /** Enhanced VOTE APIs */
  toggleUpvotePost?: Maybe<Post>;
  toggleDownvotePost?: Maybe<Post>;
  toggleUpvoteComment?: Maybe<Comment>;
  toggleDownvoteComment?: Maybe<Comment>;
  toggleUpvoteReply?: Maybe<Reply>;
  toggleDownvoteReply?: Maybe<Reply>;
  /** Enhanced Follow APIs */
  followUserV2?: Maybe<User>;
  unfollowUserV2?: Maybe<User>;
  toggleSubscribeUser?: Maybe<User>;
  followHashtagV2?: Maybe<Hashtag>;
  unfollowHashtagV2?: Maybe<Hashtag>;
  toggleSubscribeHashtag?: Maybe<Hashtag>;
  /** Enhanced Club Mutation */
  joinClubV2?: Maybe<Club>;
  leaveClubV2?: Maybe<Club>;
  /** popUp */
  hasSeenPopUp?: Maybe<PopUpSeen>;
  /** admin panel pop up */
  removePopUp?: Maybe<PopUpSeen>;
  addNewPopUp?: Maybe<PopUpAdminPanel>;
  editPopUp?: Maybe<PopUpAdminPanel>;
  /** badge system admin panel */
  addNewBadge?: Maybe<Badges>;
  deleteBadge?: Maybe<IsSuccess>;
  editBadge?: Maybe<Badges>;
  /** whatsNew admin panel */
  addWhatsNew?: Maybe<WhatsNew>;
  editWhatsNew?: Maybe<WhatsNew>;
  deleteWhatsNew?: Maybe<IsSuccess>;
  toggleWhatsNewActiveStatus?: Maybe<WhatsNew>;
  /** Recent Search */
  addToRecentSearch?: Maybe<IsSuccess>;
  removeFromRecentSearch?: Maybe<IsSuccess>;
  /** PowerUser Badge Promotion */
  addBadgeJourneyFeedback?: Maybe<IsSuccess>;
  turnOffHighlightForAchievement?: Maybe<IsSuccess>;
  /** PowerUser Badge Promotion ADMIN PANEL */
  addBadgeFeedbackQuestionAdmin?: Maybe<FeedbackQuestions>;
  updateBadgeFeedbackQuestionAdmin?: Maybe<FeedbackQuestions>;
  deleteBadgeFeedbackQuestionAdmin?: Maybe<IsSuccess>;
};


export type MutationCreateFeedbackArgs = {
  data?: Maybe<FeedbackInput>;
};


export type MutationActionToFeedbackArgs = {
  feedbackId?: Maybe<Scalars['String']>;
};


export type MutationReplyToFeedbackArgs = {
  reply?: Maybe<Scalars['String']>;
  feedbackId?: Maybe<Scalars['String']>;
};


export type MutationCreateZendeskTicketArgs = {
  data?: Maybe<TicketInput>;
};


export type MutationCreateZendeskTicketCommentArgs = {
  data?: Maybe<TicketCommentInput>;
  ticketId: Scalars['Int'];
};


export type MutationAdminLoginArgs = {
  data?: Maybe<AdminLogin>;
};


export type MutationAdminloginWithOidcArgs = {
  accessToken: Scalars['String'];
};


export type MutationAddEmailArgs = {
  email?: Maybe<Scalars['String']>;
};


export type MutationRemoveEmailArgs = {
  email?: Maybe<Scalars['String']>;
};


export type MutationToggleSuspectArgs = {
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
};


export type MutationVerificationToggleArgs = {
  userId?: Maybe<Scalars['String']>;
};


export type MutationGreenVerificationToggleArgs = {
  userId?: Maybe<Scalars['String']>;
};


export type MutationTick3ToggleArgs = {
  userId?: Maybe<Scalars['String']>;
};


export type MutationMakeMomArgs = {
  data?: Maybe<MomArgs>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationEditMomArgs = {
  data?: Maybe<MomUpdateArgs>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationAutoFollowAddVerifiedArgs = {
  data?: Maybe<AutoFollowArgs>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationAutoFollowDeleteVerifiedArgs = {
  data?: Maybe<AutoFollowArgs>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationAdminClubCreationArgs = {
  data?: Maybe<AdminCreateClubArgs>;
};


export type MutationEditClubDetailsAdminArgs = {
  clubId: Scalars['String'];
  data?: Maybe<EditClubAdminArgs>;
};


export type MutationUpdateAnalystDetailsArgs = {
  data?: Maybe<UpdateAnalystDetailsArgs>;
};


export type MutationUpdateGreenTickUserImageArgs = {
  data?: Maybe<UpdateImageArgs>;
};


export type MutationCreatePromotionArgs = {
  data?: Maybe<PromotionArgs>;
};


export type MutationAddExternalResourceArgs = {
  type: Scalars['String'];
  value: Scalars['String'];
};


export type MutationUpdateExternalResourceArgs = {
  id: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};


export type MutationDeleteExternalResourceArgs = {
  id: Scalars['String'];
};


export type MutationActivatePromotionArgs = {
  data?: Maybe<ActivateOrDeactivatePromotionArgs>;
};


export type MutationDeactivatePromotionArgs = {
  data?: Maybe<ActivateOrDeactivatePromotionArgs>;
};


export type MutationEditPromotionArgs = {
  data?: Maybe<EditPromotionArgs>;
};


export type MutationAddClubFeatureArgs = {
  featureName: Scalars['String'];
  clubIds: Array<Maybe<Scalars['String']>>;
};


export type MutationUpdateClubFeatureArgs = {
  featureId: Scalars['String'];
  featureName: Scalars['String'];
  clubIds: Array<Maybe<Scalars['String']>>;
};


export type MutationDeleteClubFeatureArgs = {
  featureId: Scalars['String'];
};


export type MutationAdminNotificationToTopicArgs = {
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  scheduleTime?: Maybe<Scalars['DateTime']>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationAssignCategoryToClubArgs = {
  featureClubCategoryId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationDeleteCategoryToClubArgs = {
  featureClubCategoryId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationAddFeatureMappingArgs = {
  data?: Maybe<FeatureWithPermissionDataInput>;
};


export type MutationUpdateFeatureMappingArgs = {
  featureId: Scalars['String'];
  data?: Maybe<FeatureWithPermissionDataInput>;
};


export type MutationDeleteFeatureMappingArgs = {
  featureId: Scalars['String'];
};


export type MutationAddFeaturePlatformPermissionArgs = {
  data: FeaturePlatformPermissionArgs;
};


export type MutationUpdateFeaturePlatformPermissionArgs = {
  featurePlatformRuleId: Scalars['String'];
  updateData: FeaturePlatformPermissionArgs;
};


export type MutationDeleteFeaturePlatformPermissionArgs = {
  featurePlatformRuleId: Scalars['String'];
};


export type MutationAddClubCategoryV2Args = {
  data?: Maybe<FeatureClubCategoryInputArgs>;
};


export type MutationUpdateClubCategoryV2Args = {
  data?: Maybe<FeatureClubCategoryUpdateArgs>;
};


export type MutationDeleteClubCategoryArgs = {
  clubCategoryId: Scalars['String'];
};


export type MutationAddFeatureDataForClubGroupArgs = {
  featureData?: Maybe<FeatureDataArgs>;
};


export type MutationDeleteFeatureDataForClubGroupArgs = {
  featureId?: Maybe<Scalars['String']>;
};


export type MutationAddMemberTypeClubPermissionArgs = {
  memberTypeId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  canPost?: Maybe<Scalars['Boolean']>;
  canViewPost?: Maybe<Scalars['Boolean']>;
  canEngage?: Maybe<Scalars['Boolean']>;
  canPropagatePost?: Maybe<Scalars['Boolean']>;
};


export type MutationEditMemberTypeClubPermissionArgs = {
  memberTypeClubPermissionId?: Maybe<Scalars['String']>;
  memberTypeId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  canPost?: Maybe<Scalars['Boolean']>;
  canViewPost?: Maybe<Scalars['Boolean']>;
  canEngage?: Maybe<Scalars['Boolean']>;
  canPropagatePost?: Maybe<Scalars['Boolean']>;
};


export type MutationDeleteMemberTypeClubPermissionArgs = {
  memberTypeClubPermissionId?: Maybe<Scalars['String']>;
};


export type MutationAddMemberTypeAndPermissionsByClubIdArgs = {
  clubId?: Maybe<Scalars['String']>;
  memberTypeAndPermission?: Maybe<ClubMemberPermissionArgs>;
};


export type MutationUpdateMemberTypeAndPermissionsByClubIdArgs = {
  memberTypeClubPermissionId?: Maybe<Scalars['String']>;
  memberTypeAndPermission?: Maybe<ClubMemberPermissionArgs>;
};


export type MutationDeleteMemberTypeAndPermissionByClubIdArgs = {
  memberTypeClubPermissionId?: Maybe<Scalars['String']>;
};


export type MutationEditFeatureDataForClubGroupArgs = {
  featureId?: Maybe<Scalars['String']>;
  featureData?: Maybe<FeatureDataArgs>;
};


export type MutationAddFeatureClubGroupArgs = {
  featureId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationDeleteFeatureClubGroupArgs = {
  clubId?: Maybe<Scalars['String']>;
  featureId?: Maybe<Scalars['String']>;
};


export type MutationSEsignupArgs = {
  data: SignupUserInput;
  interimToken: Scalars['String'];
  AcceptTerms?: Maybe<Scalars['Boolean']>;
};


export type MutationSEsignup_V2Args = {
  data: SignupUserInput;
  interimToken: Scalars['String'];
  AcceptTerms?: Maybe<Scalars['Boolean']>;
};


export type MutationSEsignup_V3Args = {
  data: SignupUserInput;
  interimToken: Scalars['String'];
  AcceptTerms?: Maybe<Scalars['Boolean']>;
};


export type MutationSEsignupViaOidcArgs = {
  data: SignupUserInput;
  interimToken: Scalars['String'];
  AcceptTerms?: Maybe<Scalars['Boolean']>;
};


export type MutationSEsignupViaOidc_V2Args = {
  data: SignupUserInput;
  interimToken: Scalars['String'];
  AcceptTerms?: Maybe<Scalars['Boolean']>;
};


export type MutationSe_LoginArgs = {
  data: LoginUserInput;
};


export type MutationSe_Login_V2Args = {
  data: LoginUserInput;
};


export type MutationSe_Login_V3Args = {
  data: LoginUserInput;
};


export type MutationSe_Social_LoginArgs = {
  data: SocialLoginUserInput;
};


export type MutationSe_Social_Login_V2Args = {
  data: SocialLoginUserInput;
};


export type MutationSe_Social_Login_V3Args = {
  data: SocialLoginUserInput;
};


export type MutationLoginWithOidcArgs = {
  accessToken: Scalars['String'];
};


export type MutationLoginWithOidc_V2Args = {
  accessToken: Scalars['String'];
};


export type MutationLogoutArgs = {
  refreshToken: Scalars['String'];
};


export type MutationUpdateUserImageArgs = {
  data: UserImageArgs;
};


export type MutationUpdateUserSettingsArgs = {
  data: UpdateUserSettings;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateArgs;
};


export type MutationAddNotificationTokenArgs = {
  notificationToken?: Maybe<Scalars['String']>;
  deviceType?: Maybe<DeviceType>;
};


export type MutationRemoveNotificationTokenArgs = {
  deviceType?: Maybe<DeviceType>;
};


export type MutationMarkHashtagContentTypeArgs = {
  hashtagName?: Maybe<Scalars['String']>;
  typeOfContentMadeByHashtag?: Maybe<UserHashtagContentType>;
};


export type MutationUnmarkHashtagContentTypeArgs = {
  hashtagName?: Maybe<Scalars['String']>;
  typeOfContentMadeByHashtag?: Maybe<UserHashtagContentType>;
};


export type MutationAddUserCreatorTypeOfContentForTickUserArgs = {
  userId?: Maybe<Scalars['String']>;
  contentMadeByUser?: Maybe<Array<Maybe<ContentMadeByUser>>>;
};


export type MutationDollarFollowArgs = {
  dollarTagId: Scalars['String'];
};


export type MutationDollarUnfollowArgs = {
  dollarTagId: Scalars['String'];
};


export type MutationDollarSubscribeArgs = {
  dollarTagId: Scalars['String'];
};


export type MutationDollarUnsubscribeArgs = {
  dollarTagId: Scalars['String'];
};


export type MutationBlockUserArgs = {
  id: Scalars['String'];
};


export type MutationUnblockUserArgs = {
  id: Scalars['String'];
};


export type MutationCreatePostArgs = {
  data?: Maybe<PostInput>;
};


export type MutationCreatePostAsyncArgs = {
  data?: Maybe<PostInput>;
};


export type MutationCreatePostV2Args = {
  data?: Maybe<PostInput>;
};


export type MutationCreatePostV3Args = {
  data?: Maybe<PostInput>;
};


export type MutationSharePostArgs = {
  data?: Maybe<PostInput>;
};


export type MutationSharePostV2Args = {
  data?: Maybe<PostInput>;
};


export type MutationSharePostV3Args = {
  data?: Maybe<PostInput>;
};


export type MutationUpdatePostArgs = {
  data?: Maybe<UpdatePostInput>;
};


export type MutationDeletePostArgs = {
  data?: Maybe<DeletePostInput>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationCreateCommentArgs = {
  data?: Maybe<CommentInput>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationCreateCommentV2Args = {
  data?: Maybe<CommentInput>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
};


export type MutationUpdateCommentArgs = {
  data?: Maybe<UpdateCommentInput>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationDeleteCommentArgs = {
  data?: Maybe<CommentId>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationCreateReplyArgs = {
  data?: Maybe<ReplyInput>;
};


export type MutationCreateReplyV2Args = {
  data?: Maybe<ReplyInput>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
};


export type MutationUpdateReplyArgs = {
  data?: Maybe<UpdateReplyInput>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationDeleteReplyArgs = {
  data?: Maybe<ReplyId>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationUpvoteArgs = {
  data?: Maybe<VoteInput>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
};


export type MutationDownvoteArgs = {
  data?: Maybe<VoteInput>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
};


export type MutationRemoveUpvoteArgs = {
  data?: Maybe<VoteInput>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationRemoveDownvoteArgs = {
  data?: Maybe<VoteInput>;
  clubId?: Maybe<Scalars['String']>;
};


export type MutationFollowArgs = {
  data?: Maybe<FollowArgs>;
};


export type MutationResolveFollowArgs = {
  followerId?: Maybe<Scalars['String']>;
  type?: Maybe<FollowStatus>;
};


export type MutationSubscribeArgs = {
  data?: Maybe<FollowArgs>;
};


export type MutationUnfollowArgs = {
  data?: Maybe<FollowArgs>;
};


export type MutationCancelFollowArgs = {
  data?: Maybe<FollowArgs>;
};


export type MutationCancelFollowUserV2Args = {
  userId?: Maybe<Scalars['ID']>;
};


export type MutationUnsubscribeArgs = {
  data?: Maybe<FollowArgs>;
};


export type MutationJoinClubArgs = {
  data: JoinClubArgs;
};


export type MutationLeaveClubArgs = {
  data: ClubInput;
};


export type MutationSubscribeClubArgs = {
  subscribeTo: ClubSubscriptionType;
  clubId: Scalars['String'];
};


export type MutationUnsubscribeClubArgs = {
  unsubscribeTo: ClubSubscriptionType;
  clubId: Scalars['String'];
};


export type MutationCreateReportArgs = {
  data?: Maybe<CreateReportInput>;
};


export type MutationPerformActionArgs = {
  data?: Maybe<ActionInput>;
};


export type MutationPerformActionOnUserReportArgs = {
  data?: Maybe<ActionInputUserReport>;
};


export type MutationCreateInterestArgs = {
  data?: Maybe<CreateInterest>;
};


export type MutationCreateBookmarkArgs = {
  data: CreateBookmark;
};


export type MutationRemoveBookmarkArgs = {
  data?: Maybe<CreateBookmark>;
};


export type MutationDeleteNotificationByIdArgs = {
  notificationId?: Maybe<Scalars['String']>;
};


export type MutationReadNotificationArgs = {
  notificationId?: Maybe<Scalars['String']>;
};


export type MutationUnreadNotificationArgs = {
  notificationId?: Maybe<Scalars['String']>;
};


export type MutationHideNotificationArgs = {
  notificationId?: Maybe<Scalars['String']>;
};


export type MutationMarkMultipleAsReadArgs = {
  notificationIds: Array<Maybe<Scalars['String']>>;
};


export type MutationMarkMultipleAsUnreadArgs = {
  notificationIds: Array<Maybe<Scalars['String']>>;
};


export type MutationAddToWatchListArgs = {
  securityId: Scalars['Int'];
};


export type MutationRemoveFromWatchListArgs = {
  securityId: Scalars['Int'];
};


export type MutationSelectPollOptionArgs = {
  data?: Maybe<SelectPollOptionArgs>;
};


export type MutationSelectPollOptionV2Args = {
  data?: Maybe<SelectPollOptionArgs>;
};


export type MutationCreateManualCronJobArgs = {
  nameOfCron: NameOfCron;
  scheduleTime?: Maybe<Scalars['DateTime']>;
};


export type MutationCancelManualCronJobArgs = {
  jobId: Scalars['String'];
};


export type MutationMarkAsPinPostArgs = {
  postId?: Maybe<Scalars['String']>;
};


export type MutationUnPinPostArgs = {
  postId?: Maybe<Scalars['String']>;
};


export type MutationAddNpsRatingForAppArgs = {
  rating?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  platformType?: Maybe<DeviceType>;
};


export type MutationIgnoreNpsRatingArgs = {
  source?: Maybe<NpsIgnoreSource>;
};


export type MutationAddNpsRatingForWebArgs = {
  rating?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  RecaptchaToken: Scalars['String'];
  platformType: DeviceType;
};


export type MutationEditUpcomingEventArgs = {
  eventId: Scalars['String'];
  text: Scalars['String'];
  imageUrl: Scalars['String'];
  startTime: Scalars['DateTime'];
  ctaButtonText: Scalars['String'];
  ctaButtonUrl: Scalars['String'];
  endTime: Scalars['DateTime'];
  isActive: Scalars['Boolean'];
  description: Scalars['String'];
};


export type MutationAddUpcomingEventArgs = {
  text: Scalars['String'];
  imageUrl: Scalars['String'];
  startTime: Scalars['DateTime'];
  ctaButtonText: Scalars['String'];
  ctaButtonUrl: Scalars['String'];
  endTime: Scalars['DateTime'];
  isActive?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
};


export type MutationDeleteUpcomingEventArgs = {
  eventId?: Maybe<Scalars['String']>;
};


export type MutationToggleEventActiveStatusArgs = {
  eventId?: Maybe<Scalars['String']>;
};


export type MutationFollowPostArgs = {
  data: FollowPostInput;
};


export type MutationUnfollowPostArgs = {
  data?: Maybe<FollowPostInput>;
};


export type MutationTurnOffNotificationByTypeOfNotificationArgs = {
  notificationId?: Maybe<Scalars['String']>;
};


export type MutationOnboardUserArgs = {
  typeOfUserByUserpreference?: Maybe<UserHashtagContentType>;
  dollarTagIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  hashtagName?: Maybe<Array<Maybe<Scalars['String']>>>;
  skipOnboarding?: Maybe<Scalars['Boolean']>;
};


export type MutationAddDataForInterstitialsArgs = {
  componentType: ComponentType;
  position: Scalars['Int'];
  platformType: PlatformTypeForInterstitial;
  data?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  title: Scalars['String'];
};


export type MutationUpdateDataForInterstitialsArgs = {
  interstitialsId: Scalars['String'];
  componentType?: Maybe<ComponentType>;
  position?: Maybe<Scalars['Int']>;
  platformType?: Maybe<PlatformTypeForInterstitial>;
  data?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type MutationDeleteInterstitialArgs = {
  interstitialsId?: Maybe<Scalars['String']>;
};


export type MutationToggleInterstitialsActiveStatusArgs = {
  interstitialsId?: Maybe<Scalars['String']>;
};


export type MutationCelebritySyncOfIndividualUserInMongoArgs = {
  userId: Scalars['String'];
};


export type MutationMakeClubLiveByAdminArgs = {
  clubId: Scalars['String'];
};


export type MutationAddGuidedTourStatusForUserArgs = {
  visitedTourKeys?: Maybe<Array<Maybe<Scalars['Float']>>>;
  tourComponent?: Maybe<Scalars['String']>;
  tourSource?: Maybe<TourSourceType>;
};


export type MutationAddGuidedTourDataByAdminArgs = {
  tourComponent: Scalars['String'];
  startingTourKey: Scalars['Float'];
  endingTourKey: Scalars['Float'];
  tourDescription: Scalars['String'];
};


export type MutationEditTourComponentDetailsByTourKeyAdminArgs = {
  tourComponent: Scalars['String'];
  tourKey: Scalars['Float'];
  tourDescription: Scalars['String'];
};


export type MutationDeleteGuidedTourDataByAdminArgs = {
  tourId: Scalars['String'];
};


export type MutationAddDataForAb_ReleasePanelArgs = {
  featureName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationRemoveDataForAb_ReleasePanelArgs = {
  releaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationUpdateDataForAb_ReleasePanelArgs = {
  releaseId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};


export type MutationToggleAb_ReleasePanelArgs = {
  releaseId?: Maybe<Scalars['String']>;
};


export type MutationSetProfileAsImportantProfileArgs = {
  userId: Scalars['String'];
  priority: Scalars['Int'];
};


export type MutationDeleteProfileAsImportantProfileArgs = {
  userId: Scalars['String'];
};


export type MutationToggleUpvotePostArgs = {
  postId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
};


export type MutationToggleDownvotePostArgs = {
  postId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
};


export type MutationToggleUpvoteCommentArgs = {
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
};


export type MutationToggleDownvoteCommentArgs = {
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
};


export type MutationToggleUpvoteReplyArgs = {
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
};


export type MutationToggleDownvoteReplyArgs = {
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
};


export type MutationFollowUserV2Args = {
  userId?: Maybe<Scalars['ID']>;
};


export type MutationUnfollowUserV2Args = {
  userId?: Maybe<Scalars['ID']>;
};


export type MutationToggleSubscribeUserArgs = {
  userId?: Maybe<Scalars['ID']>;
};


export type MutationFollowHashtagV2Args = {
  hashtagId?: Maybe<Scalars['ID']>;
};


export type MutationUnfollowHashtagV2Args = {
  hashtagId?: Maybe<Scalars['ID']>;
};


export type MutationToggleSubscribeHashtagArgs = {
  hashtagId?: Maybe<Scalars['ID']>;
};


export type MutationJoinClubV2Args = {
  data: JoinClubArgs;
};


export type MutationLeaveClubV2Args = {
  data: ClubInput;
};


export type MutationHasSeenPopUpArgs = {
  popUpType?: Maybe<Scalars['String']>;
};


export type MutationRemovePopUpArgs = {
  popUpId?: Maybe<Scalars['String']>;
};


export type MutationAddNewPopUpArgs = {
  popUpType?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  showTill?: Maybe<Scalars['Int']>;
  popUpDelay?: Maybe<Scalars['Int']>;
};


export type MutationEditPopUpArgs = {
  popUpId?: Maybe<Scalars['String']>;
  popUpType?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  showTill?: Maybe<Scalars['Int']>;
  popUpDelay?: Maybe<Scalars['Int']>;
};


export type MutationAddNewBadgeArgs = {
  badgeName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  badgeIcon?: Maybe<Scalars['String']>;
  badgeType?: Maybe<Scalars['String']>;
  promotionText?: Maybe<Scalars['String']>;
  promotionLink?: Maybe<Scalars['String']>;
  shareText?: Maybe<Scalars['String']>;
  shareImageLink?: Maybe<Scalars['String']>;
};


export type MutationDeleteBadgeArgs = {
  badgeId?: Maybe<Scalars['String']>;
};


export type MutationEditBadgeArgs = {
  badgeId?: Maybe<Scalars['String']>;
  badgeName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  badgeIcon?: Maybe<Scalars['String']>;
  badgeType?: Maybe<Scalars['String']>;
  promotionText?: Maybe<Scalars['String']>;
  promotionLink?: Maybe<Scalars['String']>;
  shareText?: Maybe<Scalars['String']>;
  shareImageLink?: Maybe<Scalars['String']>;
};


export type MutationAddWhatsNewArgs = {
  versionNo?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  whatsNew?: Maybe<Array<Maybe<WhatsNewInput>>>;
  platformType?: Maybe<Array<Maybe<PlatformTypeForWhatsNew>>>;
};


export type MutationEditWhatsNewArgs = {
  whatsNewId: Scalars['String'];
  versionNo?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  whatsNew?: Maybe<Array<Maybe<WhatsNewInput>>>;
  platformType?: Maybe<Array<Maybe<PlatformTypeForWhatsNew>>>;
};


export type MutationDeleteWhatsNewArgs = {
  whatsNewId?: Maybe<Scalars['String']>;
};


export type MutationToggleWhatsNewActiveStatusArgs = {
  whatsNewId?: Maybe<Scalars['String']>;
};


export type MutationAddToRecentSearchArgs = {
  data?: Maybe<Array<Maybe<UserRecentSearchInput>>>;
};


export type MutationRemoveFromRecentSearchArgs = {
  searchId?: Maybe<Scalars['String']>;
};


export type MutationAddBadgeJourneyFeedbackArgs = {
  questionResponse?: Maybe<Array<Maybe<FeedbackQuestionResponseInput>>>;
};


export type MutationTurnOffHighlightForAchievementArgs = {
  achievementType?: Maybe<Scalars['String']>;
};


export type MutationAddBadgeFeedbackQuestionAdminArgs = {
  questionText?: Maybe<Scalars['String']>;
  badgeId?: Maybe<Scalars['String']>;
};


export type MutationUpdateBadgeFeedbackQuestionAdminArgs = {
  questionText?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['String']>;
};


export type MutationDeleteBadgeFeedbackQuestionAdminArgs = {
  questionId?: Maybe<Scalars['String']>;
};

export type Nps = {
  __typename?: 'NPS';
  npsId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  rating?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  platform?: Maybe<DeviceTypeEnum>;
  npsIndex?: Maybe<Scalars['Int']>;
};

export enum NameOfCron {
  All = 'All',
  CountSync = 'countSync',
  ExpiryDateSyncForRecentExpires = 'ExpiryDateSyncForRecentExpires',
  DeleteNotificationCron = 'DeleteNotificationCron',
  SyncActivityOfPostCommentReply = 'syncActivityOfPostCommentReply',
  PostStockSync = 'postStockSync',
  PostHashTagSync = 'postHashTagSync',
  DeletePostCron = 'DeletePostCron',
  DeleteCommentCron = 'DeleteCommentCron',
  DeleteReplyCron = 'DeleteReplyCron',
  PostDollarTagSync = 'postDollarTagSync',
  IndustryDataSync = 'IndustryDataSync',
  SectorDataSync = 'SectorDataSync',
  PreComputeTopPostsOfAnalysts = 'preComputeTopPostsOfAnalysts',
  FcmUserTokenSubscription = 'fcmUserTokenSubscription',
  CelebrityChecker = 'celebrityChecker',
  SyncClublistWithMongo = 'syncClublistWithMongo',
  SyncAllEntityToReco = 'syncAllEntityToReco',
  CurrentWeekMissed = 'currentWeekMissed',
  UserEngagementSummaryMlCron = 'userEngagementSummaryMlCron',
  ContainsAMissedWeek = 'containsAMissedWeek'
}

export type Notification = {
  __typename?: 'Notification';
  notificationId?: Maybe<Scalars['String']>;
  notificationType?: Maybe<Scalars['String']>;
  User?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  Notifier?: Maybe<User>;
  notifierId?: Maybe<Scalars['String']>;
  Club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']>;
  Activity?: Maybe<ActivityFeed>;
  activityId?: Maybe<Scalars['Int']>;
  /** PostUserTag: PostUserTag */
  postUserTagId?: Maybe<Scalars['Int']>;
  /** PostHashTag: PostUserTag */
  postHashtagId?: Maybe<Scalars['Int']>;
  /** PostStockTag: PostStockTag */
  postStockTagId?: Maybe<Scalars['Int']>;
  Post?: Maybe<Post>;
  postId?: Maybe<Scalars['String']>;
  userupvotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  userdownvotes?: Maybe<Array<Maybe<Scalars['String']>>>;
  userscomments?: Maybe<Array<Maybe<Scalars['String']>>>;
  usersreply?: Maybe<Array<Maybe<Scalars['String']>>>;
  read?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  sharePostUserId?: Maybe<Scalars['String']>;
  sharePostId?: Maybe<Scalars['String']>;
  requestStatus?: Maybe<Scalars['Int']>;
  clubReportId?: Maybe<Scalars['String']>;
  ReportId?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export enum NotificationFilter {
  All = 'all',
  Read = 'read',
  Unread = 'unread'
}

export type NpsDataOutputType = {
  __typename?: 'NpsDataOutputType';
  type?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export enum NpsIgnoreSource {
  Cross = 'Cross',
  TooEarlyToRate = 'TooEarlyToRate'
}

export type NpsInInterValOuptut = {
  __typename?: 'NpsInInterValOuptut';
  dateRange?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  data?: Maybe<Array<Maybe<NpsDataOutputType>>>;
};

export type NpsIntervalData = {
  __typename?: 'NpsIntervalData';
  weekly?: Maybe<Array<Maybe<NpsData>>>;
  monthly?: Maybe<Array<Maybe<NpsData>>>;
  yearly?: Maybe<Array<Maybe<NpsData>>>;
  today?: Maybe<Array<Maybe<NpsTodayData>>>;
  daily?: Maybe<Array<Maybe<NpsData>>>;
};

export type Option = {
  __typename?: 'Option';
  optionId?: Maybe<Scalars['String']>;
  pollId?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
  hasUserSelected?: Maybe<Scalars['Boolean']>;
  votes?: Maybe<Scalars['Int']>;
};

export type PendingPushNotificationLogOutput = {
  __typename?: 'PendingPushNotificationLogOutput';
  pendingPushNotification?: Maybe<Array<Maybe<PushNotificationLog>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PendingScheduledJobsOutput = {
  __typename?: 'PendingScheduledJobsOutput';
  scheduledJobs?: Maybe<Array<Maybe<ScheduledJobs>>>;
  total?: Maybe<Scalars['Int']>;
};

export enum Permissions {
  AddModerator = 'ADD_MODERATOR',
  AddTeam = 'ADD_TEAM',
  HidePost = 'HIDE_POST',
  BanUser = 'BAN_USER',
  ChangeClubInfo = 'CHANGE_CLUB_INFO'
}

export type PlatformActionPermission = {
  __typename?: 'PlatformActionPermission';
  canPost?: Maybe<Scalars['Boolean']>;
  canUpvote?: Maybe<Scalars['Boolean']>;
  canDownvote?: Maybe<Scalars['Boolean']>;
  canComment?: Maybe<Scalars['Boolean']>;
  canReply?: Maybe<Scalars['Boolean']>;
  canShare?: Maybe<Scalars['Boolean']>;
  canReportPost?: Maybe<Scalars['Boolean']>;
  canBookmarkPost?: Maybe<Scalars['Boolean']>;
  canJoinClub?: Maybe<Scalars['Boolean']>;
  canCreateClub?: Maybe<Scalars['Boolean']>;
  canFollowUser?: Maybe<Scalars['Boolean']>;
  canFollowStock?: Maybe<Scalars['Boolean']>;
  canFollowHash?: Maybe<Scalars['Boolean']>;
  canBlockUser?: Maybe<Scalars['Boolean']>;
  canSubscribe?: Maybe<Scalars['Boolean']>;
  canReport?: Maybe<Scalars['Boolean']>;
  canSelectOption?: Maybe<Scalars['Boolean']>;
};

export type PlatformActionPermissionsAlias = {
  __typename?: 'PlatformActionPermissionsAlias';
  cpo?: Maybe<Scalars['Int']>;
  cupvo?: Maybe<Scalars['Int']>;
  cdovo?: Maybe<Scalars['Int']>;
  ccom?: Maybe<Scalars['Int']>;
  crep?: Maybe<Scalars['Int']>;
  csh?: Maybe<Scalars['Int']>;
  crepo?: Maybe<Scalars['Int']>;
  cbopo?: Maybe<Scalars['Int']>;
  cjocl?: Maybe<Scalars['Int']>;
  ccrcl?: Maybe<Scalars['Int']>;
  cfous?: Maybe<Scalars['Int']>;
  cfost?: Maybe<Scalars['Int']>;
  cfoha?: Maybe<Scalars['Int']>;
  cblus?: Maybe<Scalars['Int']>;
  csu?: Maybe<Scalars['Int']>;
  cre?: Maybe<Scalars['Int']>;
  cseop?: Maybe<Scalars['Int']>;
};

export type PlatformPermissionArgs = {
  canPost?: Maybe<Scalars['Boolean']>;
  canEngage?: Maybe<Scalars['Boolean']>;
  canViewPost?: Maybe<Scalars['Boolean']>;
  canFollow?: Maybe<Scalars['Boolean']>;
  canBeFollowed?: Maybe<Scalars['Boolean']>;
  canBlock?: Maybe<Scalars['Boolean']>;
  canReport?: Maybe<Scalars['Boolean']>;
  canSeeWatchList?: Maybe<Scalars['Boolean']>;
  canSeeOthersFeedPosts?: Maybe<Scalars['Boolean']>;
  canSeeMarketingPage?: Maybe<Scalars['Boolean']>;
  canAutoJoinBlueTick?: Maybe<Scalars['Boolean']>;
  canAutoJoinGreenTick?: Maybe<Scalars['Boolean']>;
  canAutoJoinYellowTick?: Maybe<Scalars['Boolean']>;
  canFollowPost?: Maybe<Scalars['Boolean']>;
  canShowNps?: Maybe<Scalars['Boolean']>;
};

export enum PlatformPermissionFromFeatureTypes {
  CanPost = 'canPost',
  CanEngage = 'canEngage',
  CanViewPost = 'canViewPost',
  CanFollow = 'canFollow',
  CanBlock = 'canBlock',
  CanReport = 'canReport',
  CanSeeWatchList = 'canSeeWatchList',
  CanSeeOthersFeedPosts = 'canSeeOthersFeedPosts',
  CanSeeMarketingPage = 'canSeeMarketingPage',
  CanAutoJoinYellowTick = 'canAutoJoinYellowTick',
  CanAutoJoinGreenTick = 'canAutoJoinGreenTick',
  CanAutoJoinBlueTick = 'canAutoJoinBlueTick',
  CanBeFollowed = 'canBeFollowed',
  CanFollowPost = 'canFollowPost',
  CanShowNps = 'canShowNps'
}

export type PlatformPermissionOutputType = {
  __typename?: 'PlatformPermissionOutputType';
  canPost?: Maybe<Scalars['Boolean']>;
  canEngage?: Maybe<Scalars['Boolean']>;
  canViewPost?: Maybe<Scalars['Boolean']>;
  canFollow?: Maybe<Scalars['Boolean']>;
  canBeFollowed?: Maybe<Scalars['Boolean']>;
  canBlock?: Maybe<Scalars['Boolean']>;
  canReport?: Maybe<Scalars['Boolean']>;
  canSeeWatchList?: Maybe<Scalars['Boolean']>;
  canSeeOthersFeedPosts?: Maybe<Scalars['Boolean']>;
  canSeeMarketingPage?: Maybe<Scalars['Boolean']>;
  canAutoJoinBlueTick?: Maybe<Scalars['Boolean']>;
  canAutoJoinGreenTick?: Maybe<Scalars['Boolean']>;
  canAutoJoinYellowTick?: Maybe<Scalars['Boolean']>;
  canFollowPost?: Maybe<Scalars['Boolean']>;
  canShowNps?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
};

export enum PlatformTypeForWhatsNew {
  Web = 'web',
  Android = 'android',
  Ios = 'ios'
}

export type Poll = {
  __typename?: 'Poll';
  pollId?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  postId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  expiryEnum?: Maybe<PollExpiryEnum>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  hasUserSelected?: Maybe<Scalars['Boolean']>;
  votes?: Maybe<Scalars['Int']>;
  options?: Maybe<Array<Maybe<Option>>>;
  isOwner?: Maybe<Scalars['Boolean']>;
  hasExpired?: Maybe<Scalars['Boolean']>;
};

export enum PollExpiryType {
  OneDay = 'oneDay',
  ThreeDay = 'threeDay',
  OneWeek = 'oneWeek',
  ThreeWeek = 'threeWeek'
}

export type PollMisInput = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  filter?: Maybe<Scalars['String']>;
};

export type PollMisOutput = {
  __typename?: 'PollMISOutput';
  data?: Maybe<Array<Maybe<PollMisOutputData>>>;
  total?: Maybe<PollMisOutputTotal>;
};

export type PollMisOutputData = {
  __typename?: 'PollMISOutputData';
  Date?: Maybe<Scalars['String']>;
  polls?: Maybe<Scalars['Int']>;
  totalvotes?: Maybe<Scalars['Int']>;
  votes?: Maybe<Scalars['Int']>;
};

export type PollMisOutputTotal = {
  __typename?: 'PollMISOutputTotal';
  poll?: Maybe<PollMisOutputTotalPoll>;
  votes?: Maybe<PollMisOutputTotalVotes>;
};

export type PollMisOutputTotalPoll = {
  __typename?: 'PollMISOutputTotalPOLL';
  pollCount?: Maybe<Scalars['Int']>;
};

export type PollMisOutputTotalVotes = {
  __typename?: 'PollMISOutputTotalVOTES';
  votesCount?: Maybe<Scalars['Int']>;
};

export type PopUpAdminPanel = {
  __typename?: 'PopUpAdminPanel';
  popUpId?: Maybe<Scalars['String']>;
  popUpType?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  showTill?: Maybe<Scalars['Int']>;
  popUpDelay?: Maybe<Scalars['Int']>;
};

export type PopUpData = {
  __typename?: 'PopUpData';
  data?: Maybe<Array<Maybe<PopUp>>>;
  errorMessage?: Maybe<ErrorMessage>;
};

export type PopUpSeen = {
  __typename?: 'PopUpSeen';
  success?: Maybe<IsSuccess>;
  errorMessage?: Maybe<ErrorMessage>;
};

export type Post = {
  __typename?: 'Post';
  postId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  User?: Maybe<User>;
  clubId?: Maybe<Scalars['String']>;
  Club?: Maybe<Club>;
  text?: Maybe<Scalars['String']>;
  textV2?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<Media>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  postType?: Maybe<Array<Maybe<Scalars['String']>>>;
  isUpvoted?: Maybe<Scalars['Int']>;
  isDownvoted?: Maybe<Scalars['Int']>;
  /**
   * upvotes: [String]
   * downvotes: [String]
   */
  upvotecount?: Maybe<Scalars['Int']>;
  downvotecount?: Maybe<Scalars['Int']>;
  sharecount?: Maybe<Scalars['Int']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  linkPreview?: Maybe<LinkPreview>;
  sharePostId?: Maybe<Scalars['String']>;
  getSharedPost?: Maybe<Post>;
  userShares?: Maybe<Array<Maybe<Scalars['String']>>>;
  stockName?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  stopLoss?: Maybe<Scalars['String']>;
  ideaType?: Maybe<IdeaType>;
  commentcount?: Maybe<Scalars['Int']>;
  memberType?: Maybe<ClubMemberType>;
  isbookmarked?: Maybe<Scalars['Int']>;
  meta?: Maybe<Meta>;
  flagged?: Maybe<Scalars['Int']>;
  isSuspected?: Maybe<Scalars['Int']>;
  isCheckedByCM?: Maybe<Scalars['Int']>;
  hasPoll?: Maybe<Scalars['Boolean']>;
  getPoll?: Maybe<Poll>;
  clubPostShareSetting?: Maybe<ClubPostShareSettingScheme>;
  clubPostShareSettingV2?: Maybe<Scalars['Boolean']>;
  isPinned?: Maybe<Scalars['Boolean']>;
  isPinnedByUser?: Maybe<Scalars['Boolean']>;
  isEdited?: Maybe<Scalars['Boolean']>;
  editHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  isFollowed?: Maybe<Scalars['Boolean']>;
  topComment?: Maybe<Comment>;
  topCommentId?: Maybe<Scalars['String']>;
  hasComments?: Maybe<Scalars['Boolean']>;
  membershipLevelOfCreator?: Maybe<Scalars['Int']>;
};


export type PostClubPostShareSettingV2Args = {
  clubBasedPermissionToken: Scalars['String'];
};

export type PostDetails = {
  __typename?: 'PostDetails';
  post?: Maybe<Post>;
  error?: Maybe<ErrorMessage>;
};

export type PostDollarTagArgs = {
  postId: Scalars['String'];
  clubId?: Maybe<Scalars['String']>;
  dollarTagId: Scalars['Int'];
};

/** GraphQL Input Types */
export type PostId = {
  postId?: Maybe<Scalars['String']>;
  oldPostId?: Maybe<Scalars['Int']>;
};

export type PostInput = {
  postId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  /**
   * this token is used by the createPostV3 resolver to check if user
   * has right permissions inside the club
   */
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<MediaInput>>>;
  tags?: Maybe<Array<Maybe<TagInput>>>;
  stockName?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  stopLoss?: Maybe<Scalars['String']>;
  ideaType?: Maybe<IdeaType>;
  linkPreview?: Maybe<LinkPreviewInput>;
  sharePostId?: Maybe<Scalars['String']>;
  poll?: Maybe<CreatePollArgs>;
};

export type PostListSinceDate = {
  __typename?: 'PostListSinceDate';
  posts?: Maybe<Array<Maybe<Post>>>;
  since?: Maybe<Scalars['String']>;
};

export type PostUpvoteDownVoteCountV2 = {
  __typename?: 'PostUpvoteDownVoteCountV2';
  success?: Maybe<Scalars['Boolean']>;
  upvotes?: Maybe<Scalars['Int']>;
  downvotes?: Maybe<Scalars['Int']>;
  post?: Maybe<Post>;
};

/** GraphQL Output Types */
export type PostWithTag = {
  __typename?: 'PostWithTag';
  post?: Maybe<Array<Maybe<Post>>>;
  discussions?: Maybe<Scalars['Int']>;
  followers?: Maybe<Scalars['Int']>;
  hashtag?: Maybe<Hashtag>;
  stock?: Maybe<Stock>;
};

export type PrevAndLaterComments = {
  __typename?: 'PrevAndLaterComments';
  hasPrev?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Comment>;
  hasLater?: Maybe<Scalars['Boolean']>;
};

export type Price = {
  __typename?: 'Price';
  SecurityID?: Maybe<Scalars['Int']>;
  Dt?: Maybe<Scalars['DateTime']>;
  O?: Maybe<Scalars['Float']>;
  H?: Maybe<Scalars['Float']>;
  L?: Maybe<Scalars['Float']>;
  C?: Maybe<Scalars['Float']>;
  CZ?: Maybe<Scalars['Float']>;
  CZG?: Maybe<Scalars['Float']>;
  TQ?: Maybe<Scalars['Float']>;
};

export type ProfileSettings = {
  __typename?: 'ProfileSettings';
  profileType?: Maybe<ProfileType>;
  isEmailPrivate?: Maybe<Scalars['Boolean']>;
  isPhonePrivate?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum ProfileType {
  Public = 'public',
  Private = 'private'
}

export type PromotionArgs = {
  redirectURL?: Maybe<Scalars['String']>;
  shareableURL?: Maybe<Scalars['String']>;
  imageURL: Scalars['String'];
};

export type PromotionData = {
  __typename?: 'PromotionData';
  promotionId?: Maybe<Scalars['String']>;
  redirectURL?: Maybe<Scalars['String']>;
  shareableURL?: Maybe<Scalars['String']>;
  imageURL?: Maybe<Scalars['MediaURI']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  activatedBy?: Maybe<User>;
  activatedById?: Maybe<Scalars['String']>;
  deactivatedBy?: Maybe<User>;
  deactivatedById?: Maybe<Scalars['String']>;
  activatedAt?: Maybe<Scalars['DateTime']>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
};

export type PromotionDataOutput = {
  __typename?: 'PromotionDataOutput';
  promotionData?: Maybe<Array<Maybe<PromotionData>>>;
  total?: Maybe<Scalars['Int']>;
};

export type PromotionShareObj = {
  __typename?: 'PromotionShareObj';
  text?: Maybe<Scalars['String']>;
  imageLink?: Maybe<Scalars['String']>;
};

export enum PushNotificationFilter {
  Pending = 'Pending',
  Completed = 'Completed',
  All = 'All'
}

export type PushNotificationLog = {
  __typename?: 'PushNotificationLog';
  pushLogId?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['MediaURI']>;
  link?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  isPushNotificationSent?: Maybe<Scalars['Boolean']>;
  scheduleTime?: Maybe<Scalars['DateTime']>;
  clubId?: Maybe<Scalars['String']>;
  Club?: Maybe<Club>;
  isPushJobRunning?: Maybe<Scalars['Boolean']>;
};

export type PushNotificationLogOutput = {
  __typename?: 'PushNotificationLogOutput';
  pushNotificationLog?: Maybe<Array<Maybe<PushNotificationLog>>>;
  total?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  /** Feedback */
  getFeedbackTypes?: Maybe<Array<Maybe<FeedbackTypeEnum>>>;
  getMyFeedbacks?: Maybe<Array<Maybe<Feedback>>>;
  getAllFeedbacks?: Maybe<Array<Maybe<Feedback>>>;
  getFeedbackReplies?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** zendesk */
  getZendeskTicketComments?: Maybe<Array<Maybe<Scalars['ZendeskTicketCommentResponseModel']>>>;
  getZendeskTicketsByUser?: Maybe<ZendeskTicketList>;
  getAllZendeskTickets?: Maybe<ZendeskTicketList>;
  getTicketById?: Maybe<Scalars['ZendeskTicketResponseModel']>;
  getZendeskTicketTypeList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** admin */
  getWhiteListedEmails?: Maybe<Array<Maybe<User>>>;
  getActivitiesForAdmin?: Maybe<Array<Maybe<Activity>>>;
  adminUserSearch?: Maybe<Array<Maybe<User>>>;
  adminSuspectedEntities?: Maybe<Array<Maybe<SuspectedEntities>>>;
  getPostForAdmin?: Maybe<Post>;
  currentMOM?: Maybe<MomData>;
  getMOMUserList?: Maybe<MomListOutput>;
  getBlueTickUserList?: Maybe<BlueTickListOutput>;
  getTick3UserList?: Maybe<Tick3ListOutput>;
  getGreenTickUserList?: Maybe<GreenTickListOutput>;
  getActivityTypeListForAdmin?: Maybe<Array<Maybe<ActivityTypeForAdmin>>>;
  getAdminFilterActivity?: Maybe<ActivityFilterOutput>;
  adminSearchText?: Maybe<Array<Maybe<Search>>>;
  AutoFollowEnabledUsers?: Maybe<AutoFollowListOutput>;
  getClubDetailForAdmin?: Maybe<GetClubDetails>;
  getClubsListForAdmin?: Maybe<ClubListOutputAdmin>;
  /** getActiveUsersList(page: Int!, limit: Int!): UserMembershipExpiryListOutput */
  getAnalystDetails?: Maybe<AnalystDetails>;
  getUserInfoAdmin?: Maybe<User>;
  getPendingScheduledJobs?: Maybe<PendingScheduledJobsOutput>;
  getJobsList?: Maybe<JobsOutput>;
  getPromotionList?: Maybe<PromotionDataOutput>;
  getExternalResourceList?: Maybe<ExternalResourceListOutput>;
  getClubFeatureList?: Maybe<Array<Maybe<FeatureMapping>>>;
  getPushNotificationLogAdmin?: Maybe<PushNotificationLogOutput>;
  getFeatureMappingList?: Maybe<FeatureMappingData>;
  getFeaturePlatformPermissionList?: Maybe<FeaturePlatformPermissionData>;
  getMemberTypeList?: Maybe<MemberTypeListData>;
  getFeatureMappingListForClub?: Maybe<Array<Maybe<FeatureWithPermissionDataOutput>>>;
  getSavedFeatureClubGroup?: Maybe<Array<Maybe<FeatureDataType>>>;
  getCategoryListByClubId?: Maybe<Array<Maybe<FeatureClubCategory>>>;
  getClubsByFeatureId?: Maybe<Array<Maybe<Club>>>;
  /** admin panel club feature based locking */
  getListOfFeatureClubGroup?: Maybe<FeatureClubGroupData>;
  getListOfMembertypeClubPermissionMap?: Maybe<MembertypeClubPermissionMapData>;
  /** For Admin - Marking contentType for new Onboarding process */
  getHashtagListForAdminBasedOnContentFilter?: Maybe<Array<Maybe<Hashtag>>>;
  getUserCreatorTypeOfContentList?: Maybe<GetUserCreatorTypeOfContentListOutput>;
  /** admin MIS */
  commentSummary?: Maybe<SummaryMisOutput>;
  postSummary?: Maybe<SummaryMisOutput>;
  userEngagementSummary?: Maybe<Array<Maybe<MisOutput>>>;
  replySummary?: Maybe<SummaryMisOutput>;
  sessionSummary?: Maybe<SessionMisOutput>;
  getClubList?: Maybe<Array<Maybe<Club>>>;
  pollInPostSummary?: Maybe<PollMisOutput>;
  dailySignUpSummary?: Maybe<SummaryMisOutput>;
  /** Club Category */
  getClubCategoryList?: Maybe<Array<Maybe<FeatureClubCategory>>>;
  /**
   * adminLogin(data: AdminLogin): AuthPayload!
   * User Queries
   */
  me: User;
  getUserList: Array<Maybe<User>>;
  getClubAuthorityList: Array<Maybe<User>>;
  getProfileInfo?: Maybe<User>;
  getProfileInfoFromOIDCToken?: Maybe<User>;
  getMySubscriptions?: Maybe<Subscriptions>;
  getMySubscribers?: Maybe<Array<Maybe<User>>>;
  getReferMsg?: Maybe<ReferMsg>;
  /** getUserInfo(data: UserId): User deprecated */
  refreshAccessToken: AuthPayload;
  refreshAccessTokenV2: AuthPayload;
  getUniqueUsername?: Maybe<IsSuccess>;
  getSuggestedPeople?: Maybe<Array<Maybe<User>>>;
  getTopMentionedPeople?: Maybe<Array<Maybe<User>>>;
  getPopularUsers?: Maybe<Array<Maybe<User>>>;
  getMarketExperts?: Maybe<Array<Maybe<User>>>;
  getTick3Experts?: Maybe<Array<Maybe<User>>>;
  getVerifiedUsers?: Maybe<Array<Maybe<User>>>;
  /**
   * Block Query
   * isBlocked(id: String!): IsSuccess!
   */
  getBlockedList?: Maybe<Array<Maybe<User>>>;
  /** Stocks & Sector Queries */
  getSectorsByName: Array<Maybe<Sector>>;
  getStocksBySectors: Array<Maybe<Stock>>;
  getStocksBySearchText: Array<Maybe<TrendingStocktag>>;
  getStocksBySearchTextForWatchlist?: Maybe<Array<Maybe<Stock>>>;
  getStocksBySearchTextViaDollarTagForWatchlist?: Maybe<Array<Maybe<DollarTag>>>;
  getSectorBySearchTextViaDollarTagForWatchlist?: Maybe<Array<Maybe<DollarTag>>>;
  getSectors: Array<Maybe<Sector>>;
  getTrendingStocks: Array<Maybe<TrendingStocktag>>;
  getTrendingStocksV2: Array<Maybe<Stock>>;
  getUserTrendingStocks: Array<Maybe<TrendingStocktag>>;
  getClubTrendingStocks: Array<Maybe<TrendingStocktag>>;
  getStockTagDetails?: Maybe<PostWithTag>;
  /** Hashtag Queries */
  getHashtagBySearchText: Array<Maybe<TrendingHashTag>>;
  getTrendingHashTags: Array<Maybe<TrendingHashTag>>;
  getTrendingHashTagsV2: Array<Maybe<Hashtag>>;
  getUserTrendingHashTags: Array<Maybe<TrendingHashTag>>;
  getClubTrendingHashtags: Array<Maybe<TrendingHashTag>>;
  getClubTrendingHashtagsV2: Array<Maybe<Hashtag>>;
  getHashTagDetails: PostWithTag;
  /** Dollartag Queries */
  getPostByDollarTag?: Maybe<Array<Maybe<Post>>>;
  getPostByDollarTagSinceDate?: Maybe<PostListSinceDate>;
  getDollarTagDetails?: Maybe<DollarTag>;
  getDollartagBySearchText?: Maybe<Array<Maybe<DollarTag>>>;
  getClubTrendingDollarTag: Array<Maybe<DollarTag>>;
  getClubTrendingStocksViaDollarTag: Array<Maybe<DollarTag>>;
  getClubTrendingSectorsViaDollarTag: Array<Maybe<DollarTag>>;
  getDollarTagForSecurityId?: Maybe<DollarTag>;
  getTrendingDollarTag?: Maybe<Array<Maybe<DollarTag>>>;
  getTrendingStocksByDollarTag?: Maybe<Array<Maybe<DollarTag>>>;
  getTrendingSectorsByDollarTag?: Maybe<Array<Maybe<DollarTag>>>;
  /** Post Queries */
  getReactions?: Maybe<Array<Maybe<Vote>>>;
  getMediaUploadURLS: Array<Maybe<MediaUrl>>;
  getLinkPreview: LinkPreview;
  getFeedPosts: Array<Maybe<ActivityFeed>>;
  getFeedPostsV3: ActivityFeedDetails;
  getRecommendedPosts: Array<Maybe<ActivityFeed>>;
  getSelfFeed: Array<Maybe<ActivityFeed>>;
  getShareFeedForPost?: Maybe<Array<Maybe<Post>>>;
  /** getFeedPostsV2(page: Int!): [ActivityFeed]! */
  getProfilePosts: Array<Maybe<Post>>;
  getProfilePostsV2: Array<Maybe<Post>>;
  getProfilePostsSinceDate?: Maybe<PostListSinceDate>;
  getProfileMarketingPosts?: Maybe<Array<Maybe<Post>>>;
  getMediaPosts: Array<Maybe<Post>>;
  getMedia: Array<Maybe<MediaPostId>>;
  getStockIdeaPosts: Array<Maybe<Post>>;
  getPostsByHashTag: PostWithTag;
  getPostsByStockTag: PostWithTag;
  getPostsByHashTagV2: Array<Maybe<Post>>;
  getPostByHashTagSinceDate?: Maybe<PostListSinceDate>;
  getHashtagMarketingPosts?: Maybe<Array<Maybe<Post>>>;
  getDollartagMarketingPosts?: Maybe<Array<Maybe<Post>>>;
  getClubMarketingPosts?: Maybe<Array<Maybe<Post>>>;
  getPostsByStockTagV2: Array<Maybe<Post>>;
  getEditPostHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  getEditCommentHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  getEditReplyHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  /**
   * getImagePosts(data: UserId): [Post]!
   * getVideoPosts(data: UserId): [Post]!
   * getAudioPosts(data: UserId): [Post]!
   */
  getPostById: Post;
  getClubPostsbyClubId: Array<Maybe<Post>>;
  getClubPostsByStockTag: PostWithTag;
  getClubPostsByHashTag: PostWithTag;
  getClubMediaPosts: Array<Maybe<Post>>;
  getClubMedia: Array<Maybe<MediaPostId>>;
  getClubStockIdeaPosts: Array<Maybe<Post>>;
  getComments: Array<Maybe<Comment>>;
  getCommentDetails: Comment;
  getReplies?: Maybe<Array<Maybe<Reply>>>;
  /** Follow Queries */
  isFollowing: IsFollowed;
  isSubscribed: IsSuccess;
  getFollowers?: Maybe<FollowingType>;
  getFollowersCount: Scalars['Int'];
  getUserFollowers?: Maybe<Array<Maybe<User>>>;
  getFollowings?: Maybe<FollowingTypeNew>;
  getUserFollowings?: Maybe<Array<Maybe<User>>>;
  getStockFollowings?: Maybe<Array<Maybe<Stock>>>;
  getHashtagFollowings?: Maybe<Array<Maybe<Hashtag>>>;
  getFollowingsCount: Scalars['Int'];
  getTopVerifiedUsers?: Maybe<Array<Maybe<User>>>;
  getTopUnverifiedUsers?: Maybe<Array<Maybe<User>>>;
  getMutualFollowers?: Maybe<Array<Maybe<User>>>;
  getMutualFollowings?: Maybe<Array<Maybe<User>>>;
  getFollowingDollarTag?: Maybe<Array<Maybe<DollarTag>>>;
  /** Club Queries */
  getMemberCount?: Maybe<Scalars['Int']>;
  getMembers?: Maybe<Array<Maybe<User>>>;
  getClubPosts?: Maybe<Array<Maybe<Post>>>;
  getClubPostsV2?: Maybe<Array<Maybe<Post>>>;
  getClubPostsSinceDate?: Maybe<PostListSinceDate>;
  getClubContributors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * getClubsBySearchText(searchText: String!): [Club]
   * getClubsByTopics(data: GetClubsByTopicsArgs!): [Club]
   */
  getClubsOfUser?: Maybe<Array<Maybe<Club>>>;
  getClubsOfUserCount: Scalars['Int'];
  getPopularClubs?: Maybe<Array<Maybe<Club>>>;
  getPopularClubsInPlatform?: Maybe<Array<Maybe<Club>>>;
  getClub?: Maybe<Club>;
  getClubAdmin?: Maybe<Club>;
  /** getUniqueClubHandle(clubHandle: String!): Boolean */
  getClubCategories?: Maybe<Array<Maybe<ClubCategory>>>;
  checkClubHandleValidation?: Maybe<IsSuccess>;
  /** User Club Permission */
  getPermissionList?: Maybe<Array<Maybe<UserClubPermissionValues>>>;
  checkPermission: Scalars['Boolean'];
  /** reports */
  getIsReported: Scalars['Boolean'];
  getReportTypes?: Maybe<Array<Maybe<ReportType>>>;
  getSiteReports?: Maybe<SiteReportOutput>;
  getSiteReportById?: Maybe<SiteReport>;
  getReportedByList?: Maybe<Array<Maybe<ReportData>>>;
  getReportActionHistory?: Maybe<ActionHistoryOutput>;
  getReportActionStatus?: Maybe<ActionState>;
  getReportOnUserActionStatus?: Maybe<UserReportActionState>;
  getReportActionHistoryList?: Maybe<ActionHistoryOutput>;
  getSiteReportDataList?: Maybe<ReportDataListOutput>;
  /** Interest Queries */
  getInterest?: Maybe<SecCat>;
  getSimilarInterestUser?: Maybe<Array<Maybe<User>>>;
  /** Bookmark Queries */
  getBookmark?: Maybe<Array<Maybe<Post>>>;
  getBookmarkV2?: Maybe<Array<Maybe<Post>>>;
  getIsBookmarked: Scalars['Boolean'];
  /** Notification Queries */
  getNotifications?: Maybe<Array<Maybe<Notification>>>;
  getAlertNotifications?: Maybe<Array<Maybe<Notification>>>;
  getClubNotifications?: Maybe<Array<Maybe<Notification>>>;
  getRequests?: Maybe<Array<Maybe<Notification>>>;
  getNotificationsCount: Scalars['Int'];
  getRequestsCount: Scalars['Int'];
  /** Search */
  unifiedSearch?: Maybe<Array<Maybe<Search>>>;
  unifiedSearchV2?: Maybe<Array<Maybe<Search>>>;
  /** Watchlist */
  getWatchlist?: Maybe<Array<Maybe<Stock>>>;
  isWatchlisted?: Maybe<Scalars['Boolean']>;
  getWatchlistV2?: Maybe<Array<Maybe<DollarTag>>>;
  getUserWatchlist?: Maybe<Array<Maybe<DollarTag>>>;
  getWatchlistCount?: Maybe<Scalars['Int']>;
  /** Poll Feature */
  getPollExpiryTypeList?: Maybe<Array<Maybe<PollExpiryType>>>;
  getVoterList?: Maybe<Array<Maybe<User>>>;
  /** Unified Feature */
  getUnifiedFeed?: Maybe<Array<Maybe<Post>>>;
  /** CRON JOB LOGS */
  getCronJobs?: Maybe<GetCronJobLogsOutput>;
  /** list of clubs where user has post permission */
  getListOfClubsWithPostPermission?: Maybe<Array<Maybe<Club>>>;
  /** pinnedPosts */
  getPinnedPost?: Maybe<Array<Maybe<Post>>>;
  getReferBanner?: Maybe<Scalars['String']>;
  getMultipleExternalResource?: Maybe<Array<Maybe<ExternalResource>>>;
  /** ADMIN NPS SCORE */
  getNpsScore?: Maybe<Scalars['Float']>;
  getNpsData?: Maybe<GetNpsOutput>;
  getCountOfNpsReviews?: Maybe<GetCountOfReviews>;
  /** admin panel home page */
  getUserCount?: Maybe<UserCount>;
  getTotalMis?: Maybe<MisTotalCount>;
  getPendingPushNotificationData?: Maybe<PendingPushNotificationLogOutput>;
  getPendingScheduledJobsData?: Maybe<Array<Maybe<PendingJobs>>>;
  getClubDataChanges?: Maybe<ClubChanges>;
  getNpsInIntervalV2?: Maybe<NpsInInterValOuptut>;
  getNpsInInterval?: Maybe<NpsIntervalData>;
  getMarkedUsers?: Maybe<MarkedUsersData>;
  getUser?: Maybe<User>;
  /** MISforCreators */
  misForCreators?: Maybe<MisOutputForCreators>;
  /** admin panel dashboard */
  membersCountInClub?: Maybe<Array<Maybe<ClubMemberCount>>>;
  getReportCount?: Maybe<ReportCount>;
  getTotalAndTickUsers?: Maybe<UsersCount>;
  getTotalMembershipLevelUsers?: Maybe<UsersCountBasedOnMembershipLevel>;
  uniqueUsersWhoPosted?: Maybe<Array<Maybe<UniqueUsers>>>;
  /** Platform Permissions */
  getFeatureToPlatformPermission?: Maybe<Array<Maybe<PlatformPermissionFromFeatureTypes>>>;
  getFeatureToClubPermissionById?: Maybe<ClubPermissionsAuthorizationDetails>;
  /** Club Permission based on Features */
  getClubPermissionsBasedOnFeatures?: Maybe<Array<Maybe<ClubPermissionsAuthorizationDetails>>>;
  /** restriction modal */
  getRestrictionModal?: Maybe<RestrictionModal>;
  /** viewOnlyPermissions */
  getViewOnlypermissionsFromToken?: Maybe<PlatformActionPermissionsAlias>;
  /** restriction for premium user */
  restriction?: Maybe<RestrictionDataForPremium>;
  /** courses and webinars */
  getWebinarUrl?: Maybe<Scalars['String']>;
  getCoursesUrl?: Maybe<Scalars['String']>;
  /** upcoming events admin panel */
  getListOfUpcomingEvents?: Maybe<ListOfEvents>;
  /** upcoming events */
  getUpcomingEvents?: Maybe<Array<Maybe<UpcomingEventsList>>>;
  showEventsDot?: Maybe<Scalars['Boolean']>;
  /** post follow */
  getTurnOffNotificationText?: Maybe<Scalars['String']>;
  isPostFollowed?: Maybe<Scalars['Boolean']>;
  /** New Onboarding Flow */
  getHashtagsListBasedOnTypeOfContent?: Maybe<Array<Maybe<Hashtag>>>;
  getUserLevelNameFromSE?: Maybe<UserHashtagContentType>;
  /** Permission And Clubs To Feature List Map */
  getPermissionToFeatureMappingList?: Maybe<ClubAndUtilityToFeatureOutput>;
  /** Interstitials */
  getListOfInterstitials?: Maybe<ListOfInterstitials>;
  getInterstitials?: Maybe<Array<Maybe<InterstitialsData>>>;
  getStockListForSmartFeed?: Maybe<Array<Maybe<DollarTag>>>;
  getSectorListForSmartFeed?: Maybe<Array<Maybe<DollarTag>>>;
  getPromotionForSmartFeed?: Maybe<PromotionData>;
  getClubListForSmartFeed?: Maybe<Array<Maybe<Club>>>;
  getTopicListForSmartFeed?: Maybe<Array<Maybe<Hashtag>>>;
  getPeopleListForSmartFeed?: Maybe<Array<Maybe<User>>>;
  getBadgePromotionForSmartFeed?: Maybe<Array<Maybe<HighlightedAchievements>>>;
  /** new post prompt */
  checkNewPosts?: Maybe<Scalars['Boolean']>;
  checkNewPostsFavoritesFeed?: Maybe<Scalars['Boolean']>;
  /** Posts By Filters */
  getPostsByFilters?: Maybe<FilteredPostListSinceDate>;
  globalSearchPosts?: Maybe<GlobalSearchPostListSinceDate>;
  /** Guided Tour */
  getGuidedTour?: Maybe<Array<Maybe<TourKeys>>>;
  /** Admin Panel Guided Tour */
  getGuidedTourListForAdmin?: Maybe<TourKeysAdminOutput>;
  /** Admin Panel AB_ReleasePanel */
  isFeatureVisible?: Maybe<Scalars['Boolean']>;
  getDataListForAB_ReleaseFeatureAdmin?: Maybe<Ab_ReleasePanelOutput>;
  /** streak details */
  getAllAchievementStatus?: Maybe<UserAchievemtStatusData>;
  getPowerUserStreakDetails?: Maybe<UserStreakData>;
  getBrokenStreakDetails?: Maybe<UserStreakData>;
  /** popUp */
  getPopUp?: Maybe<PopUpData>;
  /** admin panel popUp */
  getListOfPopUps?: Maybe<Array<Maybe<PopUpAdminPanel>>>;
  /** badge system */
  getListOfBadges?: Maybe<ListOfBadges>;
  getBadgesOfUser?: Maybe<ListOfUserBadges>;
  /** Post details page api */
  getPostDetailsById?: Maybe<PostDetails>;
  /** FileUpload */
  getMediaSignedUrl?: Maybe<Array<Maybe<SignedUrl>>>;
  /** whatsNew admin panel */
  getListOfWhatsNew?: Maybe<ListOfWhatsNew>;
  /** whatsNew */
  getWhatsNew?: Maybe<Array<Maybe<WhatsNewPlatform>>>;
  /** Discover Page and Panel Design */
  getCategories?: Maybe<Array<Maybe<FeatureClubCategory>>>;
  getClubsByCategory?: Maybe<Array<Maybe<Club>>>;
  getCategoryById?: Maybe<FeatureClubCategory>;
  getImportantProfiles?: Maybe<Array<Maybe<User>>>;
  getImportantProfilesForAdmin?: Maybe<Array<Maybe<User>>>;
  /** Recent Search */
  getRecentSearch?: Maybe<Array<Maybe<UserRecentSearchOutput>>>;
  /** PowerUser Badge Promotion */
  getAchievementDetails?: Maybe<AchievementDetailsOutput>;
  getBadgeFeedbackQuestion?: Maybe<Array<Maybe<FeedbackQuestions>>>;
  /** PowerUser Badge Promotion ADMIN PANEL */
  getBadgeFeedbackQuestionAdmin?: Maybe<Array<Maybe<FeedbackQuestions>>>;
};


export type QueryGetAllFeedbacksArgs = {
  page: Scalars['Int'];
};


export type QueryGetFeedbackRepliesArgs = {
  feedbackId: Scalars['String'];
};


export type QueryGetZendeskTicketCommentsArgs = {
  ticketId: Scalars['Int'];
};


export type QueryGetZendeskTicketsByUserArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
  filter?: Maybe<ZendeskSearchfilter>;
};


export type QueryGetAllZendeskTicketsArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
  filter?: Maybe<ZendeskSearchfilter>;
};


export type QueryGetTicketByIdArgs = {
  ticketId: Scalars['Int'];
};


export type QueryGetWhiteListedEmailsArgs = {
  page: Scalars['Int'];
  searchtext?: Maybe<Scalars['String']>;
};


export type QueryGetActivitiesForAdminArgs = {
  page: Scalars['Int'];
};


export type QueryAdminUserSearchArgs = {
  email?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filter?: Maybe<AdminUserSearchFilterType>;
};


export type QueryAdminSuspectedEntitiesArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetPostForAdminArgs = {
  postId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
};


export type QueryGetMomUserListArgs = {
  data?: Maybe<GetMomListArgs>;
};


export type QueryGetBlueTickUserListArgs = {
  data?: Maybe<GetTickListArgs>;
};


export type QueryGetTick3UserListArgs = {
  data?: Maybe<GetTickListArgs>;
};


export type QueryGetGreenTickUserListArgs = {
  data?: Maybe<GetTickListArgs>;
};


export type QueryGetAdminFilterActivityArgs = {
  data?: Maybe<FilterActivityArgs>;
};


export type QueryAdminSearchTextArgs = {
  searchText: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  type: SearchType;
  SearchFilter?: Maybe<SearchFilter>;
};


export type QueryAutoFollowEnabledUsersArgs = {
  data?: Maybe<AutoFollowInputs>;
};


export type QueryGetClubDetailForAdminArgs = {
  clubId: Scalars['String'];
};


export type QueryGetClubsListForAdminArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetAnalystDetailsArgs = {
  userId: Scalars['String'];
};


export type QueryGetUserInfoAdminArgs = {
  userId: Scalars['String'];
};


export type QueryGetPendingScheduledJobsArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetJobsListArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
  filter?: Maybe<ScheduleJobStatus>;
  searchText?: Maybe<Scalars['String']>;
};


export type QueryGetPromotionListArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetExternalResourceListArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
  searchText?: Maybe<Scalars['String']>;
};


export type QueryGetPushNotificationLogAdminArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
  filter: PushNotificationFilter;
};


export type QueryGetFeatureMappingListArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetFeaturePlatformPermissionListArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetMemberTypeListArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetSavedFeatureClubGroupArgs = {
  clubId?: Maybe<Scalars['String']>;
};


export type QueryGetCategoryListByClubIdArgs = {
  clubId: Scalars['String'];
};


export type QueryGetClubsByFeatureIdArgs = {
  featureId?: Maybe<Scalars['String']>;
};


export type QueryGetListOfFeatureClubGroupArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetListOfMembertypeClubPermissionMapArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetHashtagListForAdminBasedOnContentFilterArgs = {
  typeOfContentMadeByHashtag?: Maybe<UserHashtagContentType>;
};


export type QueryGetUserCreatorTypeOfContentListArgs = {
  typeOfContentFilter?: Maybe<Array<Maybe<ContentMadeByUser>>>;
  searchText?: Maybe<Scalars['String']>;
  tickFilter?: Maybe<Array<Maybe<TickTypeForContent>>>;
};


export type QueryCommentSummaryArgs = {
  data?: Maybe<MisInput>;
};


export type QueryPostSummaryArgs = {
  data?: Maybe<MisInput>;
};


export type QueryUserEngagementSummaryArgs = {
  data?: Maybe<MisInput>;
};


export type QueryReplySummaryArgs = {
  data?: Maybe<MisInput>;
};


export type QuerySessionSummaryArgs = {
  data?: Maybe<MisInput>;
};


export type QueryPollInPostSummaryArgs = {
  data?: Maybe<PollMisInput>;
};


export type QueryDailySignUpSummaryArgs = {
  data?: Maybe<SignUpMisInput>;
};


export type QueryGetUserListArgs = {
  data?: Maybe<GetUserListArgs>;
};


export type QueryGetClubAuthorityListArgs = {
  data?: Maybe<GetUserListArgs>;
  clubId: Scalars['String'];
};


export type QueryGetProfileInfoArgs = {
  data?: Maybe<UserId>;
};


export type QueryRefreshAccessTokenArgs = {
  data?: Maybe<RefreshToken>;
};


export type QueryRefreshAccessTokenV2Args = {
  data?: Maybe<RefreshToken>;
};


export type QueryGetUniqueUsernameArgs = {
  username: Scalars['String'];
};


export type QueryGetTopMentionedPeopleArgs = {
  limits: Limits;
};


export type QueryGetPopularUsersArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetMarketExpertsArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetTick3ExpertsArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetVerifiedUsersArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetSectorsByNameArgs = {
  name: Scalars['String'];
};


export type QueryGetStocksBySectorsArgs = {
  data?: Maybe<GetStocksBySectorsArgs>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetStocksBySearchTextArgs = {
  data?: Maybe<GetStocksBySearchTextArgs>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetStocksBySearchTextForWatchlistArgs = {
  searchText: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
};


export type QueryGetStocksBySearchTextViaDollarTagForWatchlistArgs = {
  searchText: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
};


export type QueryGetSectorBySearchTextViaDollarTagForWatchlistArgs = {
  searchText: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
};


export type QueryGetSectorsArgs = {
  limits?: Maybe<GetSectorsArgs>;
};


export type QueryGetTrendingStocksArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetTrendingStocksV2Args = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetUserTrendingStocksArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetClubTrendingStocksArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
  clubId: Scalars['String'];
};


export type QueryGetStockTagDetailsArgs = {
  securityId?: Maybe<Scalars['Int']>;
};


export type QueryGetHashtagBySearchTextArgs = {
  data?: Maybe<GetHashtagBySearchTextArgs>;
};


export type QueryGetTrendingHashTagsArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetTrendingHashTagsV2Args = {
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetUserTrendingHashTagsArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetClubTrendingHashtagsArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
  clubId: Scalars['String'];
};


export type QueryGetClubTrendingHashtagsV2Args = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  clubId: Scalars['String'];
};


export type QueryGetHashTagDetailsArgs = {
  hashTagName?: Maybe<Scalars['String']>;
  hashtagId?: Maybe<Scalars['String']>;
};


export type QueryGetPostByDollarTagArgs = {
  dollarTagId: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetPostByDollarTagSinceDateArgs = {
  dollarTagId: Scalars['Int'];
  since?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};


export type QueryGetDollarTagDetailsArgs = {
  dollarTagId?: Maybe<Scalars['Int']>;
};


export type QueryGetDollartagBySearchTextArgs = {
  searchText: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
};


export type QueryGetClubTrendingDollarTagArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
  clubId: Scalars['String'];
};


export type QueryGetClubTrendingStocksViaDollarTagArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  clubId: Scalars['String'];
};


export type QueryGetClubTrendingSectorsViaDollarTagArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  clubId: Scalars['String'];
};


export type QueryGetDollarTagForSecurityIdArgs = {
  securityId: Scalars['Int'];
};


export type QueryGetTrendingDollarTagArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  type: Array<Maybe<DollarTagEnum>>;
};


export type QueryGetTrendingStocksByDollarTagArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetTrendingSectorsByDollarTagArgs = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetReactionsArgs = {
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
  voteType?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetMediaUploadUrlsArgs = {
  data?: Maybe<Array<Maybe<MediaInput>>>;
};


export type QueryGetLinkPreviewArgs = {
  data?: Maybe<Scalars['String']>;
};


export type QueryGetFeedPostsArgs = {
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetFeedPostsV3Args = {
  limit?: Maybe<Scalars['Int']>;
  since_activityId?: Maybe<Scalars['Int']>;
};


export type QueryGetRecommendedPostsArgs = {
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetSelfFeedArgs = {
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetShareFeedForPostArgs = {
  postId: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetProfilePostsArgs = {
  data?: Maybe<UserId>;
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetProfilePostsV2Args = {
  data?: Maybe<UserId>;
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetProfilePostsSinceDateArgs = {
  data?: Maybe<UserId>;
  since?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};


export type QueryGetProfileMarketingPostsArgs = {
  data?: Maybe<UserId>;
};


export type QueryGetMediaPostsArgs = {
  data?: Maybe<UserId>;
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetMediaArgs = {
  data?: Maybe<UserId>;
  page: Scalars['Int'];
};


export type QueryGetStockIdeaPostsArgs = {
  data?: Maybe<UserId>;
  page: Scalars['Int'];
};


export type QueryGetPostsByHashTagArgs = {
  hashTagName?: Maybe<Scalars['String']>;
  hashtagId?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetPostsByStockTagArgs = {
  securityId?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetPostsByHashTagV2Args = {
  hashTagName?: Maybe<Scalars['String']>;
  hashtagId?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetPostByHashTagSinceDateArgs = {
  hashTagName?: Maybe<Scalars['String']>;
  hashtagId?: Maybe<Scalars['String']>;
  since?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
};


export type QueryGetHashtagMarketingPostsArgs = {
  hashTagName?: Maybe<Scalars['String']>;
  hashtagId?: Maybe<Scalars['String']>;
};


export type QueryGetDollartagMarketingPostsArgs = {
  dollarTagId?: Maybe<Scalars['Int']>;
};


export type QueryGetClubMarketingPostsArgs = {
  clubId?: Maybe<Scalars['String']>;
};


export type QueryGetPostsByStockTagV2Args = {
  securityId?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetEditPostHistoryArgs = {
  postId: Scalars['String'];
};


export type QueryGetEditCommentHistoryArgs = {
  commentId: Scalars['String'];
};


export type QueryGetEditReplyHistoryArgs = {
  replyId: Scalars['String'];
};


export type QueryGetPostByIdArgs = {
  data?: Maybe<PostId>;
};


export type QueryGetClubPostsbyClubIdArgs = {
  data?: Maybe<ClubInput>;
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetClubPostsByStockTagArgs = {
  securityId: Scalars['Int'];
  page: Scalars['Int'];
  clubId: Scalars['String'];
};


export type QueryGetClubPostsByHashTagArgs = {
  hashTagName: Scalars['String'];
  page: Scalars['Int'];
  clubId: Scalars['String'];
};


export type QueryGetClubMediaPostsArgs = {
  data?: Maybe<ClubInput>;
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetClubMediaArgs = {
  data?: Maybe<ClubInput>;
  page: Scalars['Int'];
};


export type QueryGetClubStockIdeaPostsArgs = {
  data?: Maybe<ClubInput>;
  page: Scalars['Int'];
};


export type QueryGetCommentsArgs = {
  postId?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetCommentDetailsArgs = {
  commentId?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetRepliesArgs = {
  commentId: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};


export type QueryIsFollowingArgs = {
  data?: Maybe<FollowArgs>;
};


export type QueryIsSubscribedArgs = {
  data?: Maybe<SubscribeArgs>;
};


export type QueryGetFollowersArgs = {
  data?: Maybe<FollowArgs>;
};


export type QueryGetFollowersCountArgs = {
  data?: Maybe<FollowArgs>;
};


export type QueryGetUserFollowersArgs = {
  userId: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetFollowingsArgs = {
  data?: Maybe<FollowArgs>;
};


export type QueryGetUserFollowingsArgs = {
  userId: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetStockFollowingsArgs = {
  userId: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetHashtagFollowingsArgs = {
  userId: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetFollowingsCountArgs = {
  data?: Maybe<FollowArgs>;
};


export type QueryGetTopVerifiedUsersArgs = {
  userId: Scalars['String'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetTopUnverifiedUsersArgs = {
  userId: Scalars['String'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetMutualFollowersArgs = {
  id: Scalars['String'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetMutualFollowingsArgs = {
  id: Scalars['String'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetFollowingDollarTagArgs = {
  id: Scalars['String'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryGetMemberCountArgs = {
  clubId: Scalars['String'];
};


export type QueryGetMembersArgs = {
  clubId: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetClubPostsArgs = {
  clubId: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetClubPostsV2Args = {
  clubId: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetClubPostsSinceDateArgs = {
  clubId: Scalars['String'];
  since?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetClubContributorsArgs = {
  clubId: Scalars['String'];
};


export type QueryGetClubsOfUserArgs = {
  userId: Scalars['String'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  entitlement?: Maybe<Scalars['Boolean']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetClubsOfUserCountArgs = {
  userId: Scalars['String'];
};


export type QueryGetPopularClubsArgs = {
  clubType: ClubType;
};


export type QueryGetClubArgs = {
  clubId?: Maybe<Scalars['String']>;
  clubHandle?: Maybe<Scalars['String']>;
};


export type QueryGetClubAdminArgs = {
  clubId?: Maybe<Scalars['String']>;
  clubHandle?: Maybe<Scalars['String']>;
};


export type QueryCheckClubHandleValidationArgs = {
  clubHandle?: Maybe<Scalars['String']>;
};


export type QueryGetPermissionListArgs = {
  clubId: Scalars['String'];
};


export type QueryCheckPermissionArgs = {
  clubId: Scalars['String'];
  Action: UserClubPermissionValues;
};


export type QueryGetIsReportedArgs = {
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
};


export type QueryGetSiteReportsArgs = {
  data?: Maybe<GetSiteReport>;
};


export type QueryGetSiteReportByIdArgs = {
  siteReportId: Scalars['String'];
};


export type QueryGetReportedByListArgs = {
  siteReportId?: Maybe<Scalars['String']>;
  clubReportId?: Maybe<Scalars['String']>;
};


export type QueryGetReportActionHistoryArgs = {
  siteReportId: Scalars['String'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetReportActionStatusArgs = {
  siteReportId: Scalars['String'];
};


export type QueryGetReportOnUserActionStatusArgs = {
  siteReportId: Scalars['String'];
};


export type QueryGetReportActionHistoryListArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetSiteReportDataListArgs = {
  data?: Maybe<GetReportData>;
};


export type QueryGetInterestArgs = {
  data: GetInterest;
};


export type QueryGetSimilarInterestUserArgs = {
  limits: Limits;
};


export type QueryGetBookmarkV2Args = {
  offset: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetIsBookmarkedArgs = {
  postId: Scalars['String'];
};


export type QueryGetNotificationsArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<NotificationFilter>;
};


export type QueryGetAlertNotificationsArgs = {
  page: Scalars['Int'];
};


export type QueryGetClubNotificationsArgs = {
  page: Scalars['Int'];
};


export type QueryGetRequestsArgs = {
  page: Scalars['Int'];
};


export type QueryUnifiedSearchArgs = {
  searchText: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  type: SearchType;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryUnifiedSearchV2Args = {
  searchText: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  type: SearchType;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetWatchlistArgs = {
  limits?: Maybe<Limits>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryIsWatchlistedArgs = {
  securityId: Scalars['Int'];
};


export type QueryGetWatchlistV2Args = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  type?: Maybe<DollarTagEnum>;
};


export type QueryGetUserWatchlistArgs = {
  userId: Scalars['String'];
  type?: Maybe<DollarTagEnum>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetWatchlistCountArgs = {
  userId: Scalars['String'];
};


export type QueryGetVoterListArgs = {
  pollId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetUnifiedFeedArgs = {
  feedId: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryGetCronJobsArgs = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  nameOfCron: NameOfCron;
  jobStatus: GetCronJobStatus;
  limit: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryGetPinnedPostArgs = {
  userId?: Maybe<Scalars['String']>;
};


export type QueryGetMultipleExternalResourceArgs = {
  type?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryGetNpsScoreArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};


export type QueryGetNpsDataArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  page: Scalars['Int'];
  limit: Scalars['Int'];
  filter?: Maybe<NpsReviewerCategory>;
};


export type QueryGetCountOfNpsReviewsArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
};


export type QueryGetTotalMisArgs = {
  data?: Maybe<MisInput>;
};


export type QueryGetPendingPushNotificationDataArgs = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};


export type QueryGetPendingScheduledJobsDataArgs = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};


export type QueryGetClubDataChangesArgs = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};


export type QueryGetNpsInIntervalV2Args = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<DateRange>;
};


export type QueryGetNpsInIntervalArgs = {
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  filter?: Maybe<DateRange>;
};


export type QueryGetMarkedUsersArgs = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};


export type QueryMisForCreatorsArgs = {
  data?: Maybe<MisForCreatorsData>;
};


export type QueryMembersCountInClubArgs = {
  clubIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type QueryGetReportCountArgs = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};


export type QueryUniqueUsersWhoPostedArgs = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};


export type QueryGetFeatureToClubPermissionByIdArgs = {
  clubId?: Maybe<Scalars['String']>;
};


export type QueryGetListOfUpcomingEventsArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetUpcomingEventsArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
};


export type QueryGetTurnOffNotificationTextArgs = {
  notificationId?: Maybe<Scalars['String']>;
};


export type QueryIsPostFollowedArgs = {
  postId?: Maybe<Scalars['String']>;
};


export type QueryGetHashtagsListBasedOnTypeOfContentArgs = {
  typeOfContentMadeByHashtag?: Maybe<UserHashtagContentType>;
};


export type QueryGetListOfInterstitialsArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
  filter?: Maybe<InterstitialsFilterArgs>;
};


export type QueryGetInterstitialsArgs = {
  platformType: PlatformTypeForInterstitial;
};


export type QueryGetStockListForSmartFeedArgs = {
  data: Scalars['String'];
};


export type QueryGetSectorListForSmartFeedArgs = {
  data: Scalars['String'];
};


export type QueryGetPromotionForSmartFeedArgs = {
  data: Scalars['String'];
};


export type QueryGetClubListForSmartFeedArgs = {
  data: Scalars['String'];
};


export type QueryGetTopicListForSmartFeedArgs = {
  data: Scalars['String'];
};


export type QueryGetPeopleListForSmartFeedArgs = {
  data: Scalars['String'];
};


export type QueryCheckNewPostsArgs = {
  date?: Maybe<Scalars['String']>;
};


export type QueryCheckNewPostsFavoritesFeedArgs = {
  date?: Maybe<Scalars['String']>;
};


export type QueryGetPostsByFiltersArgs = {
  limit: Scalars['Int'];
  filter: SearchPostsFilterArgs;
  clubId?: Maybe<Scalars['String']>;
  since?: Maybe<Scalars['String']>;
};


export type QueryGlobalSearchPostsArgs = {
  filter: GlobalSearchForPosts;
  limit: Scalars['Int'];
  since?: Maybe<Scalars['String']>;
};


export type QueryGetGuidedTourArgs = {
  tourComponent?: Maybe<Scalars['String']>;
  tourSource?: Maybe<TourSourceType>;
};


export type QueryGetGuidedTourListForAdminArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryIsFeatureVisibleArgs = {
  featureName?: Maybe<Scalars['String']>;
};


export type QueryGetListOfBadgesArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetBadgesOfUserArgs = {
  userId?: Maybe<Scalars['String']>;
};


export type QueryGetPostDetailsByIdArgs = {
  postId: Scalars['String'];
};


export type QueryGetMediaSignedUrlArgs = {
  media?: Maybe<Array<Maybe<SignedUrlMedia>>>;
};


export type QueryGetListOfWhatsNewArgs = {
  page: Scalars['Int'];
  limit: Scalars['Int'];
};


export type QueryGetWhatsNewArgs = {
  versionNo?: Maybe<Scalars['String']>;
  platformType?: Maybe<PlatformTypeForWhatsNew>;
};


export type QueryGetClubsByCategoryArgs = {
  clubCategoryId?: Maybe<Scalars['String']>;
};


export type QueryGetCategoryByIdArgs = {
  clubCategoryId?: Maybe<Scalars['String']>;
};


export type QueryGetAchievementDetailsArgs = {
  achievementType?: Maybe<Scalars['String']>;
  sourceOfClick?: Maybe<Scalars['String']>;
};


export type QueryGetBadgeFeedbackQuestionArgs = {
  badgeId?: Maybe<Scalars['String']>;
};


export type QueryGetBadgeFeedbackQuestionAdminArgs = {
  badgeId?: Maybe<Scalars['String']>;
};

export type ReferMsg = {
  __typename?: 'ReferMsg';
  url?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type RefreshToken = {
  refreshToken: Scalars['String'];
  deviceType?: Maybe<DeviceType>;
};

export type RepliesByComment = {
  __typename?: 'RepliesByComment';
  replies?: Maybe<Array<Maybe<Reply>>>;
  since?: Maybe<Scalars['String']>;
  hasMore?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<ErrorMessage>;
};

export type Reply = {
  __typename?: 'Reply';
  postId?: Maybe<Scalars['String']>;
  Post?: Maybe<Post>;
  replyId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  Comment?: Maybe<Comment>;
  text?: Maybe<Scalars['String']>;
  textV2?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<Media>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  isUpvoted?: Maybe<Scalars['Int']>;
  isDownvoted?: Maybe<Scalars['Int']>;
  /**
   * upvotes: [String]
   * downvotes: [String]
   */
  upvotecount?: Maybe<Scalars['Int']>;
  downvotecount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  linkPreview?: Maybe<LinkPreview>;
  userId?: Maybe<Scalars['String']>;
  User?: Maybe<User>;
  memberType?: Maybe<ClubMemberType>;
  isSuspected?: Maybe<Scalars['Int']>;
  isCheckedByCM?: Maybe<Scalars['Int']>;
  isEdited?: Maybe<Scalars['Boolean']>;
  editHistory?: Maybe<Array<Maybe<EditHistoryData>>>;
  membershipLevelOfCreator?: Maybe<Scalars['Int']>;
};

export type ReplyId = {
  postId: Scalars['String'];
  commentId: Scalars['String'];
  replyId: Scalars['String'];
};

export type ReplyInput = {
  postId: Scalars['String'];
  commentId: Scalars['String'];
  replyData: CommentData;
};

export type ReplyUpvoteDownVoteCountV2 = {
  __typename?: 'ReplyUpvoteDownVoteCountV2';
  success?: Maybe<Scalars['Boolean']>;
  upvotes?: Maybe<Scalars['Int']>;
  downvotes?: Maybe<Scalars['Int']>;
  reply?: Maybe<Reply>;
};

export type ReportData = {
  __typename?: 'ReportData';
  repId?: Maybe<Scalars['String']>;
  ReportId?: Maybe<Scalars['String']>;
  clubReportId?: Maybe<Scalars['String']>;
  reporter?: Maybe<User>;
  reportedBy?: Maybe<Scalars['String']>;
  reportedByBot?: Maybe<Scalars['Boolean']>;
  remark?: Maybe<Scalars['String']>;
  reportedOn?: Maybe<ReportedOn>;
  reportTime?: Maybe<Scalars['DateTime']>;
  reportType?: Maybe<ReportType>;
  Club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']>;
  Member?: Maybe<ClubMember>;
  memberId?: Maybe<Scalars['String']>;
  User?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  Post?: Maybe<Post>;
  postId?: Maybe<Scalars['String']>;
  Comment?: Maybe<Comment>;
  commentId?: Maybe<Scalars['String']>;
  Reply?: Maybe<Reply>;
  replyId?: Maybe<Scalars['String']>;
};

export type ReportDataListOutput = {
  __typename?: 'ReportDataListOutput';
  reportDataList?: Maybe<Array<Maybe<ReportData>>>;
  total?: Maybe<Scalars['Int']>;
};

export type ReportHistory = {
  __typename?: 'ReportHistory';
  ReportActionId?: Maybe<Scalars['String']>;
  SiteReport?: Maybe<SiteReport>;
  ReportId?: Maybe<Scalars['String']>;
  Admin?: Maybe<User>;
  adminId?: Maybe<Scalars['String']>;
  actionByBot?: Maybe<Scalars['Boolean']>;
  remark?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Maybe<Media>>>;
  ReportStatus: ReportStatus;
  HiddenStatus: HiddenStatus;
  SuspectedStatus: SuspectedStatus;
  SuspendedStatus: SuspendedStatus;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export enum ReportStatus {
  Resolved = 'Resolved',
  Rejected = 'Rejected',
  Pending = 'Pending'
}

export enum ReportStatusType {
  Resolved = 'Resolved',
  Rejected = 'Rejected',
  Pending = 'Pending',
  All = 'All'
}

export enum ReportType {
  Abusive = 'Abusive',
  Spam = 'Spam',
  Hateful = 'Hateful',
  Other = 'Other'
}

export enum ReportedByType {
  All = 'All',
  User = 'User',
  Bot = 'Bot'
}

export enum ReportedOn {
  Post = 'Post',
  Comment = 'Comment',
  Reply = 'Reply',
  User = 'User',
  Club = 'Club'
}

export enum ReportedOnType {
  Post = 'Post',
  Comment = 'Comment',
  Reply = 'Reply',
  User = 'User',
  Club = 'Club',
  All = 'All'
}

export type ResolveMembershipArgs = {
  clubId: Scalars['String'];
  memberId: Scalars['String'];
  membershipStatus: Status;
};

export enum ResolverType {
  Owner = 'Owner',
  Moderator = 'Moderator',
  Admin = 'Admin'
}

export type RestrictionDataForPremium = {
  __typename?: 'RestrictionDataForPremium';
  isPremium?: Maybe<Scalars['Boolean']>;
  isReferAndEarn?: Maybe<Scalars['Boolean']>;
  isPromotion?: Maybe<Scalars['Boolean']>;
  isViewOnly?: Maybe<Scalars['Boolean']>;
};

export type RestrictionModaLData = {
  __typename?: 'RestrictionModaLData';
  imageUrl?: Maybe<Scalars['String']>;
  imageUrl_dark?: Maybe<Scalars['String']>;
  cta?: Maybe<Cta>;
};

export type RestrictionModal = {
  __typename?: 'RestrictionModal';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  KNOW_MORE_URL?: Maybe<Scalars['String']>;
  iosImage_dark?: Maybe<Scalars['String']>;
  iosImage?: Maybe<Scalars['String']>;
  iosCtaText?: Maybe<Scalars['String']>;
  iosCtaUrl?: Maybe<Scalars['String']>;
  data?: Maybe<Array<Maybe<RestrictionModaLData>>>;
};

export type ScheduledJobs = {
  __typename?: 'ScheduledJobs';
  jobId?: Maybe<Scalars['String']>;
  jobToExecute: Scalars['String'];
  scheduleTime?: Maybe<Scalars['DateTime']>;
  scheduledBy?: Maybe<User>;
  scheduledById?: Maybe<Scalars['String']>;
  cancelledBy?: Maybe<User>;
  cancelledById?: Maybe<Scalars['String']>;
  isJobDone?: Maybe<Scalars['Boolean']>;
  isJobCancelled?: Maybe<Scalars['Boolean']>;
  isJobRunning?: Maybe<Scalars['Boolean']>;
  isJobFailed?: Maybe<Scalars['Boolean']>;
  jobStatus?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Search = {
  __typename?: 'Search';
  hashtag?: Maybe<HashTagSearch>;
  stock?: Maybe<StockSearch>;
  dollarTag?: Maybe<DollarTagSearch>;
  user?: Maybe<User>;
  club?: Maybe<Club>;
};

export type SearchFilter = {
  isVerified?: Maybe<Scalars['Boolean']>;
  isAutoFollowEnabled?: Maybe<Scalars['Boolean']>;
  greenTick?: Maybe<Scalars['Boolean']>;
  tick3?: Maybe<Scalars['Boolean']>;
};

export type SearchPostsFilterArgs = {
  userCreatorId?: Maybe<Scalars['String']>;
  mentions?: Maybe<MentionsFilters>;
};

export enum SearchType {
  All = 'All',
  User = 'User',
  Club = 'Club',
  Stock = 'Stock',
  Hashtag = 'Hashtag',
  DollarTag = 'DollarTag',
  DollarTagStock = 'DollarTagStock',
  DollarTagSector = 'DollarTagSector'
}

export type SecCat = {
  __typename?: 'SecCat';
  clubcategory?: Maybe<Array<Maybe<ClubCategoryOutput>>>;
  sectors?: Maybe<Array<Maybe<Sector>>>;
};

/** GraphQL Output Types */
export type Sector = {
  __typename?: 'Sector';
  sectorId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
};

export type SelectPollOptionArgs = {
  pollId?: Maybe<Scalars['String']>;
  optionId?: Maybe<Scalars['String']>;
};

export type SessionMisOutput = {
  __typename?: 'SessionMISOutput';
  dataHeaders?: Maybe<Array<Maybe<Scalars['String']>>>;
  dataValues?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']>>>>>;
};

export type SignUpMisInput = {
  startDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  signedURL?: Maybe<Scalars['String']>;
  error?: Maybe<Error>;
  uploadfilename?: Maybe<Scalars['String']>;
};

export type SignupUserInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userName: Scalars['String'];
  gender?: Maybe<Gender>;
  avatar?: Maybe<Scalars['String']>;
  externalImageUrl?: Maybe<Scalars['String']>;
  /** not used */
  email?: Maybe<Scalars['EmailAddress']>;
  password?: Maybe<Scalars['String']>;
};

export type SiteReport = {
  __typename?: 'SiteReport';
  ReportId?: Maybe<Scalars['String']>;
  ReportData?: Maybe<Array<Maybe<ReportData>>>;
  reportCount?: Maybe<Scalars['Int']>;
  spamcount?: Maybe<Scalars['Int']>;
  othercount?: Maybe<Scalars['Int']>;
  abusecount?: Maybe<Scalars['Int']>;
  hatefulcount?: Maybe<Scalars['Int']>;
  reportedUser?: Maybe<User>;
  reportedUserId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  reportedOn?: Maybe<ReportedOn>;
  reportedByBot?: Maybe<Scalars['Boolean']>;
  Club?: Maybe<Club>;
  clubId?: Maybe<Scalars['String']>;
  User?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  Post?: Maybe<Post>;
  postId?: Maybe<Scalars['String']>;
  Comment?: Maybe<Comment>;
  commentId?: Maybe<Scalars['String']>;
  Reply?: Maybe<Reply>;
  replyId?: Maybe<Scalars['String']>;
  status?: Maybe<ReportStatus>;
  lastReportedTime?: Maybe<Scalars['DateTime']>;
};

export type SiteReportOutput = {
  __typename?: 'SiteReportOutput';
  reports?: Maybe<Array<Maybe<SiteReport>>>;
  total?: Maybe<Scalars['Int']>;
};

export type SocialLoginUserInput = {
  token: Scalars['String'];
  provider: ExternalLoginProviderType;
  email?: Maybe<Scalars['String']>;
};

export enum Status {
  Resolved = 'Resolved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type Stock = {
  __typename?: 'Stock';
  securityId?: Maybe<Scalars['Int']>;
  stockName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['DateTime']>;
  sector?: Maybe<Sector>;
  nseListingId?: Maybe<Scalars['Int']>;
  bseListingId?: Maybe<Scalars['Int']>;
  alias?: Maybe<Scalars['String']>;
  postCount?: Maybe<Scalars['Int']>;
  isfollow?: Maybe<Scalars['Int']>;
  issubscribed?: Maybe<Scalars['Int']>;
  followers?: Maybe<Scalars['Int']>;
};

export type StockFeedOutput = {
  __typename?: 'StockFeedOutput';
  securityId?: Maybe<Scalars['String']>;
  stockName?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  nseListingId?: Maybe<Scalars['String']>;
  bseListingId?: Maybe<Scalars['String']>;
  isfollow?: Maybe<Scalars['Int']>;
};

export type StockSearch = {
  __typename?: 'StockSearch';
  stock?: Maybe<Stock>;
  followers?: Maybe<Scalars['Int']>;
};

export type SubscribeArgs = {
  id: Scalars['String'];
  entity: SubscribeEntity;
};

export enum SubscribeEntity {
  Stock = 'Stock',
  Hashtag = 'Hashtag',
  User = 'User',
  Club = 'Club',
  DollarTag = 'DollarTag'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** Comments Subscription */
  commentCreated?: Maybe<Comment>;
  /** Posts Subscription */
  postCreated?: Maybe<Post>;
  likeCreated?: Maybe<Post>;
  replyCreated?: Maybe<Comment>;
  postUpdated?: Maybe<Post>;
  replyUpdated?: Maybe<Comment>;
  /** counts */
  notificationCount: Scalars['Int'];
  newActivityCount: Scalars['Int'];
  notificationCreated?: Maybe<Notification>;
  changePricePull?: Maybe<NewPrice>;
  changePricePush?: Maybe<NewPrice>;
};


export type SubscriptionNotificationCountArgs = {
  userId: Scalars['String'];
};


export type SubscriptionNewActivityCountArgs = {
  userId: Scalars['String'];
};


export type SubscriptionNotificationCreatedArgs = {
  userId: Scalars['String'];
  type: Type;
};


export type SubscriptionChangePricePullArgs = {
  userId: Scalars['String'];
  securityIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};


export type SubscriptionChangePricePushArgs = {
  userId: Scalars['String'];
  securityIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type SummaryMisOutput = {
  __typename?: 'SummaryMISOutput';
  dataHeaders?: Maybe<Array<Maybe<Scalars['String']>>>;
  dataValues?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']>>>>>;
};

export type SuspectedEntities = {
  __typename?: 'SuspectedEntities';
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
  type?: Maybe<SuspectedEntityType>;
  isSuspected?: Maybe<Scalars['Int']>;
  User?: Maybe<User>;
  text?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export enum SuspectedEntityType {
  Post = 'post',
  Comment = 'comment',
  Reply = 'reply'
}

export enum SuspectedStatus {
  IsSuspected = 'isSuspected',
  IsUnsuspected = 'isUnsuspected'
}

export enum SuspendedStatus {
  IsSuspended = 'isSuspended',
  IsNotSuspended = 'isNotSuspended'
}

export type Tag = {
  __typename?: 'Tag';
  startIndex: Scalars['String'];
  endIndex: Scalars['String'];
  name: Scalars['String'];
  type: TagType;
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type TagInput = {
  startIndex: Scalars['Int'];
  endIndex: Scalars['Int'];
  name: Scalars['String'];
  type: TagType;
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/** Enums */
export enum TagType {
  StockTag = 'StockTag',
  HashTag = 'HashTag',
  UserTag = 'UserTag',
  DollarTag = 'DollarTag'
}

export type Tick3ListOutput = {
  __typename?: 'Tick3ListOutput';
  tick3List?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']>;
};

export type TicketCommentInput = {
  comment?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['String']>;
};

export type TicketInput = {
  Type: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  attachment?: Maybe<Scalars['String']>;
};

export type TourKeys = {
  __typename?: 'TourKeys';
  tourId?: Maybe<Scalars['String']>;
  tourComponent?: Maybe<Scalars['String']>;
  tourKey?: Maybe<Scalars['Float']>;
  tourDescription?: Maybe<Scalars['String']>;
};

export type TourKeysAdminOutput = {
  __typename?: 'TourKeysAdminOutput';
  tourData?: Maybe<Array<Maybe<TourKeys>>>;
  total?: Maybe<Scalars['Int']>;
};

export enum TourSourceType {
  Web = 'Web',
  App = 'App'
}

export type TrendingDollarTag = {
  __typename?: 'TrendingDollarTag';
  dollarTag?: Maybe<DollarTag>;
  userAvatars?: Maybe<Array<Maybe<Scalars['String']>>>;
  followers?: Maybe<Scalars['Int']>;
};

export type TrendingHashTag = {
  __typename?: 'TrendingHashTag';
  Hashtag?: Maybe<Hashtag>;
  userAvatars?: Maybe<Array<Maybe<Scalars['String']>>>;
  followers?: Maybe<Scalars['Int']>;
};

export type TrendingStocktag = {
  __typename?: 'TrendingStocktag';
  stock?: Maybe<Stock>;
  userAvatars?: Maybe<Array<Maybe<Scalars['String']>>>;
  followers?: Maybe<Scalars['Int']>;
};

export type UndoPollOptionArgs = {
  pollId?: Maybe<Scalars['String']>;
};

export type UpcomingEvents = {
  __typename?: 'UpcomingEvents';
  eventId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['MediaURI']>;
  ctaButtonText?: Maybe<Scalars['String']>;
  ctaButtonUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type UpcomingEventsList = {
  __typename?: 'UpcomingEventsList';
  eventId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['MediaURI']>;
  ctaButtonText?: Maybe<Scalars['String']>;
  ctaButtonUrl?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
};

export type UpdateAnalystDetailsArgs = {
  userId: Scalars['String'];
  analystBio?: Maybe<Scalars['String']>;
  qualification?: Maybe<Scalars['String']>;
  sebiCertificate?: Maybe<Scalars['String']>;
  experience?: Maybe<Scalars['String']>;
  specializes?: Maybe<Scalars['String']>;
  awards?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateClubArgs = {
  clubId: Scalars['String'];
  clubBio?: Maybe<Scalars['String']>;
  clubHandle?: Maybe<Scalars['String']>;
  clubName?: Maybe<Scalars['String']>;
  clubCategory?: Maybe<Array<Maybe<ClubCategories>>>;
  clubHeadline?: Maybe<Scalars['String']>;
  clubType?: Maybe<ClubType>;
};

export type UpdateCommentInput = {
  postId: Scalars['String'];
  commentId: Scalars['String'];
  commentData: CommentData;
};

export type UpdateImageArgs = {
  userId: Scalars['String'];
  avatar?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
};

export type UpdateMemberTypeArgs = {
  clubId: Scalars['String'];
  memberId: Scalars['String'];
  memberType: ClubMemberType;
};

export type UpdatePermissionsArgs = {
  clubId: Scalars['String'];
  memberId: Scalars['String'];
  permissions?: Maybe<Array<Maybe<Permissions>>>;
};

export type UpdatePostInput = {
  postId?: Maybe<Scalars['String']>;
  postData: PostInput;
};

export type UpdateReplyInput = {
  postId: Scalars['String'];
  commentId: Scalars['String'];
  replyId: Scalars['String'];
  replyData: CommentData;
};

export type UpdateUserSettings = {
  profileType?: Maybe<ProfileType>;
  isEmailPrivate?: Maybe<Scalars['Boolean']>;
  isPhonePrivate?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpvoteDownVoteCount = {
  __typename?: 'UpvoteDownVoteCount';
  success?: Maybe<Scalars['Boolean']>;
  upvotes?: Maybe<Scalars['Int']>;
  downvotes?: Maybe<Scalars['Int']>;
};

/** GraphQL Output Types */
export type User = {
  __typename?: 'User';
  id?: Maybe<Scalars['String']>;
  ga_secondary_id?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userLevel?: Maybe<Scalars['Int']>;
  userTags?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['MediaURI']>;
  avatarPostId?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['MediaURI']>;
  coverPostId?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  greenTick?: Maybe<Scalars['Boolean']>;
  tick3?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  facebookLink?: Maybe<Scalars['String']>;
  twitterLink?: Maybe<Scalars['String']>;
  youtubeLink?: Maybe<Scalars['String']>;
  linkedinLink?: Maybe<Scalars['String']>;
  profileType?: Maybe<ProfileType>;
  isEmailPrivate?: Maybe<Scalars['Boolean']>;
  isPhonePrivate?: Maybe<Scalars['Boolean']>;
  isfollow?: Maybe<Scalars['String']>;
  issubscribed?: Maybe<Scalars['Int']>;
  memberType?: Maybe<Scalars['String']>;
  reportCount?: Maybe<Scalars['Int']>;
  MembershipExpiryDate?: Maybe<Scalars['DateTime']>;
  watchlistVisibleStatus?: Maybe<Scalars['Boolean']>;
  signUpTime?: Maybe<Scalars['DateTime']>;
  showProductTour?: Maybe<Scalars['Boolean']>;
  showNps?: Maybe<Scalars['Boolean']>;
  showNpsV2?: Maybe<Scalars['Boolean']>;
  tickMarkedByAdmin?: Maybe<User>;
  tickMarkedByAdminId?: Maybe<Scalars['String']>;
  tickMarkedAt?: Maybe<Scalars['DateTime']>;
  tickUnmarkedByAdmin?: Maybe<User>;
  tickUnmarkedByAdminId?: Maybe<Scalars['String']>;
  tickRemovedAt?: Maybe<Scalars['DateTime']>;
  viewFeedPermission?: Maybe<ViewFeedPermission>;
  eventsTabLastVisited?: Maybe<Scalars['DateTime']>;
  isOnboarded?: Maybe<Scalars['Boolean']>;
  canBeOnboarded?: Maybe<Scalars['Boolean']>;
  typeOfContent?: Maybe<Array<Maybe<Scalars['String']>>>;
  followerCount?: Maybe<Scalars['Int']>;
  isUserDeleted?: Maybe<Scalars['Boolean']>;
  ImportantProfilePriority?: Maybe<Scalars['Int']>;
  membershipLevel?: Maybe<Scalars['Int']>;
  postCount?: Maybe<Scalars['Int']>;
  highlightedAchievements?: Maybe<Array<Maybe<HighlightedAchievements>>>;
};

export type UserAchievemtStatusData = {
  __typename?: 'UserAchievemtStatusData';
  data?: Maybe<Array<Maybe<UserAllAchievementStatus>>>;
  errorMessage?: Maybe<ErrorMessage>;
};

export type UserBadges = {
  __typename?: 'UserBadges';
  userBadgeId?: Maybe<Scalars['String']>;
  ownedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  Badges?: Maybe<Badges>;
  badgeId?: Maybe<Scalars['String']>;
  hasTurnedOffPromotion?: Maybe<Scalars['Boolean']>;
  sourceOfClick?: Maybe<Scalars['String']>;
  achievementType?: Maybe<Scalars['String']>;
};

export enum UserClubPermissionValues {
  CanPost = 'can_post',
  ViewPost = 'view_post',
  ChangeAvatar = 'change_avatar',
  ChangeCover = 'change_cover'
}

export type UserFeedOutput = {
  __typename?: 'UserFeedOutput';
  id?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['MediaURI']>;
  cover?: Maybe<Scalars['MediaURI']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  greenTick?: Maybe<Scalars['Boolean']>;
  tick3?: Maybe<Scalars['Boolean']>;
  profileType?: Maybe<Scalars['String']>;
  isfollow?: Maybe<Scalars['String']>;
  membershipLevel?: Maybe<Scalars['Int']>;
};

export type UserFollow = {
  __typename?: 'UserFollow';
  id?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  userLevel?: Maybe<Scalars['Int']>;
  userTags?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['MediaURI']>;
  cover?: Maybe<Scalars['MediaURI']>;
  birthday?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  facebookLink?: Maybe<Scalars['String']>;
  twitterLink?: Maybe<Scalars['String']>;
  youtubeLink?: Maybe<Scalars['String']>;
};

export enum UserHashtagContentType {
  Trader = 'Trader',
  Investor = 'Investor',
  Beginner = 'Beginner'
}

export type UserId = {
  userId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type UserImageArgs = {
  imageURL?: Maybe<Scalars['String']>;
  type?: Maybe<ImageType>;
};

export enum UserRecentSearchElementType {
  User = 'User',
  Club = 'Club',
  DollarTag = 'DollarTag',
  HashTag = 'HashTag'
}

export type UserRecentSearchInput = {
  searchElementId?: Maybe<Scalars['String']>;
  searchElementType?: Maybe<UserRecentSearchElementType>;
};

export type UserRecentSearchOutput = {
  __typename?: 'UserRecentSearchOutput';
  searchId?: Maybe<Scalars['String']>;
  User?: Maybe<User>;
  Club?: Maybe<Club>;
  Hashtag?: Maybe<Hashtag>;
  Dollartag?: Maybe<DollarTag>;
};

export type UserReportActionState = {
  __typename?: 'UserReportActionState';
  ReportId?: Maybe<Scalars['String']>;
  ReportStatus?: Maybe<ReportStatus>;
  SuspendedStatus?: Maybe<SuspendedStatus>;
};

export type UserSelectOption = {
  __typename?: 'UserSelectOption';
  userOptionId?: Maybe<Scalars['String']>;
  optionId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  pollId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserStreakData = {
  __typename?: 'UserStreakData';
  data?: Maybe<UserStreak>;
  errorMessage?: Maybe<ErrorMessage>;
};

export enum UserSubscriptionType {
  Followuser = 'followuser',
  Followstock = 'followstock',
  Followhash = 'followhash',
  ChangeCover = 'changeCover',
  ChangeAvatar = 'changeAvatar',
  JoinClub = 'joinClub',
  PostOnFollowedUser = 'postOnFollowedUser',
  Post = 'post',
  All = 'all'
}

export enum UserTypeForAdmin {
  Verified = 'verified',
  NonVerified = 'nonVerified',
  All = 'All',
  Tick3 = 'tick3',
  GreenTick = 'greenTick'
}

export type UserUpdateArgs = {
  bio?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  facebookLink?: Maybe<Scalars['String']>;
  twitterLink?: Maybe<Scalars['String']>;
  youtubeLink?: Maybe<Scalars['String']>;
  linkedinLink?: Maybe<Scalars['String']>;
  userTags?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type VersionControlSystem = {
  __typename?: 'VersionControlSystem';
  /** platformType: platform */
  versionId?: Maybe<Scalars['String']>;
  versionNo?: Maybe<Scalars['String']>;
  isForWeb?: Maybe<Scalars['Boolean']>;
  isForAndroid?: Maybe<Scalars['Boolean']>;
  isForIOS?: Maybe<Scalars['Boolean']>;
  isForBackend?: Maybe<Scalars['Boolean']>;
  isLatestVersionForWeb?: Maybe<Scalars['Boolean']>;
  isLatestVersionForAndroid?: Maybe<Scalars['Boolean']>;
  isLatestVersionForIOS?: Maybe<Scalars['Boolean']>;
  isLatestVersionForBackend?: Maybe<Scalars['Boolean']>;
  isReleasedForWeb?: Maybe<Scalars['Boolean']>;
  isReleasedForAndroid?: Maybe<Scalars['Boolean']>;
  isReleasedForIOS?: Maybe<Scalars['Boolean']>;
  isReleasedForBackend?: Maybe<Scalars['Boolean']>;
  isWebVersionForced?: Maybe<Scalars['Boolean']>;
  isAndroidVersionForced?: Maybe<Scalars['Boolean']>;
  isIOSVersionForced?: Maybe<Scalars['Boolean']>;
  isBackendVersionForced?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserID?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserID?: Maybe<Scalars['String']>;
  isVersionForced?: Maybe<Scalars['Boolean']>;
  releaseNoteIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ViewFeedPermission = {
  __typename?: 'ViewFeedPermission';
  canViewPost?: Maybe<Scalars['Boolean']>;
  canSeeMarketingPost?: Maybe<Scalars['Boolean']>;
};

export type Vote = {
  __typename?: 'Vote';
  voteId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
  User?: Maybe<User>;
  Post?: Maybe<Post>;
  Comment?: Maybe<Comment>;
  vote?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  membershipLevelOfVoter?: Maybe<Scalars['Int']>;
};

export type VoteInput = {
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
};

export type WhatsNew = {
  __typename?: 'WhatsNew';
  whatsNewId?: Maybe<Scalars['String']>;
  versionNo?: Maybe<Scalars['String']>;
  whatsNew?: Maybe<Array<Maybe<WhatsNewData>>>;
  isActive?: Maybe<Scalars['Boolean']>;
  platformType?: Maybe<Array<Maybe<PlatformTypeForWhatsNew>>>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type WhatsNewData = {
  __typename?: 'WhatsNewData';
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  subText?: Maybe<Scalars['String']>;
};

export type WhatsNewInput = {
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  subText?: Maybe<Scalars['String']>;
};

export type WhatsNewPlatform = {
  __typename?: 'WhatsNewPlatform';
  whatsNewId?: Maybe<Scalars['String']>;
  versionNo?: Maybe<Scalars['String']>;
  whatsNew?: Maybe<Array<Maybe<WhatsNewData>>>;
  isActive?: Maybe<Scalars['Boolean']>;
  platformType?: Maybe<Array<Maybe<PlatformTypeForWhatsNew>>>;
};

export type ZendeskSearchfilter = {
  ticketId?: Maybe<Scalars['Int']>;
  status?: Maybe<ZendeskStatus>;
  userId?: Maybe<Scalars['String']>;
};

export enum ZendeskStatus {
  All = 'all',
  New = 'new',
  Open = 'open',
  Pending = 'pending',
  Hold = 'hold',
  Solved = 'solved',
  Closed = 'closed'
}


export type ZendeskTicketList = {
  __typename?: 'ZendeskTicketList';
  total?: Maybe<Scalars['Int']>;
  tickets?: Maybe<Array<Maybe<Scalars['ZendeskTicketResponseModel']>>>;
};


export type ActivityFeedDetails = {
  __typename?: 'activityFeedDetails';
  data?: Maybe<Array<Maybe<ActivityFeed>>>;
  last_activityId?: Maybe<Scalars['Int']>;
};

export enum AdminType {
  Sales = 'Sales',
  Support = 'Support',
  SuperAdmin = 'SuperAdmin',
  Finanace = 'Finanace',
  Marketing = 'Marketing'
}

export type ClubCategoryOutput = {
  __typename?: 'clubCategoryOutput';
  categoryId?: Maybe<Scalars['Int']>;
  categoryName?: Maybe<Scalars['String']>;
};

export type ClubFeaturesOutput = {
  __typename?: 'clubFeaturesOutput';
  clubId?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ClubMemberCount = {
  __typename?: 'clubMemberCount';
  clubId?: Maybe<Scalars['String']>;
  memberCount?: Maybe<Scalars['Int']>;
  clubData?: Maybe<Club>;
};

export type ClubMemberPermissionArgs = {
  memberTypeName?: Maybe<Scalars['String']>;
  tickType?: Maybe<TickType>;
  permissions?: Maybe<ClubMemberPermissionsObj>;
};

export type ClubMemberPermissionsObj = {
  canPost?: Maybe<Scalars['Boolean']>;
  canViewPost?: Maybe<Scalars['Boolean']>;
  canEngage?: Maybe<Scalars['Boolean']>;
  canPropagatePost?: Maybe<Scalars['Boolean']>;
};

export type ClubPermissionType = {
  __typename?: 'clubPermissionType';
  canPost?: Maybe<Scalars['Boolean']>;
  canViewPost?: Maybe<Scalars['Boolean']>;
  canEngage?: Maybe<Scalars['Boolean']>;
  canPropagatePost?: Maybe<Scalars['Boolean']>;
};

export type ClubPermissionsAuthorizationDetails = {
  __typename?: 'clubPermissionsAuthorizationDetails';
  clubId?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<ClubPermissionsBasedOnMemberType>>>;
  club_permissions_token?: Maybe<Scalars['String']>;
};

export enum ClubPermissionsBasedOnMemberType {
  CanEngage = 'canEngage',
  CanPost = 'canPost',
  CanViewPost = 'canViewPost',
  CanPropagatePost = 'canPropagatePost'
}

export type ClubPostShareSettingScheme = {
  __typename?: 'clubPostShareSettingScheme';
  isVerifiedCanShare?: Maybe<Scalars['Boolean']>;
  greenTickCanShare?: Maybe<Scalars['Boolean']>;
  normalUserCanShare?: Maybe<Scalars['Boolean']>;
};

export type ClubReportData = {
  __typename?: 'clubReportData';
  pending?: Maybe<Scalars['Int']>;
  rejected?: Maybe<Scalars['Int']>;
  resolved?: Maybe<Scalars['Int']>;
};

export enum ClubSubscriptionType {
  ChangeAvatar = 'changeAvatar',
  ChangeCover = 'changeCover',
  Post = 'post',
  All = 'all'
}

export enum ComponentType {
  StockListForSmartFeed = 'stockListForSmartFeed',
  SectorListForSmartFeed = 'sectorListForSmartFeed',
  PromotionsForSmartFeed = 'promotionsForSmartFeed',
  ClubListForSmartFeed = 'clubListForSmartFeed',
  TopicListForSmartFeed = 'topicListForSmartFeed',
  PeopleListForSmartFeed = 'peopleListForSmartFeed',
  BadgePromotion = 'badgePromotion'
}

export type CreateOptionsArgs = {
  optionText?: Maybe<Scalars['String']>;
};

export type CreatePollArgs = {
  question?: Maybe<Scalars['String']>;
  expiryEnum?: Maybe<PollExpiryEnum>;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CronJobExecutionLogs = {
  __typename?: 'cronJobExecutionLogs';
  cronExecutionLogId?: Maybe<Scalars['String']>;
  nameOfCron?: Maybe<Scalars['String']>;
  isExecutionComplete?: Maybe<Scalars['Boolean']>;
  manuallyExecutedById?: Maybe<Scalars['String']>;
  manuallyExecutedBy?: Maybe<User>;
  jobExecutionId?: Maybe<Scalars['String']>;
  executionTimelapse?: Maybe<Scalars['Int']>;
  status?: Maybe<GetCronJobsStatusType>;
  /** data: any */
  startTime?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum DefaultMediaType {
  Cover = 'Cover',
  Avatar = 'Avatar',
  ClubAvatar = 'ClubAvatar',
  ClubCover = 'ClubCover'
}

export enum DollarTagEnum {
  Stock = 'Stock',
  Sector = 'Sector',
  Industry = 'Industry',
  MutualFund = 'Mutual_Fund'
}

export type EditClubAdminArgs = {
  clubName?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  cover?: Maybe<Scalars['String']>;
  clubBio?: Maybe<Scalars['String']>;
  clubHeadline?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  clubPriority?: Maybe<Scalars['Int']>;
  rule?: Maybe<Scalars['String']>;
  isAutoJoinable?: Maybe<Scalars['Boolean']>;
};

export type EditClubDetails = {
  __typename?: 'editClubDetails';
  getUpdatedClub?: Maybe<Club>;
  getUpdatedMemberTypePermissions?: Maybe<Array<Maybe<MemberTypeClubPermissionMap>>>;
};

export type FeatureToClubPermissionOutput = {
  __typename?: 'featureToClubPermissionOutput';
  permissions?: Maybe<Array<Maybe<PlatformPermissionFromFeatureTypes>>>;
  clubToken?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
};

export enum FilterComponentType {
  All = 'all',
  StockListForSmartFeed = 'stockListForSmartFeed',
  SectorListForSmartFeed = 'sectorListForSmartFeed',
  PromotionsForSmartFeed = 'promotionsForSmartFeed',
  ClubListForSmartFeed = 'clubListForSmartFeed',
  TopicListForSmartFeed = 'topicListForSmartFeed',
  PeopleListForSmartFeed = 'peopleListForSmartFeed',
  BadgePromotion = 'badgePromotion'
}

export enum FilterPlatformType {
  All = 'all',
  Web = 'web',
  Mobile = 'mobile'
}

export enum FilterType {
  AllCreators = 'allCreators',
  Bluetick = 'bluetick',
  Greentick = 'greentick',
  Goldentick = 'goldentick'
}

export type GetClubDetails = {
  __typename?: 'getClubDetails';
  getClub?: Maybe<ClubWithPermission>;
  getMemberTypePermissions?: Maybe<Array<Maybe<MemberTypeClubPermissionMap>>>;
};

export type GetCountOfReviews = {
  __typename?: 'getCountOfReviews';
  total?: Maybe<Scalars['Int']>;
  promoters?: Maybe<Scalars['Int']>;
  detractors?: Maybe<Scalars['Int']>;
  passive?: Maybe<Scalars['Int']>;
};

export type GetNpsOutput = {
  __typename?: 'getNpsOutput';
  total?: Maybe<Scalars['Int']>;
  npsOutput?: Maybe<Array<Maybe<Nps>>>;
};

export enum GetReportType {
  Abusive = 'Abusive',
  Spam = 'Spam',
  Hateful = 'Hateful',
  Other = 'Other',
  All = 'All'
}

export type GetUserCreatorTypeOfContentListOutput = {
  __typename?: 'getUserCreatorTypeOfContentListOutput';
  UserObjWithTypeOfContent?: Maybe<Array<Maybe<User>>>;
  total?: Maybe<Scalars['Int']>;
};

export type IsHidden = {
  __typename?: 'isHidden';
  isHidden?: Maybe<Scalars['Boolean']>;
};

export type MarkedUsersData = {
  __typename?: 'markedUsersData';
  bluetick?: Maybe<Array<Maybe<User>>>;
  greentick?: Maybe<Array<Maybe<User>>>;
  goldentick?: Maybe<Array<Maybe<User>>>;
};

export type MentionsFilters = {
  dollarTagMentioned?: Maybe<Scalars['Int']>;
  hashTagMentioned?: Maybe<Scalars['String']>;
};

export type MisForCreatorsData = {
  userId?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  filter?: Maybe<Array<Maybe<FilterType>>>;
  sort: SortOrder;
  sortType: SortType;
  skip: Scalars['Int'];
  take: Scalars['Int'];
};

export type MisForCreatorsOutput = {
  __typename?: 'misForCreatorsOutput';
  postId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  upvote?: Maybe<Scalars['Float']>;
  downvote?: Maybe<Scalars['Float']>;
  comment?: Maybe<Scalars['Float']>;
  reply?: Maybe<Scalars['Float']>;
  share?: Maybe<Scalars['Float']>;
  greentick?: Maybe<Scalars['Boolean']>;
  bluetick?: Maybe<Scalars['Boolean']>;
  goldentick?: Maybe<Scalars['Boolean']>;
  username?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['MediaURI']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  engagement?: Maybe<Scalars['Int']>;
  profileLink?: Maybe<Scalars['String']>;
  postLink?: Maybe<Scalars['String']>;
};

export type MisOutputForCreators = {
  __typename?: 'misOutputForCreators';
  Total?: Maybe<TotalData>;
  Data?: Maybe<Array<Maybe<MisForCreatorsOutput>>>;
};

export type MisTotalCount = {
  __typename?: 'misTotalCount';
  engagements?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  signUps?: Maybe<Scalars['Int']>;
  posts?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  comments?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  replies?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  sessions?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
  polls?: Maybe<Array<Maybe<MisOutputAdminPanel>>>;
};

export type NewPrice = {
  __typename?: 'newPrice';
  securityId?: Maybe<Scalars['Int']>;
  newPrice?: Maybe<Price>;
};

export type NpsData = {
  __typename?: 'npsData';
  start_date?: Maybe<Scalars['DateTime']>;
  end_date?: Maybe<Scalars['DateTime']>;
  total?: Maybe<Scalars['String']>;
};

export enum NpsReviewerCategory {
  Promoter = 'Promoter',
  Detractor = 'Detractor',
  Passive = 'Passive',
  All = 'All'
}

export type NpsTodayData = {
  __typename?: 'npsTodayData';
  count?: Maybe<Scalars['Int']>;
};

export type PendingJobs = {
  __typename?: 'pendingJobs';
  jobToExecute?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
};

export enum PlatformListEnum {
  Web = 'Web',
  Android = 'Android',
  Ios = 'IOS',
  Backend = 'Backend',
  All = 'All'
}

export enum PlatformType {
  Web = 'Web',
  Android = 'Android',
  Ios = 'IOS',
  Backend = 'Backend'
}

export enum PlatformTypeForInterstitial {
  Web = 'web',
  Mobile = 'mobile'
}

export enum PollExpiryEnum {
  OneDay = 'oneDay',
  ThreeDay = 'threeDay',
  OneWeek = 'oneWeek',
  ThreeWeek = 'threeWeek'
}

export type PopUp = {
  __typename?: 'popUp';
  popUpType?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  popUpDelay?: Maybe<Scalars['Int']>;
};

export type ReleaseNoteData = {
  text: Scalars['String'];
  type: ReleaseNotesTypes;
  isForWeb?: Maybe<Scalars['Boolean']>;
  isForAndroid?: Maybe<Scalars['Boolean']>;
  isForIOS?: Maybe<Scalars['Boolean']>;
};

export type ReleaseNoteEdit = {
  releaseNoteId?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  type: ReleaseNotesTypes;
  isDeleted: Scalars['Boolean'];
  isForWeb?: Maybe<Scalars['Boolean']>;
  isForAndroid?: Maybe<Scalars['Boolean']>;
  isForIOS?: Maybe<Scalars['Boolean']>;
};

export type ReleaseNoteOutput = {
  __typename?: 'releaseNoteOutput';
  releaseNoteId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<ReleaseNotesTypes>;
  isForWeb?: Maybe<Scalars['Boolean']>;
  isForAndroid?: Maybe<Scalars['Boolean']>;
  isForIOS?: Maybe<Scalars['Boolean']>;
};

export enum ReleaseNotesTypes {
  Feature = 'Feature',
  Bug = 'Bug',
  Enhancement = 'Enhancement'
}

export type ReportCount = {
  __typename?: 'reportCount';
  clubReportData?: Maybe<ClubReportData>;
  siteReportData?: Maybe<SiteReportData>;
};

export enum ScheduleJobStatus {
  Complete = 'complete',
  Cancelled = 'cancelled',
  Failed = 'failed',
  Pending = 'pending',
  Running = 'running',
  All = 'all'
}

export type SharedPostFeed = {
  __typename?: 'sharedPostFeed';
  postId: Scalars['String'];
  getPost?: Maybe<Post>;
  sharedPosts?: Maybe<Array<Maybe<Post>>>;
};

export type SignUpSummary = {
  __typename?: 'signUpSummary';
  date?: Maybe<Scalars['DateTime']>;
  count?: Maybe<Scalars['Int']>;
};

export type SignUpSummaryOutput = {
  __typename?: 'signUpSummaryOutput';
  totalCount?: Maybe<Scalars['Int']>;
  signUpSummaryData?: Maybe<Array<Maybe<SignUpSummary>>>;
};

export type SignedUrlMedia = {
  fileName?: Maybe<Scalars['String']>;
  MIME?: Maybe<Scalars['String']>;
};

export type SiteReportData = {
  __typename?: 'siteReportData';
  pending?: Maybe<Scalars['Int']>;
  rejected?: Maybe<Scalars['Int']>;
  resolved?: Maybe<Scalars['Int']>;
};

export enum SortOrder {
  Upvote = 'upvote',
  Downvote = 'downvote',
  Comment = 'comment',
  Reply = 'reply',
  Share = 'share'
}

export enum SortType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SourceEntityId {
  Number = 'number',
  String = 'string'
}

export type StreakDay = {
  __typename?: 'streakDay';
  dayName?: Maybe<Scalars['String']>;
  dayDate?: Maybe<Scalars['DateTime']>;
  hasVisited?: Maybe<Scalars['Boolean']>;
  visitedState?: Maybe<Scalars['String']>;
};

export type Subscriptions = {
  __typename?: 'subscriptions';
  users?: Maybe<Array<Maybe<User>>>;
  hashtags?: Maybe<Array<Maybe<Hashtag>>>;
  stocks?: Maybe<Array<Maybe<Stock>>>;
  clubs?: Maybe<Array<Maybe<Club>>>;
};

export enum TickType {
  IsVerified = 'isVerified',
  GreenTick = 'greenTick',
  Tick3 = 'tick3',
  Normal = 'normal'
}

export enum TickTypeForContent {
  IsVerified = 'isVerified',
  Tick3 = 'tick3',
  GreenTick = 'greenTick'
}

export type TotalData = {
  __typename?: 'totalData';
  post?: Maybe<Scalars['Float']>;
  upvote?: Maybe<Scalars['Float']>;
  downvote?: Maybe<Scalars['Float']>;
  comment?: Maybe<Scalars['Float']>;
  reply?: Maybe<Scalars['Float']>;
  share?: Maybe<Scalars['Float']>;
};

export type TurnAroundTime = {
  __typename?: 'turnAroundTime';
  postId?: Maybe<Scalars['String']>;
  postCreatedAt?: Maybe<Scalars['DateTime']>;
  commentCreatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  timeLapse?: Maybe<Scalars['Float']>;
};

export enum Type {
  Club = 'Club',
  Request = 'Request',
  Alert = 'Alert',
  All = 'All'
}

export type UniqueUsers = {
  __typename?: 'uniqueUsers';
  count?: Maybe<Scalars['Int']>;
};

export type UpdateExpiryArgs = {
  pollId?: Maybe<Scalars['String']>;
  expiryEnum?: Maybe<PollExpiryEnum>;
};

export type UserAllAchievementStatus = {
  __typename?: 'userAllAchievementStatus';
  achievementType?: Maybe<Scalars['String']>;
  achievementName?: Maybe<Scalars['String']>;
  milestoneData?: Maybe<Array<Maybe<MilestoneType>>>;
  data?: Maybe<Scalars['String']>;
};

export type UserCount = {
  __typename?: 'userCount';
  bluetick?: Maybe<Scalars['Int']>;
  greentick?: Maybe<Scalars['Int']>;
  goldentick?: Maybe<Scalars['Int']>;
  normal?: Maybe<Scalars['Int']>;
  all?: Maybe<Scalars['Int']>;
};

export type UserInfoFromIdp = {
  __typename?: 'userInfoFromIDP';
  isUserMemberOfStockEdgeClub?: Maybe<Scalars['Boolean']>;
  errorCode?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  interimToken?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  profileDetails?: Maybe<UserProfileDetailsFromIdp>;
  isViewOnly?: Maybe<Scalars['Boolean']>;
  platformPermissions?: Maybe<PlatformActionPermission>;
  canBeOnboarded?: Maybe<Scalars['Boolean']>;
};

export type UserProfileDetailsFromIdp = {
  __typename?: 'userProfileDetailsFromIDP';
  Id?: Maybe<Scalars['String']>;
  UserName?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  Firstname?: Maybe<Scalars['String']>;
  Lastname?: Maybe<Scalars['String']>;
  RegisteredOn?: Maybe<Scalars['String']>;
  Gender?: Maybe<Scalars['String']>;
  UserLevel?: Maybe<Scalars['String']>;
  IsInactive?: Maybe<Scalars['String']>;
  IsDeleted?: Maybe<Scalars['String']>;
  ImageFilePath?: Maybe<Scalars['String']>;
};

export type UserStreak = {
  __typename?: 'userStreak';
  userId?: Maybe<Scalars['String']>;
  weekData?: Maybe<Array<Maybe<WeekData>>>;
  hasStreakCompleted?: Maybe<Scalars['Boolean']>;
  prevStreak?: Maybe<Array<Maybe<WeekData>>>;
  hasStreakPopUpBeenSent?: Maybe<Scalars['Boolean']>;
};

export type UsersCount = {
  __typename?: 'usersCount';
  verifiedUsers?: Maybe<Scalars['Int']>;
  greenTickUsers?: Maybe<Scalars['Int']>;
  tick3Users?: Maybe<Scalars['Int']>;
  allUsers?: Maybe<Scalars['Int']>;
  normalUsers?: Maybe<Scalars['Int']>;
  tickUsers?: Maybe<Scalars['Int']>;
};

export type UsersCountBasedOnMembershipLevel = {
  __typename?: 'usersCountBasedOnMembershipLevel';
  MembershipLevel300?: Maybe<Scalars['Int']>;
  MembershipLevel200?: Maybe<Scalars['Int']>;
  MembershipLevel100?: Maybe<Scalars['Int']>;
  MembershipLevelNull?: Maybe<Scalars['Int']>;
};

export type UtilityFeaturesOutput = {
  __typename?: 'utilityFeaturesOutput';
  permission?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type VersionDataArgs = {
  isForWeb?: Maybe<Scalars['Boolean']>;
  isForAndroid?: Maybe<Scalars['Boolean']>;
  isForIOS?: Maybe<Scalars['Boolean']>;
  isForBackend?: Maybe<Scalars['Boolean']>;
  versionNo?: Maybe<Scalars['String']>;
  releaseNotes?: Maybe<Array<Maybe<ReleaseNoteData>>>;
};

export type VersionEdit = {
  versionId: Scalars['String'];
  versionNo: Scalars['String'];
  isForWeb: Scalars['Boolean'];
  isForAndroid: Scalars['Boolean'];
  isForIOS: Scalars['Boolean'];
  isForBackend?: Maybe<Scalars['Boolean']>;
  isLatestVersionForWeb: Scalars['Boolean'];
  isLatestVersionForAndroid: Scalars['Boolean'];
  isLatestVersionForIOS: Scalars['Boolean'];
  isLatestVersionForBackend?: Maybe<Scalars['Boolean']>;
  isReleasedForWeb: Scalars['Boolean'];
  isReleasedForAndroid: Scalars['Boolean'];
  isReleasedForIOS: Scalars['Boolean'];
  isReleasedForBackend?: Maybe<Scalars['Boolean']>;
  isWebVersionForced: Scalars['Boolean'];
  isAndroidVersionForced: Scalars['Boolean'];
  isIOSVersionForced: Scalars['Boolean'];
  isBackendVersionForced?: Maybe<Scalars['Boolean']>;
  releaseNotes: Array<Maybe<ReleaseNoteEdit>>;
};

export type VersionListOutput = {
  __typename?: 'versionListOutput';
  versionList?: Maybe<Array<Maybe<VersionControlSystem>>>;
  total?: Maybe<Scalars['Int']>;
};

export type VersionReleaseNotes = {
  __typename?: 'versionReleaseNotes';
  releaseNoteId?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<ReleaseNotesTypes>;
  isForWeb?: Maybe<Scalars['Boolean']>;
  isForAndroid?: Maybe<Scalars['Boolean']>;
  isForIOS?: Maybe<Scalars['Boolean']>;
};

export type WeekData = {
  __typename?: 'weekData';
  weekName?: Maybe<Scalars['String']>;
  days?: Maybe<Array<Maybe<StreakDay>>>;
  hasCompleted?: Maybe<Scalars['Boolean']>;
  currentWeekDayCount?: Maybe<Scalars['Int']>;
  hasWeekPopUpBeenSent?: Maybe<Scalars['Boolean']>;
  weekNumber?: Maybe<Scalars['Int']>;
  weekHeader?: Maybe<Scalars['String']>;
  weekHeaderMessage?: Maybe<Scalars['String']>;
  weekFooter?: Maybe<Scalars['String']>;
  weekDisplayName?: Maybe<Scalars['String']>;
  isCurrentWeek?: Maybe<Scalars['Boolean']>;
  isBrokenWeek?: Maybe<Scalars['Boolean']>;
};

export type ClubFieldsFragment = (
  { __typename?: 'Club' }
  & Pick<Club, 'clubId' | 'clubName' | 'clubHeadline' | 'clubHandle' | 'clubBio' | 'ownerId' | 'avatar' | 'cover' | 'ismember' | 'issubscribed' | 'totalMemberCount' | 'disclaimer' | 'showDisclaimer' | 'canJoinClub' | 'displayCategoryName'>
);

export type CommentFieldsFragment = (
  { __typename?: 'Comment' }
  & Pick<Comment, 'textV2' | 'commentId' | 'isUpvoted' | 'isDownvoted' | 'isSuspected' | 'upvotecount' | 'downvotecount' | 'replycount' | 'createdAt'>
  & { media?: Maybe<Array<Maybe<(
    { __typename?: 'Media' }
    & Pick<Media, 'type' | 'uri' | 'name'>
  )>>>, User?: Maybe<(
    { __typename?: 'User' }
    & UserFieldsFragment
  )> }
);

export type UpvoteDownvotePostFragment = (
  { __typename?: 'Post' }
  & Pick<Post, 'isUpvoted' | 'isDownvoted' | 'upvotecount' | 'downvotecount'>
);

export type UpdatePostFragment = (
  { __typename?: 'Post' }
  & Pick<Post, 'isUpvoted' | 'isDownvoted' | 'upvotecount' | 'downvotecount' | 'commentcount' | 'sharecount'>
);

export type BookmarkPostFragment = (
  { __typename?: 'Post' }
  & Pick<Post, 'isbookmarked'>
);

export type UpdateCommentFragment = (
  { __typename?: 'Comment' }
  & Pick<Comment, 'isUpvoted' | 'isDownvoted' | 'upvotecount' | 'downvotecount' | 'replycount'>
);

export type UpdateReplyFragment = (
  { __typename?: 'Reply' }
  & Pick<Reply, 'isUpvoted' | 'isDownvoted' | 'upvotecount' | 'downvotecount'>
);

export type DollarTagFieldsFragment = (
  { __typename?: 'DollarTag' }
  & Pick<DollarTag, 'dollarTagId' | 'dollarTagName' | 'slug' | 'dollarTagType' | 'sourceEntityId' | 'isfollow' | 'issubscribed' | 'followers' | 'postCount'>
);

export type HashTagFieldsFragment = (
  { __typename?: 'Hashtag' }
  & Pick<Hashtag, 'hashtagName' | 'postCount' | 'isfollow' | 'issubscribed' | 'followers'>
);

export type UpdatePollFragment = (
  { __typename?: 'Poll' }
  & Pick<Poll, 'votes' | 'hasUserSelected'>
  & { options?: Maybe<Array<Maybe<(
    { __typename?: 'Option' }
    & Pick<Option, 'optionId' | 'pollId' | 'optionText' | 'hasUserSelected' | 'votes'>
  )>>> }
);

export type StockFieldsFragment = (
  { __typename?: 'Stock' }
  & Pick<Stock, 'securityId' | 'stockName' | 'slug' | 'isfollow' | 'issubscribed'>
);

export type UpdateUserFragment = (
  { __typename?: 'User' }
  & Pick<User, 'isfollow' | 'issubscribed' | 'avatar' | 'cover' | 'profileType'>
);

export type UpdateStockFragment = (
  { __typename?: 'Stock' }
  & Pick<Stock, 'isfollow' | 'issubscribed' | 'followers'>
);

export type UpdateHashtagFragment = (
  { __typename?: 'Hashtag' }
  & Pick<Hashtag, 'isfollow' | 'issubscribed' | 'followers'>
);

export type UpdateClubFragment = (
  { __typename?: 'Club' }
  & Pick<Club, 'ismember' | 'issubscribed' | 'totalMemberCount'>
);

export type GetPollFieldsFragment = (
  { __typename?: 'Poll' }
  & Pick<Poll, 'pollId' | 'question' | 'userId' | 'postId' | 'createdAt' | 'updatedAt' | 'expiryEnum' | 'expiryDate' | 'hasUserSelected' | 'hasExpired' | 'votes'>
  & { options?: Maybe<Array<Maybe<(
    { __typename?: 'Option' }
    & Pick<Option, 'optionId' | 'pollId' | 'optionText' | 'hasUserSelected' | 'votes'>
  )>>> }
);

export type PostFieldsFragment = (
  { __typename?: 'Post' }
  & Pick<Post, 'postId' | 'textV2' | 'hasPoll' | 'createdAt' | 'upvotecount' | 'downvotecount' | 'sharecount' | 'commentcount' | 'isUpvoted' | 'isDownvoted' | 'isbookmarked' | 'isSuspected' | 'isEdited' | 'isFollowed' | 'sharePostId'>
  & { User?: Maybe<(
    { __typename?: 'User' }
    & UserFieldsFragment
  )>, Club?: Maybe<(
    { __typename?: 'Club' }
    & Pick<Club, 'clubId' | 'clubHandle' | 'clubName' | 'canJoinClub' | 'showDisclaimer' | 'disclaimer'>
  )>, media?: Maybe<Array<Maybe<(
    { __typename?: 'Media' }
    & Pick<Media, 'type' | 'uri' | 'name' | 'height' | 'width' | 'rotation'>
  )>>>, getPoll?: Maybe<(
    { __typename?: 'Poll' }
    & GetPollFieldsFragment
  )>, getSharedPost?: Maybe<(
    { __typename?: 'Post' }
    & GetSharedPostFieldsFragment
  )>, clubPostShareSetting?: Maybe<(
    { __typename?: 'clubPostShareSettingScheme' }
    & Pick<ClubPostShareSettingScheme, 'isVerifiedCanShare' | 'greenTickCanShare' | 'normalUserCanShare'>
  )>, meta?: Maybe<(
    { __typename?: 'Meta' }
    & Pick<Meta, 'isCover' | 'isAvatar'>
  )> }
);

export type ReplyFieldsFragment = (
  { __typename?: 'Reply' }
  & Pick<Reply, 'textV2' | 'replyId' | 'isUpvoted' | 'isDownvoted' | 'isSuspected' | 'createdAt' | 'upvotecount' | 'downvotecount'>
  & { media?: Maybe<Array<Maybe<(
    { __typename?: 'Media' }
    & Pick<Media, 'type' | 'uri' | 'name'>
  )>>>, User?: Maybe<(
    { __typename?: 'User' }
    & UserFieldsFragment
  )> }
);

export type GetSharedPostFieldsFragment = (
  { __typename?: 'Post' }
  & Pick<Post, 'postId' | 'textV2' | 'hasPoll' | 'createdAt' | 'isSuspected'>
  & { User?: Maybe<(
    { __typename?: 'User' }
    & UserFieldsFragment
  )>, Club?: Maybe<(
    { __typename?: 'Club' }
    & Pick<Club, 'clubId' | 'clubHandle' | 'clubName'>
  )>, media?: Maybe<Array<Maybe<(
    { __typename?: 'Media' }
    & Pick<Media, 'type' | 'uri' | 'name' | 'height' | 'width' | 'rotation'>
  )>>>, getPoll?: Maybe<(
    { __typename?: 'Poll' }
    & GetPollFieldsFragment
  )>, clubPostShareSetting?: Maybe<(
    { __typename?: 'clubPostShareSettingScheme' }
    & Pick<ClubPostShareSettingScheme, 'isVerifiedCanShare' | 'greenTickCanShare' | 'normalUserCanShare'>
  )> }
);

export type UserFieldsFragment = (
  { __typename?: 'User' }
  & Pick<User, 'id' | 'firstName' | 'lastName' | 'username' | 'avatar' | 'isVerified' | 'greenTick' | 'tick3' | 'isUserDeleted' | 'membershipLevel'>
);

export type SEsignupViaOidc_V2MutationVariables = Exact<{
  data: SignupUserInput;
  interimToken: Scalars['String'];
  AcceptTerms?: Maybe<Scalars['Boolean']>;
}>;


export type SEsignupViaOidc_V2Mutation = (
  { __typename?: 'Mutation' }
  & { SEsignupViaOIDC_V2: (
    { __typename?: 'userInfoFromIDP' }
    & Pick<UserInfoFromIdp, 'isUserMemberOfStockEdgeClub' | 'error' | 'isViewOnly'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'username' | 'showNpsV2' | 'canBeOnboarded'>
    )>, profileDetails?: Maybe<(
      { __typename?: 'userProfileDetailsFromIDP' }
      & Pick<UserProfileDetailsFromIdp, 'Id' | 'UserName' | 'Email' | 'Firstname' | 'Lastname' | 'RegisteredOn' | 'Gender' | 'ImageFilePath'>
    )> }
  ) }
);

export type AccountSyncMutationVariables = Exact<{ [key: string]: never; }>;


export type AccountSyncMutation = (
  { __typename?: 'Mutation' }
  & { accountSync?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type AddNotificationTokenMutationVariables = Exact<{
  notificationToken?: Maybe<Scalars['String']>;
  deviceType?: Maybe<DeviceType>;
}>;


export type AddNotificationTokenMutation = (
  { __typename?: 'Mutation' }
  & { addNotificationToken: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type AddBadgeJourneyFeedbackMutationVariables = Exact<{
  questionResponse?: Maybe<Array<Maybe<FeedbackQuestionResponseInput>> | Maybe<FeedbackQuestionResponseInput>>;
}>;


export type AddBadgeJourneyFeedbackMutation = (
  { __typename?: 'Mutation' }
  & { addBadgeJourneyFeedback?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type AddGuidedTourStatusForUserMutationVariables = Exact<{
  visitedTourKeys?: Maybe<Array<Maybe<Scalars['Float']>> | Maybe<Scalars['Float']>>;
  tourComponent?: Maybe<Scalars['String']>;
  tourSource?: Maybe<TourSourceType>;
}>;


export type AddGuidedTourStatusForUserMutation = (
  { __typename?: 'Mutation' }
  & { addGuidedTourStatusForUser?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type AddNpsRatingForWebMutationVariables = Exact<{
  rating?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  RecaptchaToken: Scalars['String'];
  platformType: DeviceType;
}>;


export type AddNpsRatingForWebMutation = (
  { __typename?: 'Mutation' }
  & { addNpsRatingForWeb?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type BlockUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type BlockUserMutation = (
  { __typename?: 'Mutation' }
  & { blockUser: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  ) }
);

export type CancelFollowMutationVariables = Exact<{
  data?: Maybe<FollowArgs>;
}>;


export type CancelFollowMutation = (
  { __typename?: 'Mutation' }
  & { cancelFollow: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type CreateBookmarkMutationVariables = Exact<{
  data: CreateBookmark;
}>;


export type CreateBookmarkMutation = (
  { __typename?: 'Mutation' }
  & { createBookmark?: Maybe<(
    { __typename?: 'Bookmark' }
    & Pick<Bookmark, 'postId' | 'userId' | 'timestamp'>
  )> }
);

export type CreateFeedbackMutationVariables = Exact<{
  data?: Maybe<FeedbackInput>;
}>;


export type CreateFeedbackMutation = (
  { __typename?: 'Mutation' }
  & { createFeedback?: Maybe<(
    { __typename?: 'Feedback' }
    & Pick<Feedback, 'feedbackId' | 'type' | 'subject' | 'comment' | 'status'>
    & { attachment?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'type' | 'uri' | 'name'>
    )> }
  )> }
);

export type CreatePostMutationVariables = Exact<{
  data: PostInput;
}>;


export type CreatePostMutation = (
  { __typename?: 'Mutation' }
  & { createPostAsync: (
    { __typename?: 'Post' }
    & Pick<Post, 'postId'>
  ) }
);

export type CreateCommentV2MutationVariables = Exact<{
  data?: Maybe<CommentInput>;
  clubId?: Maybe<Scalars['String']>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
}>;


export type CreateCommentV2Mutation = (
  { __typename?: 'Mutation' }
  & { createCommentV2: (
    { __typename?: 'Comment' }
    & { replies?: Maybe<Array<Maybe<(
      { __typename?: 'Reply' }
      & ReplyFieldsFragment
    )>>> }
    & CommentFieldsFragment
  ) }
);

export type CreatePostV2MutationVariables = Exact<{
  data?: Maybe<PostInput>;
}>;


export type CreatePostV2Mutation = (
  { __typename?: 'Mutation' }
  & { createPostV2: (
    { __typename?: 'Post' }
    & Pick<Post, 'postId'>
  ) }
);

export type CreateReplyV2MutationVariables = Exact<{
  data?: Maybe<ReplyInput>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
}>;


export type CreateReplyV2Mutation = (
  { __typename?: 'Mutation' }
  & { createReplyV2: (
    { __typename?: 'Reply' }
    & ReplyFieldsFragment
  ) }
);

export type CreateReportMutationVariables = Exact<{
  data?: Maybe<CreateReportInput>;
}>;


export type CreateReportMutation = (
  { __typename?: 'Mutation' }
  & { createReport?: Maybe<(
    { __typename?: 'ReportData' }
    & Pick<ReportData, 'repId' | 'ReportId' | 'remark' | 'reportedBy' | 'reportedOn' | 'reportTime' | 'reportType'>
    & { reporter?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'username'>
    )>, Post?: Maybe<(
      { __typename?: 'Post' }
      & Pick<Post, 'postId' | 'text'>
    )>, Comment?: Maybe<(
      { __typename?: 'Comment' }
      & Pick<Comment, 'commentId' | 'text'>
    )>, Reply?: Maybe<(
      { __typename?: 'Reply' }
      & Pick<Reply, 'replyId' | 'text'>
    )> }
  )> }
);

export type CreateZendeskTicketMutationVariables = Exact<{
  data?: Maybe<TicketInput>;
}>;


export type CreateZendeskTicketMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createZendeskTicket'>
);

export type CreateZendeskTicketCommentMutationVariables = Exact<{
  data?: Maybe<TicketCommentInput>;
  ticketId: Scalars['Int'];
}>;


export type CreateZendeskTicketCommentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createZendeskTicketComment'>
);

export type DeleteCommentMutationVariables = Exact<{
  data?: Maybe<CommentId>;
  clubId?: Maybe<Scalars['String']>;
}>;


export type DeleteCommentMutation = (
  { __typename?: 'Mutation' }
  & { deleteComment: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type DeletePostMutationVariables = Exact<{
  data?: Maybe<DeletePostInput>;
  clubId?: Maybe<Scalars['String']>;
}>;


export type DeletePostMutation = (
  { __typename?: 'Mutation' }
  & { deletePost: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type DeleteReplyMutationVariables = Exact<{
  data?: Maybe<ReplyId>;
  clubId?: Maybe<Scalars['String']>;
}>;


export type DeleteReplyMutation = (
  { __typename?: 'Mutation' }
  & { deleteReply: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type DollarFollowMutationVariables = Exact<{
  dollarTagId: Scalars['String'];
}>;


export type DollarFollowMutation = (
  { __typename?: 'Mutation' }
  & { dollarFollow?: Maybe<(
    { __typename?: 'DollarTag' }
    & Pick<DollarTag, 'dollarTagId' | 'isfollow' | 'issubscribed' | 'followers'>
  )> }
);

export type DollarSubscribeMutationVariables = Exact<{
  dollarTagId: Scalars['String'];
}>;


export type DollarSubscribeMutation = (
  { __typename?: 'Mutation' }
  & { dollarSubscribe?: Maybe<(
    { __typename?: 'DollarTag' }
    & Pick<DollarTag, 'dollarTagId' | 'isfollow' | 'issubscribed' | 'followers'>
  )> }
);

export type DollarUnfollowMutationVariables = Exact<{
  dollarTagId: Scalars['String'];
}>;


export type DollarUnfollowMutation = (
  { __typename?: 'Mutation' }
  & { dollarUnfollow?: Maybe<(
    { __typename?: 'DollarTag' }
    & Pick<DollarTag, 'dollarTagId' | 'isfollow' | 'issubscribed' | 'followers'>
  )> }
);

export type DollarUnsubscribeMutationVariables = Exact<{
  dollarTagId: Scalars['String'];
}>;


export type DollarUnsubscribeMutation = (
  { __typename?: 'Mutation' }
  & { dollarUnsubscribe?: Maybe<(
    { __typename?: 'DollarTag' }
    & Pick<DollarTag, 'dollarTagId' | 'isfollow' | 'issubscribed' | 'followers'>
  )> }
);

export type DownvoteMutationVariables = Exact<{
  data?: Maybe<VoteInput>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
}>;


export type DownvoteMutation = (
  { __typename?: 'Mutation' }
  & { downvote: (
    { __typename?: 'UpvoteDownVoteCount' }
    & Pick<UpvoteDownVoteCount, 'success' | 'upvotes' | 'downvotes'>
  ) }
);

export type FollowUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type FollowUserMutation = (
  { __typename?: 'Mutation' }
  & { follow: (
    { __typename?: 'FollowOutput' }
    & Pick<FollowOutput, 'success'>
  ) }
);

export type FollowMutationVariables = Exact<{
  data?: Maybe<FollowArgs>;
}>;


export type FollowMutation = (
  { __typename?: 'Mutation' }
  & { follow: (
    { __typename?: 'FollowOutput' }
    & Pick<FollowOutput, 'success' | 'followStatus'>
  ) }
);

export type FollowPostMutationVariables = Exact<{
  data: FollowPostInput;
}>;


export type FollowPostMutation = (
  { __typename?: 'Mutation' }
  & { followPost?: Maybe<(
    { __typename?: 'FolowPostOutput' }
    & Pick<FolowPostOutput, 'message'>
    & { post?: Maybe<(
      { __typename?: 'Post' }
      & Pick<Post, 'postId' | 'isFollowed'>
    )> }
  )> }
);

export type HasSeenPopUpMutationVariables = Exact<{
  popUpType?: Maybe<Scalars['String']>;
}>;


export type HasSeenPopUpMutation = (
  { __typename?: 'Mutation' }
  & { hasSeenPopUp?: Maybe<(
    { __typename?: 'PopUpSeen' }
    & { success?: Maybe<(
      { __typename?: 'IsSuccess' }
      & Pick<IsSuccess, 'success' | 'message'>
    )> }
  )> }
);

export type IgnoreNpsRatingMutationVariables = Exact<{
  source?: Maybe<NpsIgnoreSource>;
}>;


export type IgnoreNpsRatingMutation = (
  { __typename?: 'Mutation' }
  & { ignoreNpsRating?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type JoinClubMutationVariables = Exact<{
  data: JoinClubArgs;
}>;


export type JoinClubMutation = (
  { __typename?: 'Mutation' }
  & { joinClub?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  )> }
);

export type LeaveClubMutationVariables = Exact<{
  data: ClubInput;
}>;


export type LeaveClubMutation = (
  { __typename?: 'Mutation' }
  & { leaveClub?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  )> }
);

export type LoginWithOidc_V2MutationVariables = Exact<{
  accessToken: Scalars['String'];
}>;


export type LoginWithOidc_V2Mutation = (
  { __typename?: 'Mutation' }
  & { loginWithOIDC_V2?: Maybe<(
    { __typename?: 'userInfoFromIDP' }
    & Pick<UserInfoFromIdp, 'isUserMemberOfStockEdgeClub' | 'error' | 'interimToken' | 'isViewOnly'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'username' | 'showNpsV2' | 'canBeOnboarded'>
    )>, profileDetails?: Maybe<(
      { __typename?: 'userProfileDetailsFromIDP' }
      & Pick<UserProfileDetailsFromIdp, 'Id' | 'UserName' | 'Email' | 'Firstname' | 'Lastname' | 'RegisteredOn' | 'Gender' | 'ImageFilePath'>
    )> }
  )> }
);

export type LogoutMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'logout'>
);

export type MarkAsPinPostMutationVariables = Exact<{
  postId?: Maybe<Scalars['String']>;
}>;


export type MarkAsPinPostMutation = (
  { __typename?: 'Mutation' }
  & { markAsPinPost?: Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, 'isPinned'>
    & PostFieldsFragment
  )> }
);

export type OnboardUserMutationVariables = Exact<{
  typeOfUserByUserpreference?: Maybe<UserHashtagContentType>;
  dollarTagIds?: Maybe<Array<Maybe<Scalars['Int']>> | Maybe<Scalars['Int']>>;
  hashtagName?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
  skipOnboarding?: Maybe<Scalars['Boolean']>;
}>;


export type OnboardUserMutation = (
  { __typename?: 'Mutation' }
  & { onboardUser?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type ReadAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllNotificationsMutation = (
  { __typename?: 'Mutation' }
  & { readAllNotifications?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type ReadNotificationMutationVariables = Exact<{
  notificationId?: Maybe<Scalars['String']>;
}>;


export type ReadNotificationMutation = (
  { __typename?: 'Mutation' }
  & { readNotification?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type RemoveBookmarkMutationVariables = Exact<{
  data?: Maybe<CreateBookmark>;
}>;


export type RemoveBookmarkMutation = (
  { __typename?: 'Mutation' }
  & { removeBookmark?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  )> }
);

export type RemoveDownvoteMutationVariables = Exact<{
  data?: Maybe<VoteInput>;
  clubId?: Maybe<Scalars['String']>;
}>;


export type RemoveDownvoteMutation = (
  { __typename?: 'Mutation' }
  & { removeDownvote: (
    { __typename?: 'UpvoteDownVoteCount' }
    & Pick<UpvoteDownVoteCount, 'success' | 'upvotes' | 'downvotes'>
  ) }
);

export type RemoveUpvoteMutationVariables = Exact<{
  data?: Maybe<VoteInput>;
  clubId?: Maybe<Scalars['String']>;
}>;


export type RemoveUpvoteMutation = (
  { __typename?: 'Mutation' }
  & { removeUpvote: (
    { __typename?: 'UpvoteDownVoteCount' }
    & Pick<UpvoteDownVoteCount, 'success' | 'upvotes' | 'downvotes'>
  ) }
);

export type ResolveFollowMutationVariables = Exact<{
  followerId?: Maybe<Scalars['String']>;
  type?: Maybe<FollowStatus>;
}>;


export type ResolveFollowMutation = (
  { __typename?: 'Mutation' }
  & { resolveFollow: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type SelectPollOptionMutationVariables = Exact<{
  data?: Maybe<SelectPollOptionArgs>;
}>;


export type SelectPollOptionMutation = (
  { __typename?: 'Mutation' }
  & { selectPollOption?: Maybe<Array<Maybe<(
    { __typename?: 'Option' }
    & Pick<Option, 'optionId' | 'pollId' | 'optionText' | 'hasUserSelected' | 'votes'>
  )>>> }
);

export type SharePostV3MutationVariables = Exact<{
  data: PostInput;
}>;


export type SharePostV3Mutation = (
  { __typename?: 'Mutation' }
  & { sharePostV3: (
    { __typename?: 'Post' }
    & Pick<Post, 'postId'>
  ) }
);

export type SubscribeClubMutationVariables = Exact<{
  subscribeTo: ClubSubscriptionType;
  clubId: Scalars['String'];
}>;


export type SubscribeClubMutation = (
  { __typename?: 'Mutation' }
  & { subscribeClub: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type SubscribeMutationVariables = Exact<{
  data?: Maybe<FollowArgs>;
}>;


export type SubscribeMutation = (
  { __typename?: 'Mutation' }
  & { subscribe: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type ToggleIsWatchlistVisibleMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleIsWatchlistVisibleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'toggleIsWatchlistVisible'>
);

export type TurnOffHighlightForAchievementMutationVariables = Exact<{
  achievementType?: Maybe<Scalars['String']>;
}>;


export type TurnOffHighlightForAchievementMutation = (
  { __typename?: 'Mutation' }
  & { turnOffHighlightForAchievement?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type TurnOffNotificationByTypeOfNotificationMutationVariables = Exact<{
  notificationId?: Maybe<Scalars['String']>;
}>;


export type TurnOffNotificationByTypeOfNotificationMutation = (
  { __typename?: 'Mutation' }
  & { turnOffNotificationByTypeOfNotification?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type UnPinPostMutationVariables = Exact<{
  postId?: Maybe<Scalars['String']>;
}>;


export type UnPinPostMutation = (
  { __typename?: 'Mutation' }
  & { unPinPost?: Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, 'isPinned'>
    & PostFieldsFragment
  )> }
);

export type UnblockUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UnblockUserMutation = (
  { __typename?: 'Mutation' }
  & { unblockUser: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  ) }
);

export type UnfollowUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UnfollowUserMutation = (
  { __typename?: 'Mutation' }
  & { unfollow: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type UnfollowMutationVariables = Exact<{
  data?: Maybe<FollowArgs>;
}>;


export type UnfollowMutation = (
  { __typename?: 'Mutation' }
  & { unfollow: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type UnfollowPostMutationVariables = Exact<{
  data: FollowPostInput;
}>;


export type UnfollowPostMutation = (
  { __typename?: 'Mutation' }
  & { unfollowPost?: Maybe<(
    { __typename?: 'FolowPostOutput' }
    & Pick<FolowPostOutput, 'message'>
    & { post?: Maybe<(
      { __typename?: 'Post' }
      & Pick<Post, 'postId' | 'isFollowed'>
    )> }
  )> }
);

export type UnreadNotificationMutationVariables = Exact<{
  notificationId?: Maybe<Scalars['String']>;
}>;


export type UnreadNotificationMutation = (
  { __typename?: 'Mutation' }
  & { unreadNotification?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success' | 'message'>
  )> }
);

export type UnsubscribeClubMutationVariables = Exact<{
  unsubscribeTo: ClubSubscriptionType;
  clubId: Scalars['String'];
}>;


export type UnsubscribeClubMutation = (
  { __typename?: 'Mutation' }
  & { unsubscribeClub: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type UnsubscribeMutationVariables = Exact<{
  data?: Maybe<FollowArgs>;
}>;


export type UnsubscribeMutation = (
  { __typename?: 'Mutation' }
  & { unsubscribe: (
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  ) }
);

export type UpdateUserSettingsMutationVariables = Exact<{
  data: UpdateUserSettings;
}>;


export type UpdateUserSettingsMutation = (
  { __typename?: 'Mutation' }
  & { updateUserSettings?: Maybe<(
    { __typename?: 'ProfileSettings' }
    & Pick<ProfileSettings, 'profileType'>
  )> }
);

export type UpdateUserMutationVariables = Exact<{
  data: UserUpdateArgs;
}>;


export type UpdateUserMutation = (
  { __typename?: 'Mutation' }
  & { updateUser?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'username' | 'firstName' | 'lastName' | 'bio'>
  )> }
);

export type UpdatePostMutationVariables = Exact<{
  data?: Maybe<UpdatePostInput>;
}>;


export type UpdatePostMutation = (
  { __typename?: 'Mutation' }
  & { updatePost: (
    { __typename?: 'Post' }
    & Pick<Post, 'postId' | 'textV2' | 'isEdited'>
    & { media?: Maybe<Array<Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'type' | 'uri' | 'name' | 'height' | 'width' | 'rotation'>
    )>>> }
  ) }
);

export type UpdateUserImageMutationVariables = Exact<{
  data: UserImageArgs;
}>;


export type UpdateUserImageMutation = (
  { __typename?: 'Mutation' }
  & { updateUserImage?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  )> }
);

export type UpvoteMutationVariables = Exact<{
  data?: Maybe<VoteInput>;
  clubBasedPermissionToken?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
}>;


export type UpvoteMutation = (
  { __typename?: 'Mutation' }
  & { upvote: (
    { __typename?: 'UpvoteDownVoteCount' }
    & Pick<UpvoteDownVoteCount, 'success' | 'upvotes' | 'downvotes'>
  ) }
);

export type CheckNewPostsQueryVariables = Exact<{
  date?: Maybe<Scalars['String']>;
}>;


export type CheckNewPostsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'checkNewPosts'>
);

export type CheckNewPostsFavoritesFeedQueryVariables = Exact<{
  date?: Maybe<Scalars['String']>;
}>;


export type CheckNewPostsFavoritesFeedQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'checkNewPostsFavoritesFeed'>
);

export type CheckPermissionQueryVariables = Exact<{
  clubId: Scalars['String'];
  Action: UserClubPermissionValues;
}>;


export type CheckPermissionQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'checkPermission'>
);

export type GetMemberCountQueryVariables = Exact<{
  clubId: Scalars['String'];
}>;


export type GetMemberCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getMemberCount'>
);

export type ClubsQueryVariables = Exact<{
  userId: Scalars['String'];
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
  entitlement?: Maybe<Scalars['Boolean']>;
}>;


export type ClubsQuery = (
  { __typename?: 'Query' }
  & { getClubsOfUser?: Maybe<Array<Maybe<(
    { __typename?: 'Club' }
    & ClubFieldsFragment
  )>>> }
);

export type CountsQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CountsQuery = (
  { __typename?: 'Query' }
  & { clubs: Query['getClubsOfUserCount'], followers: Query['getFollowersCount'], followings: Query['getFollowingsCount'] }
);

export type FeedPostsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type FeedPostsQuery = (
  { __typename?: 'Query' }
  & { getFeedPosts: Array<Maybe<(
    { __typename?: 'ActivityFeed' }
    & Pick<ActivityFeed, 'actId' | 'activityId' | 'activityType' | 'createdAt' | 'avatar' | 'cover'>
    & { user?: Maybe<(
      { __typename?: 'UserFeedOutput' }
      & Pick<UserFeedOutput, 'id' | 'firstName' | 'lastName' | 'avatar' | 'cover' | 'username' | 'isVerified' | 'greenTick' | 'tick3' | 'profileType'>
    )>, followingUser?: Maybe<(
      { __typename?: 'UserFeedOutput' }
      & Pick<UserFeedOutput, 'id' | 'firstName' | 'lastName' | 'username' | 'avatar' | 'cover' | 'isVerified' | 'greenTick' | 'tick3' | 'profileType'>
    )>, club?: Maybe<(
      { __typename?: 'ClubFeedOutput' }
      & Pick<ClubFeedOutput, 'clubId' | 'clubHandle' | 'avatar' | 'cover' | 'clubName'>
    )>, followingHashtag?: Maybe<(
      { __typename?: 'HashtagFeedOutput' }
      & Pick<HashtagFeedOutput, 'hashtagName' | 'hashtagType'>
    )>, followingStocktag?: Maybe<(
      { __typename?: 'StockFeedOutput' }
      & Pick<StockFeedOutput, 'securityId' | 'stockName' | 'slug' | 'nseListingId' | 'bseListingId'>
    )>, post?: Maybe<(
      { __typename?: 'Post' }
      & { comments?: Maybe<Array<Maybe<(
        { __typename?: 'Comment' }
        & { replies?: Maybe<Array<Maybe<(
          { __typename?: 'Reply' }
          & ReplyFieldsFragment
        )>>> }
        & CommentFieldsFragment
      )>>> }
      & PostFieldsFragment
    )> }
  )>> }
);

export type FollowFollowingClubCountsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type FollowFollowingClubCountsQuery = (
  { __typename?: 'Query' }
  & { followers: Query['getFollowersCount'], followings: Query['getFollowingsCount'], clubs: Query['getClubsOfUserCount'] }
);

export type FollowersQueryVariables = Exact<{
  data?: Maybe<FollowArgs>;
}>;


export type FollowersQuery = (
  { __typename?: 'Query' }
  & { getFollowers?: Maybe<(
    { __typename?: 'FollowingType' }
    & { users?: Maybe<Array<Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'username' | 'cover' | 'bio' | 'avatar' | 'isfollow' | 'isVerified' | 'greenTick' | 'tick3' | 'issubscribed' | 'isUserDeleted'>
    )>>> }
  )> }
);

export type FollowingUsersQueryVariables = Exact<{
  data?: Maybe<FollowArgs>;
}>;


export type FollowingUsersQuery = (
  { __typename?: 'Query' }
  & { getFollowings?: Maybe<(
    { __typename?: 'FollowingTypeNew' }
    & { users?: Maybe<Array<Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'username' | 'cover' | 'bio' | 'avatar' | 'isfollow' | 'isVerified' | 'greenTick' | 'tick3' | 'issubscribed' | 'isUserDeleted'>
    )>>> }
  )> }
);

export type GetFollowingsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetFollowingsQuery = (
  { __typename?: 'Query' }
  & { Hashtag?: Maybe<(
    { __typename?: 'FollowingTypeNew' }
    & { hashtags?: Maybe<Array<Maybe<(
      { __typename?: 'TrendingHashTag' }
      & Pick<TrendingHashTag, 'userAvatars' | 'followers'>
      & { Hashtag?: Maybe<(
        { __typename?: 'Hashtag' }
        & Pick<Hashtag, 'hashtagName' | 'hashtagType' | 'postCount' | 'isfollow' | 'issubscribed'>
      )> }
    )>>> }
  )>, Stocks?: Maybe<(
    { __typename?: 'FollowingTypeNew' }
    & { stocks?: Maybe<Array<Maybe<(
      { __typename?: 'TrendingStocktag' }
      & Pick<TrendingStocktag, 'userAvatars' | 'followers'>
      & { stock?: Maybe<(
        { __typename?: 'Stock' }
        & Pick<Stock, 'securityId' | 'stockName' | 'slug' | 'nseListingId' | 'postCount' | 'bseListingId' | 'isfollow' | 'issubscribed'>
      )> }
    )>>> }
  )>, Sectors?: Maybe<(
    { __typename?: 'SecCat' }
    & { sectors?: Maybe<Array<Maybe<(
      { __typename?: 'Sector' }
      & Pick<Sector, 'sectorId' | 'name' | 'icon'>
    )>>> }
  )> }
);

export type GetWatchListQueryVariables = Exact<{
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetWatchListQuery = (
  { __typename?: 'Query' }
  & { getWatchlist?: Maybe<Array<Maybe<(
    { __typename?: 'Stock' }
    & Pick<Stock, 'securityId' | 'stockName' | 'slug' | 'isfollow'>
  )>>> }
);

export type GetWatchlistV2QueryVariables = Exact<{
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  type?: Maybe<DollarTagEnum>;
}>;


export type GetWatchlistV2Query = (
  { __typename?: 'Query' }
  & { getWatchlistV2?: Maybe<Array<Maybe<(
    { __typename?: 'DollarTag' }
    & Pick<DollarTag, 'dollarTagId' | 'dollarTagName' | 'slug' | 'alias' | 'dollarTagType' | 'sourceEntityId' | 'sourceEntityIdType' | 'isfollow' | 'issubscribed' | 'followers'>
  )>>> }
);

export type GetAchievementDetailsQueryVariables = Exact<{
  achievementType?: Maybe<Scalars['String']>;
  sourceOfClick?: Maybe<Scalars['String']>;
}>;


export type GetAchievementDetailsQuery = (
  { __typename?: 'Query' }
  & { getAchievementDetails?: Maybe<(
    { __typename?: 'AchievementDetailsOutput' }
    & Pick<AchievementDetailsOutput, 'text1' | 'text2' | 'text3' | 'allowFeedback'>
    & { badgeDetails?: Maybe<(
      { __typename?: 'Badges' }
      & Pick<Badges, 'badgeName' | 'badgeId' | 'badgeIcon' | 'badgeType'>
    )>, share?: Maybe<(
      { __typename?: 'PromotionShareObj' }
      & Pick<PromotionShareObj, 'text' | 'imageLink'>
    )> }
  )> }
);

export type GetAllAchievementStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAchievementStatusQuery = (
  { __typename?: 'Query' }
  & { getAllAchievementStatus?: Maybe<(
    { __typename?: 'UserAchievemtStatusData' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'userAllAchievementStatus' }
      & Pick<UserAllAchievementStatus, 'achievementType' | 'achievementName'>
      & { milestoneData?: Maybe<Array<Maybe<(
        { __typename?: 'MilestoneType' }
        & Pick<MilestoneType, 'isMilestoneCompleted' | 'MilestoneName' | 'runningMilestone'>
      )>>> }
    )>>>, errorMessage?: Maybe<(
      { __typename?: 'ErrorMessage' }
      & Pick<ErrorMessage, 'errCode' | 'errMessage'>
    )> }
  )> }
);

export type GetBadgeFeedbackQuestionQueryVariables = Exact<{
  badgeId?: Maybe<Scalars['String']>;
}>;


export type GetBadgeFeedbackQuestionQuery = (
  { __typename?: 'Query' }
  & { getBadgeFeedbackQuestion?: Maybe<Array<Maybe<(
    { __typename?: 'FeedbackQuestions' }
    & Pick<FeedbackQuestions, 'questionId' | 'questionText' | 'badgeId' | 'createdAt'>
    & { Badge?: Maybe<(
      { __typename?: 'Badges' }
      & Pick<Badges, 'badgeId' | 'badgeName' | 'description' | 'badgeIcon' | 'badgeType'>
    )> }
  )>>> }
);

export type GetBadgesOfUserQueryVariables = Exact<{
  userId?: Maybe<Scalars['String']>;
}>;


export type GetBadgesOfUserQuery = (
  { __typename?: 'Query' }
  & { getBadgesOfUser?: Maybe<(
    { __typename?: 'ListOfUserBadges' }
    & { userBadgesList?: Maybe<Array<Maybe<(
      { __typename?: 'UserBadges' }
      & Pick<UserBadges, 'userId' | 'badgeId' | 'hasTurnedOffPromotion' | 'sourceOfClick' | 'achievementType'>
      & { Badges?: Maybe<(
        { __typename?: 'Badges' }
        & Pick<Badges, 'badgeId' | 'badgeName' | 'description' | 'badgeIcon' | 'badgeType'>
      )> }
    )>>>, errorMessage?: Maybe<(
      { __typename?: 'ErrorMessage' }
      & Pick<ErrorMessage, 'errMessage'>
    )> }
  )> }
);

export type GetBlockedListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBlockedListQuery = (
  { __typename?: 'Query' }
  & { getBlockedList?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'cover' | 'isfollow'>
    & UserFieldsFragment
  )>>> }
);

export type GetBookmarkV2QueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetBookmarkV2Query = (
  { __typename?: 'Query' }
  & { getBookmarkV2?: Maybe<Array<Maybe<(
    { __typename?: 'Post' }
    & PostFieldsFragment
  )>>> }
);

export type GetBrokenStreakDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrokenStreakDetailsQuery = (
  { __typename?: 'Query' }
  & { getBrokenStreakDetails?: Maybe<(
    { __typename?: 'UserStreakData' }
    & { data?: Maybe<(
      { __typename?: 'userStreak' }
      & Pick<UserStreak, 'userId'>
      & { prevStreak?: Maybe<Array<Maybe<(
        { __typename?: 'weekData' }
        & Pick<WeekData, 'isCurrentWeek' | 'weekDisplayName' | 'hasCompleted' | 'currentWeekDayCount' | 'weekNumber' | 'weekHeader' | 'weekHeaderMessage' | 'isBrokenWeek' | 'weekFooter'>
        & { days?: Maybe<Array<Maybe<(
          { __typename?: 'streakDay' }
          & Pick<StreakDay, 'dayName' | 'dayDate' | 'hasVisited' | 'visitedState'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = (
  { __typename?: 'Query' }
  & { getCategories?: Maybe<Array<Maybe<(
    { __typename?: 'FeatureClubCategory' }
    & Pick<FeatureClubCategory, 'clubCategoryId' | 'clubCategoryName' | 'headline' | 'description' | 'priority' | 'icon' | 'cover'>
  )>>> }
);

export type GetCategoryByIdQueryVariables = Exact<{
  clubCategoryId?: Maybe<Scalars['String']>;
}>;


export type GetCategoryByIdQuery = (
  { __typename?: 'Query' }
  & { getCategoryById?: Maybe<(
    { __typename?: 'FeatureClubCategory' }
    & Pick<FeatureClubCategory, 'clubCategoryId' | 'clubCategoryName' | 'headline' | 'description' | 'priority' | 'icon' | 'cover'>
  )> }
);

export type GetClubQueryVariables = Exact<{
  clubId: Scalars['String'];
}>;


export type GetClubQuery = (
  { __typename?: 'Query' }
  & { getClub?: Maybe<(
    { __typename?: 'Club' }
    & Pick<Club, 'clubType' | 'memberType' | 'rule'>
    & { viewFeedPermission?: Maybe<(
      { __typename?: 'ViewFeedPermission' }
      & Pick<ViewFeedPermission, 'canViewPost' | 'canSeeMarketingPost'>
    )> }
    & ClubFieldsFragment
  )> }
);

export type GetClubCategoryListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClubCategoryListQuery = (
  { __typename?: 'Query' }
  & { getClubCategoryList?: Maybe<Array<Maybe<(
    { __typename?: 'FeatureClubCategory' }
    & Pick<FeatureClubCategory, 'clubCategoryId' | 'clubCategoryName' | 'headline' | 'description' | 'priority' | 'icon' | 'cover'>
  )>>> }
);

export type GetClubListForSmartFeedQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type GetClubListForSmartFeedQuery = (
  { __typename?: 'Query' }
  & { getClubListForSmartFeed?: Maybe<Array<Maybe<(
    { __typename?: 'Club' }
    & ClubFieldsFragment
  )>>> }
);

export type GetClubMarketingPostsQueryVariables = Exact<{
  clubId?: Maybe<Scalars['String']>;
}>;


export type GetClubMarketingPostsQuery = (
  { __typename?: 'Query' }
  & { getClubMarketingPosts?: Maybe<Array<Maybe<(
    { __typename?: 'Post' }
    & PostFieldsFragment
  )>>> }
);

export type GetClubMediaPostsQueryVariables = Exact<{
  data?: Maybe<ClubInput>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetClubMediaPostsQuery = (
  { __typename?: 'Query' }
  & { getClubMediaPosts: Array<Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, 'postId'>
    & { media?: Maybe<Array<Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'type' | 'uri' | 'name'>
    )>>> }
  )>> }
);

export type GetClubPermissionsBasedOnFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClubPermissionsBasedOnFeaturesQuery = (
  { __typename?: 'Query' }
  & { getClubPermissionsBasedOnFeatures?: Maybe<Array<Maybe<(
    { __typename?: 'clubPermissionsAuthorizationDetails' }
    & Pick<ClubPermissionsAuthorizationDetails, 'clubId' | 'permissions' | 'club_permissions_token'>
  )>>> }
);

export type ClubPostQueryVariables = Exact<{
  clubId: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type ClubPostQuery = (
  { __typename?: 'Query' }
  & { getClubPosts?: Maybe<Array<Maybe<(
    { __typename?: 'Post' }
    & PostFieldsFragment
  )>>> }
);

export type GetClubPostsSinceDateQueryVariables = Exact<{
  clubId: Scalars['String'];
  since?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
}>;


export type GetClubPostsSinceDateQuery = (
  { __typename?: 'Query' }
  & { getClubPostsSinceDate?: Maybe<(
    { __typename?: 'PostListSinceDate' }
    & Pick<PostListSinceDate, 'since'>
    & { posts?: Maybe<Array<Maybe<(
      { __typename?: 'Post' }
      & PostFieldsFragment
    )>>> }
  )> }
);

export type GetClubTrendingHashtagsV2QueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  clubId: Scalars['String'];
}>;


export type GetClubTrendingHashtagsV2Query = (
  { __typename?: 'Query' }
  & { getClubTrendingHashtagsV2: Array<Maybe<(
    { __typename?: 'Hashtag' }
    & Pick<Hashtag, 'hashtagName' | 'postCount' | 'isfollow' | 'issubscribed' | 'followers'>
  )>> }
);

export type GetClubTrendingSectorsViaDollarTagQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  clubId: Scalars['String'];
}>;


export type GetClubTrendingSectorsViaDollarTagQuery = (
  { __typename?: 'Query' }
  & { getClubTrendingSectorsViaDollarTag: Array<Maybe<(
    { __typename?: 'DollarTag' }
    & DollarTagFieldsFragment
  )>> }
);

export type GetClubTrendingStocksViaDollarTagQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  clubId: Scalars['String'];
}>;


export type GetClubTrendingStocksViaDollarTagQuery = (
  { __typename?: 'Query' }
  & { getClubTrendingStocksViaDollarTag: Array<Maybe<(
    { __typename?: 'DollarTag' }
    & DollarTagFieldsFragment
  )>> }
);

export type GetClubsByCategoryQueryVariables = Exact<{
  clubCategoryId?: Maybe<Scalars['String']>;
}>;


export type GetClubsByCategoryQuery = (
  { __typename?: 'Query' }
  & { getClubsByCategory?: Maybe<Array<Maybe<(
    { __typename?: 'Club' }
    & ClubFieldsFragment
  )>>> }
);

export type GetCommentsQueryVariables = Exact<{
  postId?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetCommentsQuery = (
  { __typename?: 'Query' }
  & { getComments: Array<Maybe<(
    { __typename?: 'Comment' }
    & Pick<Comment, 'commentId' | 'textV2' | 'isUpvoted' | 'isDownvoted' | 'isSuspected' | 'upvotecount' | 'downvotecount' | 'replycount' | 'createdAt'>
    & { media?: Maybe<Array<Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'type' | 'uri' | 'name'>
    )>>>, User?: Maybe<(
      { __typename?: 'User' }
      & UserFieldsFragment
    )> }
  )>> }
);

export type GetDollarTagDetailsQueryVariables = Exact<{
  dollarTagId?: Maybe<Scalars['Int']>;
}>;


export type GetDollarTagDetailsQuery = (
  { __typename?: 'Query' }
  & { getDollarTagDetails?: Maybe<(
    { __typename?: 'DollarTag' }
    & { viewFeedPermission?: Maybe<(
      { __typename?: 'ViewFeedPermission' }
      & Pick<ViewFeedPermission, 'canViewPost' | 'canSeeMarketingPost'>
    )> }
    & DollarTagFieldsFragment
  )> }
);

export type GetDollarTagForSecurityIdQueryVariables = Exact<{
  securityId: Scalars['Int'];
}>;


export type GetDollarTagForSecurityIdQuery = (
  { __typename?: 'Query' }
  & { getDollarTagForSecurityId?: Maybe<(
    { __typename?: 'DollarTag' }
    & Pick<DollarTag, 'dollarTagId' | 'slug' | 'dollarTagType'>
  )> }
);

export type GetDollartagBySearchTextQueryVariables = Exact<{
  searchText: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type GetDollartagBySearchTextQuery = (
  { __typename?: 'Query' }
  & { getDollartagBySearchText?: Maybe<Array<Maybe<(
    { __typename?: 'DollarTag' }
    & Pick<DollarTag, 'dollarTagId' | 'dollarTagName' | 'slug' | 'dollarTagType'>
  )>>> }
);

export type GetDollartagMarketingPostsQueryVariables = Exact<{
  dollarTagId?: Maybe<Scalars['Int']>;
}>;


export type GetDollartagMarketingPostsQuery = (
  { __typename?: 'Query' }
  & { getDollartagMarketingPosts?: Maybe<Array<Maybe<(
    { __typename?: 'Post' }
    & PostFieldsFragment
  )>>> }
);

export type GetEditPostHistoryQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetEditPostHistoryQuery = (
  { __typename?: 'Query' }
  & { getEditPostHistory?: Maybe<Array<Maybe<(
    { __typename?: 'EditHistoryData' }
    & Pick<EditHistoryData, 'text' | 'editedAt'>
    & { media?: Maybe<Array<Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'type' | 'uri' | 'name' | 'height' | 'width' | 'rotation'>
    )>>>, tags?: Maybe<Array<Maybe<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'startIndex' | 'endIndex' | 'name' | 'type' | 'id' | 'slug'>
    )>>> }
  )>>> }
);

export type GetFeatureToClubPermissionByIdQueryVariables = Exact<{
  clubId?: Maybe<Scalars['String']>;
}>;


export type GetFeatureToClubPermissionByIdQuery = (
  { __typename?: 'Query' }
  & { getFeatureToClubPermissionById?: Maybe<(
    { __typename?: 'clubPermissionsAuthorizationDetails' }
    & Pick<ClubPermissionsAuthorizationDetails, 'clubId' | 'permissions' | 'club_permissions_token'>
  )> }
);

export type GetFeatureToPlatformPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureToPlatformPermissionQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getFeatureToPlatformPermission'>
);

export type GetFeedbackTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeedbackTypesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getFeedbackTypes'>
);

export type GetGuidedTourQueryVariables = Exact<{
  tourComponent?: Maybe<Scalars['String']>;
  tourSource?: Maybe<TourSourceType>;
}>;


export type GetGuidedTourQuery = (
  { __typename?: 'Query' }
  & { getGuidedTour?: Maybe<Array<Maybe<(
    { __typename?: 'TourKeys' }
    & Pick<TourKeys, 'tourId' | 'tourComponent' | 'tourKey' | 'tourDescription'>
  )>>> }
);

export type GetHashTagDetailsQueryVariables = Exact<{
  hashTagName?: Maybe<Scalars['String']>;
  hashtagId?: Maybe<Scalars['String']>;
}>;


export type GetHashTagDetailsQuery = (
  { __typename?: 'Query' }
  & { getHashTagDetails: (
    { __typename?: 'PostWithTag' }
    & Pick<PostWithTag, 'discussions' | 'followers'>
    & { hashtag?: Maybe<(
      { __typename?: 'Hashtag' }
      & Pick<Hashtag, 'hashtagName' | 'hashtagType' | 'postCount' | 'isfollow' | 'issubscribed' | 'followers'>
      & { viewFeedPermission?: Maybe<(
        { __typename?: 'ViewFeedPermission' }
        & Pick<ViewFeedPermission, 'canViewPost' | 'canSeeMarketingPost'>
      )> }
    )> }
  ) }
);

export type GetHashtagBySearchTextQueryVariables = Exact<{
  data?: Maybe<GetHashtagBySearchTextArgs>;
}>;


export type GetHashtagBySearchTextQuery = (
  { __typename?: 'Query' }
  & { getHashtagBySearchText: Array<Maybe<(
    { __typename?: 'TrendingHashTag' }
    & { Hashtag?: Maybe<(
      { __typename?: 'Hashtag' }
      & Pick<Hashtag, 'hashtagName' | 'hashtagType'>
    )> }
  )>> }
);

export type GetHashtagFollowingsQueryVariables = Exact<{
  userId: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetHashtagFollowingsQuery = (
  { __typename?: 'Query' }
  & { getHashtagFollowings?: Maybe<Array<Maybe<(
    { __typename?: 'Hashtag' }
    & Pick<Hashtag, 'hashtagName' | 'postCount' | 'isfollow' | 'issubscribed' | 'followers'>
  )>>> }
);

export type GetHashtagMarketingPostsQueryVariables = Exact<{
  hashTagName?: Maybe<Scalars['String']>;
  hashtagId?: Maybe<Scalars['String']>;
}>;


export type GetHashtagMarketingPostsQuery = (
  { __typename?: 'Query' }
  & { getHashtagMarketingPosts?: Maybe<Array<Maybe<(
    { __typename?: 'Post' }
    & PostFieldsFragment
  )>>> }
);

export type GetHashtagsListBasedOnTypeOfContentQueryVariables = Exact<{
  typeOfContentMadeByHashtag?: Maybe<UserHashtagContentType>;
}>;


export type GetHashtagsListBasedOnTypeOfContentQuery = (
  { __typename?: 'Query' }
  & { getHashtagsListBasedOnTypeOfContent?: Maybe<Array<Maybe<(
    { __typename?: 'Hashtag' }
    & Pick<Hashtag, 'hashtagName'>
  )>>> }
);

export type GetImportantProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImportantProfilesQuery = (
  { __typename?: 'Query' }
  & { getImportantProfiles?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'cover' | 'isfollow' | 'postCount' | 'followerCount'>
    & UserFieldsFragment
  )>>> }
);

export type GetInterstitialsQueryVariables = Exact<{
  platformType: PlatformTypeForInterstitial;
}>;


export type GetInterstitialsQuery = (
  { __typename?: 'Query' }
  & { getInterstitials?: Maybe<Array<Maybe<(
    { __typename?: 'InterstitialsData' }
    & Pick<InterstitialsData, 'interstitialsId' | 'componentType' | 'position' | 'data' | 'title'>
  )>>> }
);

export type GetListOfClubsWithPostPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListOfClubsWithPostPermissionQuery = (
  { __typename?: 'Query' }
  & { getListOfClubsWithPostPermission?: Maybe<Array<Maybe<(
    { __typename?: 'Club' }
    & Pick<Club, 'clubId' | 'clubHandle' | 'clubName' | 'avatar'>
  )>>> }
);

export type GetMarketExpertsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetMarketExpertsQuery = (
  { __typename?: 'Query' }
  & { getMarketExperts?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'cover' | 'isfollow'>
    & UserFieldsFragment
  )>>> }
);

export type GetProfileMediaQueryVariables = Exact<{
  data?: Maybe<UserId>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetProfileMediaQuery = (
  { __typename?: 'Query' }
  & { getMediaPosts: Array<Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, 'postId'>
    & { media?: Maybe<Array<Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'type' | 'uri' | 'name'>
    )>>> }
  )>> }
);

export type MediaUploadUrlsQueryVariables = Exact<{
  data?: Maybe<Array<Maybe<MediaInput>> | Maybe<MediaInput>>;
}>;


export type MediaUploadUrlsQuery = (
  { __typename?: 'Query' }
  & { getMediaUploadURLS: Array<Maybe<(
    { __typename?: 'MediaURL' }
    & Pick<MediaUrl, 'key' | 'url'>
  )>> }
);

export type GetMembersQueryVariables = Exact<{
  clubId: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetMembersQuery = (
  { __typename?: 'Query' }
  & { getMembers?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'cover' | 'isfollow'>
    & UserFieldsFragment
  )>>> }
);

export type GetMultipleExternalResourceQueryVariables = Exact<{
  type?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;


export type GetMultipleExternalResourceQuery = (
  { __typename?: 'Query' }
  & { getMultipleExternalResource?: Maybe<Array<Maybe<(
    { __typename?: 'ExternalResource' }
    & Pick<ExternalResource, 'id' | 'type' | 'value'>
  )>>> }
);

export type GetMyFeedbacksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyFeedbacksQuery = (
  { __typename?: 'Query' }
  & { getMyFeedbacks?: Maybe<Array<Maybe<(
    { __typename?: 'Feedback' }
    & Pick<Feedback, 'feedbackId' | 'type' | 'subject' | 'comment' | 'status'>
    & { user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'firstName' | 'lastName' | 'id' | 'username' | 'avatar' | 'cover' | 'isVerified' | 'greenTick' | 'tick3'>
    )>, attachment?: Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'type' | 'uri' | 'name'>
    )> }
  )>>> }
);

export type GetNotificationsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  filter?: Maybe<NotificationFilter>;
}>;


export type GetNotificationsQuery = (
  { __typename?: 'Query' }
  & { getNotifications?: Maybe<Array<Maybe<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'notificationId' | 'notificationType' | 'createdAt' | 'link' | 'message' | 'read' | 'postId'>
    & { User?: Maybe<(
      { __typename?: 'User' }
      & UserFieldsFragment
    )>, Notifier?: Maybe<(
      { __typename?: 'User' }
      & UserFieldsFragment
    )>, Club?: Maybe<(
      { __typename?: 'Club' }
      & Pick<Club, 'clubHandle' | 'clubId' | 'clubName'>
    )> }
  )>>> }
);

export type UpdateNotificationFragment = (
  { __typename?: 'Notification' }
  & Pick<Notification, 'read'>
);

export type GetPeopleListForSmartFeedQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type GetPeopleListForSmartFeedQuery = (
  { __typename?: 'Query' }
  & { getPeopleListForSmartFeed?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'isfollow' | 'followerCount'>
    & UserFieldsFragment
  )>>> }
);

export type GetPermissionToFeatureMappingListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPermissionToFeatureMappingListQuery = (
  { __typename?: 'Query' }
  & { getPermissionToFeatureMappingList?: Maybe<(
    { __typename?: 'ClubAndUtilityToFeatureOutput' }
    & { clubFeatures?: Maybe<Array<Maybe<(
      { __typename?: 'clubFeaturesOutput' }
      & Pick<ClubFeaturesOutput, 'clubId' | 'features'>
    )>>>, platformFeatures?: Maybe<Array<Maybe<(
      { __typename?: 'utilityFeaturesOutput' }
      & Pick<UtilityFeaturesOutput, 'permission' | 'features'>
    )>>> }
  )> }
);

export type GetPinnedPostQueryVariables = Exact<{
  userId?: Maybe<Scalars['String']>;
}>;


export type GetPinnedPostQuery = (
  { __typename?: 'Query' }
  & { getPinnedPost?: Maybe<Array<Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, 'isPinned'>
    & PostFieldsFragment
  )>>> }
);

export type GetPopUpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPopUpQuery = (
  { __typename?: 'Query' }
  & { getPopUp?: Maybe<(
    { __typename?: 'PopUpData' }
    & { data?: Maybe<Array<Maybe<(
      { __typename?: 'popUp' }
      & Pick<PopUp, 'popUpType' | 'data' | 'popUpDelay'>
    )>>> }
  )> }
);

export type GetPopularClubsInPlatformQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPopularClubsInPlatformQuery = (
  { __typename?: 'Query' }
  & { getPopularClubsInPlatform?: Maybe<Array<Maybe<(
    { __typename?: 'Club' }
    & ClubFieldsFragment
  )>>> }
);

export type GetPopularUsersQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetPopularUsersQuery = (
  { __typename?: 'Query' }
  & { getPopularUsers?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'cover' | 'isfollow'>
    & UserFieldsFragment
  )>>> }
);

export type GetPostByDollarTagQueryVariables = Exact<{
  dollarTagId: Scalars['Int'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetPostByDollarTagQuery = (
  { __typename?: 'Query' }
  & { getPostByDollarTag?: Maybe<Array<Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, 'topCommentId'>
    & { comments?: Maybe<Array<Maybe<(
      { __typename?: 'Comment' }
      & Pick<Comment, 'isTopComment'>
      & CommentFieldsFragment
    )>>> }
    & PostFieldsFragment
  )>>> }
);

export type GetPostByDollarTagSinceDateQueryVariables = Exact<{
  dollarTagId: Scalars['Int'];
  since?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
}>;


export type GetPostByDollarTagSinceDateQuery = (
  { __typename?: 'Query' }
  & { getPostByDollarTagSinceDate?: Maybe<(
    { __typename?: 'PostListSinceDate' }
    & Pick<PostListSinceDate, 'since'>
    & { posts?: Maybe<Array<Maybe<(
      { __typename?: 'Post' }
      & PostFieldsFragment
    )>>> }
  )> }
);

export type GetPostByHashTagSinceDateQueryVariables = Exact<{
  hashTagName?: Maybe<Scalars['String']>;
  since?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
}>;


export type GetPostByHashTagSinceDateQuery = (
  { __typename?: 'Query' }
  & { getPostByHashTagSinceDate?: Maybe<(
    { __typename?: 'PostListSinceDate' }
    & Pick<PostListSinceDate, 'since'>
    & { posts?: Maybe<Array<Maybe<(
      { __typename?: 'Post' }
      & PostFieldsFragment
    )>>> }
  )> }
);

export type SinglePostQueryVariables = Exact<{
  data?: Maybe<PostId>;
}>;


export type SinglePostQuery = (
  { __typename?: 'Query' }
  & { getPostById: (
    { __typename?: 'Post' }
    & { comments?: Maybe<Array<Maybe<(
      { __typename?: 'Comment' }
      & Pick<Comment, 'replycount' | 'postId' | 'commentId' | 'userId' | 'textV2' | 'isSuspected' | 'createdAt' | 'updatedAt'>
      & { User?: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName' | 'avatar' | 'cover' | 'greenTick'>
      )>, media?: Maybe<Array<Maybe<(
        { __typename?: 'Media' }
        & Pick<Media, 'type' | 'uri' | 'name' | 'height' | 'width' | 'rotation'>
      )>>>, tags?: Maybe<Array<Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'startIndex' | 'endIndex' | 'name' | 'type' | 'id' | 'slug'>
      )>>>, linkPreview?: Maybe<(
        { __typename?: 'LinkPreview' }
        & Pick<LinkPreview, 'siteName' | 'images' | 'url' | 'description' | 'title'>
      )>, replies?: Maybe<Array<Maybe<(
        { __typename?: 'Reply' }
        & Pick<Reply, 'replyId' | 'postId' | 'userId' | 'commentId' | 'textV2' | 'isSuspected' | 'createdAt' | 'updatedAt'>
        & { User?: Maybe<(
          { __typename?: 'User' }
          & Pick<User, 'id' | 'firstName' | 'lastName' | 'avatar' | 'cover' | 'greenTick'>
        )>, media?: Maybe<Array<Maybe<(
          { __typename?: 'Media' }
          & Pick<Media, 'type' | 'uri' | 'name' | 'height' | 'width' | 'rotation'>
        )>>>, tags?: Maybe<Array<Maybe<(
          { __typename?: 'Tag' }
          & Pick<Tag, 'startIndex' | 'endIndex' | 'name' | 'type' | 'id' | 'slug'>
        )>>>, linkPreview?: Maybe<(
          { __typename?: 'LinkPreview' }
          & Pick<LinkPreview, 'siteName' | 'images' | 'url' | 'description' | 'title'>
        )> }
      )>>> }
    )>>> }
    & PostFieldsFragment
  ) }
);

export type GetPostDetailsByIdQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type GetPostDetailsByIdQuery = (
  { __typename?: 'Query' }
  & { getPostDetailsById?: Maybe<(
    { __typename?: 'PostDetails' }
    & { post?: Maybe<(
      { __typename?: 'Post' }
      & PostFieldsFragment
    )>, error?: Maybe<(
      { __typename?: 'ErrorMessage' }
      & Pick<ErrorMessage, 'errCode' | 'errMessage' | 'errLabel'>
    )> }
  )> }
);

export type GetPostsByFiltersQueryVariables = Exact<{
  limit: Scalars['Int'];
  filter: SearchPostsFilterArgs;
  clubId?: Maybe<Scalars['String']>;
  since?: Maybe<Scalars['String']>;
}>;


export type GetPostsByFiltersQuery = (
  { __typename?: 'Query' }
  & { getPostsByFilters?: Maybe<(
    { __typename?: 'FilteredPostListSinceDate' }
    & Pick<FilteredPostListSinceDate, 'since' | 'hasMore'>
    & { posts?: Maybe<Array<Maybe<(
      { __typename?: 'Post' }
      & PostFieldsFragment
    )>>> }
  )> }
);

export type GetPostsByHashTagV2QueryVariables = Exact<{
  hashTagName?: Maybe<Scalars['String']>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetPostsByHashTagV2Query = (
  { __typename?: 'Query' }
  & { getPostsByHashTagV2: Array<Maybe<(
    { __typename?: 'Post' }
    & PostFieldsFragment
  )>> }
);

export type GetPowerUserStreakDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPowerUserStreakDetailsQuery = (
  { __typename?: 'Query' }
  & { getPowerUserStreakDetails?: Maybe<(
    { __typename?: 'UserStreakData' }
    & { data?: Maybe<(
      { __typename?: 'userStreak' }
      & Pick<UserStreak, 'userId'>
      & { weekData?: Maybe<Array<Maybe<(
        { __typename?: 'weekData' }
        & Pick<WeekData, 'isCurrentWeek' | 'weekDisplayName' | 'hasCompleted' | 'currentWeekDayCount' | 'weekNumber' | 'weekHeader' | 'weekHeaderMessage' | 'weekFooter'>
        & { days?: Maybe<Array<Maybe<(
          { __typename?: 'streakDay' }
          & Pick<StreakDay, 'dayName' | 'dayDate' | 'hasVisited' | 'visitedState'>
        )>>> }
      )>>> }
    )> }
  )> }
);

export type ProfileInfoQueryVariables = Exact<{
  data?: Maybe<UserId>;
}>;


export type ProfileInfoQuery = (
  { __typename?: 'Query' }
  & { getProfileInfo?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'profileType' | 'isfollow' | 'issubscribed' | 'cover' | 'bio' | 'watchlistVisibleStatus'>
    & { viewFeedPermission?: Maybe<(
      { __typename?: 'ViewFeedPermission' }
      & Pick<ViewFeedPermission, 'canViewPost' | 'canSeeMarketingPost'>
    )> }
    & UserFieldsFragment
  )> }
);

export type GetProfileMarketingPostsQueryVariables = Exact<{
  data?: Maybe<UserId>;
}>;


export type GetProfileMarketingPostsQuery = (
  { __typename?: 'Query' }
  & { getProfileMarketingPosts?: Maybe<Array<Maybe<(
    { __typename?: 'Post' }
    & PostFieldsFragment
  )>>> }
);

export type GetProfilePostsSinceDateQueryVariables = Exact<{
  data?: Maybe<UserId>;
  since?: Maybe<Scalars['String']>;
  limit: Scalars['Int'];
}>;


export type GetProfilePostsSinceDateQuery = (
  { __typename?: 'Query' }
  & { getProfilePostsSinceDate?: Maybe<(
    { __typename?: 'PostListSinceDate' }
    & Pick<PostListSinceDate, 'since'>
    & { posts?: Maybe<Array<Maybe<(
      { __typename?: 'Post' }
      & Pick<Post, 'isPinned'>
      & PostFieldsFragment
    )>>> }
  )> }
);

export type GetProfilePostsV2QueryVariables = Exact<{
  data?: Maybe<UserId>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetProfilePostsV2Query = (
  { __typename?: 'Query' }
  & { getProfilePostsV2: Array<Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, 'isPinned'>
    & PostFieldsFragment
  )>> }
);

export type GetPromotionForSmartFeedQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type GetPromotionForSmartFeedQuery = (
  { __typename?: 'Query' }
  & { getPromotionForSmartFeed?: Maybe<(
    { __typename?: 'PromotionData' }
    & Pick<PromotionData, 'promotionId' | 'redirectURL' | 'shareableURL' | 'imageURL'>
  )> }
);

export type GetReactionsQueryVariables = Exact<{
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
  voteType?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetReactionsQuery = (
  { __typename?: 'Query' }
  & { getReactions?: Maybe<Array<Maybe<(
    { __typename?: 'Vote' }
    & Pick<Vote, 'voteId' | 'postId' | 'commentId' | 'replyId' | 'createdAt' | 'vote'>
    & { User?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'isfollow'>
      & UserFieldsFragment
    )> }
  )>>> }
);

export type GetRecommendedPostsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetRecommendedPostsQuery = (
  { __typename?: 'Query' }
  & { getRecommendedPosts: Array<Maybe<(
    { __typename?: 'ActivityFeed' }
    & Pick<ActivityFeed, 'actId' | 'activityId' | 'activityType' | 'createdAt' | 'avatar' | 'cover'>
    & { user?: Maybe<(
      { __typename?: 'UserFeedOutput' }
      & Pick<UserFeedOutput, 'id' | 'firstName' | 'lastName' | 'avatar' | 'cover' | 'username' | 'isVerified' | 'greenTick' | 'tick3' | 'profileType'>
    )>, followingUser?: Maybe<(
      { __typename?: 'UserFeedOutput' }
      & Pick<UserFeedOutput, 'id' | 'firstName' | 'lastName' | 'username' | 'avatar' | 'cover' | 'isVerified' | 'greenTick' | 'tick3' | 'profileType'>
    )>, club?: Maybe<(
      { __typename?: 'ClubFeedOutput' }
      & Pick<ClubFeedOutput, 'clubId' | 'clubHandle' | 'avatar' | 'cover' | 'clubName'>
    )>, followingHashtag?: Maybe<(
      { __typename?: 'HashtagFeedOutput' }
      & Pick<HashtagFeedOutput, 'hashtagName' | 'hashtagType'>
    )>, followingStocktag?: Maybe<(
      { __typename?: 'StockFeedOutput' }
      & Pick<StockFeedOutput, 'securityId' | 'stockName' | 'slug' | 'nseListingId' | 'bseListingId'>
    )>, post?: Maybe<(
      { __typename?: 'Post' }
      & { comments?: Maybe<Array<Maybe<(
        { __typename?: 'Comment' }
        & { replies?: Maybe<Array<Maybe<(
          { __typename?: 'Reply' }
          & ReplyFieldsFragment
        )>>> }
        & CommentFieldsFragment
      )>>> }
      & PostFieldsFragment
    )> }
  )>> }
);

export type GetReferBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferBannerQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getReferBanner'>
);

export type GetReferMsgQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReferMsgQuery = (
  { __typename?: 'Query' }
  & { getReferMsg?: Maybe<(
    { __typename?: 'ReferMsg' }
    & Pick<ReferMsg, 'url' | 'message'>
  )> }
);

export type GetRepliesQueryVariables = Exact<{
  commentId: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetRepliesQuery = (
  { __typename?: 'Query' }
  & { getReplies?: Maybe<Array<Maybe<(
    { __typename?: 'Reply' }
    & ReplyFieldsFragment
  )>>> }
);

export type GetReportTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportTypesQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getReportTypes'>
);

export type GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables = Exact<{
  searchText: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type GetSectorBySearchTextViaDollarTagForWatchlistQuery = (
  { __typename?: 'Query' }
  & { getSectorBySearchTextViaDollarTagForWatchlist?: Maybe<Array<Maybe<(
    { __typename?: 'DollarTag' }
    & DollarTagFieldsFragment
  )>>> }
);

export type GetSectorListForSmartFeedQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type GetSectorListForSmartFeedQuery = (
  { __typename?: 'Query' }
  & { getSectorListForSmartFeed?: Maybe<Array<Maybe<(
    { __typename?: 'DollarTag' }
    & DollarTagFieldsFragment
  )>>> }
);

export type GetSelfFeedQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetSelfFeedQuery = (
  { __typename?: 'Query' }
  & { getSelfFeed: Array<Maybe<(
    { __typename?: 'ActivityFeed' }
    & Pick<ActivityFeed, 'actId' | 'activityId' | 'activityType' | 'createdAt' | 'avatar' | 'cover'>
    & { user?: Maybe<(
      { __typename?: 'UserFeedOutput' }
      & Pick<UserFeedOutput, 'id' | 'firstName' | 'lastName' | 'avatar' | 'username' | 'isVerified' | 'greenTick' | 'profileType' | 'tick3'>
    )>, followingUser?: Maybe<(
      { __typename?: 'UserFeedOutput' }
      & Pick<UserFeedOutput, 'id' | 'firstName' | 'lastName' | 'username' | 'avatar' | 'isVerified' | 'greenTick' | 'tick3' | 'profileType'>
    )>, club?: Maybe<(
      { __typename?: 'ClubFeedOutput' }
      & Pick<ClubFeedOutput, 'clubId' | 'clubHandle' | 'avatar' | 'clubName'>
    )>, followingHashtag?: Maybe<(
      { __typename?: 'HashtagFeedOutput' }
      & Pick<HashtagFeedOutput, 'hashtagName' | 'hashtagType'>
    )>, followingStocktag?: Maybe<(
      { __typename?: 'StockFeedOutput' }
      & Pick<StockFeedOutput, 'securityId' | 'stockName' | 'slug' | 'nseListingId' | 'bseListingId'>
    )>, post?: Maybe<(
      { __typename?: 'Post' }
      & { comments?: Maybe<Array<Maybe<(
        { __typename?: 'Comment' }
        & { replies?: Maybe<Array<Maybe<(
          { __typename?: 'Reply' }
          & ReplyFieldsFragment
        )>>> }
        & CommentFieldsFragment
      )>>> }
      & PostFieldsFragment
    )> }
  )>> }
);

export type GetShareFeedForPostQueryVariables = Exact<{
  postId: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetShareFeedForPostQuery = (
  { __typename?: 'Query' }
  & { getShareFeedForPost?: Maybe<Array<Maybe<(
    { __typename?: 'Post' }
    & PostFieldsFragment
  )>>> }
);

export type GetStockListForSmartFeedQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type GetStockListForSmartFeedQuery = (
  { __typename?: 'Query' }
  & { getStockListForSmartFeed?: Maybe<Array<Maybe<(
    { __typename?: 'DollarTag' }
    & DollarTagFieldsFragment
  )>>> }
);

export type GetStockTagDetailsQueryVariables = Exact<{
  securityId?: Maybe<Scalars['Int']>;
}>;


export type GetStockTagDetailsQuery = (
  { __typename?: 'Query' }
  & { getStockTagDetails?: Maybe<(
    { __typename?: 'PostWithTag' }
    & Pick<PostWithTag, 'discussions' | 'followers'>
    & { stock?: Maybe<(
      { __typename?: 'Stock' }
      & Pick<Stock, 'isfollow' | 'issubscribed' | 'stockName' | 'securityId'>
    )> }
  )> }
);

export type GetStocksBySearchTextForWatchlistQueryVariables = Exact<{
  searchText: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetStocksBySearchTextForWatchlistQuery = (
  { __typename?: 'Query' }
  & { getStocksBySearchTextForWatchlist?: Maybe<Array<Maybe<(
    { __typename?: 'Stock' }
    & Pick<Stock, 'securityId' | 'stockName' | 'slug' | 'isfollow'>
  )>>> }
);

export type GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables = Exact<{
  searchText: Scalars['String'];
  offset?: Maybe<Scalars['Int']>;
  limit: Scalars['Int'];
}>;


export type GetStocksBySearchTextViaDollarTagForWatchlistQuery = (
  { __typename?: 'Query' }
  & { getStocksBySearchTextViaDollarTagForWatchlist?: Maybe<Array<Maybe<(
    { __typename?: 'DollarTag' }
    & DollarTagFieldsFragment
  )>>> }
);

export type SuggestedPeopleQueryVariables = Exact<{ [key: string]: never; }>;


export type SuggestedPeopleQuery = (
  { __typename?: 'Query' }
  & { getSuggestedPeople?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'cover' | 'isfollow'>
    & UserFieldsFragment
  )>>> }
);

export type GetTick3ExpertsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetTick3ExpertsQuery = (
  { __typename?: 'Query' }
  & { getTick3Experts?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'cover' | 'isfollow'>
    & UserFieldsFragment
  )>>> }
);

export type GetTicketByIdQueryVariables = Exact<{
  ticketId: Scalars['Int'];
}>;


export type GetTicketByIdQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getTicketById'>
);

export type GetTopicListForSmartFeedQueryVariables = Exact<{
  data: Scalars['String'];
}>;


export type GetTopicListForSmartFeedQuery = (
  { __typename?: 'Query' }
  & { getTopicListForSmartFeed?: Maybe<Array<Maybe<(
    { __typename?: 'Hashtag' }
    & HashTagFieldsFragment
  )>>> }
);

export type TrendingHashQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type TrendingHashQuery = (
  { __typename?: 'Query' }
  & { getTrendingHashTags: Array<Maybe<(
    { __typename?: 'TrendingHashTag' }
    & Pick<TrendingHashTag, 'userAvatars' | 'followers'>
    & { Hashtag?: Maybe<(
      { __typename?: 'Hashtag' }
      & Pick<Hashtag, 'hashtagName' | 'hashtagType' | 'postCount' | 'isfollow' | 'issubscribed'>
    )> }
  )>> }
);

export type GetTrendingHashTagsV2QueryVariables = Exact<{
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetTrendingHashTagsV2Query = (
  { __typename?: 'Query' }
  & { getTrendingHashTagsV2: Array<Maybe<(
    { __typename?: 'Hashtag' }
    & HashTagFieldsFragment
  )>> }
);

export type GetTrendingSectorsByDollarTagQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetTrendingSectorsByDollarTagQuery = (
  { __typename?: 'Query' }
  & { getTrendingSectorsByDollarTag?: Maybe<Array<Maybe<(
    { __typename?: 'DollarTag' }
    & DollarTagFieldsFragment
  )>>> }
);

export type TrendingStocksQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type TrendingStocksQuery = (
  { __typename?: 'Query' }
  & { getTrendingStocks: Array<Maybe<(
    { __typename?: 'TrendingStocktag' }
    & Pick<TrendingStocktag, 'followers' | 'userAvatars'>
    & { stock?: Maybe<(
      { __typename?: 'Stock' }
      & Pick<Stock, 'securityId' | 'slug' | 'stockName' | 'postCount' | 'isfollow' | 'issubscribed' | 'bseListingId' | 'nseListingId'>
    )> }
  )>> }
);

export type GetTrendingStocksByDollarTagQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetTrendingStocksByDollarTagQuery = (
  { __typename?: 'Query' }
  & { getTrendingStocksByDollarTag?: Maybe<Array<Maybe<(
    { __typename?: 'DollarTag' }
    & DollarTagFieldsFragment
  )>>> }
);

export type GetTrendingStocksV2QueryVariables = Exact<{
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetTrendingStocksV2Query = (
  { __typename?: 'Query' }
  & { getTrendingStocksV2: Array<Maybe<(
    { __typename?: 'Stock' }
    & Pick<Stock, 'postCount' | 'followers'>
    & StockFieldsFragment
  )>> }
);

export type GetTurnOffNotificationTextQueryVariables = Exact<{
  notificationId?: Maybe<Scalars['String']>;
}>;


export type GetTurnOffNotificationTextQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getTurnOffNotificationText'>
);

export type GetUniqueUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type GetUniqueUsernameQuery = (
  { __typename?: 'Query' }
  & { getUniqueUsername?: Maybe<(
    { __typename?: 'IsSuccess' }
    & Pick<IsSuccess, 'success'>
  )> }
);

export type GetUpcomingEventsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetUpcomingEventsQuery = (
  { __typename?: 'Query' }
  & { getUpcomingEvents?: Maybe<Array<Maybe<(
    { __typename?: 'UpcomingEventsList' }
    & Pick<UpcomingEventsList, 'eventId' | 'title' | 'imageUrl' | 'ctaButtonText' | 'ctaButtonUrl' | 'startTime' | 'endTime' | 'description'>
  )>>> }
);

export type GetUserFollowersQueryVariables = Exact<{
  userId: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetUserFollowersQuery = (
  { __typename?: 'Query' }
  & { getUserFollowers?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'isfollow'>
    & UserFieldsFragment
  )>>> }
);

export type GetUserFollowingsQueryVariables = Exact<{
  userId: Scalars['String'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetUserFollowingsQuery = (
  { __typename?: 'Query' }
  & { getUserFollowings?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'isfollow'>
    & UserFieldsFragment
  )>>> }
);

export type GetUserLevelNameFromSeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserLevelNameFromSeQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getUserLevelNameFromSE'>
);

export type GetUserListQueryVariables = Exact<{
  data?: Maybe<GetUserListArgs>;
}>;


export type GetUserListQuery = (
  { __typename?: 'Query' }
  & { getUserList: Array<Maybe<(
    { __typename?: 'User' }
    & UserFieldsFragment
  )>> }
);

export type GetUserWatchlistQueryVariables = Exact<{
  userId: Scalars['String'];
  type?: Maybe<DollarTagEnum>;
  offset?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type GetUserWatchlistQuery = (
  { __typename?: 'Query' }
  & { getUserWatchlist?: Maybe<Array<Maybe<(
    { __typename?: 'DollarTag' }
    & Pick<DollarTag, 'dollarTagId' | 'dollarTagName' | 'slug' | 'dollarTagType' | 'sourceEntityId' | 'isfollow'>
  )>>> }
);

export type GetVerifiedUsersQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetVerifiedUsersQuery = (
  { __typename?: 'Query' }
  & { getVerifiedUsers?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'cover' | 'isfollow'>
    & UserFieldsFragment
  )>>> }
);

export type GetViewOnlypermissionsFromTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewOnlypermissionsFromTokenQuery = (
  { __typename?: 'Query' }
  & { getViewOnlypermissionsFromToken?: Maybe<(
    { __typename?: 'PlatformActionPermissionsAlias' }
    & Pick<PlatformActionPermissionsAlias, 'cpo' | 'cupvo' | 'cdovo' | 'ccom' | 'crep' | 'csh' | 'crepo' | 'cbopo' | 'cjocl' | 'ccrcl' | 'cfous' | 'cfost' | 'cfoha' | 'cblus' | 'csu' | 'cre' | 'cseop'>
  )> }
);

export type GetVoterListQueryVariables = Exact<{
  pollId: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetVoterListQuery = (
  { __typename?: 'Query' }
  & { getVoterList?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'isfollow'>
    & UserFieldsFragment
  )>>> }
);

export type GetWatchlistCountQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetWatchlistCountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getWatchlistCount'>
);

export type GetZendeskTicketCommentsQueryVariables = Exact<{
  ticketId: Scalars['Int'];
}>;


export type GetZendeskTicketCommentsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getZendeskTicketComments'>
);

export type GetZendeskTicketTypeListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetZendeskTicketTypeListQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getZendeskTicketTypeList'>
);

export type GetZendeskTicketsByUserQueryVariables = Exact<{
  limit: Scalars['Int'];
  page: Scalars['Int'];
  filter?: Maybe<ZendeskSearchfilter>;
}>;


export type GetZendeskTicketsByUserQuery = (
  { __typename?: 'Query' }
  & { getZendeskTicketsByUser?: Maybe<(
    { __typename?: 'ZendeskTicketList' }
    & Pick<ZendeskTicketList, 'total' | 'tickets'>
  )> }
);

export type GetPostsByHashTagQueryVariables = Exact<{
  hashTagName?: Maybe<Scalars['String']>;
  page: Scalars['Int'];
}>;


export type GetPostsByHashTagQuery = (
  { __typename?: 'Query' }
  & { getPostsByHashTag: (
    { __typename?: 'PostWithTag' }
    & Pick<PostWithTag, 'discussions' | 'followers'>
    & { hashtag?: Maybe<(
      { __typename?: 'Hashtag' }
      & Pick<Hashtag, 'hashtagName' | 'hashtagType' | 'postCount' | 'isfollow' | 'issubscribed'>
    )>, post?: Maybe<Array<Maybe<(
      { __typename?: 'Post' }
      & Pick<Post, 'commentcount' | 'upvotecount' | 'downvotecount' | 'sharecount' | 'hasPoll' | 'clubId' | 'postId' | 'userId' | 'stockName' | 'target' | 'stopLoss' | 'ideaType' | 'text' | 'postType' | 'isUpvoted' | 'isDownvoted' | 'isbookmarked' | 'isSuspected' | 'createdAt' | 'updatedAt' | 'sharePostId' | 'userShares'>
      & { getPoll?: Maybe<(
        { __typename?: 'Poll' }
        & GetPollFieldsFragment
      )>, User?: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'id' | 'firstName' | 'lastName' | 'username' | 'avatar' | 'isVerified' | 'greenTick' | 'tick3'>
      )>, Club?: Maybe<(
        { __typename?: 'Club' }
        & Pick<Club, 'clubId' | 'clubHandle' | 'clubName'>
      )>, media?: Maybe<Array<Maybe<(
        { __typename?: 'Media' }
        & Pick<Media, 'type' | 'uri' | 'name' | 'height' | 'width' | 'rotation'>
      )>>>, tags?: Maybe<Array<Maybe<(
        { __typename?: 'Tag' }
        & Pick<Tag, 'startIndex' | 'endIndex' | 'name' | 'type' | 'id' | 'slug'>
      )>>>, linkPreview?: Maybe<(
        { __typename?: 'LinkPreview' }
        & Pick<LinkPreview, 'siteName' | 'images' | 'url' | 'description' | 'title'>
      )>, getSharedPost?: Maybe<(
        { __typename?: 'Post' }
        & GetSharedPostFieldsFragment
      )> }
    )>>> }
  ) }
);

export type IsFeatureVisibleQueryVariables = Exact<{
  featureName?: Maybe<Scalars['String']>;
}>;


export type IsFeatureVisibleQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isFeatureVisible'>
);

export type IsReportQueryVariables = Exact<{
  postId?: Maybe<Scalars['String']>;
  commentId?: Maybe<Scalars['String']>;
  replyId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
}>;


export type IsReportQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getIsReported'>
);

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = (
  { __typename?: 'Query' }
  & { me: (
    { __typename?: 'User' }
    & Pick<User, 'profileType' | 'showNpsV2' | 'watchlistVisibleStatus'>
    & { viewFeedPermission?: Maybe<(
      { __typename?: 'ViewFeedPermission' }
      & Pick<ViewFeedPermission, 'canViewPost' | 'canSeeMarketingPost'>
    )>, highlightedAchievements?: Maybe<Array<Maybe<(
      { __typename?: 'HighlightedAchievements' }
      & Pick<HighlightedAchievements, 'achievementType' | 'sourceOfClick' | 'promotionImage' | 'promotionText'>
      & { badges?: Maybe<(
        { __typename?: 'Badges' }
        & Pick<Badges, 'badgeId' | 'badgeName' | 'badgeIcon'>
      )> }
    )>>> }
    & UserFieldsFragment
  ) }
);

export type GetPeoplesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPeoplesQuery = (
  { __typename?: 'Query' }
  & { getPopularUsers?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'username' | 'firstName' | 'lastName' | 'avatar' | 'cover' | 'isfollow' | 'bio' | 'isVerified' | 'greenTick' | 'tick3'>
  )>>> }
);

export type GetPopularClubsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPopularClubsQuery = (
  { __typename?: 'Query' }
  & { private?: Maybe<Array<Maybe<(
    { __typename?: 'Club' }
    & ClubFieldsFragment
  )>>>, paid?: Maybe<Array<Maybe<(
    { __typename?: 'Club' }
    & ClubFieldsFragment
  )>>>, public?: Maybe<Array<Maybe<(
    { __typename?: 'Club' }
    & ClubFieldsFragment
  )>>> }
);

export type PopularUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type PopularUsersQuery = (
  { __typename?: 'Query' }
  & { getPopularUsers?: Maybe<Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'avatar' | 'cover' | 'isfollow' | 'bio' | 'tick3' | 'isVerified' | 'greenTick' | 'username'>
  )>>> }
);

export type PostMoreMenuQueryVariables = Exact<{
  postId: Scalars['String'];
}>;


export type PostMoreMenuQuery = (
  { __typename?: 'Query' }
  & { isFollowed: Query['isPostFollowed'], isBookmarked: Query['getIsBookmarked'], isReported: Query['getIsReported'] }
);

export type ProfileDetailsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ProfileDetailsQuery = (
  { __typename?: 'Query' }
  & { followers: Query['getFollowersCount'], followings: Query['getFollowingsCount'], clubs: Query['getClubsOfUserCount'] }
  & { profile?: Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'username' | 'firstName' | 'lastName' | 'avatar' | 'userLevel' | 'profileType' | 'isfollow' | 'issubscribed' | 'cover' | 'isVerified' | 'greenTick' | 'tick3' | 'email' | 'phone' | 'website' | 'bio' | 'facebookLink' | 'twitterLink' | 'youtubeLink' | 'avatarPostId' | 'coverPostId'>
  )> }
);

export type RepliesQueryVariables = Exact<{
  commentId?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
  take?: Maybe<Scalars['Int']>;
}>;


export type RepliesQuery = (
  { __typename?: 'Query' }
  & { getCommentDetails: (
    { __typename?: 'Comment' }
    & Pick<Comment, 'commentId' | 'isUpvoted' | 'isDownvoted' | 'textV2' | 'upvotecount' | 'downvotecount'>
    & { User?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'firstName' | 'lastName' | 'username' | 'avatar' | 'id' | 'isVerified' | 'greenTick' | 'tick3' | 'isUserDeleted'>
    )>, media?: Maybe<Array<Maybe<(
      { __typename?: 'Media' }
      & Pick<Media, 'type' | 'uri' | 'name'>
    )>>>, replies?: Maybe<Array<Maybe<(
      { __typename?: 'Reply' }
      & Pick<Reply, 'textV2' | 'isUpvoted' | 'replyId' | 'isDownvoted' | 'isSuspected' | 'upvotecount' | 'downvotecount' | 'createdAt'>
      & { media?: Maybe<Array<Maybe<(
        { __typename?: 'Media' }
        & Pick<Media, 'type' | 'uri' | 'name'>
      )>>>, User?: Maybe<(
        { __typename?: 'User' }
        & Pick<User, 'firstName' | 'lastName' | 'username' | 'avatar' | 'id' | 'isVerified' | 'greenTick' | 'isUserDeleted'>
      )> }
    )>>> }
  ) }
);

export type SearchStocksQueryVariables = Exact<{
  search: Scalars['String'];
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type SearchStocksQuery = (
  { __typename?: 'Query' }
  & { getStocksBySearchText: Array<Maybe<(
    { __typename?: 'TrendingStocktag' }
    & { stock?: Maybe<(
      { __typename?: 'Stock' }
      & Pick<Stock, 'securityId' | 'stockName' | 'slug' | 'postCount' | 'isfollow' | 'issubscribed'>
    )> }
  )>> }
);

export type SearchTopicQueryVariables = Exact<{
  search: Scalars['String'];
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type SearchTopicQuery = (
  { __typename?: 'Query' }
  & { getHashtagBySearchText: Array<Maybe<(
    { __typename?: 'TrendingHashTag' }
    & Pick<TrendingHashTag, 'userAvatars' | 'followers'>
    & { Hashtag?: Maybe<(
      { __typename?: 'Hashtag' }
      & Pick<Hashtag, 'hashtagName' | 'hashtagType' | 'postCount' | 'isfollow' | 'issubscribed'>
    )> }
  )>> }
);

export type SearchUserQueryVariables = Exact<{
  search: Scalars['String'];
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type SearchUserQuery = (
  { __typename?: 'Query' }
  & { getUserList: Array<Maybe<(
    { __typename?: 'User' }
    & Pick<User, 'id' | 'firstName' | 'lastName' | 'username' | 'userTags' | 'avatar' | 'cover' | 'email' | 'phone' | 'bio' | 'isfollow' | 'isVerified' | 'greenTick' | 'tick3'>
  )>> }
);

export type ShowEventsDotQueryVariables = Exact<{ [key: string]: never; }>;


export type ShowEventsDotQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'showEventsDot'>
);

export type UnifiedSearchQueryVariables = Exact<{
  searchText: Scalars['String'];
  type: SearchType;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type UnifiedSearchQuery = (
  { __typename?: 'Query' }
  & { unifiedSearch?: Maybe<Array<Maybe<(
    { __typename?: 'Search' }
    & { hashtag?: Maybe<(
      { __typename?: 'HashTagSearch' }
      & Pick<HashTagSearch, 'followers'>
      & { hashtag?: Maybe<(
        { __typename?: 'Hashtag' }
        & Pick<Hashtag, 'hashtagName' | 'postCount'>
      )> }
    )>, user?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'username' | 'firstName' | 'lastName' | 'avatar' | 'isVerified' | 'greenTick' | 'tick3'>
    )>, club?: Maybe<(
      { __typename?: 'Club' }
      & Pick<Club, 'clubId' | 'clubHandle' | 'clubName' | 'avatar' | 'clubBio'>
    )>, dollarTag?: Maybe<(
      { __typename?: 'DollarTagSearch' }
      & { dollarTag?: Maybe<(
        { __typename?: 'DollarTag' }
        & Pick<DollarTag, 'dollarTagId' | 'dollarTagName' | 'slug' | 'dollarTagType'>
      )> }
    )> }
  )>>> }
);

export type UnifiedSearchV2QueryVariables = Exact<{
  searchText: Scalars['String'];
  type: SearchType;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type UnifiedSearchV2Query = (
  { __typename?: 'Query' }
  & { unifiedSearchV2?: Maybe<Array<Maybe<(
    { __typename?: 'Search' }
    & { hashtag?: Maybe<(
      { __typename?: 'HashTagSearch' }
      & Pick<HashTagSearch, 'followers'>
      & { hashtag?: Maybe<(
        { __typename?: 'Hashtag' }
        & Pick<Hashtag, 'hashtagName' | 'postCount' | 'TagId'>
      )> }
    )>, user?: Maybe<(
      { __typename?: 'User' }
      & UserFieldsFragment
    )>, club?: Maybe<(
      { __typename?: 'Club' }
      & Pick<Club, 'clubId' | 'clubHandle' | 'clubName' | 'avatar' | 'clubBio'>
    )>, dollarTag?: Maybe<(
      { __typename?: 'DollarTagSearch' }
      & { dollarTag?: Maybe<(
        { __typename?: 'DollarTag' }
        & Pick<DollarTag, 'dollarTagId' | 'dollarTagName' | 'slug' | 'dollarTagType'>
      )> }
    )> }
  )>>> }
);

export type NewActivityCountSubscriptionVariables = Exact<{
  userId: Scalars['String'];
}>;


export type NewActivityCountSubscription = (
  { __typename?: 'Subscription' }
  & Pick<Subscription, 'newActivityCount'>
);

export type NotificationCreatedSubscriptionVariables = Exact<{
  userId: Scalars['String'];
  type: Type;
}>;


export type NotificationCreatedSubscription = (
  { __typename?: 'Subscription' }
  & { notificationCreated?: Maybe<(
    { __typename?: 'Notification' }
    & Pick<Notification, 'message' | 'link' | 'notificationId' | 'notificationType' | 'createdAt' | 'userId'>
    & { User?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'avatar' | 'username'>
    )>, Club?: Maybe<(
      { __typename?: 'Club' }
      & Pick<Club, 'clubId' | 'clubHandle' | 'clubName'>
    )>, Notifier?: Maybe<(
      { __typename?: 'User' }
      & Pick<User, 'id' | 'firstName' | 'lastName' | 'avatar' | 'username'>
    )> }
  )> }
);

export type NotificationCountSubscriptionVariables = Exact<{
  userId: Scalars['String'];
}>;


export type NotificationCountSubscription = (
  { __typename?: 'Subscription' }
  & { counts: Subscription['notificationCount'] }
);

export const ClubFieldsFragmentDoc = gql`
    fragment ClubFields on Club {
  clubId
  clubName
  clubHeadline
  clubHandle
  clubBio
  ownerId
  avatar
  cover
  ismember
  issubscribed
  totalMemberCount
  disclaimer
  showDisclaimer
  canJoinClub
  displayCategoryName
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  firstName
  lastName
  username
  avatar
  isVerified
  greenTick
  tick3
  isUserDeleted
  membershipLevel
}
    `;
export const CommentFieldsFragmentDoc = gql`
    fragment CommentFields on Comment {
  textV2
  media {
    type
    uri
    name
  }
  commentId
  isUpvoted
  isDownvoted
  isSuspected
  upvotecount
  downvotecount
  replycount
  createdAt
  User {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const UpvoteDownvotePostFragmentDoc = gql`
    fragment UpvoteDownvotePost on Post {
  isUpvoted
  isDownvoted
  upvotecount
  downvotecount
}
    `;
export const UpdatePostFragmentDoc = gql`
    fragment UpdatePost on Post {
  isUpvoted
  isDownvoted
  upvotecount
  downvotecount
  commentcount
  sharecount
}
    `;
export const BookmarkPostFragmentDoc = gql`
    fragment BookmarkPost on Post {
  isbookmarked
}
    `;
export const UpdateCommentFragmentDoc = gql`
    fragment UpdateComment on Comment {
  isUpvoted
  isDownvoted
  upvotecount
  downvotecount
  replycount
}
    `;
export const UpdateReplyFragmentDoc = gql`
    fragment UpdateReply on Reply {
  isUpvoted
  isDownvoted
  upvotecount
  downvotecount
}
    `;
export const DollarTagFieldsFragmentDoc = gql`
    fragment DollarTagFields on DollarTag {
  dollarTagId
  dollarTagName
  slug
  dollarTagType
  sourceEntityId
  isfollow
  issubscribed
  followers
  postCount
}
    `;
export const HashTagFieldsFragmentDoc = gql`
    fragment HashTagFields on Hashtag {
  hashtagName
  postCount
  isfollow
  issubscribed
  followers
}
    `;
export const UpdatePollFragmentDoc = gql`
    fragment UpdatePoll on Poll {
  votes
  hasUserSelected
  options {
    optionId
    pollId
    optionText
    hasUserSelected
    votes
  }
}
    `;
export const StockFieldsFragmentDoc = gql`
    fragment StockFields on Stock {
  securityId
  stockName
  slug
  isfollow
  issubscribed
}
    `;
export const UpdateUserFragmentDoc = gql`
    fragment UpdateUser on User {
  isfollow
  issubscribed
  avatar
  cover
  profileType
}
    `;
export const UpdateStockFragmentDoc = gql`
    fragment UpdateStock on Stock {
  isfollow
  issubscribed
  followers
}
    `;
export const UpdateHashtagFragmentDoc = gql`
    fragment UpdateHashtag on Hashtag {
  isfollow
  issubscribed
  followers
}
    `;
export const UpdateClubFragmentDoc = gql`
    fragment UpdateClub on Club {
  ismember
  issubscribed
  totalMemberCount
}
    `;
export const GetPollFieldsFragmentDoc = gql`
    fragment GetPollFields on Poll {
  pollId
  question
  userId
  postId
  createdAt
  updatedAt
  expiryEnum
  expiryDate
  hasUserSelected
  hasExpired
  votes
  options {
    optionId
    pollId
    optionText
    hasUserSelected
    votes
  }
}
    `;
export const GetSharedPostFieldsFragmentDoc = gql`
    fragment GetSharedPostFields on Post {
  postId
  User {
    ...UserFields
  }
  Club {
    clubId
    clubHandle
    clubName
  }
  media {
    type
    uri
    name
    height
    width
    rotation
  }
  textV2
  hasPoll
  getPoll {
    ...GetPollFields
  }
  createdAt
  isSuspected
  clubPostShareSetting {
    isVerifiedCanShare
    greenTickCanShare
    normalUserCanShare
  }
}
    ${UserFieldsFragmentDoc}
${GetPollFieldsFragmentDoc}`;
export const PostFieldsFragmentDoc = gql`
    fragment PostFields on Post {
  postId
  User {
    ...UserFields
  }
  Club {
    clubId
    clubHandle
    clubName
    canJoinClub
    showDisclaimer
    disclaimer
  }
  media {
    type
    uri
    name
    height
    width
    rotation
  }
  textV2
  hasPoll
  getPoll {
    ...GetPollFields
  }
  createdAt
  upvotecount
  downvotecount
  sharecount
  commentcount
  isUpvoted
  isDownvoted
  isbookmarked
  isSuspected
  isEdited
  isFollowed
  sharePostId
  getSharedPost {
    ...GetSharedPostFields
  }
  clubPostShareSetting {
    isVerifiedCanShare
    greenTickCanShare
    normalUserCanShare
  }
  meta {
    isCover
    isAvatar
  }
}
    ${UserFieldsFragmentDoc}
${GetPollFieldsFragmentDoc}
${GetSharedPostFieldsFragmentDoc}`;
export const ReplyFieldsFragmentDoc = gql`
    fragment ReplyFields on Reply {
  textV2
  media {
    type
    uri
    name
  }
  replyId
  isUpvoted
  isDownvoted
  isSuspected
  createdAt
  upvotecount
  downvotecount
  User {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const UpdateNotificationFragmentDoc = gql`
    fragment UpdateNotification on Notification {
  read
}
    `;
export const SEsignupViaOidc_V2Document = gql`
    mutation SEsignupViaOIDC_V2($data: SignupUserInput!, $interimToken: String!, $AcceptTerms: Boolean) {
  SEsignupViaOIDC_V2(
    data: $data
    interimToken: $interimToken
    AcceptTerms: $AcceptTerms
  ) {
    isUserMemberOfStockEdgeClub
    error
    user {
      id
      username
      showNpsV2
      canBeOnboarded
    }
    isViewOnly
    profileDetails {
      Id
      UserName
      Email
      Firstname
      Lastname
      RegisteredOn
      Gender
      ImageFilePath
    }
  }
}
    `;
export type SEsignupViaOidc_V2MutationFn = Apollo.MutationFunction<SEsignupViaOidc_V2Mutation, SEsignupViaOidc_V2MutationVariables>;

/**
 * __useSEsignupViaOidc_V2Mutation__
 *
 * To run a mutation, you first call `useSEsignupViaOidc_V2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSEsignupViaOidc_V2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sEsignupViaOidcV2Mutation, { data, loading, error }] = useSEsignupViaOidc_V2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *      interimToken: // value for 'interimToken'
 *      AcceptTerms: // value for 'AcceptTerms'
 *   },
 * });
 */
export function useSEsignupViaOidc_V2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SEsignupViaOidc_V2Mutation, SEsignupViaOidc_V2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SEsignupViaOidc_V2Mutation, SEsignupViaOidc_V2MutationVariables>(SEsignupViaOidc_V2Document, options);
      }
export type SEsignupViaOidc_V2MutationHookResult = ReturnType<typeof useSEsignupViaOidc_V2Mutation>;
export type SEsignupViaOidc_V2MutationResult = Apollo.MutationResult<SEsignupViaOidc_V2Mutation>;
export type SEsignupViaOidc_V2MutationOptions = Apollo.BaseMutationOptions<SEsignupViaOidc_V2Mutation, SEsignupViaOidc_V2MutationVariables>;
export const AccountSyncDocument = gql`
    mutation accountSync {
  accountSync {
    success
    message
  }
}
    `;
export type AccountSyncMutationFn = Apollo.MutationFunction<AccountSyncMutation, AccountSyncMutationVariables>;

/**
 * __useAccountSyncMutation__
 *
 * To run a mutation, you first call `useAccountSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountSyncMutation, { data, loading, error }] = useAccountSyncMutation({
 *   variables: {
 *   },
 * });
 */
export function useAccountSyncMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AccountSyncMutation, AccountSyncMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AccountSyncMutation, AccountSyncMutationVariables>(AccountSyncDocument, options);
      }
export type AccountSyncMutationHookResult = ReturnType<typeof useAccountSyncMutation>;
export type AccountSyncMutationResult = Apollo.MutationResult<AccountSyncMutation>;
export type AccountSyncMutationOptions = Apollo.BaseMutationOptions<AccountSyncMutation, AccountSyncMutationVariables>;
export const AddNotificationTokenDocument = gql`
    mutation AddNotificationToken($notificationToken: String, $deviceType: DeviceType) {
  addNotificationToken(
    notificationToken: $notificationToken
    deviceType: $deviceType
  ) {
    success
  }
}
    `;
export type AddNotificationTokenMutationFn = Apollo.MutationFunction<AddNotificationTokenMutation, AddNotificationTokenMutationVariables>;

/**
 * __useAddNotificationTokenMutation__
 *
 * To run a mutation, you first call `useAddNotificationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNotificationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNotificationTokenMutation, { data, loading, error }] = useAddNotificationTokenMutation({
 *   variables: {
 *      notificationToken: // value for 'notificationToken'
 *      deviceType: // value for 'deviceType'
 *   },
 * });
 */
export function useAddNotificationTokenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNotificationTokenMutation, AddNotificationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddNotificationTokenMutation, AddNotificationTokenMutationVariables>(AddNotificationTokenDocument, options);
      }
export type AddNotificationTokenMutationHookResult = ReturnType<typeof useAddNotificationTokenMutation>;
export type AddNotificationTokenMutationResult = Apollo.MutationResult<AddNotificationTokenMutation>;
export type AddNotificationTokenMutationOptions = Apollo.BaseMutationOptions<AddNotificationTokenMutation, AddNotificationTokenMutationVariables>;
export const AddBadgeJourneyFeedbackDocument = gql`
    mutation addBadgeJourneyFeedback($questionResponse: [FeedbackQuestionResponseInput]) {
  addBadgeJourneyFeedback(questionResponse: $questionResponse) {
    success
    message
  }
}
    `;
export type AddBadgeJourneyFeedbackMutationFn = Apollo.MutationFunction<AddBadgeJourneyFeedbackMutation, AddBadgeJourneyFeedbackMutationVariables>;

/**
 * __useAddBadgeJourneyFeedbackMutation__
 *
 * To run a mutation, you first call `useAddBadgeJourneyFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddBadgeJourneyFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addBadgeJourneyFeedbackMutation, { data, loading, error }] = useAddBadgeJourneyFeedbackMutation({
 *   variables: {
 *      questionResponse: // value for 'questionResponse'
 *   },
 * });
 */
export function useAddBadgeJourneyFeedbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddBadgeJourneyFeedbackMutation, AddBadgeJourneyFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddBadgeJourneyFeedbackMutation, AddBadgeJourneyFeedbackMutationVariables>(AddBadgeJourneyFeedbackDocument, options);
      }
export type AddBadgeJourneyFeedbackMutationHookResult = ReturnType<typeof useAddBadgeJourneyFeedbackMutation>;
export type AddBadgeJourneyFeedbackMutationResult = Apollo.MutationResult<AddBadgeJourneyFeedbackMutation>;
export type AddBadgeJourneyFeedbackMutationOptions = Apollo.BaseMutationOptions<AddBadgeJourneyFeedbackMutation, AddBadgeJourneyFeedbackMutationVariables>;
export const AddGuidedTourStatusForUserDocument = gql`
    mutation addGuidedTourStatusForUser($visitedTourKeys: [Float], $tourComponent: String, $tourSource: TourSourceType) {
  addGuidedTourStatusForUser(
    visitedTourKeys: $visitedTourKeys
    tourComponent: $tourComponent
    tourSource: $tourSource
  ) {
    success
    message
  }
}
    `;
export type AddGuidedTourStatusForUserMutationFn = Apollo.MutationFunction<AddGuidedTourStatusForUserMutation, AddGuidedTourStatusForUserMutationVariables>;

/**
 * __useAddGuidedTourStatusForUserMutation__
 *
 * To run a mutation, you first call `useAddGuidedTourStatusForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGuidedTourStatusForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGuidedTourStatusForUserMutation, { data, loading, error }] = useAddGuidedTourStatusForUserMutation({
 *   variables: {
 *      visitedTourKeys: // value for 'visitedTourKeys'
 *      tourComponent: // value for 'tourComponent'
 *      tourSource: // value for 'tourSource'
 *   },
 * });
 */
export function useAddGuidedTourStatusForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddGuidedTourStatusForUserMutation, AddGuidedTourStatusForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddGuidedTourStatusForUserMutation, AddGuidedTourStatusForUserMutationVariables>(AddGuidedTourStatusForUserDocument, options);
      }
export type AddGuidedTourStatusForUserMutationHookResult = ReturnType<typeof useAddGuidedTourStatusForUserMutation>;
export type AddGuidedTourStatusForUserMutationResult = Apollo.MutationResult<AddGuidedTourStatusForUserMutation>;
export type AddGuidedTourStatusForUserMutationOptions = Apollo.BaseMutationOptions<AddGuidedTourStatusForUserMutation, AddGuidedTourStatusForUserMutationVariables>;
export const AddNpsRatingForWebDocument = gql`
    mutation addNpsRatingForWeb($rating: Int, $reason: String, $RecaptchaToken: String!, $platformType: DeviceType!) {
  addNpsRatingForWeb(
    rating: $rating
    reason: $reason
    RecaptchaToken: $RecaptchaToken
    platformType: $platformType
  ) {
    success
    message
  }
}
    `;
export type AddNpsRatingForWebMutationFn = Apollo.MutationFunction<AddNpsRatingForWebMutation, AddNpsRatingForWebMutationVariables>;

/**
 * __useAddNpsRatingForWebMutation__
 *
 * To run a mutation, you first call `useAddNpsRatingForWebMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNpsRatingForWebMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNpsRatingForWebMutation, { data, loading, error }] = useAddNpsRatingForWebMutation({
 *   variables: {
 *      rating: // value for 'rating'
 *      reason: // value for 'reason'
 *      RecaptchaToken: // value for 'RecaptchaToken'
 *      platformType: // value for 'platformType'
 *   },
 * });
 */
export function useAddNpsRatingForWebMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNpsRatingForWebMutation, AddNpsRatingForWebMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddNpsRatingForWebMutation, AddNpsRatingForWebMutationVariables>(AddNpsRatingForWebDocument, options);
      }
export type AddNpsRatingForWebMutationHookResult = ReturnType<typeof useAddNpsRatingForWebMutation>;
export type AddNpsRatingForWebMutationResult = Apollo.MutationResult<AddNpsRatingForWebMutation>;
export type AddNpsRatingForWebMutationOptions = Apollo.BaseMutationOptions<AddNpsRatingForWebMutation, AddNpsRatingForWebMutationVariables>;
export const BlockUserDocument = gql`
    mutation blockUser($id: String!) {
  blockUser(id: $id) {
    success
    message
  }
}
    `;
export type BlockUserMutationFn = Apollo.MutationFunction<BlockUserMutation, BlockUserMutationVariables>;

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BlockUserMutation, BlockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BlockUserMutation, BlockUserMutationVariables>(BlockUserDocument, options);
      }
export type BlockUserMutationHookResult = ReturnType<typeof useBlockUserMutation>;
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>;
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<BlockUserMutation, BlockUserMutationVariables>;
export const CancelFollowDocument = gql`
    mutation CancelFollow($data: FollowArgs) {
  cancelFollow(data: $data) {
    success
  }
}
    `;
export type CancelFollowMutationFn = Apollo.MutationFunction<CancelFollowMutation, CancelFollowMutationVariables>;

/**
 * __useCancelFollowMutation__
 *
 * To run a mutation, you first call `useCancelFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelFollowMutation, { data, loading, error }] = useCancelFollowMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCancelFollowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelFollowMutation, CancelFollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelFollowMutation, CancelFollowMutationVariables>(CancelFollowDocument, options);
      }
export type CancelFollowMutationHookResult = ReturnType<typeof useCancelFollowMutation>;
export type CancelFollowMutationResult = Apollo.MutationResult<CancelFollowMutation>;
export type CancelFollowMutationOptions = Apollo.BaseMutationOptions<CancelFollowMutation, CancelFollowMutationVariables>;
export const CreateBookmarkDocument = gql`
    mutation CreateBookmark($data: CreateBookmark!) {
  createBookmark(data: $data) {
    postId
    userId
    timestamp
  }
}
    `;
export type CreateBookmarkMutationFn = Apollo.MutationFunction<CreateBookmarkMutation, CreateBookmarkMutationVariables>;

/**
 * __useCreateBookmarkMutation__
 *
 * To run a mutation, you first call `useCreateBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookmarkMutation, { data, loading, error }] = useCreateBookmarkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateBookmarkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBookmarkMutation, CreateBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBookmarkMutation, CreateBookmarkMutationVariables>(CreateBookmarkDocument, options);
      }
export type CreateBookmarkMutationHookResult = ReturnType<typeof useCreateBookmarkMutation>;
export type CreateBookmarkMutationResult = Apollo.MutationResult<CreateBookmarkMutation>;
export type CreateBookmarkMutationOptions = Apollo.BaseMutationOptions<CreateBookmarkMutation, CreateBookmarkMutationVariables>;
export const CreateFeedbackDocument = gql`
    mutation createFeedback($data: FeedbackInput) {
  createFeedback(data: $data) {
    feedbackId
    type
    subject
    comment
    status
    attachment {
      type
      uri
      name
    }
  }
}
    `;
export type CreateFeedbackMutationFn = Apollo.MutationFunction<CreateFeedbackMutation, CreateFeedbackMutationVariables>;

/**
 * __useCreateFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackMutation, { data, loading, error }] = useCreateFeedbackMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFeedbackMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument, options);
      }
export type CreateFeedbackMutationHookResult = ReturnType<typeof useCreateFeedbackMutation>;
export type CreateFeedbackMutationResult = Apollo.MutationResult<CreateFeedbackMutation>;
export type CreateFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const CreatePostDocument = gql`
    mutation CreatePost($data: PostInput!) {
  createPostAsync(data: $data) {
    postId
  }
}
    `;
export type CreatePostMutationFn = Apollo.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
      }
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const CreateCommentV2Document = gql`
    mutation createCommentV2($data: CommentInput, $clubId: String, $clubBasedPermissionToken: String) {
  createCommentV2(
    data: $data
    clubId: $clubId
    clubBasedPermissionToken: $clubBasedPermissionToken
  ) {
    ...CommentFields
    replies {
      ...ReplyFields
    }
  }
}
    ${CommentFieldsFragmentDoc}
${ReplyFieldsFragmentDoc}`;
export type CreateCommentV2MutationFn = Apollo.MutationFunction<CreateCommentV2Mutation, CreateCommentV2MutationVariables>;

/**
 * __useCreateCommentV2Mutation__
 *
 * To run a mutation, you first call `useCreateCommentV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentV2Mutation, { data, loading, error }] = useCreateCommentV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubId: // value for 'clubId'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *   },
 * });
 */
export function useCreateCommentV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCommentV2Mutation, CreateCommentV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCommentV2Mutation, CreateCommentV2MutationVariables>(CreateCommentV2Document, options);
      }
export type CreateCommentV2MutationHookResult = ReturnType<typeof useCreateCommentV2Mutation>;
export type CreateCommentV2MutationResult = Apollo.MutationResult<CreateCommentV2Mutation>;
export type CreateCommentV2MutationOptions = Apollo.BaseMutationOptions<CreateCommentV2Mutation, CreateCommentV2MutationVariables>;
export const CreatePostV2Document = gql`
    mutation createPostV2($data: PostInput) {
  createPostV2(data: $data) {
    postId
  }
}
    `;
export type CreatePostV2MutationFn = Apollo.MutationFunction<CreatePostV2Mutation, CreatePostV2MutationVariables>;

/**
 * __useCreatePostV2Mutation__
 *
 * To run a mutation, you first call `useCreatePostV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostV2Mutation, { data, loading, error }] = useCreatePostV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePostV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePostV2Mutation, CreatePostV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePostV2Mutation, CreatePostV2MutationVariables>(CreatePostV2Document, options);
      }
export type CreatePostV2MutationHookResult = ReturnType<typeof useCreatePostV2Mutation>;
export type CreatePostV2MutationResult = Apollo.MutationResult<CreatePostV2Mutation>;
export type CreatePostV2MutationOptions = Apollo.BaseMutationOptions<CreatePostV2Mutation, CreatePostV2MutationVariables>;
export const CreateReplyV2Document = gql`
    mutation createReplyV2($data: ReplyInput, $clubBasedPermissionToken: String, $clubId: String) {
  createReplyV2(
    data: $data
    clubBasedPermissionToken: $clubBasedPermissionToken
    clubId: $clubId
  ) {
    ...ReplyFields
  }
}
    ${ReplyFieldsFragmentDoc}`;
export type CreateReplyV2MutationFn = Apollo.MutationFunction<CreateReplyV2Mutation, CreateReplyV2MutationVariables>;

/**
 * __useCreateReplyV2Mutation__
 *
 * To run a mutation, you first call `useCreateReplyV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReplyV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReplyV2Mutation, { data, loading, error }] = useCreateReplyV2Mutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useCreateReplyV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateReplyV2Mutation, CreateReplyV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateReplyV2Mutation, CreateReplyV2MutationVariables>(CreateReplyV2Document, options);
      }
export type CreateReplyV2MutationHookResult = ReturnType<typeof useCreateReplyV2Mutation>;
export type CreateReplyV2MutationResult = Apollo.MutationResult<CreateReplyV2Mutation>;
export type CreateReplyV2MutationOptions = Apollo.BaseMutationOptions<CreateReplyV2Mutation, CreateReplyV2MutationVariables>;
export const CreateReportDocument = gql`
    mutation createReport($data: CreateReportInput) {
  createReport(data: $data) {
    repId
    ReportId
    reporter {
      id
      firstName
      lastName
      username
    }
    remark
    reportedBy
    reportedOn
    reportTime
    reportType
    Post {
      postId
      text
    }
    Comment {
      commentId
      text
    }
    Reply {
      replyId
      text
    }
  }
}
    `;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const CreateZendeskTicketDocument = gql`
    mutation createZendeskTicket($data: TicketInput) {
  createZendeskTicket(data: $data)
}
    `;
export type CreateZendeskTicketMutationFn = Apollo.MutationFunction<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>;

/**
 * __useCreateZendeskTicketMutation__
 *
 * To run a mutation, you first call `useCreateZendeskTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZendeskTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZendeskTicketMutation, { data, loading, error }] = useCreateZendeskTicketMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateZendeskTicketMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>(CreateZendeskTicketDocument, options);
      }
export type CreateZendeskTicketMutationHookResult = ReturnType<typeof useCreateZendeskTicketMutation>;
export type CreateZendeskTicketMutationResult = Apollo.MutationResult<CreateZendeskTicketMutation>;
export type CreateZendeskTicketMutationOptions = Apollo.BaseMutationOptions<CreateZendeskTicketMutation, CreateZendeskTicketMutationVariables>;
export const CreateZendeskTicketCommentDocument = gql`
    mutation createZendeskTicketComment($data: TicketCommentInput, $ticketId: Int!) {
  createZendeskTicketComment(data: $data, ticketId: $ticketId)
}
    `;
export type CreateZendeskTicketCommentMutationFn = Apollo.MutationFunction<CreateZendeskTicketCommentMutation, CreateZendeskTicketCommentMutationVariables>;

/**
 * __useCreateZendeskTicketCommentMutation__
 *
 * To run a mutation, you first call `useCreateZendeskTicketCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateZendeskTicketCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createZendeskTicketCommentMutation, { data, loading, error }] = useCreateZendeskTicketCommentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useCreateZendeskTicketCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateZendeskTicketCommentMutation, CreateZendeskTicketCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateZendeskTicketCommentMutation, CreateZendeskTicketCommentMutationVariables>(CreateZendeskTicketCommentDocument, options);
      }
export type CreateZendeskTicketCommentMutationHookResult = ReturnType<typeof useCreateZendeskTicketCommentMutation>;
export type CreateZendeskTicketCommentMutationResult = Apollo.MutationResult<CreateZendeskTicketCommentMutation>;
export type CreateZendeskTicketCommentMutationOptions = Apollo.BaseMutationOptions<CreateZendeskTicketCommentMutation, CreateZendeskTicketCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($data: CommentId, $clubId: String) {
  deleteComment(data: $data, clubId: $clubId) {
    success
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeletePostDocument = gql`
    mutation DeletePost($data: DeletePostInput, $clubId: String) {
  deletePost(data: $data, clubId: $clubId) {
    success
  }
}
    `;
export type DeletePostMutationFn = Apollo.MutationFunction<DeletePostMutation, DeletePostMutationVariables>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDeletePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePostMutation, DeletePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument, options);
      }
export type DeletePostMutationHookResult = ReturnType<typeof useDeletePostMutation>;
export type DeletePostMutationResult = Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<DeletePostMutation, DeletePostMutationVariables>;
export const DeleteReplyDocument = gql`
    mutation deleteReply($data: ReplyId, $clubId: String) {
  deleteReply(data: $data, clubId: $clubId) {
    success
  }
}
    `;
export type DeleteReplyMutationFn = Apollo.MutationFunction<DeleteReplyMutation, DeleteReplyMutationVariables>;

/**
 * __useDeleteReplyMutation__
 *
 * To run a mutation, you first call `useDeleteReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReplyMutation, { data, loading, error }] = useDeleteReplyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDeleteReplyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteReplyMutation, DeleteReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteReplyMutation, DeleteReplyMutationVariables>(DeleteReplyDocument, options);
      }
export type DeleteReplyMutationHookResult = ReturnType<typeof useDeleteReplyMutation>;
export type DeleteReplyMutationResult = Apollo.MutationResult<DeleteReplyMutation>;
export type DeleteReplyMutationOptions = Apollo.BaseMutationOptions<DeleteReplyMutation, DeleteReplyMutationVariables>;
export const DollarFollowDocument = gql`
    mutation dollarFollow($dollarTagId: String!) {
  dollarFollow(dollarTagId: $dollarTagId) {
    dollarTagId
    isfollow
    issubscribed
    followers
  }
}
    `;
export type DollarFollowMutationFn = Apollo.MutationFunction<DollarFollowMutation, DollarFollowMutationVariables>;

/**
 * __useDollarFollowMutation__
 *
 * To run a mutation, you first call `useDollarFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDollarFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dollarFollowMutation, { data, loading, error }] = useDollarFollowMutation({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useDollarFollowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DollarFollowMutation, DollarFollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DollarFollowMutation, DollarFollowMutationVariables>(DollarFollowDocument, options);
      }
export type DollarFollowMutationHookResult = ReturnType<typeof useDollarFollowMutation>;
export type DollarFollowMutationResult = Apollo.MutationResult<DollarFollowMutation>;
export type DollarFollowMutationOptions = Apollo.BaseMutationOptions<DollarFollowMutation, DollarFollowMutationVariables>;
export const DollarSubscribeDocument = gql`
    mutation DollarSubscribe($dollarTagId: String!) {
  dollarSubscribe(dollarTagId: $dollarTagId) {
    dollarTagId
    isfollow
    issubscribed
    followers
  }
}
    `;
export type DollarSubscribeMutationFn = Apollo.MutationFunction<DollarSubscribeMutation, DollarSubscribeMutationVariables>;

/**
 * __useDollarSubscribeMutation__
 *
 * To run a mutation, you first call `useDollarSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDollarSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dollarSubscribeMutation, { data, loading, error }] = useDollarSubscribeMutation({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useDollarSubscribeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DollarSubscribeMutation, DollarSubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DollarSubscribeMutation, DollarSubscribeMutationVariables>(DollarSubscribeDocument, options);
      }
export type DollarSubscribeMutationHookResult = ReturnType<typeof useDollarSubscribeMutation>;
export type DollarSubscribeMutationResult = Apollo.MutationResult<DollarSubscribeMutation>;
export type DollarSubscribeMutationOptions = Apollo.BaseMutationOptions<DollarSubscribeMutation, DollarSubscribeMutationVariables>;
export const DollarUnfollowDocument = gql`
    mutation DollarUnfollow($dollarTagId: String!) {
  dollarUnfollow(dollarTagId: $dollarTagId) {
    dollarTagId
    isfollow
    issubscribed
    followers
  }
}
    `;
export type DollarUnfollowMutationFn = Apollo.MutationFunction<DollarUnfollowMutation, DollarUnfollowMutationVariables>;

/**
 * __useDollarUnfollowMutation__
 *
 * To run a mutation, you first call `useDollarUnfollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDollarUnfollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dollarUnfollowMutation, { data, loading, error }] = useDollarUnfollowMutation({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useDollarUnfollowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DollarUnfollowMutation, DollarUnfollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DollarUnfollowMutation, DollarUnfollowMutationVariables>(DollarUnfollowDocument, options);
      }
export type DollarUnfollowMutationHookResult = ReturnType<typeof useDollarUnfollowMutation>;
export type DollarUnfollowMutationResult = Apollo.MutationResult<DollarUnfollowMutation>;
export type DollarUnfollowMutationOptions = Apollo.BaseMutationOptions<DollarUnfollowMutation, DollarUnfollowMutationVariables>;
export const DollarUnsubscribeDocument = gql`
    mutation DollarUnsubscribe($dollarTagId: String!) {
  dollarUnsubscribe(dollarTagId: $dollarTagId) {
    dollarTagId
    isfollow
    issubscribed
    followers
  }
}
    `;
export type DollarUnsubscribeMutationFn = Apollo.MutationFunction<DollarUnsubscribeMutation, DollarUnsubscribeMutationVariables>;

/**
 * __useDollarUnsubscribeMutation__
 *
 * To run a mutation, you first call `useDollarUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDollarUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dollarUnsubscribeMutation, { data, loading, error }] = useDollarUnsubscribeMutation({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useDollarUnsubscribeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DollarUnsubscribeMutation, DollarUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DollarUnsubscribeMutation, DollarUnsubscribeMutationVariables>(DollarUnsubscribeDocument, options);
      }
export type DollarUnsubscribeMutationHookResult = ReturnType<typeof useDollarUnsubscribeMutation>;
export type DollarUnsubscribeMutationResult = Apollo.MutationResult<DollarUnsubscribeMutation>;
export type DollarUnsubscribeMutationOptions = Apollo.BaseMutationOptions<DollarUnsubscribeMutation, DollarUnsubscribeMutationVariables>;
export const DownvoteDocument = gql`
    mutation downvote($data: VoteInput, $clubBasedPermissionToken: String, $clubId: String) {
  downvote(
    data: $data
    clubId: $clubId
    clubBasedPermissionToken: $clubBasedPermissionToken
  ) {
    success
    upvotes
    downvotes
  }
}
    `;
export type DownvoteMutationFn = Apollo.MutationFunction<DownvoteMutation, DownvoteMutationVariables>;

/**
 * __useDownvoteMutation__
 *
 * To run a mutation, you first call `useDownvoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownvoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downvoteMutation, { data, loading, error }] = useDownvoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useDownvoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DownvoteMutation, DownvoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DownvoteMutation, DownvoteMutationVariables>(DownvoteDocument, options);
      }
export type DownvoteMutationHookResult = ReturnType<typeof useDownvoteMutation>;
export type DownvoteMutationResult = Apollo.MutationResult<DownvoteMutation>;
export type DownvoteMutationOptions = Apollo.BaseMutationOptions<DownvoteMutation, DownvoteMutationVariables>;
export const FollowUserDocument = gql`
    mutation FollowUser($userId: String!) {
  follow(data: {id: $userId, entity: User}) {
    success
  }
}
    `;
export type FollowUserMutationFn = Apollo.MutationFunction<FollowUserMutation, FollowUserMutationVariables>;

/**
 * __useFollowUserMutation__
 *
 * To run a mutation, you first call `useFollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserMutation, { data, loading, error }] = useFollowUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFollowUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FollowUserMutation, FollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FollowUserMutation, FollowUserMutationVariables>(FollowUserDocument, options);
      }
export type FollowUserMutationHookResult = ReturnType<typeof useFollowUserMutation>;
export type FollowUserMutationResult = Apollo.MutationResult<FollowUserMutation>;
export type FollowUserMutationOptions = Apollo.BaseMutationOptions<FollowUserMutation, FollowUserMutationVariables>;
export const FollowDocument = gql`
    mutation Follow($data: FollowArgs) {
  follow(data: $data) {
    success
    followStatus
  }
}
    `;
export type FollowMutationFn = Apollo.MutationFunction<FollowMutation, FollowMutationVariables>;

/**
 * __useFollowMutation__
 *
 * To run a mutation, you first call `useFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followMutation, { data, loading, error }] = useFollowMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFollowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FollowMutation, FollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FollowMutation, FollowMutationVariables>(FollowDocument, options);
      }
export type FollowMutationHookResult = ReturnType<typeof useFollowMutation>;
export type FollowMutationResult = Apollo.MutationResult<FollowMutation>;
export type FollowMutationOptions = Apollo.BaseMutationOptions<FollowMutation, FollowMutationVariables>;
export const FollowPostDocument = gql`
    mutation followPost($data: FollowPostInput!) {
  followPost(data: $data) {
    post {
      postId
      isFollowed
    }
    message
  }
}
    `;
export type FollowPostMutationFn = Apollo.MutationFunction<FollowPostMutation, FollowPostMutationVariables>;

/**
 * __useFollowPostMutation__
 *
 * To run a mutation, you first call `useFollowPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followPostMutation, { data, loading, error }] = useFollowPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFollowPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FollowPostMutation, FollowPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FollowPostMutation, FollowPostMutationVariables>(FollowPostDocument, options);
      }
export type FollowPostMutationHookResult = ReturnType<typeof useFollowPostMutation>;
export type FollowPostMutationResult = Apollo.MutationResult<FollowPostMutation>;
export type FollowPostMutationOptions = Apollo.BaseMutationOptions<FollowPostMutation, FollowPostMutationVariables>;
export const HasSeenPopUpDocument = gql`
    mutation hasSeenPopUp($popUpType: String) {
  hasSeenPopUp(popUpType: $popUpType) {
    success {
      success
      message
    }
  }
}
    `;
export type HasSeenPopUpMutationFn = Apollo.MutationFunction<HasSeenPopUpMutation, HasSeenPopUpMutationVariables>;

/**
 * __useHasSeenPopUpMutation__
 *
 * To run a mutation, you first call `useHasSeenPopUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHasSeenPopUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hasSeenPopUpMutation, { data, loading, error }] = useHasSeenPopUpMutation({
 *   variables: {
 *      popUpType: // value for 'popUpType'
 *   },
 * });
 */
export function useHasSeenPopUpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<HasSeenPopUpMutation, HasSeenPopUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<HasSeenPopUpMutation, HasSeenPopUpMutationVariables>(HasSeenPopUpDocument, options);
      }
export type HasSeenPopUpMutationHookResult = ReturnType<typeof useHasSeenPopUpMutation>;
export type HasSeenPopUpMutationResult = Apollo.MutationResult<HasSeenPopUpMutation>;
export type HasSeenPopUpMutationOptions = Apollo.BaseMutationOptions<HasSeenPopUpMutation, HasSeenPopUpMutationVariables>;
export const IgnoreNpsRatingDocument = gql`
    mutation ignoreNpsRating($source: NpsIgnoreSource) {
  ignoreNpsRating(source: $source) {
    success
    message
  }
}
    `;
export type IgnoreNpsRatingMutationFn = Apollo.MutationFunction<IgnoreNpsRatingMutation, IgnoreNpsRatingMutationVariables>;

/**
 * __useIgnoreNpsRatingMutation__
 *
 * To run a mutation, you first call `useIgnoreNpsRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreNpsRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreNpsRatingMutation, { data, loading, error }] = useIgnoreNpsRatingMutation({
 *   variables: {
 *      source: // value for 'source'
 *   },
 * });
 */
export function useIgnoreNpsRatingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IgnoreNpsRatingMutation, IgnoreNpsRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IgnoreNpsRatingMutation, IgnoreNpsRatingMutationVariables>(IgnoreNpsRatingDocument, options);
      }
export type IgnoreNpsRatingMutationHookResult = ReturnType<typeof useIgnoreNpsRatingMutation>;
export type IgnoreNpsRatingMutationResult = Apollo.MutationResult<IgnoreNpsRatingMutation>;
export type IgnoreNpsRatingMutationOptions = Apollo.BaseMutationOptions<IgnoreNpsRatingMutation, IgnoreNpsRatingMutationVariables>;
export const JoinClubDocument = gql`
    mutation joinClub($data: JoinClubArgs!) {
  joinClub(data: $data) {
    success
  }
}
    `;
export type JoinClubMutationFn = Apollo.MutationFunction<JoinClubMutation, JoinClubMutationVariables>;

/**
 * __useJoinClubMutation__
 *
 * To run a mutation, you first call `useJoinClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinClubMutation, { data, loading, error }] = useJoinClubMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useJoinClubMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<JoinClubMutation, JoinClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<JoinClubMutation, JoinClubMutationVariables>(JoinClubDocument, options);
      }
export type JoinClubMutationHookResult = ReturnType<typeof useJoinClubMutation>;
export type JoinClubMutationResult = Apollo.MutationResult<JoinClubMutation>;
export type JoinClubMutationOptions = Apollo.BaseMutationOptions<JoinClubMutation, JoinClubMutationVariables>;
export const LeaveClubDocument = gql`
    mutation leaveClub($data: ClubInput!) {
  leaveClub(data: $data) {
    success
  }
}
    `;
export type LeaveClubMutationFn = Apollo.MutationFunction<LeaveClubMutation, LeaveClubMutationVariables>;

/**
 * __useLeaveClubMutation__
 *
 * To run a mutation, you first call `useLeaveClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveClubMutation, { data, loading, error }] = useLeaveClubMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLeaveClubMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LeaveClubMutation, LeaveClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LeaveClubMutation, LeaveClubMutationVariables>(LeaveClubDocument, options);
      }
export type LeaveClubMutationHookResult = ReturnType<typeof useLeaveClubMutation>;
export type LeaveClubMutationResult = Apollo.MutationResult<LeaveClubMutation>;
export type LeaveClubMutationOptions = Apollo.BaseMutationOptions<LeaveClubMutation, LeaveClubMutationVariables>;
export const LoginWithOidc_V2Document = gql`
    mutation loginWithOIDC_V2($accessToken: String!) {
  loginWithOIDC_V2(accessToken: $accessToken) {
    isUserMemberOfStockEdgeClub
    error
    interimToken
    user {
      id
      username
      showNpsV2
      canBeOnboarded
    }
    isViewOnly
    profileDetails {
      Id
      UserName
      Email
      Firstname
      Lastname
      RegisteredOn
      Gender
      ImageFilePath
    }
  }
}
    `;
export type LoginWithOidc_V2MutationFn = Apollo.MutationFunction<LoginWithOidc_V2Mutation, LoginWithOidc_V2MutationVariables>;

/**
 * __useLoginWithOidc_V2Mutation__
 *
 * To run a mutation, you first call `useLoginWithOidc_V2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginWithOidc_V2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginWithOidcV2Mutation, { data, loading, error }] = useLoginWithOidc_V2Mutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useLoginWithOidc_V2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginWithOidc_V2Mutation, LoginWithOidc_V2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginWithOidc_V2Mutation, LoginWithOidc_V2MutationVariables>(LoginWithOidc_V2Document, options);
      }
export type LoginWithOidc_V2MutationHookResult = ReturnType<typeof useLoginWithOidc_V2Mutation>;
export type LoginWithOidc_V2MutationResult = Apollo.MutationResult<LoginWithOidc_V2Mutation>;
export type LoginWithOidc_V2MutationOptions = Apollo.BaseMutationOptions<LoginWithOidc_V2Mutation, LoginWithOidc_V2MutationVariables>;
export const LogoutDocument = gql`
    mutation Logout($refreshToken: String!) {
  logout(refreshToken: $refreshToken)
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MarkAsPinPostDocument = gql`
    mutation markAsPinPost($postId: String) {
  markAsPinPost(postId: $postId) {
    ...PostFields
    isPinned
  }
}
    ${PostFieldsFragmentDoc}`;
export type MarkAsPinPostMutationFn = Apollo.MutationFunction<MarkAsPinPostMutation, MarkAsPinPostMutationVariables>;

/**
 * __useMarkAsPinPostMutation__
 *
 * To run a mutation, you first call `useMarkAsPinPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsPinPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsPinPostMutation, { data, loading, error }] = useMarkAsPinPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useMarkAsPinPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MarkAsPinPostMutation, MarkAsPinPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MarkAsPinPostMutation, MarkAsPinPostMutationVariables>(MarkAsPinPostDocument, options);
      }
export type MarkAsPinPostMutationHookResult = ReturnType<typeof useMarkAsPinPostMutation>;
export type MarkAsPinPostMutationResult = Apollo.MutationResult<MarkAsPinPostMutation>;
export type MarkAsPinPostMutationOptions = Apollo.BaseMutationOptions<MarkAsPinPostMutation, MarkAsPinPostMutationVariables>;
export const OnboardUserDocument = gql`
    mutation onboardUser($typeOfUserByUserpreference: UserHashtagContentType, $dollarTagIds: [Int], $hashtagName: [String], $skipOnboarding: Boolean) {
  onboardUser(
    typeOfUserByUserpreference: $typeOfUserByUserpreference
    dollarTagIds: $dollarTagIds
    hashtagName: $hashtagName
    skipOnboarding: $skipOnboarding
  ) {
    success
    message
  }
}
    `;
export type OnboardUserMutationFn = Apollo.MutationFunction<OnboardUserMutation, OnboardUserMutationVariables>;

/**
 * __useOnboardUserMutation__
 *
 * To run a mutation, you first call `useOnboardUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardUserMutation, { data, loading, error }] = useOnboardUserMutation({
 *   variables: {
 *      typeOfUserByUserpreference: // value for 'typeOfUserByUserpreference'
 *      dollarTagIds: // value for 'dollarTagIds'
 *      hashtagName: // value for 'hashtagName'
 *      skipOnboarding: // value for 'skipOnboarding'
 *   },
 * });
 */
export function useOnboardUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OnboardUserMutation, OnboardUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OnboardUserMutation, OnboardUserMutationVariables>(OnboardUserDocument, options);
      }
export type OnboardUserMutationHookResult = ReturnType<typeof useOnboardUserMutation>;
export type OnboardUserMutationResult = Apollo.MutationResult<OnboardUserMutation>;
export type OnboardUserMutationOptions = Apollo.BaseMutationOptions<OnboardUserMutation, OnboardUserMutationVariables>;
export const ReadAllNotificationsDocument = gql`
    mutation readAllNotifications {
  readAllNotifications {
    success
    message
  }
}
    `;
export type ReadAllNotificationsMutationFn = Apollo.MutationFunction<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;

/**
 * __useReadAllNotificationsMutation__
 *
 * To run a mutation, you first call `useReadAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllNotificationsMutation, { data, loading, error }] = useReadAllNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadAllNotificationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>(ReadAllNotificationsDocument, options);
      }
export type ReadAllNotificationsMutationHookResult = ReturnType<typeof useReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationResult = Apollo.MutationResult<ReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;
export const ReadNotificationDocument = gql`
    mutation readNotification($notificationId: String) {
  readNotification(notificationId: $notificationId) {
    success
    message
  }
}
    `;
export type ReadNotificationMutationFn = Apollo.MutationFunction<ReadNotificationMutation, ReadNotificationMutationVariables>;

/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useReadNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReadNotificationMutation, ReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, options);
      }
export type ReadNotificationMutationHookResult = ReturnType<typeof useReadNotificationMutation>;
export type ReadNotificationMutationResult = Apollo.MutationResult<ReadNotificationMutation>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const RemoveBookmarkDocument = gql`
    mutation removeBookmark($data: CreateBookmark) {
  removeBookmark(data: $data) {
    success
  }
}
    `;
export type RemoveBookmarkMutationFn = Apollo.MutationFunction<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;

/**
 * __useRemoveBookmarkMutation__
 *
 * To run a mutation, you first call `useRemoveBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBookmarkMutation, { data, loading, error }] = useRemoveBookmarkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRemoveBookmarkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>(RemoveBookmarkDocument, options);
      }
export type RemoveBookmarkMutationHookResult = ReturnType<typeof useRemoveBookmarkMutation>;
export type RemoveBookmarkMutationResult = Apollo.MutationResult<RemoveBookmarkMutation>;
export type RemoveBookmarkMutationOptions = Apollo.BaseMutationOptions<RemoveBookmarkMutation, RemoveBookmarkMutationVariables>;
export const RemoveDownvoteDocument = gql`
    mutation RemoveDownvote($data: VoteInput, $clubId: String) {
  removeDownvote(data: $data, clubId: $clubId) {
    success
    upvotes
    downvotes
  }
}
    `;
export type RemoveDownvoteMutationFn = Apollo.MutationFunction<RemoveDownvoteMutation, RemoveDownvoteMutationVariables>;

/**
 * __useRemoveDownvoteMutation__
 *
 * To run a mutation, you first call `useRemoveDownvoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDownvoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDownvoteMutation, { data, loading, error }] = useRemoveDownvoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useRemoveDownvoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveDownvoteMutation, RemoveDownvoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveDownvoteMutation, RemoveDownvoteMutationVariables>(RemoveDownvoteDocument, options);
      }
export type RemoveDownvoteMutationHookResult = ReturnType<typeof useRemoveDownvoteMutation>;
export type RemoveDownvoteMutationResult = Apollo.MutationResult<RemoveDownvoteMutation>;
export type RemoveDownvoteMutationOptions = Apollo.BaseMutationOptions<RemoveDownvoteMutation, RemoveDownvoteMutationVariables>;
export const RemoveUpvoteDocument = gql`
    mutation RemoveUpvote($data: VoteInput, $clubId: String) {
  removeUpvote(data: $data, clubId: $clubId) {
    success
    upvotes
    downvotes
  }
}
    `;
export type RemoveUpvoteMutationFn = Apollo.MutationFunction<RemoveUpvoteMutation, RemoveUpvoteMutationVariables>;

/**
 * __useRemoveUpvoteMutation__
 *
 * To run a mutation, you first call `useRemoveUpvoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUpvoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUpvoteMutation, { data, loading, error }] = useRemoveUpvoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useRemoveUpvoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUpvoteMutation, RemoveUpvoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUpvoteMutation, RemoveUpvoteMutationVariables>(RemoveUpvoteDocument, options);
      }
export type RemoveUpvoteMutationHookResult = ReturnType<typeof useRemoveUpvoteMutation>;
export type RemoveUpvoteMutationResult = Apollo.MutationResult<RemoveUpvoteMutation>;
export type RemoveUpvoteMutationOptions = Apollo.BaseMutationOptions<RemoveUpvoteMutation, RemoveUpvoteMutationVariables>;
export const ResolveFollowDocument = gql`
    mutation resolveFollow($followerId: String, $type: FollowStatus) {
  resolveFollow(followerId: $followerId, type: $type) {
    success
  }
}
    `;
export type ResolveFollowMutationFn = Apollo.MutationFunction<ResolveFollowMutation, ResolveFollowMutationVariables>;

/**
 * __useResolveFollowMutation__
 *
 * To run a mutation, you first call `useResolveFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveFollowMutation, { data, loading, error }] = useResolveFollowMutation({
 *   variables: {
 *      followerId: // value for 'followerId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useResolveFollowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResolveFollowMutation, ResolveFollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResolveFollowMutation, ResolveFollowMutationVariables>(ResolveFollowDocument, options);
      }
export type ResolveFollowMutationHookResult = ReturnType<typeof useResolveFollowMutation>;
export type ResolveFollowMutationResult = Apollo.MutationResult<ResolveFollowMutation>;
export type ResolveFollowMutationOptions = Apollo.BaseMutationOptions<ResolveFollowMutation, ResolveFollowMutationVariables>;
export const SelectPollOptionDocument = gql`
    mutation SelectPollOption($data: SelectPollOptionArgs) {
  selectPollOption(data: $data) {
    optionId
    pollId
    optionText
    hasUserSelected
    votes
  }
}
    `;
export type SelectPollOptionMutationFn = Apollo.MutationFunction<SelectPollOptionMutation, SelectPollOptionMutationVariables>;

/**
 * __useSelectPollOptionMutation__
 *
 * To run a mutation, you first call `useSelectPollOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectPollOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectPollOptionMutation, { data, loading, error }] = useSelectPollOptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSelectPollOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SelectPollOptionMutation, SelectPollOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SelectPollOptionMutation, SelectPollOptionMutationVariables>(SelectPollOptionDocument, options);
      }
export type SelectPollOptionMutationHookResult = ReturnType<typeof useSelectPollOptionMutation>;
export type SelectPollOptionMutationResult = Apollo.MutationResult<SelectPollOptionMutation>;
export type SelectPollOptionMutationOptions = Apollo.BaseMutationOptions<SelectPollOptionMutation, SelectPollOptionMutationVariables>;
export const SharePostV3Document = gql`
    mutation sharePostV3($data: PostInput!) {
  sharePostV3(data: $data) {
    postId
  }
}
    `;
export type SharePostV3MutationFn = Apollo.MutationFunction<SharePostV3Mutation, SharePostV3MutationVariables>;

/**
 * __useSharePostV3Mutation__
 *
 * To run a mutation, you first call `useSharePostV3Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSharePostV3Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sharePostV3Mutation, { data, loading, error }] = useSharePostV3Mutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSharePostV3Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SharePostV3Mutation, SharePostV3MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SharePostV3Mutation, SharePostV3MutationVariables>(SharePostV3Document, options);
      }
export type SharePostV3MutationHookResult = ReturnType<typeof useSharePostV3Mutation>;
export type SharePostV3MutationResult = Apollo.MutationResult<SharePostV3Mutation>;
export type SharePostV3MutationOptions = Apollo.BaseMutationOptions<SharePostV3Mutation, SharePostV3MutationVariables>;
export const SubscribeClubDocument = gql`
    mutation subscribeClub($subscribeTo: clubSubscriptionType!, $clubId: String!) {
  subscribeClub(subscribeTo: $subscribeTo, clubId: $clubId) {
    success
  }
}
    `;
export type SubscribeClubMutationFn = Apollo.MutationFunction<SubscribeClubMutation, SubscribeClubMutationVariables>;

/**
 * __useSubscribeClubMutation__
 *
 * To run a mutation, you first call `useSubscribeClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeClubMutation, { data, loading, error }] = useSubscribeClubMutation({
 *   variables: {
 *      subscribeTo: // value for 'subscribeTo'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useSubscribeClubMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubscribeClubMutation, SubscribeClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubscribeClubMutation, SubscribeClubMutationVariables>(SubscribeClubDocument, options);
      }
export type SubscribeClubMutationHookResult = ReturnType<typeof useSubscribeClubMutation>;
export type SubscribeClubMutationResult = Apollo.MutationResult<SubscribeClubMutation>;
export type SubscribeClubMutationOptions = Apollo.BaseMutationOptions<SubscribeClubMutation, SubscribeClubMutationVariables>;
export const SubscribeDocument = gql`
    mutation subscribe($data: FollowArgs) {
  subscribe(data: $data) {
    success
  }
}
    `;
export type SubscribeMutationFn = Apollo.MutationFunction<SubscribeMutation, SubscribeMutationVariables>;

/**
 * __useSubscribeMutation__
 *
 * To run a mutation, you first call `useSubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeMutation, { data, loading, error }] = useSubscribeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSubscribeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubscribeMutation, SubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubscribeMutation, SubscribeMutationVariables>(SubscribeDocument, options);
      }
export type SubscribeMutationHookResult = ReturnType<typeof useSubscribeMutation>;
export type SubscribeMutationResult = Apollo.MutationResult<SubscribeMutation>;
export type SubscribeMutationOptions = Apollo.BaseMutationOptions<SubscribeMutation, SubscribeMutationVariables>;
export const ToggleIsWatchlistVisibleDocument = gql`
    mutation toggleIsWatchlistVisible {
  toggleIsWatchlistVisible
}
    `;
export type ToggleIsWatchlistVisibleMutationFn = Apollo.MutationFunction<ToggleIsWatchlistVisibleMutation, ToggleIsWatchlistVisibleMutationVariables>;

/**
 * __useToggleIsWatchlistVisibleMutation__
 *
 * To run a mutation, you first call `useToggleIsWatchlistVisibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleIsWatchlistVisibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleIsWatchlistVisibleMutation, { data, loading, error }] = useToggleIsWatchlistVisibleMutation({
 *   variables: {
 *   },
 * });
 */
export function useToggleIsWatchlistVisibleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleIsWatchlistVisibleMutation, ToggleIsWatchlistVisibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ToggleIsWatchlistVisibleMutation, ToggleIsWatchlistVisibleMutationVariables>(ToggleIsWatchlistVisibleDocument, options);
      }
export type ToggleIsWatchlistVisibleMutationHookResult = ReturnType<typeof useToggleIsWatchlistVisibleMutation>;
export type ToggleIsWatchlistVisibleMutationResult = Apollo.MutationResult<ToggleIsWatchlistVisibleMutation>;
export type ToggleIsWatchlistVisibleMutationOptions = Apollo.BaseMutationOptions<ToggleIsWatchlistVisibleMutation, ToggleIsWatchlistVisibleMutationVariables>;
export const TurnOffHighlightForAchievementDocument = gql`
    mutation turnOffHighlightForAchievement($achievementType: String) {
  turnOffHighlightForAchievement(achievementType: $achievementType) {
    success
    message
  }
}
    `;
export type TurnOffHighlightForAchievementMutationFn = Apollo.MutationFunction<TurnOffHighlightForAchievementMutation, TurnOffHighlightForAchievementMutationVariables>;

/**
 * __useTurnOffHighlightForAchievementMutation__
 *
 * To run a mutation, you first call `useTurnOffHighlightForAchievementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnOffHighlightForAchievementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnOffHighlightForAchievementMutation, { data, loading, error }] = useTurnOffHighlightForAchievementMutation({
 *   variables: {
 *      achievementType: // value for 'achievementType'
 *   },
 * });
 */
export function useTurnOffHighlightForAchievementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TurnOffHighlightForAchievementMutation, TurnOffHighlightForAchievementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TurnOffHighlightForAchievementMutation, TurnOffHighlightForAchievementMutationVariables>(TurnOffHighlightForAchievementDocument, options);
      }
export type TurnOffHighlightForAchievementMutationHookResult = ReturnType<typeof useTurnOffHighlightForAchievementMutation>;
export type TurnOffHighlightForAchievementMutationResult = Apollo.MutationResult<TurnOffHighlightForAchievementMutation>;
export type TurnOffHighlightForAchievementMutationOptions = Apollo.BaseMutationOptions<TurnOffHighlightForAchievementMutation, TurnOffHighlightForAchievementMutationVariables>;
export const TurnOffNotificationByTypeOfNotificationDocument = gql`
    mutation turnOffNotificationByTypeOfNotification($notificationId: String) {
  turnOffNotificationByTypeOfNotification(notificationId: $notificationId) {
    success
    message
  }
}
    `;
export type TurnOffNotificationByTypeOfNotificationMutationFn = Apollo.MutationFunction<TurnOffNotificationByTypeOfNotificationMutation, TurnOffNotificationByTypeOfNotificationMutationVariables>;

/**
 * __useTurnOffNotificationByTypeOfNotificationMutation__
 *
 * To run a mutation, you first call `useTurnOffNotificationByTypeOfNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnOffNotificationByTypeOfNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnOffNotificationByTypeOfNotificationMutation, { data, loading, error }] = useTurnOffNotificationByTypeOfNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useTurnOffNotificationByTypeOfNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TurnOffNotificationByTypeOfNotificationMutation, TurnOffNotificationByTypeOfNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TurnOffNotificationByTypeOfNotificationMutation, TurnOffNotificationByTypeOfNotificationMutationVariables>(TurnOffNotificationByTypeOfNotificationDocument, options);
      }
export type TurnOffNotificationByTypeOfNotificationMutationHookResult = ReturnType<typeof useTurnOffNotificationByTypeOfNotificationMutation>;
export type TurnOffNotificationByTypeOfNotificationMutationResult = Apollo.MutationResult<TurnOffNotificationByTypeOfNotificationMutation>;
export type TurnOffNotificationByTypeOfNotificationMutationOptions = Apollo.BaseMutationOptions<TurnOffNotificationByTypeOfNotificationMutation, TurnOffNotificationByTypeOfNotificationMutationVariables>;
export const UnPinPostDocument = gql`
    mutation unPinPost($postId: String) {
  unPinPost(postId: $postId) {
    ...PostFields
    isPinned
  }
}
    ${PostFieldsFragmentDoc}`;
export type UnPinPostMutationFn = Apollo.MutationFunction<UnPinPostMutation, UnPinPostMutationVariables>;

/**
 * __useUnPinPostMutation__
 *
 * To run a mutation, you first call `useUnPinPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnPinPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unPinPostMutation, { data, loading, error }] = useUnPinPostMutation({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useUnPinPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnPinPostMutation, UnPinPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnPinPostMutation, UnPinPostMutationVariables>(UnPinPostDocument, options);
      }
export type UnPinPostMutationHookResult = ReturnType<typeof useUnPinPostMutation>;
export type UnPinPostMutationResult = Apollo.MutationResult<UnPinPostMutation>;
export type UnPinPostMutationOptions = Apollo.BaseMutationOptions<UnPinPostMutation, UnPinPostMutationVariables>;
export const UnblockUserDocument = gql`
    mutation unblockUser($id: String!) {
  unblockUser(id: $id) {
    success
    message
  }
}
    `;
export type UnblockUserMutationFn = Apollo.MutationFunction<UnblockUserMutation, UnblockUserMutationVariables>;

/**
 * __useUnblockUserMutation__
 *
 * To run a mutation, you first call `useUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockUserMutation, { data, loading, error }] = useUnblockUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnblockUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnblockUserMutation, UnblockUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnblockUserMutation, UnblockUserMutationVariables>(UnblockUserDocument, options);
      }
export type UnblockUserMutationHookResult = ReturnType<typeof useUnblockUserMutation>;
export type UnblockUserMutationResult = Apollo.MutationResult<UnblockUserMutation>;
export type UnblockUserMutationOptions = Apollo.BaseMutationOptions<UnblockUserMutation, UnblockUserMutationVariables>;
export const UnfollowUserDocument = gql`
    mutation UnfollowUser($userId: String!) {
  unfollow(data: {id: $userId, entity: User}) {
    success
  }
}
    `;
export type UnfollowUserMutationFn = Apollo.MutationFunction<UnfollowUserMutation, UnfollowUserMutationVariables>;

/**
 * __useUnfollowUserMutation__
 *
 * To run a mutation, you first call `useUnfollowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowUserMutation, { data, loading, error }] = useUnfollowUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnfollowUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnfollowUserMutation, UnfollowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnfollowUserMutation, UnfollowUserMutationVariables>(UnfollowUserDocument, options);
      }
export type UnfollowUserMutationHookResult = ReturnType<typeof useUnfollowUserMutation>;
export type UnfollowUserMutationResult = Apollo.MutationResult<UnfollowUserMutation>;
export type UnfollowUserMutationOptions = Apollo.BaseMutationOptions<UnfollowUserMutation, UnfollowUserMutationVariables>;
export const UnfollowDocument = gql`
    mutation unfollow($data: FollowArgs) {
  unfollow(data: $data) {
    success
  }
}
    `;
export type UnfollowMutationFn = Apollo.MutationFunction<UnfollowMutation, UnfollowMutationVariables>;

/**
 * __useUnfollowMutation__
 *
 * To run a mutation, you first call `useUnfollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowMutation, { data, loading, error }] = useUnfollowMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnfollowMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnfollowMutation, UnfollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnfollowMutation, UnfollowMutationVariables>(UnfollowDocument, options);
      }
export type UnfollowMutationHookResult = ReturnType<typeof useUnfollowMutation>;
export type UnfollowMutationResult = Apollo.MutationResult<UnfollowMutation>;
export type UnfollowMutationOptions = Apollo.BaseMutationOptions<UnfollowMutation, UnfollowMutationVariables>;
export const UnfollowPostDocument = gql`
    mutation unfollowPost($data: FollowPostInput!) {
  unfollowPost(data: $data) {
    post {
      postId
      isFollowed
    }
    message
  }
}
    `;
export type UnfollowPostMutationFn = Apollo.MutationFunction<UnfollowPostMutation, UnfollowPostMutationVariables>;

/**
 * __useUnfollowPostMutation__
 *
 * To run a mutation, you first call `useUnfollowPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowPostMutation, { data, loading, error }] = useUnfollowPostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnfollowPostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnfollowPostMutation, UnfollowPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnfollowPostMutation, UnfollowPostMutationVariables>(UnfollowPostDocument, options);
      }
export type UnfollowPostMutationHookResult = ReturnType<typeof useUnfollowPostMutation>;
export type UnfollowPostMutationResult = Apollo.MutationResult<UnfollowPostMutation>;
export type UnfollowPostMutationOptions = Apollo.BaseMutationOptions<UnfollowPostMutation, UnfollowPostMutationVariables>;
export const UnreadNotificationDocument = gql`
    mutation unreadNotification($notificationId: String) {
  unreadNotification(notificationId: $notificationId) {
    success
    message
  }
}
    `;
export type UnreadNotificationMutationFn = Apollo.MutationFunction<UnreadNotificationMutation, UnreadNotificationMutationVariables>;

/**
 * __useUnreadNotificationMutation__
 *
 * To run a mutation, you first call `useUnreadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unreadNotificationMutation, { data, loading, error }] = useUnreadNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useUnreadNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnreadNotificationMutation, UnreadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnreadNotificationMutation, UnreadNotificationMutationVariables>(UnreadNotificationDocument, options);
      }
export type UnreadNotificationMutationHookResult = ReturnType<typeof useUnreadNotificationMutation>;
export type UnreadNotificationMutationResult = Apollo.MutationResult<UnreadNotificationMutation>;
export type UnreadNotificationMutationOptions = Apollo.BaseMutationOptions<UnreadNotificationMutation, UnreadNotificationMutationVariables>;
export const UnsubscribeClubDocument = gql`
    mutation unsubscribeClub($unsubscribeTo: clubSubscriptionType!, $clubId: String!) {
  unsubscribeClub(unsubscribeTo: $unsubscribeTo, clubId: $clubId) {
    success
  }
}
    `;
export type UnsubscribeClubMutationFn = Apollo.MutationFunction<UnsubscribeClubMutation, UnsubscribeClubMutationVariables>;

/**
 * __useUnsubscribeClubMutation__
 *
 * To run a mutation, you first call `useUnsubscribeClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeClubMutation, { data, loading, error }] = useUnsubscribeClubMutation({
 *   variables: {
 *      unsubscribeTo: // value for 'unsubscribeTo'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useUnsubscribeClubMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnsubscribeClubMutation, UnsubscribeClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnsubscribeClubMutation, UnsubscribeClubMutationVariables>(UnsubscribeClubDocument, options);
      }
export type UnsubscribeClubMutationHookResult = ReturnType<typeof useUnsubscribeClubMutation>;
export type UnsubscribeClubMutationResult = Apollo.MutationResult<UnsubscribeClubMutation>;
export type UnsubscribeClubMutationOptions = Apollo.BaseMutationOptions<UnsubscribeClubMutation, UnsubscribeClubMutationVariables>;
export const UnsubscribeDocument = gql`
    mutation unsubscribe($data: FollowArgs) {
  unsubscribe(data: $data) {
    success
  }
}
    `;
export type UnsubscribeMutationFn = Apollo.MutationFunction<UnsubscribeMutation, UnsubscribeMutationVariables>;

/**
 * __useUnsubscribeMutation__
 *
 * To run a mutation, you first call `useUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeMutation, { data, loading, error }] = useUnsubscribeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUnsubscribeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnsubscribeMutation, UnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnsubscribeMutation, UnsubscribeMutationVariables>(UnsubscribeDocument, options);
      }
export type UnsubscribeMutationHookResult = ReturnType<typeof useUnsubscribeMutation>;
export type UnsubscribeMutationResult = Apollo.MutationResult<UnsubscribeMutation>;
export type UnsubscribeMutationOptions = Apollo.BaseMutationOptions<UnsubscribeMutation, UnsubscribeMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation updateUserSettings($data: UpdateUserSettings!) {
  updateUserSettings(data: $data) {
    profileType
  }
}
    `;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($data: UserUpdateArgs!) {
  updateUser(data: $data) {
    id
    username
    firstName
    lastName
    bio
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdatePostDocument = gql`
    mutation updatePost($data: UpdatePostInput) {
  updatePost(data: $data) {
    postId
    media {
      type
      uri
      name
      height
      width
      rotation
    }
    textV2
    isEdited
  }
}
    `;
export type UpdatePostMutationFn = Apollo.MutationFunction<UpdatePostMutation, UpdatePostMutationVariables>;

/**
 * __useUpdatePostMutation__
 *
 * To run a mutation, you first call `useUpdatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostMutation, { data, loading, error }] = useUpdatePostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePostMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdatePostMutation, UpdatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdatePostMutation, UpdatePostMutationVariables>(UpdatePostDocument, options);
      }
export type UpdatePostMutationHookResult = ReturnType<typeof useUpdatePostMutation>;
export type UpdatePostMutationResult = Apollo.MutationResult<UpdatePostMutation>;
export type UpdatePostMutationOptions = Apollo.BaseMutationOptions<UpdatePostMutation, UpdatePostMutationVariables>;
export const UpdateUserImageDocument = gql`
    mutation updateUserImage($data: UserImageArgs!) {
  updateUserImage(data: $data) {
    success
  }
}
    `;
export type UpdateUserImageMutationFn = Apollo.MutationFunction<UpdateUserImageMutation, UpdateUserImageMutationVariables>;

/**
 * __useUpdateUserImageMutation__
 *
 * To run a mutation, you first call `useUpdateUserImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserImageMutation, { data, loading, error }] = useUpdateUserImageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserImageMutation, UpdateUserImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserImageMutation, UpdateUserImageMutationVariables>(UpdateUserImageDocument, options);
      }
export type UpdateUserImageMutationHookResult = ReturnType<typeof useUpdateUserImageMutation>;
export type UpdateUserImageMutationResult = Apollo.MutationResult<UpdateUserImageMutation>;
export type UpdateUserImageMutationOptions = Apollo.BaseMutationOptions<UpdateUserImageMutation, UpdateUserImageMutationVariables>;
export const UpvoteDocument = gql`
    mutation upvote($data: VoteInput, $clubBasedPermissionToken: String, $clubId: String) {
  upvote(
    data: $data
    clubId: $clubId
    clubBasedPermissionToken: $clubBasedPermissionToken
  ) {
    success
    upvotes
    downvotes
  }
}
    `;
export type UpvoteMutationFn = Apollo.MutationFunction<UpvoteMutation, UpvoteMutationVariables>;

/**
 * __useUpvoteMutation__
 *
 * To run a mutation, you first call `useUpvoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpvoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upvoteMutation, { data, loading, error }] = useUpvoteMutation({
 *   variables: {
 *      data: // value for 'data'
 *      clubBasedPermissionToken: // value for 'clubBasedPermissionToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useUpvoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpvoteMutation, UpvoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpvoteMutation, UpvoteMutationVariables>(UpvoteDocument, options);
      }
export type UpvoteMutationHookResult = ReturnType<typeof useUpvoteMutation>;
export type UpvoteMutationResult = Apollo.MutationResult<UpvoteMutation>;
export type UpvoteMutationOptions = Apollo.BaseMutationOptions<UpvoteMutation, UpvoteMutationVariables>;
export const CheckNewPostsDocument = gql`
    query checkNewPosts($date: String) {
  checkNewPosts(date: $date)
}
    `;

/**
 * __useCheckNewPostsQuery__
 *
 * To run a query within a React component, call `useCheckNewPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckNewPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckNewPostsQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCheckNewPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckNewPostsQuery, CheckNewPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckNewPostsQuery, CheckNewPostsQueryVariables>(CheckNewPostsDocument, options);
      }
export function useCheckNewPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckNewPostsQuery, CheckNewPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckNewPostsQuery, CheckNewPostsQueryVariables>(CheckNewPostsDocument, options);
        }
export type CheckNewPostsQueryHookResult = ReturnType<typeof useCheckNewPostsQuery>;
export type CheckNewPostsLazyQueryHookResult = ReturnType<typeof useCheckNewPostsLazyQuery>;
export type CheckNewPostsQueryResult = Apollo.QueryResult<CheckNewPostsQuery, CheckNewPostsQueryVariables>;
export const CheckNewPostsFavoritesFeedDocument = gql`
    query checkNewPostsFavoritesFeed($date: String) {
  checkNewPostsFavoritesFeed(date: $date)
}
    `;

/**
 * __useCheckNewPostsFavoritesFeedQuery__
 *
 * To run a query within a React component, call `useCheckNewPostsFavoritesFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckNewPostsFavoritesFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckNewPostsFavoritesFeedQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCheckNewPostsFavoritesFeedQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckNewPostsFavoritesFeedQuery, CheckNewPostsFavoritesFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckNewPostsFavoritesFeedQuery, CheckNewPostsFavoritesFeedQueryVariables>(CheckNewPostsFavoritesFeedDocument, options);
      }
export function useCheckNewPostsFavoritesFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckNewPostsFavoritesFeedQuery, CheckNewPostsFavoritesFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckNewPostsFavoritesFeedQuery, CheckNewPostsFavoritesFeedQueryVariables>(CheckNewPostsFavoritesFeedDocument, options);
        }
export type CheckNewPostsFavoritesFeedQueryHookResult = ReturnType<typeof useCheckNewPostsFavoritesFeedQuery>;
export type CheckNewPostsFavoritesFeedLazyQueryHookResult = ReturnType<typeof useCheckNewPostsFavoritesFeedLazyQuery>;
export type CheckNewPostsFavoritesFeedQueryResult = Apollo.QueryResult<CheckNewPostsFavoritesFeedQuery, CheckNewPostsFavoritesFeedQueryVariables>;
export const CheckPermissionDocument = gql`
    query checkPermission($clubId: String!, $Action: UserClubPermissionValues!) {
  checkPermission(clubId: $clubId, Action: $Action)
}
    `;

/**
 * __useCheckPermissionQuery__
 *
 * To run a query within a React component, call `useCheckPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckPermissionQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      Action: // value for 'Action'
 *   },
 * });
 */
export function useCheckPermissionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckPermissionQuery, CheckPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckPermissionQuery, CheckPermissionQueryVariables>(CheckPermissionDocument, options);
      }
export function useCheckPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckPermissionQuery, CheckPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckPermissionQuery, CheckPermissionQueryVariables>(CheckPermissionDocument, options);
        }
export type CheckPermissionQueryHookResult = ReturnType<typeof useCheckPermissionQuery>;
export type CheckPermissionLazyQueryHookResult = ReturnType<typeof useCheckPermissionLazyQuery>;
export type CheckPermissionQueryResult = Apollo.QueryResult<CheckPermissionQuery, CheckPermissionQueryVariables>;
export const GetMemberCountDocument = gql`
    query getMemberCount($clubId: String!) {
  getMemberCount(clubId: $clubId)
}
    `;

/**
 * __useGetMemberCountQuery__
 *
 * To run a query within a React component, call `useGetMemberCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberCountQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetMemberCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMemberCountQuery, GetMemberCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMemberCountQuery, GetMemberCountQueryVariables>(GetMemberCountDocument, options);
      }
export function useGetMemberCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMemberCountQuery, GetMemberCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMemberCountQuery, GetMemberCountQueryVariables>(GetMemberCountDocument, options);
        }
export type GetMemberCountQueryHookResult = ReturnType<typeof useGetMemberCountQuery>;
export type GetMemberCountLazyQueryHookResult = ReturnType<typeof useGetMemberCountLazyQuery>;
export type GetMemberCountQueryResult = Apollo.QueryResult<GetMemberCountQuery, GetMemberCountQueryVariables>;
export const ClubsDocument = gql`
    query Clubs($userId: String!, $skip: Int, $take: Int, $entitlement: Boolean) {
  getClubsOfUser(
    userId: $userId
    skip: $skip
    take: $take
    entitlement: $entitlement
  ) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useClubsQuery__
 *
 * To run a query within a React component, call `useClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClubsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      entitlement: // value for 'entitlement'
 *   },
 * });
 */
export function useClubsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClubsQuery, ClubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClubsQuery, ClubsQueryVariables>(ClubsDocument, options);
      }
export function useClubsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClubsQuery, ClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClubsQuery, ClubsQueryVariables>(ClubsDocument, options);
        }
export type ClubsQueryHookResult = ReturnType<typeof useClubsQuery>;
export type ClubsLazyQueryHookResult = ReturnType<typeof useClubsLazyQuery>;
export type ClubsQueryResult = Apollo.QueryResult<ClubsQuery, ClubsQueryVariables>;
export const CountsDocument = gql`
    query Counts($id: String!) {
  clubs: getClubsOfUserCount(userId: $id)
  followers: getFollowersCount(data: {id: $id, entity: User})
  followings: getFollowingsCount(data: {id: $id, entity: User})
}
    `;

/**
 * __useCountsQuery__
 *
 * To run a query within a React component, call `useCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CountsQuery, CountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CountsQuery, CountsQueryVariables>(CountsDocument, options);
      }
export function useCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CountsQuery, CountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CountsQuery, CountsQueryVariables>(CountsDocument, options);
        }
export type CountsQueryHookResult = ReturnType<typeof useCountsQuery>;
export type CountsLazyQueryHookResult = ReturnType<typeof useCountsLazyQuery>;
export type CountsQueryResult = Apollo.QueryResult<CountsQuery, CountsQueryVariables>;
export const FeedPostsDocument = gql`
    query FeedPosts($limit: Int!, $offset: Int!) {
  getFeedPosts(limit: $limit, offset: $offset) {
    actId
    activityId
    activityType
    createdAt
    avatar
    cover
    user {
      id
      firstName
      lastName
      avatar
      cover
      username
      isVerified
      greenTick
      tick3
      profileType
    }
    followingUser {
      id
      firstName
      lastName
      username
      avatar
      cover
      isVerified
      greenTick
      tick3
      profileType
    }
    club {
      clubId
      clubHandle
      avatar
      cover
      clubName
    }
    followingHashtag {
      hashtagName
      hashtagType
    }
    followingStocktag {
      securityId
      stockName
      slug
      nseListingId
      bseListingId
    }
    post {
      ...PostFields
      comments {
        ...CommentFields
        replies {
          ...ReplyFields
        }
      }
    }
  }
}
    ${PostFieldsFragmentDoc}
${CommentFieldsFragmentDoc}
${ReplyFieldsFragmentDoc}`;

/**
 * __useFeedPostsQuery__
 *
 * To run a query within a React component, call `useFeedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedPostsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useFeedPostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FeedPostsQuery, FeedPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FeedPostsQuery, FeedPostsQueryVariables>(FeedPostsDocument, options);
      }
export function useFeedPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FeedPostsQuery, FeedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FeedPostsQuery, FeedPostsQueryVariables>(FeedPostsDocument, options);
        }
export type FeedPostsQueryHookResult = ReturnType<typeof useFeedPostsQuery>;
export type FeedPostsLazyQueryHookResult = ReturnType<typeof useFeedPostsLazyQuery>;
export type FeedPostsQueryResult = Apollo.QueryResult<FeedPostsQuery, FeedPostsQueryVariables>;
export const FollowFollowingClubCountsDocument = gql`
    query FollowFollowingClubCounts($userId: String!) {
  followers: getFollowersCount(data: {id: $userId, entity: User})
  followings: getFollowingsCount(data: {id: $userId, entity: User})
  clubs: getClubsOfUserCount(userId: $userId)
}
    `;

/**
 * __useFollowFollowingClubCountsQuery__
 *
 * To run a query within a React component, call `useFollowFollowingClubCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowFollowingClubCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowFollowingClubCountsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFollowFollowingClubCountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>(FollowFollowingClubCountsDocument, options);
      }
export function useFollowFollowingClubCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>(FollowFollowingClubCountsDocument, options);
        }
export type FollowFollowingClubCountsQueryHookResult = ReturnType<typeof useFollowFollowingClubCountsQuery>;
export type FollowFollowingClubCountsLazyQueryHookResult = ReturnType<typeof useFollowFollowingClubCountsLazyQuery>;
export type FollowFollowingClubCountsQueryResult = Apollo.QueryResult<FollowFollowingClubCountsQuery, FollowFollowingClubCountsQueryVariables>;
export const FollowersDocument = gql`
    query Followers($data: FollowArgs) {
  getFollowers(data: $data) {
    users {
      id
      firstName
      lastName
      username
      cover
      bio
      avatar
      isfollow
      isVerified
      greenTick
      tick3
      issubscribed
      isUserDeleted
    }
  }
}
    `;

/**
 * __useFollowersQuery__
 *
 * To run a query within a React component, call `useFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowersQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFollowersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FollowersQuery, FollowersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FollowersQuery, FollowersQueryVariables>(FollowersDocument, options);
      }
export function useFollowersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FollowersQuery, FollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FollowersQuery, FollowersQueryVariables>(FollowersDocument, options);
        }
export type FollowersQueryHookResult = ReturnType<typeof useFollowersQuery>;
export type FollowersLazyQueryHookResult = ReturnType<typeof useFollowersLazyQuery>;
export type FollowersQueryResult = Apollo.QueryResult<FollowersQuery, FollowersQueryVariables>;
export const FollowingUsersDocument = gql`
    query FollowingUsers($data: FollowArgs) {
  getFollowings(data: $data) {
    users {
      id
      firstName
      lastName
      username
      cover
      bio
      avatar
      isfollow
      isVerified
      greenTick
      tick3
      issubscribed
      isUserDeleted
    }
  }
}
    `;

/**
 * __useFollowingUsersQuery__
 *
 * To run a query within a React component, call `useFollowingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowingUsersQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useFollowingUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FollowingUsersQuery, FollowingUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FollowingUsersQuery, FollowingUsersQueryVariables>(FollowingUsersDocument, options);
      }
export function useFollowingUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FollowingUsersQuery, FollowingUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FollowingUsersQuery, FollowingUsersQueryVariables>(FollowingUsersDocument, options);
        }
export type FollowingUsersQueryHookResult = ReturnType<typeof useFollowingUsersQuery>;
export type FollowingUsersLazyQueryHookResult = ReturnType<typeof useFollowingUsersLazyQuery>;
export type FollowingUsersQueryResult = Apollo.QueryResult<FollowingUsersQuery, FollowingUsersQueryVariables>;
export const GetFollowingsDocument = gql`
    query getFollowings($userId: String!) {
  Hashtag: getFollowings(
    data: {id: $userId, entity: Hashtag, limits: {skip: 0, take: 20}}
  ) {
    hashtags {
      Hashtag {
        hashtagName
        hashtagType
        postCount
        isfollow
        issubscribed
      }
      userAvatars
      followers
    }
  }
  Stocks: getFollowings(
    data: {id: $userId, entity: Stock, limits: {skip: 0, take: 20}}
  ) {
    stocks {
      stock {
        securityId
        stockName
        slug
        nseListingId
        postCount
        bseListingId
        isfollow
        issubscribed
      }
      userAvatars
      followers
    }
  }
  Sectors: getInterest(data: {interestType: Sector, userId: $userId}) {
    sectors {
      sectorId
      name
      icon
    }
  }
}
    `;

/**
 * __useGetFollowingsQuery__
 *
 * To run a query within a React component, call `useGetFollowingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFollowingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFollowingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetFollowingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFollowingsQuery, GetFollowingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFollowingsQuery, GetFollowingsQueryVariables>(GetFollowingsDocument, options);
      }
export function useGetFollowingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFollowingsQuery, GetFollowingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFollowingsQuery, GetFollowingsQueryVariables>(GetFollowingsDocument, options);
        }
export type GetFollowingsQueryHookResult = ReturnType<typeof useGetFollowingsQuery>;
export type GetFollowingsLazyQueryHookResult = ReturnType<typeof useGetFollowingsLazyQuery>;
export type GetFollowingsQueryResult = Apollo.QueryResult<GetFollowingsQuery, GetFollowingsQueryVariables>;
export const GetWatchListDocument = gql`
    query getWatchList($offset: Int, $limit: Int) {
  getWatchlist(offset: $offset, limit: $limit) {
    securityId
    stockName
    slug
    isfollow
  }
}
    `;

/**
 * __useGetWatchListQuery__
 *
 * To run a query within a React component, call `useGetWatchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchListQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetWatchListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWatchListQuery, GetWatchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWatchListQuery, GetWatchListQueryVariables>(GetWatchListDocument, options);
      }
export function useGetWatchListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWatchListQuery, GetWatchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWatchListQuery, GetWatchListQueryVariables>(GetWatchListDocument, options);
        }
export type GetWatchListQueryHookResult = ReturnType<typeof useGetWatchListQuery>;
export type GetWatchListLazyQueryHookResult = ReturnType<typeof useGetWatchListLazyQuery>;
export type GetWatchListQueryResult = Apollo.QueryResult<GetWatchListQuery, GetWatchListQueryVariables>;
export const GetWatchlistV2Document = gql`
    query getWatchlistV2($offset: Int, $limit: Int, $type: dollarTagEnum) {
  getWatchlistV2(offset: $offset, limit: $limit, type: $type) {
    dollarTagId
    dollarTagName
    slug
    alias
    dollarTagType
    sourceEntityId
    sourceEntityIdType
    isfollow
    issubscribed
    followers
  }
}
    `;

/**
 * __useGetWatchlistV2Query__
 *
 * To run a query within a React component, call `useGetWatchlistV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchlistV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchlistV2Query({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetWatchlistV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWatchlistV2Query, GetWatchlistV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWatchlistV2Query, GetWatchlistV2QueryVariables>(GetWatchlistV2Document, options);
      }
export function useGetWatchlistV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWatchlistV2Query, GetWatchlistV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWatchlistV2Query, GetWatchlistV2QueryVariables>(GetWatchlistV2Document, options);
        }
export type GetWatchlistV2QueryHookResult = ReturnType<typeof useGetWatchlistV2Query>;
export type GetWatchlistV2LazyQueryHookResult = ReturnType<typeof useGetWatchlistV2LazyQuery>;
export type GetWatchlistV2QueryResult = Apollo.QueryResult<GetWatchlistV2Query, GetWatchlistV2QueryVariables>;
export const GetAchievementDetailsDocument = gql`
    query getAchievementDetails($achievementType: String, $sourceOfClick: String) {
  getAchievementDetails(
    achievementType: $achievementType
    sourceOfClick: $sourceOfClick
  ) {
    text1
    text2
    text3
    allowFeedback
    badgeDetails {
      badgeName
      badgeId
      badgeIcon
      badgeType
    }
    share {
      text
      imageLink
    }
  }
}
    `;

/**
 * __useGetAchievementDetailsQuery__
 *
 * To run a query within a React component, call `useGetAchievementDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAchievementDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAchievementDetailsQuery({
 *   variables: {
 *      achievementType: // value for 'achievementType'
 *      sourceOfClick: // value for 'sourceOfClick'
 *   },
 * });
 */
export function useGetAchievementDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>(GetAchievementDetailsDocument, options);
      }
export function useGetAchievementDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>(GetAchievementDetailsDocument, options);
        }
export type GetAchievementDetailsQueryHookResult = ReturnType<typeof useGetAchievementDetailsQuery>;
export type GetAchievementDetailsLazyQueryHookResult = ReturnType<typeof useGetAchievementDetailsLazyQuery>;
export type GetAchievementDetailsQueryResult = Apollo.QueryResult<GetAchievementDetailsQuery, GetAchievementDetailsQueryVariables>;
export const GetAllAchievementStatusDocument = gql`
    query getAllAchievementStatus {
  getAllAchievementStatus {
    data {
      achievementType
      achievementName
      milestoneData {
        isMilestoneCompleted
        MilestoneName
        runningMilestone
      }
    }
    errorMessage {
      errCode
      errMessage
    }
  }
}
    `;

/**
 * __useGetAllAchievementStatusQuery__
 *
 * To run a query within a React component, call `useGetAllAchievementStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAchievementStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAchievementStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllAchievementStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>(GetAllAchievementStatusDocument, options);
      }
export function useGetAllAchievementStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>(GetAllAchievementStatusDocument, options);
        }
export type GetAllAchievementStatusQueryHookResult = ReturnType<typeof useGetAllAchievementStatusQuery>;
export type GetAllAchievementStatusLazyQueryHookResult = ReturnType<typeof useGetAllAchievementStatusLazyQuery>;
export type GetAllAchievementStatusQueryResult = Apollo.QueryResult<GetAllAchievementStatusQuery, GetAllAchievementStatusQueryVariables>;
export const GetBadgeFeedbackQuestionDocument = gql`
    query getBadgeFeedbackQuestion($badgeId: String) {
  getBadgeFeedbackQuestion(badgeId: $badgeId) {
    questionId
    questionText
    Badge {
      badgeId
      badgeName
      description
      badgeIcon
      badgeType
    }
    badgeId
    createdAt
  }
}
    `;

/**
 * __useGetBadgeFeedbackQuestionQuery__
 *
 * To run a query within a React component, call `useGetBadgeFeedbackQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgeFeedbackQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgeFeedbackQuestionQuery({
 *   variables: {
 *      badgeId: // value for 'badgeId'
 *   },
 * });
 */
export function useGetBadgeFeedbackQuestionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>(GetBadgeFeedbackQuestionDocument, options);
      }
export function useGetBadgeFeedbackQuestionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>(GetBadgeFeedbackQuestionDocument, options);
        }
export type GetBadgeFeedbackQuestionQueryHookResult = ReturnType<typeof useGetBadgeFeedbackQuestionQuery>;
export type GetBadgeFeedbackQuestionLazyQueryHookResult = ReturnType<typeof useGetBadgeFeedbackQuestionLazyQuery>;
export type GetBadgeFeedbackQuestionQueryResult = Apollo.QueryResult<GetBadgeFeedbackQuestionQuery, GetBadgeFeedbackQuestionQueryVariables>;
export const GetBadgesOfUserDocument = gql`
    query getBadgesOfUser($userId: String) {
  getBadgesOfUser(userId: $userId) {
    userBadgesList {
      userId
      badgeId
      Badges {
        badgeId
        badgeName
        description
        badgeIcon
        badgeType
      }
      hasTurnedOffPromotion
      sourceOfClick
      achievementType
    }
    errorMessage {
      errMessage
    }
  }
}
    `;

/**
 * __useGetBadgesOfUserQuery__
 *
 * To run a query within a React component, call `useGetBadgesOfUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgesOfUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgesOfUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetBadgesOfUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>(GetBadgesOfUserDocument, options);
      }
export function useGetBadgesOfUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>(GetBadgesOfUserDocument, options);
        }
export type GetBadgesOfUserQueryHookResult = ReturnType<typeof useGetBadgesOfUserQuery>;
export type GetBadgesOfUserLazyQueryHookResult = ReturnType<typeof useGetBadgesOfUserLazyQuery>;
export type GetBadgesOfUserQueryResult = Apollo.QueryResult<GetBadgesOfUserQuery, GetBadgesOfUserQueryVariables>;
export const GetBlockedListDocument = gql`
    query getBlockedList {
  getBlockedList {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetBlockedListQuery__
 *
 * To run a query within a React component, call `useGetBlockedListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockedListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockedListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBlockedListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBlockedListQuery, GetBlockedListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBlockedListQuery, GetBlockedListQueryVariables>(GetBlockedListDocument, options);
      }
export function useGetBlockedListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockedListQuery, GetBlockedListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBlockedListQuery, GetBlockedListQueryVariables>(GetBlockedListDocument, options);
        }
export type GetBlockedListQueryHookResult = ReturnType<typeof useGetBlockedListQuery>;
export type GetBlockedListLazyQueryHookResult = ReturnType<typeof useGetBlockedListLazyQuery>;
export type GetBlockedListQueryResult = Apollo.QueryResult<GetBlockedListQuery, GetBlockedListQueryVariables>;
export const GetBookmarkV2Document = gql`
    query getBookmarkV2($offset: Int!, $limit: Int!) {
  getBookmarkV2(offset: $offset, limit: $limit) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetBookmarkV2Query__
 *
 * To run a query within a React component, call `useGetBookmarkV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetBookmarkV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookmarkV2Query({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBookmarkV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GetBookmarkV2Query, GetBookmarkV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBookmarkV2Query, GetBookmarkV2QueryVariables>(GetBookmarkV2Document, options);
      }
export function useGetBookmarkV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBookmarkV2Query, GetBookmarkV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBookmarkV2Query, GetBookmarkV2QueryVariables>(GetBookmarkV2Document, options);
        }
export type GetBookmarkV2QueryHookResult = ReturnType<typeof useGetBookmarkV2Query>;
export type GetBookmarkV2LazyQueryHookResult = ReturnType<typeof useGetBookmarkV2LazyQuery>;
export type GetBookmarkV2QueryResult = Apollo.QueryResult<GetBookmarkV2Query, GetBookmarkV2QueryVariables>;
export const GetBrokenStreakDetailsDocument = gql`
    query getBrokenStreakDetails {
  getBrokenStreakDetails {
    data {
      userId
      prevStreak {
        isCurrentWeek
        weekDisplayName
        hasCompleted
        currentWeekDayCount
        weekNumber
        weekHeader
        weekHeaderMessage
        isBrokenWeek
        weekFooter
        days {
          dayName
          dayDate
          hasVisited
          visitedState
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrokenStreakDetailsQuery__
 *
 * To run a query within a React component, call `useGetBrokenStreakDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokenStreakDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokenStreakDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrokenStreakDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>(GetBrokenStreakDetailsDocument, options);
      }
export function useGetBrokenStreakDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>(GetBrokenStreakDetailsDocument, options);
        }
export type GetBrokenStreakDetailsQueryHookResult = ReturnType<typeof useGetBrokenStreakDetailsQuery>;
export type GetBrokenStreakDetailsLazyQueryHookResult = ReturnType<typeof useGetBrokenStreakDetailsLazyQuery>;
export type GetBrokenStreakDetailsQueryResult = Apollo.QueryResult<GetBrokenStreakDetailsQuery, GetBrokenStreakDetailsQueryVariables>;
export const GetCategoriesDocument = gql`
    query getCategories {
  getCategories {
    clubCategoryId
    clubCategoryName
    headline
    description
    priority
    icon
    cover
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategoryByIdDocument = gql`
    query getCategoryById($clubCategoryId: String) {
  getCategoryById(clubCategoryId: $clubCategoryId) {
    clubCategoryId
    clubCategoryName
    headline
    description
    priority
    icon
    cover
  }
}
    `;

/**
 * __useGetCategoryByIdQuery__
 *
 * To run a query within a React component, call `useGetCategoryByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryByIdQuery({
 *   variables: {
 *      clubCategoryId: // value for 'clubCategoryId'
 *   },
 * });
 */
export function useGetCategoryByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>(GetCategoryByIdDocument, options);
      }
export function useGetCategoryByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>(GetCategoryByIdDocument, options);
        }
export type GetCategoryByIdQueryHookResult = ReturnType<typeof useGetCategoryByIdQuery>;
export type GetCategoryByIdLazyQueryHookResult = ReturnType<typeof useGetCategoryByIdLazyQuery>;
export type GetCategoryByIdQueryResult = Apollo.QueryResult<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>;
export const GetClubDocument = gql`
    query GetClub($clubId: String!) {
  getClub(clubId: $clubId) {
    ...ClubFields
    clubType
    memberType
    rule
    viewFeedPermission {
      canViewPost
      canSeeMarketingPost
    }
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetClubQuery__
 *
 * To run a query within a React component, call `useGetClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubQuery, GetClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
      }
export function useGetClubLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubQuery, GetClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
        }
export type GetClubQueryHookResult = ReturnType<typeof useGetClubQuery>;
export type GetClubLazyQueryHookResult = ReturnType<typeof useGetClubLazyQuery>;
export type GetClubQueryResult = Apollo.QueryResult<GetClubQuery, GetClubQueryVariables>;
export const GetClubCategoryListDocument = gql`
    query getClubCategoryList {
  getClubCategoryList {
    clubCategoryId
    clubCategoryName
    headline
    description
    priority
    icon
    cover
  }
}
    `;

/**
 * __useGetClubCategoryListQuery__
 *
 * To run a query within a React component, call `useGetClubCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClubCategoryListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>(GetClubCategoryListDocument, options);
      }
export function useGetClubCategoryListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>(GetClubCategoryListDocument, options);
        }
export type GetClubCategoryListQueryHookResult = ReturnType<typeof useGetClubCategoryListQuery>;
export type GetClubCategoryListLazyQueryHookResult = ReturnType<typeof useGetClubCategoryListLazyQuery>;
export type GetClubCategoryListQueryResult = Apollo.QueryResult<GetClubCategoryListQuery, GetClubCategoryListQueryVariables>;
export const GetClubListForSmartFeedDocument = gql`
    query getClubListForSmartFeed($data: String!) {
  getClubListForSmartFeed(data: $data) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetClubListForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetClubListForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubListForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubListForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetClubListForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>(GetClubListForSmartFeedDocument, options);
      }
export function useGetClubListForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>(GetClubListForSmartFeedDocument, options);
        }
export type GetClubListForSmartFeedQueryHookResult = ReturnType<typeof useGetClubListForSmartFeedQuery>;
export type GetClubListForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetClubListForSmartFeedLazyQuery>;
export type GetClubListForSmartFeedQueryResult = Apollo.QueryResult<GetClubListForSmartFeedQuery, GetClubListForSmartFeedQueryVariables>;
export const GetClubMarketingPostsDocument = gql`
    query getClubMarketingPosts($clubId: String) {
  getClubMarketingPosts(clubId: $clubId) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetClubMarketingPostsQuery__
 *
 * To run a query within a React component, call `useGetClubMarketingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubMarketingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubMarketingPostsQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubMarketingPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>(GetClubMarketingPostsDocument, options);
      }
export function useGetClubMarketingPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>(GetClubMarketingPostsDocument, options);
        }
export type GetClubMarketingPostsQueryHookResult = ReturnType<typeof useGetClubMarketingPostsQuery>;
export type GetClubMarketingPostsLazyQueryHookResult = ReturnType<typeof useGetClubMarketingPostsLazyQuery>;
export type GetClubMarketingPostsQueryResult = Apollo.QueryResult<GetClubMarketingPostsQuery, GetClubMarketingPostsQueryVariables>;
export const GetClubMediaPostsDocument = gql`
    query getClubMediaPosts($data: ClubInput, $offset: Int, $limit: Int) {
  getClubMediaPosts(data: $data, offset: $offset, limit: $limit) {
    postId
    media {
      type
      uri
      name
    }
  }
}
    `;

/**
 * __useGetClubMediaPostsQuery__
 *
 * To run a query within a React component, call `useGetClubMediaPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubMediaPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubMediaPostsQuery({
 *   variables: {
 *      data: // value for 'data'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClubMediaPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>(GetClubMediaPostsDocument, options);
      }
export function useGetClubMediaPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>(GetClubMediaPostsDocument, options);
        }
export type GetClubMediaPostsQueryHookResult = ReturnType<typeof useGetClubMediaPostsQuery>;
export type GetClubMediaPostsLazyQueryHookResult = ReturnType<typeof useGetClubMediaPostsLazyQuery>;
export type GetClubMediaPostsQueryResult = Apollo.QueryResult<GetClubMediaPostsQuery, GetClubMediaPostsQueryVariables>;
export const GetClubPermissionsBasedOnFeaturesDocument = gql`
    query getClubPermissionsBasedOnFeatures {
  getClubPermissionsBasedOnFeatures {
    clubId
    permissions
    club_permissions_token
  }
}
    `;

/**
 * __useGetClubPermissionsBasedOnFeaturesQuery__
 *
 * To run a query within a React component, call `useGetClubPermissionsBasedOnFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubPermissionsBasedOnFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubPermissionsBasedOnFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClubPermissionsBasedOnFeaturesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>(GetClubPermissionsBasedOnFeaturesDocument, options);
      }
export function useGetClubPermissionsBasedOnFeaturesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>(GetClubPermissionsBasedOnFeaturesDocument, options);
        }
export type GetClubPermissionsBasedOnFeaturesQueryHookResult = ReturnType<typeof useGetClubPermissionsBasedOnFeaturesQuery>;
export type GetClubPermissionsBasedOnFeaturesLazyQueryHookResult = ReturnType<typeof useGetClubPermissionsBasedOnFeaturesLazyQuery>;
export type GetClubPermissionsBasedOnFeaturesQueryResult = Apollo.QueryResult<GetClubPermissionsBasedOnFeaturesQuery, GetClubPermissionsBasedOnFeaturesQueryVariables>;
export const ClubPostDocument = gql`
    query clubPost($clubId: String!, $limit: Int!, $offset: Int!) {
  getClubPosts(clubId: $clubId, limit: $limit, offset: $offset) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useClubPostQuery__
 *
 * To run a query within a React component, call `useClubPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useClubPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClubPostQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useClubPostQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClubPostQuery, ClubPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClubPostQuery, ClubPostQueryVariables>(ClubPostDocument, options);
      }
export function useClubPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClubPostQuery, ClubPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClubPostQuery, ClubPostQueryVariables>(ClubPostDocument, options);
        }
export type ClubPostQueryHookResult = ReturnType<typeof useClubPostQuery>;
export type ClubPostLazyQueryHookResult = ReturnType<typeof useClubPostLazyQuery>;
export type ClubPostQueryResult = Apollo.QueryResult<ClubPostQuery, ClubPostQueryVariables>;
export const GetClubPostsSinceDateDocument = gql`
    query getClubPostsSinceDate($clubId: String!, $since: String, $limit: Int!) {
  getClubPostsSinceDate(clubId: $clubId, since: $since, limit: $limit) {
    since
    posts {
      ...PostFields
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetClubPostsSinceDateQuery__
 *
 * To run a query within a React component, call `useGetClubPostsSinceDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubPostsSinceDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubPostsSinceDateQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetClubPostsSinceDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>(GetClubPostsSinceDateDocument, options);
      }
export function useGetClubPostsSinceDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>(GetClubPostsSinceDateDocument, options);
        }
export type GetClubPostsSinceDateQueryHookResult = ReturnType<typeof useGetClubPostsSinceDateQuery>;
export type GetClubPostsSinceDateLazyQueryHookResult = ReturnType<typeof useGetClubPostsSinceDateLazyQuery>;
export type GetClubPostsSinceDateQueryResult = Apollo.QueryResult<GetClubPostsSinceDateQuery, GetClubPostsSinceDateQueryVariables>;
export const GetClubTrendingHashtagsV2Document = gql`
    query getClubTrendingHashtagsV2($offset: Int!, $limit: Int!, $clubId: String!) {
  getClubTrendingHashtagsV2(offset: $offset, limit: $limit, clubId: $clubId) {
    hashtagName
    postCount
    isfollow
    issubscribed
    followers
  }
}
    `;

/**
 * __useGetClubTrendingHashtagsV2Query__
 *
 * To run a query within a React component, call `useGetClubTrendingHashtagsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetClubTrendingHashtagsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubTrendingHashtagsV2Query({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubTrendingHashtagsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>(GetClubTrendingHashtagsV2Document, options);
      }
export function useGetClubTrendingHashtagsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>(GetClubTrendingHashtagsV2Document, options);
        }
export type GetClubTrendingHashtagsV2QueryHookResult = ReturnType<typeof useGetClubTrendingHashtagsV2Query>;
export type GetClubTrendingHashtagsV2LazyQueryHookResult = ReturnType<typeof useGetClubTrendingHashtagsV2LazyQuery>;
export type GetClubTrendingHashtagsV2QueryResult = Apollo.QueryResult<GetClubTrendingHashtagsV2Query, GetClubTrendingHashtagsV2QueryVariables>;
export const GetClubTrendingSectorsViaDollarTagDocument = gql`
    query getClubTrendingSectorsViaDollarTag($offset: Int!, $limit: Int!, $clubId: String!) {
  getClubTrendingSectorsViaDollarTag(
    offset: $offset
    limit: $limit
    clubId: $clubId
  ) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetClubTrendingSectorsViaDollarTagQuery__
 *
 * To run a query within a React component, call `useGetClubTrendingSectorsViaDollarTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubTrendingSectorsViaDollarTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubTrendingSectorsViaDollarTagQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubTrendingSectorsViaDollarTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>(GetClubTrendingSectorsViaDollarTagDocument, options);
      }
export function useGetClubTrendingSectorsViaDollarTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>(GetClubTrendingSectorsViaDollarTagDocument, options);
        }
export type GetClubTrendingSectorsViaDollarTagQueryHookResult = ReturnType<typeof useGetClubTrendingSectorsViaDollarTagQuery>;
export type GetClubTrendingSectorsViaDollarTagLazyQueryHookResult = ReturnType<typeof useGetClubTrendingSectorsViaDollarTagLazyQuery>;
export type GetClubTrendingSectorsViaDollarTagQueryResult = Apollo.QueryResult<GetClubTrendingSectorsViaDollarTagQuery, GetClubTrendingSectorsViaDollarTagQueryVariables>;
export const GetClubTrendingStocksViaDollarTagDocument = gql`
    query getClubTrendingStocksViaDollarTag($offset: Int!, $limit: Int!, $clubId: String!) {
  getClubTrendingStocksViaDollarTag(
    offset: $offset
    limit: $limit
    clubId: $clubId
  ) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetClubTrendingStocksViaDollarTagQuery__
 *
 * To run a query within a React component, call `useGetClubTrendingStocksViaDollarTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubTrendingStocksViaDollarTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubTrendingStocksViaDollarTagQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubTrendingStocksViaDollarTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>(GetClubTrendingStocksViaDollarTagDocument, options);
      }
export function useGetClubTrendingStocksViaDollarTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>(GetClubTrendingStocksViaDollarTagDocument, options);
        }
export type GetClubTrendingStocksViaDollarTagQueryHookResult = ReturnType<typeof useGetClubTrendingStocksViaDollarTagQuery>;
export type GetClubTrendingStocksViaDollarTagLazyQueryHookResult = ReturnType<typeof useGetClubTrendingStocksViaDollarTagLazyQuery>;
export type GetClubTrendingStocksViaDollarTagQueryResult = Apollo.QueryResult<GetClubTrendingStocksViaDollarTagQuery, GetClubTrendingStocksViaDollarTagQueryVariables>;
export const GetClubsByCategoryDocument = gql`
    query getClubsByCategory($clubCategoryId: String) {
  getClubsByCategory(clubCategoryId: $clubCategoryId) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetClubsByCategoryQuery__
 *
 * To run a query within a React component, call `useGetClubsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubsByCategoryQuery({
 *   variables: {
 *      clubCategoryId: // value for 'clubCategoryId'
 *   },
 * });
 */
export function useGetClubsByCategoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>(GetClubsByCategoryDocument, options);
      }
export function useGetClubsByCategoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>(GetClubsByCategoryDocument, options);
        }
export type GetClubsByCategoryQueryHookResult = ReturnType<typeof useGetClubsByCategoryQuery>;
export type GetClubsByCategoryLazyQueryHookResult = ReturnType<typeof useGetClubsByCategoryLazyQuery>;
export type GetClubsByCategoryQueryResult = Apollo.QueryResult<GetClubsByCategoryQuery, GetClubsByCategoryQueryVariables>;
export const GetCommentsDocument = gql`
    query getComments($postId: String, $limit: Int, $offset: Int) {
  getComments(postId: $postId, limit: $limit, offset: $offset) {
    commentId
    textV2
    media {
      type
      uri
      name
    }
    isUpvoted
    isDownvoted
    isSuspected
    upvotecount
    downvotecount
    replycount
    createdAt
    User {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export const GetDollarTagDetailsDocument = gql`
    query getDollarTagDetails($dollarTagId: Int) {
  getDollarTagDetails(dollarTagId: $dollarTagId) {
    ...DollarTagFields
    viewFeedPermission {
      canViewPost
      canSeeMarketingPost
    }
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetDollarTagDetailsQuery__
 *
 * To run a query within a React component, call `useGetDollarTagDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDollarTagDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDollarTagDetailsQuery({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useGetDollarTagDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>(GetDollarTagDetailsDocument, options);
      }
export function useGetDollarTagDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>(GetDollarTagDetailsDocument, options);
        }
export type GetDollarTagDetailsQueryHookResult = ReturnType<typeof useGetDollarTagDetailsQuery>;
export type GetDollarTagDetailsLazyQueryHookResult = ReturnType<typeof useGetDollarTagDetailsLazyQuery>;
export type GetDollarTagDetailsQueryResult = Apollo.QueryResult<GetDollarTagDetailsQuery, GetDollarTagDetailsQueryVariables>;
export const GetDollarTagForSecurityIdDocument = gql`
    query GetDollarTagForSecurityId($securityId: Int!) {
  getDollarTagForSecurityId(securityId: $securityId) {
    dollarTagId
    slug
    dollarTagType
  }
}
    `;

/**
 * __useGetDollarTagForSecurityIdQuery__
 *
 * To run a query within a React component, call `useGetDollarTagForSecurityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDollarTagForSecurityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDollarTagForSecurityIdQuery({
 *   variables: {
 *      securityId: // value for 'securityId'
 *   },
 * });
 */
export function useGetDollarTagForSecurityIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>(GetDollarTagForSecurityIdDocument, options);
      }
export function useGetDollarTagForSecurityIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>(GetDollarTagForSecurityIdDocument, options);
        }
export type GetDollarTagForSecurityIdQueryHookResult = ReturnType<typeof useGetDollarTagForSecurityIdQuery>;
export type GetDollarTagForSecurityIdLazyQueryHookResult = ReturnType<typeof useGetDollarTagForSecurityIdLazyQuery>;
export type GetDollarTagForSecurityIdQueryResult = Apollo.QueryResult<GetDollarTagForSecurityIdQuery, GetDollarTagForSecurityIdQueryVariables>;
export const GetDollartagBySearchTextDocument = gql`
    query getDollartagBySearchText($searchText: String!, $offset: Int, $limit: Int!) {
  getDollartagBySearchText(
    searchText: $searchText
    offset: $offset
    limit: $limit
  ) {
    dollarTagId
    dollarTagName
    slug
    dollarTagType
  }
}
    `;

/**
 * __useGetDollartagBySearchTextQuery__
 *
 * To run a query within a React component, call `useGetDollartagBySearchTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDollartagBySearchTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDollartagBySearchTextQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDollartagBySearchTextQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>(GetDollartagBySearchTextDocument, options);
      }
export function useGetDollartagBySearchTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>(GetDollartagBySearchTextDocument, options);
        }
export type GetDollartagBySearchTextQueryHookResult = ReturnType<typeof useGetDollartagBySearchTextQuery>;
export type GetDollartagBySearchTextLazyQueryHookResult = ReturnType<typeof useGetDollartagBySearchTextLazyQuery>;
export type GetDollartagBySearchTextQueryResult = Apollo.QueryResult<GetDollartagBySearchTextQuery, GetDollartagBySearchTextQueryVariables>;
export const GetDollartagMarketingPostsDocument = gql`
    query getDollartagMarketingPosts($dollarTagId: Int) {
  getDollartagMarketingPosts(dollarTagId: $dollarTagId) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetDollartagMarketingPostsQuery__
 *
 * To run a query within a React component, call `useGetDollartagMarketingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDollartagMarketingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDollartagMarketingPostsQuery({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *   },
 * });
 */
export function useGetDollartagMarketingPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>(GetDollartagMarketingPostsDocument, options);
      }
export function useGetDollartagMarketingPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>(GetDollartagMarketingPostsDocument, options);
        }
export type GetDollartagMarketingPostsQueryHookResult = ReturnType<typeof useGetDollartagMarketingPostsQuery>;
export type GetDollartagMarketingPostsLazyQueryHookResult = ReturnType<typeof useGetDollartagMarketingPostsLazyQuery>;
export type GetDollartagMarketingPostsQueryResult = Apollo.QueryResult<GetDollartagMarketingPostsQuery, GetDollartagMarketingPostsQueryVariables>;
export const GetEditPostHistoryDocument = gql`
    query getEditPostHistory($postId: String!) {
  getEditPostHistory(postId: $postId) {
    text
    editedAt
    media {
      type
      uri
      name
      height
      width
      rotation
    }
    tags {
      startIndex
      endIndex
      name
      type
      id
      slug
    }
  }
}
    `;

/**
 * __useGetEditPostHistoryQuery__
 *
 * To run a query within a React component, call `useGetEditPostHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEditPostHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEditPostHistoryQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetEditPostHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>(GetEditPostHistoryDocument, options);
      }
export function useGetEditPostHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>(GetEditPostHistoryDocument, options);
        }
export type GetEditPostHistoryQueryHookResult = ReturnType<typeof useGetEditPostHistoryQuery>;
export type GetEditPostHistoryLazyQueryHookResult = ReturnType<typeof useGetEditPostHistoryLazyQuery>;
export type GetEditPostHistoryQueryResult = Apollo.QueryResult<GetEditPostHistoryQuery, GetEditPostHistoryQueryVariables>;
export const GetFeatureToClubPermissionByIdDocument = gql`
    query getFeatureToClubPermissionById($clubId: String) {
  getFeatureToClubPermissionById(clubId: $clubId) {
    clubId
    permissions
    club_permissions_token
  }
}
    `;

/**
 * __useGetFeatureToClubPermissionByIdQuery__
 *
 * To run a query within a React component, call `useGetFeatureToClubPermissionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureToClubPermissionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureToClubPermissionByIdQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetFeatureToClubPermissionByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>(GetFeatureToClubPermissionByIdDocument, options);
      }
export function useGetFeatureToClubPermissionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>(GetFeatureToClubPermissionByIdDocument, options);
        }
export type GetFeatureToClubPermissionByIdQueryHookResult = ReturnType<typeof useGetFeatureToClubPermissionByIdQuery>;
export type GetFeatureToClubPermissionByIdLazyQueryHookResult = ReturnType<typeof useGetFeatureToClubPermissionByIdLazyQuery>;
export type GetFeatureToClubPermissionByIdQueryResult = Apollo.QueryResult<GetFeatureToClubPermissionByIdQuery, GetFeatureToClubPermissionByIdQueryVariables>;
export const GetFeatureToPlatformPermissionDocument = gql`
    query getFeatureToPlatformPermission {
  getFeatureToPlatformPermission
}
    `;

/**
 * __useGetFeatureToPlatformPermissionQuery__
 *
 * To run a query within a React component, call `useGetFeatureToPlatformPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureToPlatformPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureToPlatformPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureToPlatformPermissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>(GetFeatureToPlatformPermissionDocument, options);
      }
export function useGetFeatureToPlatformPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>(GetFeatureToPlatformPermissionDocument, options);
        }
export type GetFeatureToPlatformPermissionQueryHookResult = ReturnType<typeof useGetFeatureToPlatformPermissionQuery>;
export type GetFeatureToPlatformPermissionLazyQueryHookResult = ReturnType<typeof useGetFeatureToPlatformPermissionLazyQuery>;
export type GetFeatureToPlatformPermissionQueryResult = Apollo.QueryResult<GetFeatureToPlatformPermissionQuery, GetFeatureToPlatformPermissionQueryVariables>;
export const GetFeedbackTypesDocument = gql`
    query getFeedbackTypes {
  getFeedbackTypes
}
    `;

/**
 * __useGetFeedbackTypesQuery__
 *
 * To run a query within a React component, call `useGetFeedbackTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeedbackTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>(GetFeedbackTypesDocument, options);
      }
export function useGetFeedbackTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>(GetFeedbackTypesDocument, options);
        }
export type GetFeedbackTypesQueryHookResult = ReturnType<typeof useGetFeedbackTypesQuery>;
export type GetFeedbackTypesLazyQueryHookResult = ReturnType<typeof useGetFeedbackTypesLazyQuery>;
export type GetFeedbackTypesQueryResult = Apollo.QueryResult<GetFeedbackTypesQuery, GetFeedbackTypesQueryVariables>;
export const GetGuidedTourDocument = gql`
    query getGuidedTour($tourComponent: String, $tourSource: TourSourceType) {
  getGuidedTour(tourComponent: $tourComponent, tourSource: $tourSource) {
    tourId
    tourComponent
    tourKey
    tourDescription
  }
}
    `;

/**
 * __useGetGuidedTourQuery__
 *
 * To run a query within a React component, call `useGetGuidedTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuidedTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuidedTourQuery({
 *   variables: {
 *      tourComponent: // value for 'tourComponent'
 *      tourSource: // value for 'tourSource'
 *   },
 * });
 */
export function useGetGuidedTourQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetGuidedTourQuery, GetGuidedTourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetGuidedTourQuery, GetGuidedTourQueryVariables>(GetGuidedTourDocument, options);
      }
export function useGetGuidedTourLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGuidedTourQuery, GetGuidedTourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetGuidedTourQuery, GetGuidedTourQueryVariables>(GetGuidedTourDocument, options);
        }
export type GetGuidedTourQueryHookResult = ReturnType<typeof useGetGuidedTourQuery>;
export type GetGuidedTourLazyQueryHookResult = ReturnType<typeof useGetGuidedTourLazyQuery>;
export type GetGuidedTourQueryResult = Apollo.QueryResult<GetGuidedTourQuery, GetGuidedTourQueryVariables>;
export const GetHashTagDetailsDocument = gql`
    query getHashTagDetails($hashTagName: String, $hashtagId: String) {
  getHashTagDetails(hashTagName: $hashTagName, hashtagId: $hashtagId) {
    hashtag {
      hashtagName
      hashtagType
      postCount
      isfollow
      issubscribed
      followers
      viewFeedPermission {
        canViewPost
        canSeeMarketingPost
      }
    }
    discussions
    followers
  }
}
    `;

/**
 * __useGetHashTagDetailsQuery__
 *
 * To run a query within a React component, call `useGetHashTagDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashTagDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashTagDetailsQuery({
 *   variables: {
 *      hashTagName: // value for 'hashTagName'
 *      hashtagId: // value for 'hashtagId'
 *   },
 * });
 */
export function useGetHashTagDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>(GetHashTagDetailsDocument, options);
      }
export function useGetHashTagDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>(GetHashTagDetailsDocument, options);
        }
export type GetHashTagDetailsQueryHookResult = ReturnType<typeof useGetHashTagDetailsQuery>;
export type GetHashTagDetailsLazyQueryHookResult = ReturnType<typeof useGetHashTagDetailsLazyQuery>;
export type GetHashTagDetailsQueryResult = Apollo.QueryResult<GetHashTagDetailsQuery, GetHashTagDetailsQueryVariables>;
export const GetHashtagBySearchTextDocument = gql`
    query getHashtagBySearchText($data: GetHashtagBySearchTextArgs) {
  getHashtagBySearchText(data: $data) {
    Hashtag {
      hashtagName
      hashtagType
    }
  }
}
    `;

/**
 * __useGetHashtagBySearchTextQuery__
 *
 * To run a query within a React component, call `useGetHashtagBySearchTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagBySearchTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagBySearchTextQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetHashtagBySearchTextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>(GetHashtagBySearchTextDocument, options);
      }
export function useGetHashtagBySearchTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>(GetHashtagBySearchTextDocument, options);
        }
export type GetHashtagBySearchTextQueryHookResult = ReturnType<typeof useGetHashtagBySearchTextQuery>;
export type GetHashtagBySearchTextLazyQueryHookResult = ReturnType<typeof useGetHashtagBySearchTextLazyQuery>;
export type GetHashtagBySearchTextQueryResult = Apollo.QueryResult<GetHashtagBySearchTextQuery, GetHashtagBySearchTextQueryVariables>;
export const GetHashtagFollowingsDocument = gql`
    query getHashtagFollowings($userId: String!, $offset: Int!, $limit: Int!) {
  getHashtagFollowings(userId: $userId, offset: $offset, limit: $limit) {
    hashtagName
    postCount
    isfollow
    issubscribed
    followers
  }
}
    `;

/**
 * __useGetHashtagFollowingsQuery__
 *
 * To run a query within a React component, call `useGetHashtagFollowingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagFollowingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagFollowingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetHashtagFollowingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>(GetHashtagFollowingsDocument, options);
      }
export function useGetHashtagFollowingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>(GetHashtagFollowingsDocument, options);
        }
export type GetHashtagFollowingsQueryHookResult = ReturnType<typeof useGetHashtagFollowingsQuery>;
export type GetHashtagFollowingsLazyQueryHookResult = ReturnType<typeof useGetHashtagFollowingsLazyQuery>;
export type GetHashtagFollowingsQueryResult = Apollo.QueryResult<GetHashtagFollowingsQuery, GetHashtagFollowingsQueryVariables>;
export const GetHashtagMarketingPostsDocument = gql`
    query getHashtagMarketingPosts($hashTagName: String, $hashtagId: String) {
  getHashtagMarketingPosts(hashTagName: $hashTagName, hashtagId: $hashtagId) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetHashtagMarketingPostsQuery__
 *
 * To run a query within a React component, call `useGetHashtagMarketingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagMarketingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagMarketingPostsQuery({
 *   variables: {
 *      hashTagName: // value for 'hashTagName'
 *      hashtagId: // value for 'hashtagId'
 *   },
 * });
 */
export function useGetHashtagMarketingPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>(GetHashtagMarketingPostsDocument, options);
      }
export function useGetHashtagMarketingPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>(GetHashtagMarketingPostsDocument, options);
        }
export type GetHashtagMarketingPostsQueryHookResult = ReturnType<typeof useGetHashtagMarketingPostsQuery>;
export type GetHashtagMarketingPostsLazyQueryHookResult = ReturnType<typeof useGetHashtagMarketingPostsLazyQuery>;
export type GetHashtagMarketingPostsQueryResult = Apollo.QueryResult<GetHashtagMarketingPostsQuery, GetHashtagMarketingPostsQueryVariables>;
export const GetHashtagsListBasedOnTypeOfContentDocument = gql`
    query getHashtagsListBasedOnTypeOfContent($typeOfContentMadeByHashtag: UserHashtagContentType) {
  getHashtagsListBasedOnTypeOfContent(
    typeOfContentMadeByHashtag: $typeOfContentMadeByHashtag
  ) {
    hashtagName
  }
}
    `;

/**
 * __useGetHashtagsListBasedOnTypeOfContentQuery__
 *
 * To run a query within a React component, call `useGetHashtagsListBasedOnTypeOfContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHashtagsListBasedOnTypeOfContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHashtagsListBasedOnTypeOfContentQuery({
 *   variables: {
 *      typeOfContentMadeByHashtag: // value for 'typeOfContentMadeByHashtag'
 *   },
 * });
 */
export function useGetHashtagsListBasedOnTypeOfContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>(GetHashtagsListBasedOnTypeOfContentDocument, options);
      }
export function useGetHashtagsListBasedOnTypeOfContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>(GetHashtagsListBasedOnTypeOfContentDocument, options);
        }
export type GetHashtagsListBasedOnTypeOfContentQueryHookResult = ReturnType<typeof useGetHashtagsListBasedOnTypeOfContentQuery>;
export type GetHashtagsListBasedOnTypeOfContentLazyQueryHookResult = ReturnType<typeof useGetHashtagsListBasedOnTypeOfContentLazyQuery>;
export type GetHashtagsListBasedOnTypeOfContentQueryResult = Apollo.QueryResult<GetHashtagsListBasedOnTypeOfContentQuery, GetHashtagsListBasedOnTypeOfContentQueryVariables>;
export const GetImportantProfilesDocument = gql`
    query getImportantProfiles {
  getImportantProfiles {
    ...UserFields
    cover
    isfollow
    postCount
    followerCount
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetImportantProfilesQuery__
 *
 * To run a query within a React component, call `useGetImportantProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportantProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportantProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetImportantProfilesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>(GetImportantProfilesDocument, options);
      }
export function useGetImportantProfilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>(GetImportantProfilesDocument, options);
        }
export type GetImportantProfilesQueryHookResult = ReturnType<typeof useGetImportantProfilesQuery>;
export type GetImportantProfilesLazyQueryHookResult = ReturnType<typeof useGetImportantProfilesLazyQuery>;
export type GetImportantProfilesQueryResult = Apollo.QueryResult<GetImportantProfilesQuery, GetImportantProfilesQueryVariables>;
export const GetInterstitialsDocument = gql`
    query getInterstitials($platformType: platformTypeForInterstitial!) {
  getInterstitials(platformType: $platformType) {
    interstitialsId
    componentType
    position
    data
    title
  }
}
    `;

/**
 * __useGetInterstitialsQuery__
 *
 * To run a query within a React component, call `useGetInterstitialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterstitialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterstitialsQuery({
 *   variables: {
 *      platformType: // value for 'platformType'
 *   },
 * });
 */
export function useGetInterstitialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInterstitialsQuery, GetInterstitialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInterstitialsQuery, GetInterstitialsQueryVariables>(GetInterstitialsDocument, options);
      }
export function useGetInterstitialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInterstitialsQuery, GetInterstitialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInterstitialsQuery, GetInterstitialsQueryVariables>(GetInterstitialsDocument, options);
        }
export type GetInterstitialsQueryHookResult = ReturnType<typeof useGetInterstitialsQuery>;
export type GetInterstitialsLazyQueryHookResult = ReturnType<typeof useGetInterstitialsLazyQuery>;
export type GetInterstitialsQueryResult = Apollo.QueryResult<GetInterstitialsQuery, GetInterstitialsQueryVariables>;
export const GetListOfClubsWithPostPermissionDocument = gql`
    query getListOfClubsWithPostPermission {
  getListOfClubsWithPostPermission {
    clubId
    clubHandle
    clubName
    avatar
  }
}
    `;

/**
 * __useGetListOfClubsWithPostPermissionQuery__
 *
 * To run a query within a React component, call `useGetListOfClubsWithPostPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListOfClubsWithPostPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListOfClubsWithPostPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListOfClubsWithPostPermissionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>(GetListOfClubsWithPostPermissionDocument, options);
      }
export function useGetListOfClubsWithPostPermissionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>(GetListOfClubsWithPostPermissionDocument, options);
        }
export type GetListOfClubsWithPostPermissionQueryHookResult = ReturnType<typeof useGetListOfClubsWithPostPermissionQuery>;
export type GetListOfClubsWithPostPermissionLazyQueryHookResult = ReturnType<typeof useGetListOfClubsWithPostPermissionLazyQuery>;
export type GetListOfClubsWithPostPermissionQueryResult = Apollo.QueryResult<GetListOfClubsWithPostPermissionQuery, GetListOfClubsWithPostPermissionQueryVariables>;
export const GetMarketExpertsDocument = gql`
    query getMarketExperts($limit: Int, $offset: Int) {
  getMarketExperts(limit: $limit, offset: $offset) {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetMarketExpertsQuery__
 *
 * To run a query within a React component, call `useGetMarketExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketExpertsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetMarketExpertsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>(GetMarketExpertsDocument, options);
      }
export function useGetMarketExpertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>(GetMarketExpertsDocument, options);
        }
export type GetMarketExpertsQueryHookResult = ReturnType<typeof useGetMarketExpertsQuery>;
export type GetMarketExpertsLazyQueryHookResult = ReturnType<typeof useGetMarketExpertsLazyQuery>;
export type GetMarketExpertsQueryResult = Apollo.QueryResult<GetMarketExpertsQuery, GetMarketExpertsQueryVariables>;
export const GetProfileMediaDocument = gql`
    query getProfileMedia($data: UserId, $offset: Int, $limit: Int) {
  getMediaPosts(data: $data, offset: $offset, limit: $limit) {
    postId
    media {
      type
      uri
      name
    }
  }
}
    `;

/**
 * __useGetProfileMediaQuery__
 *
 * To run a query within a React component, call `useGetProfileMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileMediaQuery({
 *   variables: {
 *      data: // value for 'data'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProfileMediaQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProfileMediaQuery, GetProfileMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileMediaQuery, GetProfileMediaQueryVariables>(GetProfileMediaDocument, options);
      }
export function useGetProfileMediaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileMediaQuery, GetProfileMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileMediaQuery, GetProfileMediaQueryVariables>(GetProfileMediaDocument, options);
        }
export type GetProfileMediaQueryHookResult = ReturnType<typeof useGetProfileMediaQuery>;
export type GetProfileMediaLazyQueryHookResult = ReturnType<typeof useGetProfileMediaLazyQuery>;
export type GetProfileMediaQueryResult = Apollo.QueryResult<GetProfileMediaQuery, GetProfileMediaQueryVariables>;
export const MediaUploadUrlsDocument = gql`
    query MediaUploadURLS($data: [MediaInput]) {
  getMediaUploadURLS(data: $data) {
    key
    url
  }
}
    `;

/**
 * __useMediaUploadUrlsQuery__
 *
 * To run a query within a React component, call `useMediaUploadUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaUploadUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaUploadUrlsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useMediaUploadUrlsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MediaUploadUrlsQuery, MediaUploadUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MediaUploadUrlsQuery, MediaUploadUrlsQueryVariables>(MediaUploadUrlsDocument, options);
      }
export function useMediaUploadUrlsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MediaUploadUrlsQuery, MediaUploadUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MediaUploadUrlsQuery, MediaUploadUrlsQueryVariables>(MediaUploadUrlsDocument, options);
        }
export type MediaUploadUrlsQueryHookResult = ReturnType<typeof useMediaUploadUrlsQuery>;
export type MediaUploadUrlsLazyQueryHookResult = ReturnType<typeof useMediaUploadUrlsLazyQuery>;
export type MediaUploadUrlsQueryResult = Apollo.QueryResult<MediaUploadUrlsQuery, MediaUploadUrlsQueryVariables>;
export const GetMembersDocument = gql`
    query getMembers($clubId: String!, $offset: Int, $limit: Int) {
  getMembers(clubId: $clubId, offset: $offset, limit: $limit) {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
      }
export function useGetMembersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersQueryResult = Apollo.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const GetMultipleExternalResourceDocument = gql`
    query getMultipleExternalResource($type: [String]) {
  getMultipleExternalResource(type: $type) {
    id
    type
    value
  }
}
    `;

/**
 * __useGetMultipleExternalResourceQuery__
 *
 * To run a query within a React component, call `useGetMultipleExternalResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipleExternalResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipleExternalResourceQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetMultipleExternalResourceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>(GetMultipleExternalResourceDocument, options);
      }
export function useGetMultipleExternalResourceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>(GetMultipleExternalResourceDocument, options);
        }
export type GetMultipleExternalResourceQueryHookResult = ReturnType<typeof useGetMultipleExternalResourceQuery>;
export type GetMultipleExternalResourceLazyQueryHookResult = ReturnType<typeof useGetMultipleExternalResourceLazyQuery>;
export type GetMultipleExternalResourceQueryResult = Apollo.QueryResult<GetMultipleExternalResourceQuery, GetMultipleExternalResourceQueryVariables>;
export const GetMyFeedbacksDocument = gql`
    query getMyFeedbacks {
  getMyFeedbacks {
    feedbackId
    user {
      firstName
      lastName
      id
      username
      avatar
      cover
      isVerified
      greenTick
      tick3
    }
    type
    subject
    comment
    status
    attachment {
      type
      uri
      name
    }
  }
}
    `;

/**
 * __useGetMyFeedbacksQuery__
 *
 * To run a query within a React component, call `useGetMyFeedbacksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyFeedbacksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyFeedbacksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyFeedbacksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>(GetMyFeedbacksDocument, options);
      }
export function useGetMyFeedbacksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>(GetMyFeedbacksDocument, options);
        }
export type GetMyFeedbacksQueryHookResult = ReturnType<typeof useGetMyFeedbacksQuery>;
export type GetMyFeedbacksLazyQueryHookResult = ReturnType<typeof useGetMyFeedbacksLazyQuery>;
export type GetMyFeedbacksQueryResult = Apollo.QueryResult<GetMyFeedbacksQuery, GetMyFeedbacksQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($page: Int, $limit: Int, $offset: Int, $filter: NotificationFilter) {
  getNotifications(page: $page, limit: $limit, offset: $offset, filter: $filter) {
    notificationId
    notificationType
    createdAt
    link
    message
    read
    User {
      ...UserFields
    }
    Notifier {
      ...UserFields
    }
    Club {
      clubHandle
      clubId
      clubName
    }
    postId
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetPeopleListForSmartFeedDocument = gql`
    query getPeopleListForSmartFeed($data: String!) {
  getPeopleListForSmartFeed(data: $data) {
    ...UserFields
    isfollow
    followerCount
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetPeopleListForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetPeopleListForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeopleListForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeopleListForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPeopleListForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>(GetPeopleListForSmartFeedDocument, options);
      }
export function useGetPeopleListForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>(GetPeopleListForSmartFeedDocument, options);
        }
export type GetPeopleListForSmartFeedQueryHookResult = ReturnType<typeof useGetPeopleListForSmartFeedQuery>;
export type GetPeopleListForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetPeopleListForSmartFeedLazyQuery>;
export type GetPeopleListForSmartFeedQueryResult = Apollo.QueryResult<GetPeopleListForSmartFeedQuery, GetPeopleListForSmartFeedQueryVariables>;
export const GetPermissionToFeatureMappingListDocument = gql`
    query getPermissionToFeatureMappingList {
  getPermissionToFeatureMappingList {
    clubFeatures {
      clubId
      features
    }
    platformFeatures {
      permission
      features
    }
  }
}
    `;

/**
 * __useGetPermissionToFeatureMappingListQuery__
 *
 * To run a query within a React component, call `useGetPermissionToFeatureMappingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionToFeatureMappingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionToFeatureMappingListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPermissionToFeatureMappingListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>(GetPermissionToFeatureMappingListDocument, options);
      }
export function useGetPermissionToFeatureMappingListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>(GetPermissionToFeatureMappingListDocument, options);
        }
export type GetPermissionToFeatureMappingListQueryHookResult = ReturnType<typeof useGetPermissionToFeatureMappingListQuery>;
export type GetPermissionToFeatureMappingListLazyQueryHookResult = ReturnType<typeof useGetPermissionToFeatureMappingListLazyQuery>;
export type GetPermissionToFeatureMappingListQueryResult = Apollo.QueryResult<GetPermissionToFeatureMappingListQuery, GetPermissionToFeatureMappingListQueryVariables>;
export const GetPinnedPostDocument = gql`
    query getPinnedPost($userId: String) {
  getPinnedPost(userId: $userId) {
    ...PostFields
    isPinned
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPinnedPostQuery__
 *
 * To run a query within a React component, call `useGetPinnedPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPinnedPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPinnedPostQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetPinnedPostQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPinnedPostQuery, GetPinnedPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPinnedPostQuery, GetPinnedPostQueryVariables>(GetPinnedPostDocument, options);
      }
export function useGetPinnedPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPinnedPostQuery, GetPinnedPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPinnedPostQuery, GetPinnedPostQueryVariables>(GetPinnedPostDocument, options);
        }
export type GetPinnedPostQueryHookResult = ReturnType<typeof useGetPinnedPostQuery>;
export type GetPinnedPostLazyQueryHookResult = ReturnType<typeof useGetPinnedPostLazyQuery>;
export type GetPinnedPostQueryResult = Apollo.QueryResult<GetPinnedPostQuery, GetPinnedPostQueryVariables>;
export const GetPopUpDocument = gql`
    query getPopUp {
  getPopUp {
    data {
      popUpType
      data
      popUpDelay
    }
  }
}
    `;

/**
 * __useGetPopUpQuery__
 *
 * To run a query within a React component, call `useGetPopUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopUpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPopUpQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPopUpQuery, GetPopUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPopUpQuery, GetPopUpQueryVariables>(GetPopUpDocument, options);
      }
export function useGetPopUpLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPopUpQuery, GetPopUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPopUpQuery, GetPopUpQueryVariables>(GetPopUpDocument, options);
        }
export type GetPopUpQueryHookResult = ReturnType<typeof useGetPopUpQuery>;
export type GetPopUpLazyQueryHookResult = ReturnType<typeof useGetPopUpLazyQuery>;
export type GetPopUpQueryResult = Apollo.QueryResult<GetPopUpQuery, GetPopUpQueryVariables>;
export const GetPopularClubsInPlatformDocument = gql`
    query GetPopularClubsInPlatform {
  getPopularClubsInPlatform {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetPopularClubsInPlatformQuery__
 *
 * To run a query within a React component, call `useGetPopularClubsInPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularClubsInPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularClubsInPlatformQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPopularClubsInPlatformQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>(GetPopularClubsInPlatformDocument, options);
      }
export function useGetPopularClubsInPlatformLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>(GetPopularClubsInPlatformDocument, options);
        }
export type GetPopularClubsInPlatformQueryHookResult = ReturnType<typeof useGetPopularClubsInPlatformQuery>;
export type GetPopularClubsInPlatformLazyQueryHookResult = ReturnType<typeof useGetPopularClubsInPlatformLazyQuery>;
export type GetPopularClubsInPlatformQueryResult = Apollo.QueryResult<GetPopularClubsInPlatformQuery, GetPopularClubsInPlatformQueryVariables>;
export const GetPopularUsersDocument = gql`
    query getPopularUsers($limit: Int, $offset: Int) {
  getPopularUsers(limit: $limit, offset: $offset) {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetPopularUsersQuery__
 *
 * To run a query within a React component, call `useGetPopularUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetPopularUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPopularUsersQuery, GetPopularUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPopularUsersQuery, GetPopularUsersQueryVariables>(GetPopularUsersDocument, options);
      }
export function useGetPopularUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPopularUsersQuery, GetPopularUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPopularUsersQuery, GetPopularUsersQueryVariables>(GetPopularUsersDocument, options);
        }
export type GetPopularUsersQueryHookResult = ReturnType<typeof useGetPopularUsersQuery>;
export type GetPopularUsersLazyQueryHookResult = ReturnType<typeof useGetPopularUsersLazyQuery>;
export type GetPopularUsersQueryResult = Apollo.QueryResult<GetPopularUsersQuery, GetPopularUsersQueryVariables>;
export const GetPostByDollarTagDocument = gql`
    query getPostByDollarTag($dollarTagId: Int!, $offset: Int, $limit: Int) {
  getPostByDollarTag(dollarTagId: $dollarTagId, offset: $offset, limit: $limit) {
    ...PostFields
    topCommentId
    comments {
      ...CommentFields
      isTopComment
    }
  }
}
    ${PostFieldsFragmentDoc}
${CommentFieldsFragmentDoc}`;

/**
 * __useGetPostByDollarTagQuery__
 *
 * To run a query within a React component, call `useGetPostByDollarTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByDollarTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByDollarTagQuery({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostByDollarTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>(GetPostByDollarTagDocument, options);
      }
export function useGetPostByDollarTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>(GetPostByDollarTagDocument, options);
        }
export type GetPostByDollarTagQueryHookResult = ReturnType<typeof useGetPostByDollarTagQuery>;
export type GetPostByDollarTagLazyQueryHookResult = ReturnType<typeof useGetPostByDollarTagLazyQuery>;
export type GetPostByDollarTagQueryResult = Apollo.QueryResult<GetPostByDollarTagQuery, GetPostByDollarTagQueryVariables>;
export const GetPostByDollarTagSinceDateDocument = gql`
    query getPostByDollarTagSinceDate($dollarTagId: Int!, $since: String, $limit: Int!) {
  getPostByDollarTagSinceDate(
    dollarTagId: $dollarTagId
    since: $since
    limit: $limit
  ) {
    since
    posts {
      ...PostFields
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPostByDollarTagSinceDateQuery__
 *
 * To run a query within a React component, call `useGetPostByDollarTagSinceDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByDollarTagSinceDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByDollarTagSinceDateQuery({
 *   variables: {
 *      dollarTagId: // value for 'dollarTagId'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostByDollarTagSinceDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>(GetPostByDollarTagSinceDateDocument, options);
      }
export function useGetPostByDollarTagSinceDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>(GetPostByDollarTagSinceDateDocument, options);
        }
export type GetPostByDollarTagSinceDateQueryHookResult = ReturnType<typeof useGetPostByDollarTagSinceDateQuery>;
export type GetPostByDollarTagSinceDateLazyQueryHookResult = ReturnType<typeof useGetPostByDollarTagSinceDateLazyQuery>;
export type GetPostByDollarTagSinceDateQueryResult = Apollo.QueryResult<GetPostByDollarTagSinceDateQuery, GetPostByDollarTagSinceDateQueryVariables>;
export const GetPostByHashTagSinceDateDocument = gql`
    query getPostByHashTagSinceDate($hashTagName: String, $since: String, $limit: Int!) {
  getPostByHashTagSinceDate(
    hashTagName: $hashTagName
    since: $since
    limit: $limit
  ) {
    since
    posts {
      ...PostFields
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPostByHashTagSinceDateQuery__
 *
 * To run a query within a React component, call `useGetPostByHashTagSinceDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostByHashTagSinceDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostByHashTagSinceDateQuery({
 *   variables: {
 *      hashTagName: // value for 'hashTagName'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostByHashTagSinceDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>(GetPostByHashTagSinceDateDocument, options);
      }
export function useGetPostByHashTagSinceDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>(GetPostByHashTagSinceDateDocument, options);
        }
export type GetPostByHashTagSinceDateQueryHookResult = ReturnType<typeof useGetPostByHashTagSinceDateQuery>;
export type GetPostByHashTagSinceDateLazyQueryHookResult = ReturnType<typeof useGetPostByHashTagSinceDateLazyQuery>;
export type GetPostByHashTagSinceDateQueryResult = Apollo.QueryResult<GetPostByHashTagSinceDateQuery, GetPostByHashTagSinceDateQueryVariables>;
export const SinglePostDocument = gql`
    query SinglePost($data: PostId) {
  getPostById(data: $data) {
    ...PostFields
    comments {
      User {
        id
        firstName
        lastName
        avatar
        cover
        greenTick
      }
      replycount
      postId
      commentId
      userId
      textV2
      isSuspected
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      tags {
        startIndex
        endIndex
        name
        type
        id
        slug
      }
      createdAt
      updatedAt
      linkPreview {
        siteName
        images
        url
        description
        title
      }
      replies {
        replyId
        postId
        userId
        commentId
        textV2
        isSuspected
        User {
          id
          firstName
          lastName
          avatar
          cover
          greenTick
        }
        media {
          type
          uri
          name
          height
          width
          rotation
        }
        tags {
          startIndex
          endIndex
          name
          type
          id
          slug
        }
        createdAt
        updatedAt
        linkPreview {
          siteName
          images
          url
          description
          title
        }
      }
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useSinglePostQuery__
 *
 * To run a query within a React component, call `useSinglePostQuery` and pass it any options that fit your needs.
 * When your component renders, `useSinglePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSinglePostQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSinglePostQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SinglePostQuery, SinglePostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SinglePostQuery, SinglePostQueryVariables>(SinglePostDocument, options);
      }
export function useSinglePostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SinglePostQuery, SinglePostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SinglePostQuery, SinglePostQueryVariables>(SinglePostDocument, options);
        }
export type SinglePostQueryHookResult = ReturnType<typeof useSinglePostQuery>;
export type SinglePostLazyQueryHookResult = ReturnType<typeof useSinglePostLazyQuery>;
export type SinglePostQueryResult = Apollo.QueryResult<SinglePostQuery, SinglePostQueryVariables>;
export const GetPostDetailsByIdDocument = gql`
    query getPostDetailsById($postId: String!) {
  getPostDetailsById(postId: $postId) {
    post {
      ...PostFields
    }
    error {
      errCode
      errMessage
      errLabel
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPostDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetPostDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostDetailsByIdQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useGetPostDetailsByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>(GetPostDetailsByIdDocument, options);
      }
export function useGetPostDetailsByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>(GetPostDetailsByIdDocument, options);
        }
export type GetPostDetailsByIdQueryHookResult = ReturnType<typeof useGetPostDetailsByIdQuery>;
export type GetPostDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetPostDetailsByIdLazyQuery>;
export type GetPostDetailsByIdQueryResult = Apollo.QueryResult<GetPostDetailsByIdQuery, GetPostDetailsByIdQueryVariables>;
export const GetPostsByFiltersDocument = gql`
    query getPostsByFilters($limit: Int!, $filter: SearchPostsFilterArgs!, $clubId: String, $since: String) {
  getPostsByFilters(
    limit: $limit
    filter: $filter
    clubId: $clubId
    since: $since
  ) {
    since
    hasMore
    posts {
      ...PostFields
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPostsByFiltersQuery__
 *
 * To run a query within a React component, call `useGetPostsByFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByFiltersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      clubId: // value for 'clubId'
 *      since: // value for 'since'
 *   },
 * });
 */
export function useGetPostsByFiltersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>(GetPostsByFiltersDocument, options);
      }
export function useGetPostsByFiltersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>(GetPostsByFiltersDocument, options);
        }
export type GetPostsByFiltersQueryHookResult = ReturnType<typeof useGetPostsByFiltersQuery>;
export type GetPostsByFiltersLazyQueryHookResult = ReturnType<typeof useGetPostsByFiltersLazyQuery>;
export type GetPostsByFiltersQueryResult = Apollo.QueryResult<GetPostsByFiltersQuery, GetPostsByFiltersQueryVariables>;
export const GetPostsByHashTagV2Document = gql`
    query getPostsByHashTagV2($hashTagName: String, $offset: Int, $limit: Int) {
  getPostsByHashTagV2(hashTagName: $hashTagName, offset: $offset, limit: $limit) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetPostsByHashTagV2Query__
 *
 * To run a query within a React component, call `useGetPostsByHashTagV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByHashTagV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByHashTagV2Query({
 *   variables: {
 *      hashTagName: // value for 'hashTagName'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPostsByHashTagV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>(GetPostsByHashTagV2Document, options);
      }
export function useGetPostsByHashTagV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>(GetPostsByHashTagV2Document, options);
        }
export type GetPostsByHashTagV2QueryHookResult = ReturnType<typeof useGetPostsByHashTagV2Query>;
export type GetPostsByHashTagV2LazyQueryHookResult = ReturnType<typeof useGetPostsByHashTagV2LazyQuery>;
export type GetPostsByHashTagV2QueryResult = Apollo.QueryResult<GetPostsByHashTagV2Query, GetPostsByHashTagV2QueryVariables>;
export const GetPowerUserStreakDetailsDocument = gql`
    query getPowerUserStreakDetails {
  getPowerUserStreakDetails {
    data {
      userId
      weekData {
        isCurrentWeek
        weekDisplayName
        hasCompleted
        currentWeekDayCount
        weekNumber
        weekHeader
        weekHeaderMessage
        weekFooter
        days {
          dayName
          dayDate
          hasVisited
          visitedState
        }
      }
    }
  }
}
    `;

/**
 * __useGetPowerUserStreakDetailsQuery__
 *
 * To run a query within a React component, call `useGetPowerUserStreakDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPowerUserStreakDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPowerUserStreakDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPowerUserStreakDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>(GetPowerUserStreakDetailsDocument, options);
      }
export function useGetPowerUserStreakDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>(GetPowerUserStreakDetailsDocument, options);
        }
export type GetPowerUserStreakDetailsQueryHookResult = ReturnType<typeof useGetPowerUserStreakDetailsQuery>;
export type GetPowerUserStreakDetailsLazyQueryHookResult = ReturnType<typeof useGetPowerUserStreakDetailsLazyQuery>;
export type GetPowerUserStreakDetailsQueryResult = Apollo.QueryResult<GetPowerUserStreakDetailsQuery, GetPowerUserStreakDetailsQueryVariables>;
export const ProfileInfoDocument = gql`
    query ProfileInfo($data: UserId) {
  getProfileInfo(data: $data) {
    ...UserFields
    profileType
    isfollow
    issubscribed
    cover
    bio
    watchlistVisibleStatus
    viewFeedPermission {
      canViewPost
      canSeeMarketingPost
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useProfileInfoQuery__
 *
 * To run a query within a React component, call `useProfileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileInfoQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useProfileInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfileInfoQuery, ProfileInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileInfoQuery, ProfileInfoQueryVariables>(ProfileInfoDocument, options);
      }
export function useProfileInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileInfoQuery, ProfileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileInfoQuery, ProfileInfoQueryVariables>(ProfileInfoDocument, options);
        }
export type ProfileInfoQueryHookResult = ReturnType<typeof useProfileInfoQuery>;
export type ProfileInfoLazyQueryHookResult = ReturnType<typeof useProfileInfoLazyQuery>;
export type ProfileInfoQueryResult = Apollo.QueryResult<ProfileInfoQuery, ProfileInfoQueryVariables>;
export const GetProfileMarketingPostsDocument = gql`
    query getProfileMarketingPosts($data: UserId) {
  getProfileMarketingPosts(data: $data) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetProfileMarketingPostsQuery__
 *
 * To run a query within a React component, call `useGetProfileMarketingPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileMarketingPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileMarketingPostsQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetProfileMarketingPostsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>(GetProfileMarketingPostsDocument, options);
      }
export function useGetProfileMarketingPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>(GetProfileMarketingPostsDocument, options);
        }
export type GetProfileMarketingPostsQueryHookResult = ReturnType<typeof useGetProfileMarketingPostsQuery>;
export type GetProfileMarketingPostsLazyQueryHookResult = ReturnType<typeof useGetProfileMarketingPostsLazyQuery>;
export type GetProfileMarketingPostsQueryResult = Apollo.QueryResult<GetProfileMarketingPostsQuery, GetProfileMarketingPostsQueryVariables>;
export const GetProfilePostsSinceDateDocument = gql`
    query getProfilePostsSinceDate($data: UserId, $since: String, $limit: Int!) {
  getProfilePostsSinceDate(data: $data, since: $since, limit: $limit) {
    since
    posts {
      ...PostFields
      isPinned
    }
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetProfilePostsSinceDateQuery__
 *
 * To run a query within a React component, call `useGetProfilePostsSinceDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePostsSinceDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePostsSinceDateQuery({
 *   variables: {
 *      data: // value for 'data'
 *      since: // value for 'since'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProfilePostsSinceDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>(GetProfilePostsSinceDateDocument, options);
      }
export function useGetProfilePostsSinceDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>(GetProfilePostsSinceDateDocument, options);
        }
export type GetProfilePostsSinceDateQueryHookResult = ReturnType<typeof useGetProfilePostsSinceDateQuery>;
export type GetProfilePostsSinceDateLazyQueryHookResult = ReturnType<typeof useGetProfilePostsSinceDateLazyQuery>;
export type GetProfilePostsSinceDateQueryResult = Apollo.QueryResult<GetProfilePostsSinceDateQuery, GetProfilePostsSinceDateQueryVariables>;
export const GetProfilePostsV2Document = gql`
    query getProfilePostsV2($data: UserId, $limit: Int!, $offset: Int!) {
  getProfilePostsV2(data: $data, limit: $limit, offset: $offset) {
    ...PostFields
    isPinned
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetProfilePostsV2Query__
 *
 * To run a query within a React component, call `useGetProfilePostsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePostsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePostsV2Query({
 *   variables: {
 *      data: // value for 'data'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetProfilePostsV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>(GetProfilePostsV2Document, options);
      }
export function useGetProfilePostsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>(GetProfilePostsV2Document, options);
        }
export type GetProfilePostsV2QueryHookResult = ReturnType<typeof useGetProfilePostsV2Query>;
export type GetProfilePostsV2LazyQueryHookResult = ReturnType<typeof useGetProfilePostsV2LazyQuery>;
export type GetProfilePostsV2QueryResult = Apollo.QueryResult<GetProfilePostsV2Query, GetProfilePostsV2QueryVariables>;
export const GetPromotionForSmartFeedDocument = gql`
    query getPromotionForSmartFeed($data: String!) {
  getPromotionForSmartFeed(data: $data) {
    promotionId
    redirectURL
    shareableURL
    imageURL
  }
}
    `;

/**
 * __useGetPromotionForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetPromotionForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPromotionForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPromotionForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetPromotionForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>(GetPromotionForSmartFeedDocument, options);
      }
export function useGetPromotionForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>(GetPromotionForSmartFeedDocument, options);
        }
export type GetPromotionForSmartFeedQueryHookResult = ReturnType<typeof useGetPromotionForSmartFeedQuery>;
export type GetPromotionForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetPromotionForSmartFeedLazyQuery>;
export type GetPromotionForSmartFeedQueryResult = Apollo.QueryResult<GetPromotionForSmartFeedQuery, GetPromotionForSmartFeedQueryVariables>;
export const GetReactionsDocument = gql`
    query getReactions($postId: String, $commentId: String, $replyId: String, $voteType: Int, $limit: Int, $offset: Int) {
  getReactions(
    postId: $postId
    commentId: $commentId
    replyId: $replyId
    voteType: $voteType
    limit: $limit
    offset: $offset
  ) {
    voteId
    postId
    commentId
    replyId
    createdAt
    vote
    User {
      ...UserFields
      isfollow
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetReactionsQuery__
 *
 * To run a query within a React component, call `useGetReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReactionsQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *      voteType: // value for 'voteType'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetReactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReactionsQuery, GetReactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReactionsQuery, GetReactionsQueryVariables>(GetReactionsDocument, options);
      }
export function useGetReactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReactionsQuery, GetReactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReactionsQuery, GetReactionsQueryVariables>(GetReactionsDocument, options);
        }
export type GetReactionsQueryHookResult = ReturnType<typeof useGetReactionsQuery>;
export type GetReactionsLazyQueryHookResult = ReturnType<typeof useGetReactionsLazyQuery>;
export type GetReactionsQueryResult = Apollo.QueryResult<GetReactionsQuery, GetReactionsQueryVariables>;
export const GetRecommendedPostsDocument = gql`
    query getRecommendedPosts($limit: Int!, $offset: Int!) {
  getRecommendedPosts(limit: $limit, offset: $offset) {
    actId
    activityId
    activityType
    createdAt
    avatar
    cover
    user {
      id
      firstName
      lastName
      avatar
      cover
      username
      isVerified
      greenTick
      tick3
      profileType
    }
    followingUser {
      id
      firstName
      lastName
      username
      avatar
      cover
      isVerified
      greenTick
      tick3
      profileType
    }
    club {
      clubId
      clubHandle
      avatar
      cover
      clubName
    }
    followingHashtag {
      hashtagName
      hashtagType
    }
    followingStocktag {
      securityId
      stockName
      slug
      nseListingId
      bseListingId
    }
    post {
      ...PostFields
      comments {
        ...CommentFields
        replies {
          ...ReplyFields
        }
      }
    }
  }
}
    ${PostFieldsFragmentDoc}
${CommentFieldsFragmentDoc}
${ReplyFieldsFragmentDoc}`;

/**
 * __useGetRecommendedPostsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedPostsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetRecommendedPostsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>(GetRecommendedPostsDocument, options);
      }
export function useGetRecommendedPostsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>(GetRecommendedPostsDocument, options);
        }
export type GetRecommendedPostsQueryHookResult = ReturnType<typeof useGetRecommendedPostsQuery>;
export type GetRecommendedPostsLazyQueryHookResult = ReturnType<typeof useGetRecommendedPostsLazyQuery>;
export type GetRecommendedPostsQueryResult = Apollo.QueryResult<GetRecommendedPostsQuery, GetRecommendedPostsQueryVariables>;
export const GetReferBannerDocument = gql`
    query getReferBanner {
  getReferBanner
}
    `;

/**
 * __useGetReferBannerQuery__
 *
 * To run a query within a React component, call `useGetReferBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferBannerQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReferBannerQuery, GetReferBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReferBannerQuery, GetReferBannerQueryVariables>(GetReferBannerDocument, options);
      }
export function useGetReferBannerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReferBannerQuery, GetReferBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReferBannerQuery, GetReferBannerQueryVariables>(GetReferBannerDocument, options);
        }
export type GetReferBannerQueryHookResult = ReturnType<typeof useGetReferBannerQuery>;
export type GetReferBannerLazyQueryHookResult = ReturnType<typeof useGetReferBannerLazyQuery>;
export type GetReferBannerQueryResult = Apollo.QueryResult<GetReferBannerQuery, GetReferBannerQueryVariables>;
export const GetReferMsgDocument = gql`
    query getReferMsg {
  getReferMsg {
    url
    message
  }
}
    `;

/**
 * __useGetReferMsgQuery__
 *
 * To run a query within a React component, call `useGetReferMsgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferMsgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferMsgQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferMsgQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReferMsgQuery, GetReferMsgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReferMsgQuery, GetReferMsgQueryVariables>(GetReferMsgDocument, options);
      }
export function useGetReferMsgLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReferMsgQuery, GetReferMsgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReferMsgQuery, GetReferMsgQueryVariables>(GetReferMsgDocument, options);
        }
export type GetReferMsgQueryHookResult = ReturnType<typeof useGetReferMsgQuery>;
export type GetReferMsgLazyQueryHookResult = ReturnType<typeof useGetReferMsgLazyQuery>;
export type GetReferMsgQueryResult = Apollo.QueryResult<GetReferMsgQuery, GetReferMsgQueryVariables>;
export const GetRepliesDocument = gql`
    query getReplies($commentId: String!, $limit: Int!, $offset: Int!) {
  getReplies(commentId: $commentId, limit: $limit, offset: $offset) {
    ...ReplyFields
  }
}
    ${ReplyFieldsFragmentDoc}`;

/**
 * __useGetRepliesQuery__
 *
 * To run a query within a React component, call `useGetRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRepliesQuery({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetRepliesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRepliesQuery, GetRepliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRepliesQuery, GetRepliesQueryVariables>(GetRepliesDocument, options);
      }
export function useGetRepliesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRepliesQuery, GetRepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRepliesQuery, GetRepliesQueryVariables>(GetRepliesDocument, options);
        }
export type GetRepliesQueryHookResult = ReturnType<typeof useGetRepliesQuery>;
export type GetRepliesLazyQueryHookResult = ReturnType<typeof useGetRepliesLazyQuery>;
export type GetRepliesQueryResult = Apollo.QueryResult<GetRepliesQuery, GetRepliesQueryVariables>;
export const GetReportTypesDocument = gql`
    query getReportTypes {
  getReportTypes
}
    `;

/**
 * __useGetReportTypesQuery__
 *
 * To run a query within a React component, call `useGetReportTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetReportTypesQuery, GetReportTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReportTypesQuery, GetReportTypesQueryVariables>(GetReportTypesDocument, options);
      }
export function useGetReportTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReportTypesQuery, GetReportTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReportTypesQuery, GetReportTypesQueryVariables>(GetReportTypesDocument, options);
        }
export type GetReportTypesQueryHookResult = ReturnType<typeof useGetReportTypesQuery>;
export type GetReportTypesLazyQueryHookResult = ReturnType<typeof useGetReportTypesLazyQuery>;
export type GetReportTypesQueryResult = Apollo.QueryResult<GetReportTypesQuery, GetReportTypesQueryVariables>;
export const GetSectorBySearchTextViaDollarTagForWatchlistDocument = gql`
    query getSectorBySearchTextViaDollarTagForWatchlist($searchText: String!, $offset: Int, $limit: Int!) {
  getSectorBySearchTextViaDollarTagForWatchlist(
    searchText: $searchText
    offset: $offset
    limit: $limit
  ) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetSectorBySearchTextViaDollarTagForWatchlistQuery__
 *
 * To run a query within a React component, call `useGetSectorBySearchTextViaDollarTagForWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectorBySearchTextViaDollarTagForWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectorBySearchTextViaDollarTagForWatchlistQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSectorBySearchTextViaDollarTagForWatchlistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>(GetSectorBySearchTextViaDollarTagForWatchlistDocument, options);
      }
export function useGetSectorBySearchTextViaDollarTagForWatchlistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>(GetSectorBySearchTextViaDollarTagForWatchlistDocument, options);
        }
export type GetSectorBySearchTextViaDollarTagForWatchlistQueryHookResult = ReturnType<typeof useGetSectorBySearchTextViaDollarTagForWatchlistQuery>;
export type GetSectorBySearchTextViaDollarTagForWatchlistLazyQueryHookResult = ReturnType<typeof useGetSectorBySearchTextViaDollarTagForWatchlistLazyQuery>;
export type GetSectorBySearchTextViaDollarTagForWatchlistQueryResult = Apollo.QueryResult<GetSectorBySearchTextViaDollarTagForWatchlistQuery, GetSectorBySearchTextViaDollarTagForWatchlistQueryVariables>;
export const GetSectorListForSmartFeedDocument = gql`
    query getSectorListForSmartFeed($data: String!) {
  getSectorListForSmartFeed(data: $data) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetSectorListForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetSectorListForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectorListForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectorListForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetSectorListForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>(GetSectorListForSmartFeedDocument, options);
      }
export function useGetSectorListForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>(GetSectorListForSmartFeedDocument, options);
        }
export type GetSectorListForSmartFeedQueryHookResult = ReturnType<typeof useGetSectorListForSmartFeedQuery>;
export type GetSectorListForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetSectorListForSmartFeedLazyQuery>;
export type GetSectorListForSmartFeedQueryResult = Apollo.QueryResult<GetSectorListForSmartFeedQuery, GetSectorListForSmartFeedQueryVariables>;
export const GetSelfFeedDocument = gql`
    query GetSelfFeed($limit: Int!, $offset: Int!) {
  getSelfFeed(limit: $limit, offset: $offset) {
    actId
    activityId
    activityType
    createdAt
    avatar
    cover
    user {
      id
      firstName
      lastName
      avatar
      username
      isVerified
      greenTick
      profileType
      tick3
    }
    followingUser {
      id
      firstName
      lastName
      username
      avatar
      isVerified
      greenTick
      tick3
      profileType
    }
    club {
      clubId
      clubHandle
      avatar
      clubName
    }
    followingHashtag {
      hashtagName
      hashtagType
    }
    followingStocktag {
      securityId
      stockName
      slug
      nseListingId
      bseListingId
    }
    post {
      ...PostFields
      comments {
        ...CommentFields
        replies {
          ...ReplyFields
        }
      }
    }
  }
}
    ${PostFieldsFragmentDoc}
${CommentFieldsFragmentDoc}
${ReplyFieldsFragmentDoc}`;

/**
 * __useGetSelfFeedQuery__
 *
 * To run a query within a React component, call `useGetSelfFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelfFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelfFeedQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSelfFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSelfFeedQuery, GetSelfFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSelfFeedQuery, GetSelfFeedQueryVariables>(GetSelfFeedDocument, options);
      }
export function useGetSelfFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSelfFeedQuery, GetSelfFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSelfFeedQuery, GetSelfFeedQueryVariables>(GetSelfFeedDocument, options);
        }
export type GetSelfFeedQueryHookResult = ReturnType<typeof useGetSelfFeedQuery>;
export type GetSelfFeedLazyQueryHookResult = ReturnType<typeof useGetSelfFeedLazyQuery>;
export type GetSelfFeedQueryResult = Apollo.QueryResult<GetSelfFeedQuery, GetSelfFeedQueryVariables>;
export const GetShareFeedForPostDocument = gql`
    query getShareFeedForPost($postId: String!, $offset: Int, $limit: Int) {
  getShareFeedForPost(postId: $postId, offset: $offset, limit: $limit) {
    ...PostFields
  }
}
    ${PostFieldsFragmentDoc}`;

/**
 * __useGetShareFeedForPostQuery__
 *
 * To run a query within a React component, call `useGetShareFeedForPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareFeedForPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareFeedForPostQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetShareFeedForPostQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>(GetShareFeedForPostDocument, options);
      }
export function useGetShareFeedForPostLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>(GetShareFeedForPostDocument, options);
        }
export type GetShareFeedForPostQueryHookResult = ReturnType<typeof useGetShareFeedForPostQuery>;
export type GetShareFeedForPostLazyQueryHookResult = ReturnType<typeof useGetShareFeedForPostLazyQuery>;
export type GetShareFeedForPostQueryResult = Apollo.QueryResult<GetShareFeedForPostQuery, GetShareFeedForPostQueryVariables>;
export const GetStockListForSmartFeedDocument = gql`
    query getStockListForSmartFeed($data: String!) {
  getStockListForSmartFeed(data: $data) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetStockListForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetStockListForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockListForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockListForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetStockListForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>(GetStockListForSmartFeedDocument, options);
      }
export function useGetStockListForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>(GetStockListForSmartFeedDocument, options);
        }
export type GetStockListForSmartFeedQueryHookResult = ReturnType<typeof useGetStockListForSmartFeedQuery>;
export type GetStockListForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetStockListForSmartFeedLazyQuery>;
export type GetStockListForSmartFeedQueryResult = Apollo.QueryResult<GetStockListForSmartFeedQuery, GetStockListForSmartFeedQueryVariables>;
export const GetStockTagDetailsDocument = gql`
    query getStockTagDetails($securityId: Int) {
  getStockTagDetails(securityId: $securityId) {
    stock {
      isfollow
      issubscribed
      stockName
      securityId
    }
    discussions
    followers
  }
}
    `;

/**
 * __useGetStockTagDetailsQuery__
 *
 * To run a query within a React component, call `useGetStockTagDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStockTagDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStockTagDetailsQuery({
 *   variables: {
 *      securityId: // value for 'securityId'
 *   },
 * });
 */
export function useGetStockTagDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>(GetStockTagDetailsDocument, options);
      }
export function useGetStockTagDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>(GetStockTagDetailsDocument, options);
        }
export type GetStockTagDetailsQueryHookResult = ReturnType<typeof useGetStockTagDetailsQuery>;
export type GetStockTagDetailsLazyQueryHookResult = ReturnType<typeof useGetStockTagDetailsLazyQuery>;
export type GetStockTagDetailsQueryResult = Apollo.QueryResult<GetStockTagDetailsQuery, GetStockTagDetailsQueryVariables>;
export const GetStocksBySearchTextForWatchlistDocument = gql`
    query getStocksBySearchTextForWatchlist($searchText: String!, $offset: Int!, $limit: Int!) {
  getStocksBySearchTextForWatchlist(
    searchText: $searchText
    offset: $offset
    limit: $limit
  ) {
    securityId
    stockName
    slug
    isfollow
  }
}
    `;

/**
 * __useGetStocksBySearchTextForWatchlistQuery__
 *
 * To run a query within a React component, call `useGetStocksBySearchTextForWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStocksBySearchTextForWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStocksBySearchTextForWatchlistQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetStocksBySearchTextForWatchlistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>(GetStocksBySearchTextForWatchlistDocument, options);
      }
export function useGetStocksBySearchTextForWatchlistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>(GetStocksBySearchTextForWatchlistDocument, options);
        }
export type GetStocksBySearchTextForWatchlistQueryHookResult = ReturnType<typeof useGetStocksBySearchTextForWatchlistQuery>;
export type GetStocksBySearchTextForWatchlistLazyQueryHookResult = ReturnType<typeof useGetStocksBySearchTextForWatchlistLazyQuery>;
export type GetStocksBySearchTextForWatchlistQueryResult = Apollo.QueryResult<GetStocksBySearchTextForWatchlistQuery, GetStocksBySearchTextForWatchlistQueryVariables>;
export const GetStocksBySearchTextViaDollarTagForWatchlistDocument = gql`
    query getStocksBySearchTextViaDollarTagForWatchlist($searchText: String!, $offset: Int, $limit: Int!) {
  getStocksBySearchTextViaDollarTagForWatchlist(
    searchText: $searchText
    offset: $offset
    limit: $limit
  ) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetStocksBySearchTextViaDollarTagForWatchlistQuery__
 *
 * To run a query within a React component, call `useGetStocksBySearchTextViaDollarTagForWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStocksBySearchTextViaDollarTagForWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStocksBySearchTextViaDollarTagForWatchlistQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetStocksBySearchTextViaDollarTagForWatchlistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>(GetStocksBySearchTextViaDollarTagForWatchlistDocument, options);
      }
export function useGetStocksBySearchTextViaDollarTagForWatchlistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>(GetStocksBySearchTextViaDollarTagForWatchlistDocument, options);
        }
export type GetStocksBySearchTextViaDollarTagForWatchlistQueryHookResult = ReturnType<typeof useGetStocksBySearchTextViaDollarTagForWatchlistQuery>;
export type GetStocksBySearchTextViaDollarTagForWatchlistLazyQueryHookResult = ReturnType<typeof useGetStocksBySearchTextViaDollarTagForWatchlistLazyQuery>;
export type GetStocksBySearchTextViaDollarTagForWatchlistQueryResult = Apollo.QueryResult<GetStocksBySearchTextViaDollarTagForWatchlistQuery, GetStocksBySearchTextViaDollarTagForWatchlistQueryVariables>;
export const SuggestedPeopleDocument = gql`
    query SuggestedPeople {
  getSuggestedPeople {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useSuggestedPeopleQuery__
 *
 * To run a query within a React component, call `useSuggestedPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedPeopleQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuggestedPeopleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>(SuggestedPeopleDocument, options);
      }
export function useSuggestedPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>(SuggestedPeopleDocument, options);
        }
export type SuggestedPeopleQueryHookResult = ReturnType<typeof useSuggestedPeopleQuery>;
export type SuggestedPeopleLazyQueryHookResult = ReturnType<typeof useSuggestedPeopleLazyQuery>;
export type SuggestedPeopleQueryResult = Apollo.QueryResult<SuggestedPeopleQuery, SuggestedPeopleQueryVariables>;
export const GetTick3ExpertsDocument = gql`
    query getTick3Experts($limit: Int, $offset: Int) {
  getTick3Experts(limit: $limit, offset: $offset) {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetTick3ExpertsQuery__
 *
 * To run a query within a React component, call `useGetTick3ExpertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTick3ExpertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTick3ExpertsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetTick3ExpertsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>(GetTick3ExpertsDocument, options);
      }
export function useGetTick3ExpertsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>(GetTick3ExpertsDocument, options);
        }
export type GetTick3ExpertsQueryHookResult = ReturnType<typeof useGetTick3ExpertsQuery>;
export type GetTick3ExpertsLazyQueryHookResult = ReturnType<typeof useGetTick3ExpertsLazyQuery>;
export type GetTick3ExpertsQueryResult = Apollo.QueryResult<GetTick3ExpertsQuery, GetTick3ExpertsQueryVariables>;
export const GetTicketByIdDocument = gql`
    query getTicketById($ticketId: Int!) {
  getTicketById(ticketId: $ticketId)
}
    `;

/**
 * __useGetTicketByIdQuery__
 *
 * To run a query within a React component, call `useGetTicketByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketByIdQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGetTicketByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTicketByIdQuery, GetTicketByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTicketByIdQuery, GetTicketByIdQueryVariables>(GetTicketByIdDocument, options);
      }
export function useGetTicketByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTicketByIdQuery, GetTicketByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTicketByIdQuery, GetTicketByIdQueryVariables>(GetTicketByIdDocument, options);
        }
export type GetTicketByIdQueryHookResult = ReturnType<typeof useGetTicketByIdQuery>;
export type GetTicketByIdLazyQueryHookResult = ReturnType<typeof useGetTicketByIdLazyQuery>;
export type GetTicketByIdQueryResult = Apollo.QueryResult<GetTicketByIdQuery, GetTicketByIdQueryVariables>;
export const GetTopicListForSmartFeedDocument = gql`
    query getTopicListForSmartFeed($data: String!) {
  getTopicListForSmartFeed(data: $data) {
    ...HashTagFields
  }
}
    ${HashTagFieldsFragmentDoc}`;

/**
 * __useGetTopicListForSmartFeedQuery__
 *
 * To run a query within a React component, call `useGetTopicListForSmartFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopicListForSmartFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopicListForSmartFeedQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetTopicListForSmartFeedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>(GetTopicListForSmartFeedDocument, options);
      }
export function useGetTopicListForSmartFeedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>(GetTopicListForSmartFeedDocument, options);
        }
export type GetTopicListForSmartFeedQueryHookResult = ReturnType<typeof useGetTopicListForSmartFeedQuery>;
export type GetTopicListForSmartFeedLazyQueryHookResult = ReturnType<typeof useGetTopicListForSmartFeedLazyQuery>;
export type GetTopicListForSmartFeedQueryResult = Apollo.QueryResult<GetTopicListForSmartFeedQuery, GetTopicListForSmartFeedQueryVariables>;
export const TrendingHashDocument = gql`
    query TrendingHash($skip: Int!, $take: Int!) {
  getTrendingHashTags(skip: $skip, take: $take) {
    Hashtag {
      hashtagName
      hashtagType
      postCount
      isfollow
      issubscribed
    }
    userAvatars
    followers
  }
}
    `;

/**
 * __useTrendingHashQuery__
 *
 * To run a query within a React component, call `useTrendingHashQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendingHashQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendingHashQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useTrendingHashQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrendingHashQuery, TrendingHashQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrendingHashQuery, TrendingHashQueryVariables>(TrendingHashDocument, options);
      }
export function useTrendingHashLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrendingHashQuery, TrendingHashQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrendingHashQuery, TrendingHashQueryVariables>(TrendingHashDocument, options);
        }
export type TrendingHashQueryHookResult = ReturnType<typeof useTrendingHashQuery>;
export type TrendingHashLazyQueryHookResult = ReturnType<typeof useTrendingHashLazyQuery>;
export type TrendingHashQueryResult = Apollo.QueryResult<TrendingHashQuery, TrendingHashQueryVariables>;
export const GetTrendingHashTagsV2Document = gql`
    query getTrendingHashTagsV2($offset: Int, $limit: Int) {
  getTrendingHashTagsV2(offset: $offset, limit: $limit) {
    ...HashTagFields
  }
}
    ${HashTagFieldsFragmentDoc}`;

/**
 * __useGetTrendingHashTagsV2Query__
 *
 * To run a query within a React component, call `useGetTrendingHashTagsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingHashTagsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingHashTagsV2Query({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingHashTagsV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>(GetTrendingHashTagsV2Document, options);
      }
export function useGetTrendingHashTagsV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>(GetTrendingHashTagsV2Document, options);
        }
export type GetTrendingHashTagsV2QueryHookResult = ReturnType<typeof useGetTrendingHashTagsV2Query>;
export type GetTrendingHashTagsV2LazyQueryHookResult = ReturnType<typeof useGetTrendingHashTagsV2LazyQuery>;
export type GetTrendingHashTagsV2QueryResult = Apollo.QueryResult<GetTrendingHashTagsV2Query, GetTrendingHashTagsV2QueryVariables>;
export const GetTrendingSectorsByDollarTagDocument = gql`
    query GetTrendingSectorsByDollarTag($offset: Int!, $limit: Int!) {
  getTrendingSectorsByDollarTag(offset: $offset, limit: $limit) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetTrendingSectorsByDollarTagQuery__
 *
 * To run a query within a React component, call `useGetTrendingSectorsByDollarTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingSectorsByDollarTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingSectorsByDollarTagQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingSectorsByDollarTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>(GetTrendingSectorsByDollarTagDocument, options);
      }
export function useGetTrendingSectorsByDollarTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>(GetTrendingSectorsByDollarTagDocument, options);
        }
export type GetTrendingSectorsByDollarTagQueryHookResult = ReturnType<typeof useGetTrendingSectorsByDollarTagQuery>;
export type GetTrendingSectorsByDollarTagLazyQueryHookResult = ReturnType<typeof useGetTrendingSectorsByDollarTagLazyQuery>;
export type GetTrendingSectorsByDollarTagQueryResult = Apollo.QueryResult<GetTrendingSectorsByDollarTagQuery, GetTrendingSectorsByDollarTagQueryVariables>;
export const TrendingStocksDocument = gql`
    query TrendingStocks($skip: Int!, $take: Int!) {
  getTrendingStocks(skip: $skip, take: $take) {
    stock {
      securityId
      slug
      stockName
      postCount
      isfollow
      issubscribed
      bseListingId
      nseListingId
      slug
    }
    followers
    userAvatars
  }
}
    `;

/**
 * __useTrendingStocksQuery__
 *
 * To run a query within a React component, call `useTrendingStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendingStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendingStocksQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useTrendingStocksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TrendingStocksQuery, TrendingStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TrendingStocksQuery, TrendingStocksQueryVariables>(TrendingStocksDocument, options);
      }
export function useTrendingStocksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TrendingStocksQuery, TrendingStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TrendingStocksQuery, TrendingStocksQueryVariables>(TrendingStocksDocument, options);
        }
export type TrendingStocksQueryHookResult = ReturnType<typeof useTrendingStocksQuery>;
export type TrendingStocksLazyQueryHookResult = ReturnType<typeof useTrendingStocksLazyQuery>;
export type TrendingStocksQueryResult = Apollo.QueryResult<TrendingStocksQuery, TrendingStocksQueryVariables>;
export const GetTrendingStocksByDollarTagDocument = gql`
    query GetTrendingStocksByDollarTag($offset: Int!, $limit: Int!) {
  getTrendingStocksByDollarTag(offset: $offset, limit: $limit) {
    ...DollarTagFields
  }
}
    ${DollarTagFieldsFragmentDoc}`;

/**
 * __useGetTrendingStocksByDollarTagQuery__
 *
 * To run a query within a React component, call `useGetTrendingStocksByDollarTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingStocksByDollarTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingStocksByDollarTagQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingStocksByDollarTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>(GetTrendingStocksByDollarTagDocument, options);
      }
export function useGetTrendingStocksByDollarTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>(GetTrendingStocksByDollarTagDocument, options);
        }
export type GetTrendingStocksByDollarTagQueryHookResult = ReturnType<typeof useGetTrendingStocksByDollarTagQuery>;
export type GetTrendingStocksByDollarTagLazyQueryHookResult = ReturnType<typeof useGetTrendingStocksByDollarTagLazyQuery>;
export type GetTrendingStocksByDollarTagQueryResult = Apollo.QueryResult<GetTrendingStocksByDollarTagQuery, GetTrendingStocksByDollarTagQueryVariables>;
export const GetTrendingStocksV2Document = gql`
    query getTrendingStocksV2($offset: Int, $limit: Int) {
  getTrendingStocksV2(offset: $offset, limit: $limit) {
    ...StockFields
    postCount
    followers
  }
}
    ${StockFieldsFragmentDoc}`;

/**
 * __useGetTrendingStocksV2Query__
 *
 * To run a query within a React component, call `useGetTrendingStocksV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendingStocksV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendingStocksV2Query({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTrendingStocksV2Query(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>(GetTrendingStocksV2Document, options);
      }
export function useGetTrendingStocksV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>(GetTrendingStocksV2Document, options);
        }
export type GetTrendingStocksV2QueryHookResult = ReturnType<typeof useGetTrendingStocksV2Query>;
export type GetTrendingStocksV2LazyQueryHookResult = ReturnType<typeof useGetTrendingStocksV2LazyQuery>;
export type GetTrendingStocksV2QueryResult = Apollo.QueryResult<GetTrendingStocksV2Query, GetTrendingStocksV2QueryVariables>;
export const GetTurnOffNotificationTextDocument = gql`
    query getTurnOffNotificationText($notificationId: String) {
  getTurnOffNotificationText(notificationId: $notificationId)
}
    `;

/**
 * __useGetTurnOffNotificationTextQuery__
 *
 * To run a query within a React component, call `useGetTurnOffNotificationTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTurnOffNotificationTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTurnOffNotificationTextQuery({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useGetTurnOffNotificationTextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>(GetTurnOffNotificationTextDocument, options);
      }
export function useGetTurnOffNotificationTextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>(GetTurnOffNotificationTextDocument, options);
        }
export type GetTurnOffNotificationTextQueryHookResult = ReturnType<typeof useGetTurnOffNotificationTextQuery>;
export type GetTurnOffNotificationTextLazyQueryHookResult = ReturnType<typeof useGetTurnOffNotificationTextLazyQuery>;
export type GetTurnOffNotificationTextQueryResult = Apollo.QueryResult<GetTurnOffNotificationTextQuery, GetTurnOffNotificationTextQueryVariables>;
export const GetUniqueUsernameDocument = gql`
    query getUniqueUsername($username: String!) {
  getUniqueUsername(username: $username) {
    success
  }
}
    `;

/**
 * __useGetUniqueUsernameQuery__
 *
 * To run a query within a React component, call `useGetUniqueUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetUniqueUsernameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>(GetUniqueUsernameDocument, options);
      }
export function useGetUniqueUsernameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>(GetUniqueUsernameDocument, options);
        }
export type GetUniqueUsernameQueryHookResult = ReturnType<typeof useGetUniqueUsernameQuery>;
export type GetUniqueUsernameLazyQueryHookResult = ReturnType<typeof useGetUniqueUsernameLazyQuery>;
export type GetUniqueUsernameQueryResult = Apollo.QueryResult<GetUniqueUsernameQuery, GetUniqueUsernameQueryVariables>;
export const GetUpcomingEventsDocument = gql`
    query getUpcomingEvents($limit: Int, $offset: Int) {
  getUpcomingEvents(limit: $limit, offset: $offset) {
    eventId
    title
    imageUrl
    ctaButtonText
    ctaButtonUrl
    startTime
    endTime
    description
  }
}
    `;

/**
 * __useGetUpcomingEventsQuery__
 *
 * To run a query within a React component, call `useGetUpcomingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingEventsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetUpcomingEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>(GetUpcomingEventsDocument, options);
      }
export function useGetUpcomingEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>(GetUpcomingEventsDocument, options);
        }
export type GetUpcomingEventsQueryHookResult = ReturnType<typeof useGetUpcomingEventsQuery>;
export type GetUpcomingEventsLazyQueryHookResult = ReturnType<typeof useGetUpcomingEventsLazyQuery>;
export type GetUpcomingEventsQueryResult = Apollo.QueryResult<GetUpcomingEventsQuery, GetUpcomingEventsQueryVariables>;
export const GetUserFollowersDocument = gql`
    query getUserFollowers($userId: String!, $offset: Int!, $limit: Int!) {
  getUserFollowers(userId: $userId, offset: $offset, limit: $limit) {
    ...UserFields
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserFollowersQuery__
 *
 * To run a query within a React component, call `useGetUserFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFollowersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserFollowersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserFollowersQuery, GetUserFollowersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserFollowersQuery, GetUserFollowersQueryVariables>(GetUserFollowersDocument, options);
      }
export function useGetUserFollowersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserFollowersQuery, GetUserFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserFollowersQuery, GetUserFollowersQueryVariables>(GetUserFollowersDocument, options);
        }
export type GetUserFollowersQueryHookResult = ReturnType<typeof useGetUserFollowersQuery>;
export type GetUserFollowersLazyQueryHookResult = ReturnType<typeof useGetUserFollowersLazyQuery>;
export type GetUserFollowersQueryResult = Apollo.QueryResult<GetUserFollowersQuery, GetUserFollowersQueryVariables>;
export const GetUserFollowingsDocument = gql`
    query getUserFollowings($userId: String!, $offset: Int!, $limit: Int!) {
  getUserFollowings(userId: $userId, offset: $offset, limit: $limit) {
    ...UserFields
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserFollowingsQuery__
 *
 * To run a query within a React component, call `useGetUserFollowingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFollowingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFollowingsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserFollowingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>(GetUserFollowingsDocument, options);
      }
export function useGetUserFollowingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>(GetUserFollowingsDocument, options);
        }
export type GetUserFollowingsQueryHookResult = ReturnType<typeof useGetUserFollowingsQuery>;
export type GetUserFollowingsLazyQueryHookResult = ReturnType<typeof useGetUserFollowingsLazyQuery>;
export type GetUserFollowingsQueryResult = Apollo.QueryResult<GetUserFollowingsQuery, GetUserFollowingsQueryVariables>;
export const GetUserLevelNameFromSeDocument = gql`
    query getUserLevelNameFromSE {
  getUserLevelNameFromSE
}
    `;

/**
 * __useGetUserLevelNameFromSeQuery__
 *
 * To run a query within a React component, call `useGetUserLevelNameFromSeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserLevelNameFromSeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserLevelNameFromSeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserLevelNameFromSeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>(GetUserLevelNameFromSeDocument, options);
      }
export function useGetUserLevelNameFromSeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>(GetUserLevelNameFromSeDocument, options);
        }
export type GetUserLevelNameFromSeQueryHookResult = ReturnType<typeof useGetUserLevelNameFromSeQuery>;
export type GetUserLevelNameFromSeLazyQueryHookResult = ReturnType<typeof useGetUserLevelNameFromSeLazyQuery>;
export type GetUserLevelNameFromSeQueryResult = Apollo.QueryResult<GetUserLevelNameFromSeQuery, GetUserLevelNameFromSeQueryVariables>;
export const GetUserListDocument = gql`
    query getUserList($data: GetUserListArgs) {
  getUserList(data: $data) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserListQuery__
 *
 * To run a query within a React component, call `useGetUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserListQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetUserListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserListQuery, GetUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserListQuery, GetUserListQueryVariables>(GetUserListDocument, options);
      }
export function useGetUserListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserListQuery, GetUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserListQuery, GetUserListQueryVariables>(GetUserListDocument, options);
        }
export type GetUserListQueryHookResult = ReturnType<typeof useGetUserListQuery>;
export type GetUserListLazyQueryHookResult = ReturnType<typeof useGetUserListLazyQuery>;
export type GetUserListQueryResult = Apollo.QueryResult<GetUserListQuery, GetUserListQueryVariables>;
export const GetUserWatchlistDocument = gql`
    query getUserWatchlist($userId: String!, $type: dollarTagEnum, $offset: Int, $limit: Int) {
  getUserWatchlist(userId: $userId, type: $type, offset: $offset, limit: $limit) {
    dollarTagId
    dollarTagName
    slug
    dollarTagType
    sourceEntityId
    isfollow
  }
}
    `;

/**
 * __useGetUserWatchlistQuery__
 *
 * To run a query within a React component, call `useGetUserWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWatchlistQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetUserWatchlistQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>(GetUserWatchlistDocument, options);
      }
export function useGetUserWatchlistLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>(GetUserWatchlistDocument, options);
        }
export type GetUserWatchlistQueryHookResult = ReturnType<typeof useGetUserWatchlistQuery>;
export type GetUserWatchlistLazyQueryHookResult = ReturnType<typeof useGetUserWatchlistLazyQuery>;
export type GetUserWatchlistQueryResult = Apollo.QueryResult<GetUserWatchlistQuery, GetUserWatchlistQueryVariables>;
export const GetVerifiedUsersDocument = gql`
    query getVerifiedUsers($limit: Int, $offset: Int) {
  getVerifiedUsers(limit: $limit, offset: $offset) {
    ...UserFields
    cover
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetVerifiedUsersQuery__
 *
 * To run a query within a React component, call `useGetVerifiedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVerifiedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVerifiedUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetVerifiedUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>(GetVerifiedUsersDocument, options);
      }
export function useGetVerifiedUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>(GetVerifiedUsersDocument, options);
        }
export type GetVerifiedUsersQueryHookResult = ReturnType<typeof useGetVerifiedUsersQuery>;
export type GetVerifiedUsersLazyQueryHookResult = ReturnType<typeof useGetVerifiedUsersLazyQuery>;
export type GetVerifiedUsersQueryResult = Apollo.QueryResult<GetVerifiedUsersQuery, GetVerifiedUsersQueryVariables>;
export const GetViewOnlypermissionsFromTokenDocument = gql`
    query getViewOnlypermissionsFromToken {
  getViewOnlypermissionsFromToken {
    cpo
    cupvo
    cdovo
    ccom
    crep
    csh
    crepo
    cbopo
    cjocl
    ccrcl
    cfous
    cfost
    cfoha
    cblus
    csu
    cre
    cseop
  }
}
    `;

/**
 * __useGetViewOnlypermissionsFromTokenQuery__
 *
 * To run a query within a React component, call `useGetViewOnlypermissionsFromTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewOnlypermissionsFromTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewOnlypermissionsFromTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewOnlypermissionsFromTokenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetViewOnlypermissionsFromTokenQuery, GetViewOnlypermissionsFromTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetViewOnlypermissionsFromTokenQuery, GetViewOnlypermissionsFromTokenQueryVariables>(GetViewOnlypermissionsFromTokenDocument, options);
      }
export function useGetViewOnlypermissionsFromTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetViewOnlypermissionsFromTokenQuery, GetViewOnlypermissionsFromTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetViewOnlypermissionsFromTokenQuery, GetViewOnlypermissionsFromTokenQueryVariables>(GetViewOnlypermissionsFromTokenDocument, options);
        }
export type GetViewOnlypermissionsFromTokenQueryHookResult = ReturnType<typeof useGetViewOnlypermissionsFromTokenQuery>;
export type GetViewOnlypermissionsFromTokenLazyQueryHookResult = ReturnType<typeof useGetViewOnlypermissionsFromTokenLazyQuery>;
export type GetViewOnlypermissionsFromTokenQueryResult = Apollo.QueryResult<GetViewOnlypermissionsFromTokenQuery, GetViewOnlypermissionsFromTokenQueryVariables>;
export const GetVoterListDocument = gql`
    query GetVoterList($pollId: String!, $limit: Int, $offset: Int) {
  getVoterList(pollId: $pollId, limit: $limit, offset: $offset) {
    ...UserFields
    isfollow
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetVoterListQuery__
 *
 * To run a query within a React component, call `useGetVoterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoterListQuery({
 *   variables: {
 *      pollId: // value for 'pollId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetVoterListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetVoterListQuery, GetVoterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetVoterListQuery, GetVoterListQueryVariables>(GetVoterListDocument, options);
      }
export function useGetVoterListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetVoterListQuery, GetVoterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetVoterListQuery, GetVoterListQueryVariables>(GetVoterListDocument, options);
        }
export type GetVoterListQueryHookResult = ReturnType<typeof useGetVoterListQuery>;
export type GetVoterListLazyQueryHookResult = ReturnType<typeof useGetVoterListLazyQuery>;
export type GetVoterListQueryResult = Apollo.QueryResult<GetVoterListQuery, GetVoterListQueryVariables>;
export const GetWatchlistCountDocument = gql`
    query getWatchlistCount($userId: String!) {
  getWatchlistCount(userId: $userId)
}
    `;

/**
 * __useGetWatchlistCountQuery__
 *
 * To run a query within a React component, call `useGetWatchlistCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchlistCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchlistCountQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetWatchlistCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>(GetWatchlistCountDocument, options);
      }
export function useGetWatchlistCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>(GetWatchlistCountDocument, options);
        }
export type GetWatchlistCountQueryHookResult = ReturnType<typeof useGetWatchlistCountQuery>;
export type GetWatchlistCountLazyQueryHookResult = ReturnType<typeof useGetWatchlistCountLazyQuery>;
export type GetWatchlistCountQueryResult = Apollo.QueryResult<GetWatchlistCountQuery, GetWatchlistCountQueryVariables>;
export const GetZendeskTicketCommentsDocument = gql`
    query getZendeskTicketComments($ticketId: Int!) {
  getZendeskTicketComments(ticketId: $ticketId)
}
    `;

/**
 * __useGetZendeskTicketCommentsQuery__
 *
 * To run a query within a React component, call `useGetZendeskTicketCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZendeskTicketCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZendeskTicketCommentsQuery({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useGetZendeskTicketCommentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>(GetZendeskTicketCommentsDocument, options);
      }
export function useGetZendeskTicketCommentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>(GetZendeskTicketCommentsDocument, options);
        }
export type GetZendeskTicketCommentsQueryHookResult = ReturnType<typeof useGetZendeskTicketCommentsQuery>;
export type GetZendeskTicketCommentsLazyQueryHookResult = ReturnType<typeof useGetZendeskTicketCommentsLazyQuery>;
export type GetZendeskTicketCommentsQueryResult = Apollo.QueryResult<GetZendeskTicketCommentsQuery, GetZendeskTicketCommentsQueryVariables>;
export const GetZendeskTicketTypeListDocument = gql`
    query getZendeskTicketTypeList {
  getZendeskTicketTypeList
}
    `;

/**
 * __useGetZendeskTicketTypeListQuery__
 *
 * To run a query within a React component, call `useGetZendeskTicketTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZendeskTicketTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZendeskTicketTypeListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetZendeskTicketTypeListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>(GetZendeskTicketTypeListDocument, options);
      }
export function useGetZendeskTicketTypeListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>(GetZendeskTicketTypeListDocument, options);
        }
export type GetZendeskTicketTypeListQueryHookResult = ReturnType<typeof useGetZendeskTicketTypeListQuery>;
export type GetZendeskTicketTypeListLazyQueryHookResult = ReturnType<typeof useGetZendeskTicketTypeListLazyQuery>;
export type GetZendeskTicketTypeListQueryResult = Apollo.QueryResult<GetZendeskTicketTypeListQuery, GetZendeskTicketTypeListQueryVariables>;
export const GetZendeskTicketsByUserDocument = gql`
    query getZendeskTicketsByUser($limit: Int!, $page: Int!, $filter: ZendeskSearchfilter) {
  getZendeskTicketsByUser(limit: $limit, page: $page, filter: $filter) {
    total
    tickets
  }
}
    `;

/**
 * __useGetZendeskTicketsByUserQuery__
 *
 * To run a query within a React component, call `useGetZendeskTicketsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZendeskTicketsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZendeskTicketsByUserQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetZendeskTicketsByUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>(GetZendeskTicketsByUserDocument, options);
      }
export function useGetZendeskTicketsByUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>(GetZendeskTicketsByUserDocument, options);
        }
export type GetZendeskTicketsByUserQueryHookResult = ReturnType<typeof useGetZendeskTicketsByUserQuery>;
export type GetZendeskTicketsByUserLazyQueryHookResult = ReturnType<typeof useGetZendeskTicketsByUserLazyQuery>;
export type GetZendeskTicketsByUserQueryResult = Apollo.QueryResult<GetZendeskTicketsByUserQuery, GetZendeskTicketsByUserQueryVariables>;
export const GetPostsByHashTagDocument = gql`
    query getPostsByHashTag($hashTagName: String, $page: Int!) {
  getPostsByHashTag(hashTagName: $hashTagName, page: $page) {
    hashtag {
      hashtagName
      hashtagType
      postCount
      isfollow
      issubscribed
    }
    discussions
    followers
    post {
      commentcount
      upvotecount
      downvotecount
      sharecount
      hasPoll
      getPoll {
        ...GetPollFields
      }
      clubId
      User {
        id
        firstName
        lastName
        username
        avatar
        isVerified
        greenTick
        tick3
      }
      Club {
        clubId
        clubHandle
        clubName
      }
      postId
      userId
      stockName
      target
      stopLoss
      ideaType
      media {
        type
        uri
        name
        height
        width
        rotation
      }
      text
      tags {
        startIndex
        endIndex
        name
        type
        id
        slug
      }
      postType
      isUpvoted
      isDownvoted
      isbookmarked
      isSuspected
      createdAt
      updatedAt
      linkPreview {
        siteName
        images
        url
        description
        title
      }
      sharePostId
      userShares
      getSharedPost {
        ...GetSharedPostFields
      }
    }
  }
}
    ${GetPollFieldsFragmentDoc}
${GetSharedPostFieldsFragmentDoc}`;

/**
 * __useGetPostsByHashTagQuery__
 *
 * To run a query within a React component, call `useGetPostsByHashTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostsByHashTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostsByHashTagQuery({
 *   variables: {
 *      hashTagName: // value for 'hashTagName'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetPostsByHashTagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>(GetPostsByHashTagDocument, options);
      }
export function useGetPostsByHashTagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>(GetPostsByHashTagDocument, options);
        }
export type GetPostsByHashTagQueryHookResult = ReturnType<typeof useGetPostsByHashTagQuery>;
export type GetPostsByHashTagLazyQueryHookResult = ReturnType<typeof useGetPostsByHashTagLazyQuery>;
export type GetPostsByHashTagQueryResult = Apollo.QueryResult<GetPostsByHashTagQuery, GetPostsByHashTagQueryVariables>;
export const IsFeatureVisibleDocument = gql`
    query isFeatureVisible($featureName: String) {
  isFeatureVisible(featureName: $featureName)
}
    `;

/**
 * __useIsFeatureVisibleQuery__
 *
 * To run a query within a React component, call `useIsFeatureVisibleQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsFeatureVisibleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsFeatureVisibleQuery({
 *   variables: {
 *      featureName: // value for 'featureName'
 *   },
 * });
 */
export function useIsFeatureVisibleQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>(IsFeatureVisibleDocument, options);
      }
export function useIsFeatureVisibleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>(IsFeatureVisibleDocument, options);
        }
export type IsFeatureVisibleQueryHookResult = ReturnType<typeof useIsFeatureVisibleQuery>;
export type IsFeatureVisibleLazyQueryHookResult = ReturnType<typeof useIsFeatureVisibleLazyQuery>;
export type IsFeatureVisibleQueryResult = Apollo.QueryResult<IsFeatureVisibleQuery, IsFeatureVisibleQueryVariables>;
export const IsReportDocument = gql`
    query isReport($postId: String, $commentId: String, $replyId: String, $userId: String, $clubId: String) {
  getIsReported(
    postId: $postId
    commentId: $commentId
    replyId: $replyId
    userId: $userId
    clubId: $clubId
  )
}
    `;

/**
 * __useIsReportQuery__
 *
 * To run a query within a React component, call `useIsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsReportQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *      commentId: // value for 'commentId'
 *      replyId: // value for 'replyId'
 *      userId: // value for 'userId'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useIsReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsReportQuery, IsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsReportQuery, IsReportQueryVariables>(IsReportDocument, options);
      }
export function useIsReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsReportQuery, IsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsReportQuery, IsReportQueryVariables>(IsReportDocument, options);
        }
export type IsReportQueryHookResult = ReturnType<typeof useIsReportQuery>;
export type IsReportLazyQueryHookResult = ReturnType<typeof useIsReportLazyQuery>;
export type IsReportQueryResult = Apollo.QueryResult<IsReportQuery, IsReportQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...UserFields
    profileType
    showNpsV2
    watchlistVisibleStatus
    viewFeedPermission {
      canViewPost
      canSeeMarketingPost
    }
    highlightedAchievements {
      achievementType
      sourceOfClick
      promotionImage
      promotionText
      badges {
        badgeId
        badgeName
        badgeIcon
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const GetPeoplesDocument = gql`
    query getPeoples {
  getPopularUsers(page: 1) {
    id
    username
    firstName
    lastName
    avatar
    cover
    isfollow
    bio
    isVerified
    greenTick
    tick3
  }
}
    `;

/**
 * __useGetPeoplesQuery__
 *
 * To run a query within a React component, call `useGetPeoplesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeoplesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeoplesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPeoplesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPeoplesQuery, GetPeoplesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPeoplesQuery, GetPeoplesQueryVariables>(GetPeoplesDocument, options);
      }
export function useGetPeoplesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPeoplesQuery, GetPeoplesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPeoplesQuery, GetPeoplesQueryVariables>(GetPeoplesDocument, options);
        }
export type GetPeoplesQueryHookResult = ReturnType<typeof useGetPeoplesQuery>;
export type GetPeoplesLazyQueryHookResult = ReturnType<typeof useGetPeoplesLazyQuery>;
export type GetPeoplesQueryResult = Apollo.QueryResult<GetPeoplesQuery, GetPeoplesQueryVariables>;
export const GetPopularClubsDocument = gql`
    query getPopularClubs {
  private: getPopularClubs(clubType: Private) {
    ...ClubFields
  }
  paid: getPopularClubs(clubType: Paid) {
    ...ClubFields
  }
  public: getPopularClubs(clubType: Public) {
    ...ClubFields
  }
}
    ${ClubFieldsFragmentDoc}`;

/**
 * __useGetPopularClubsQuery__
 *
 * To run a query within a React component, call `useGetPopularClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPopularClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPopularClubsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPopularClubsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPopularClubsQuery, GetPopularClubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPopularClubsQuery, GetPopularClubsQueryVariables>(GetPopularClubsDocument, options);
      }
export function useGetPopularClubsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPopularClubsQuery, GetPopularClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPopularClubsQuery, GetPopularClubsQueryVariables>(GetPopularClubsDocument, options);
        }
export type GetPopularClubsQueryHookResult = ReturnType<typeof useGetPopularClubsQuery>;
export type GetPopularClubsLazyQueryHookResult = ReturnType<typeof useGetPopularClubsLazyQuery>;
export type GetPopularClubsQueryResult = Apollo.QueryResult<GetPopularClubsQuery, GetPopularClubsQueryVariables>;
export const PopularUsersDocument = gql`
    query PopularUsers {
  getPopularUsers(page: 1) {
    id
    firstName
    lastName
    avatar
    cover
    isfollow
    bio
    tick3
    isVerified
    greenTick
    username
  }
}
    `;

/**
 * __usePopularUsersQuery__
 *
 * To run a query within a React component, call `usePopularUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePopularUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PopularUsersQuery, PopularUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PopularUsersQuery, PopularUsersQueryVariables>(PopularUsersDocument, options);
      }
export function usePopularUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PopularUsersQuery, PopularUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PopularUsersQuery, PopularUsersQueryVariables>(PopularUsersDocument, options);
        }
export type PopularUsersQueryHookResult = ReturnType<typeof usePopularUsersQuery>;
export type PopularUsersLazyQueryHookResult = ReturnType<typeof usePopularUsersLazyQuery>;
export type PopularUsersQueryResult = Apollo.QueryResult<PopularUsersQuery, PopularUsersQueryVariables>;
export const PostMoreMenuDocument = gql`
    query PostMoreMenu($postId: String!) {
  isFollowed: isPostFollowed(postId: $postId)
  isBookmarked: getIsBookmarked(postId: $postId)
  isReported: getIsReported(postId: $postId)
}
    `;

/**
 * __usePostMoreMenuQuery__
 *
 * To run a query within a React component, call `usePostMoreMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostMoreMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostMoreMenuQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostMoreMenuQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PostMoreMenuQuery, PostMoreMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PostMoreMenuQuery, PostMoreMenuQueryVariables>(PostMoreMenuDocument, options);
      }
export function usePostMoreMenuLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PostMoreMenuQuery, PostMoreMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PostMoreMenuQuery, PostMoreMenuQueryVariables>(PostMoreMenuDocument, options);
        }
export type PostMoreMenuQueryHookResult = ReturnType<typeof usePostMoreMenuQuery>;
export type PostMoreMenuLazyQueryHookResult = ReturnType<typeof usePostMoreMenuLazyQuery>;
export type PostMoreMenuQueryResult = Apollo.QueryResult<PostMoreMenuQuery, PostMoreMenuQueryVariables>;
export const ProfileDetailsDocument = gql`
    query ProfileDetails($userId: String!) {
  profile: getProfileInfo(data: {userId: $userId}) {
    id
    username
    firstName
    lastName
    avatar
    userLevel
    profileType
    isfollow
    issubscribed
    cover
    isVerified
    greenTick
    tick3
    email
    phone
    website
    bio
    facebookLink
    twitterLink
    youtubeLink
    avatarPostId
    coverPostId
  }
  followers: getFollowersCount(data: {id: $userId, entity: User})
  followings: getFollowingsCount(data: {id: $userId, entity: User})
  clubs: getClubsOfUserCount(userId: $userId)
}
    `;

/**
 * __useProfileDetailsQuery__
 *
 * To run a query within a React component, call `useProfileDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProfileDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProfileDetailsQuery, ProfileDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileDetailsQuery, ProfileDetailsQueryVariables>(ProfileDetailsDocument, options);
      }
export function useProfileDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileDetailsQuery, ProfileDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileDetailsQuery, ProfileDetailsQueryVariables>(ProfileDetailsDocument, options);
        }
export type ProfileDetailsQueryHookResult = ReturnType<typeof useProfileDetailsQuery>;
export type ProfileDetailsLazyQueryHookResult = ReturnType<typeof useProfileDetailsLazyQuery>;
export type ProfileDetailsQueryResult = Apollo.QueryResult<ProfileDetailsQuery, ProfileDetailsQueryVariables>;
export const RepliesDocument = gql`
    query Replies($commentId: String, $skip: Int, $take: Int) {
  getCommentDetails(commentId: $commentId, skip: $skip, take: $take) {
    commentId
    isUpvoted
    isDownvoted
    User {
      firstName
      lastName
      username
      avatar
      id
      isVerified
      greenTick
      tick3
      isUserDeleted
    }
    textV2
    media {
      type
      uri
      name
    }
    upvotecount
    downvotecount
    replies {
      textV2
      media {
        type
        uri
        name
      }
      isUpvoted
      replyId
      isDownvoted
      isSuspected
      upvotecount
      downvotecount
      createdAt
      User {
        firstName
        lastName
        username
        avatar
        id
        isVerified
        greenTick
        isUserDeleted
      }
    }
  }
}
    `;

/**
 * __useRepliesQuery__
 *
 * To run a query within a React component, call `useRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRepliesQuery({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useRepliesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RepliesQuery, RepliesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RepliesQuery, RepliesQueryVariables>(RepliesDocument, options);
      }
export function useRepliesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RepliesQuery, RepliesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RepliesQuery, RepliesQueryVariables>(RepliesDocument, options);
        }
export type RepliesQueryHookResult = ReturnType<typeof useRepliesQuery>;
export type RepliesLazyQueryHookResult = ReturnType<typeof useRepliesLazyQuery>;
export type RepliesQueryResult = Apollo.QueryResult<RepliesQuery, RepliesQueryVariables>;
export const SearchStocksDocument = gql`
    query SearchStocks($search: String!, $take: Int, $skip: Int) {
  getStocksBySearchText(data: {searchText: $search, skip: $skip, take: $take}) {
    stock {
      securityId
      stockName
      slug
      postCount
      isfollow
      issubscribed
    }
  }
}
    `;

/**
 * __useSearchStocksQuery__
 *
 * To run a query within a React component, call `useSearchStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchStocksQuery({
 *   variables: {
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSearchStocksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchStocksQuery, SearchStocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchStocksQuery, SearchStocksQueryVariables>(SearchStocksDocument, options);
      }
export function useSearchStocksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchStocksQuery, SearchStocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchStocksQuery, SearchStocksQueryVariables>(SearchStocksDocument, options);
        }
export type SearchStocksQueryHookResult = ReturnType<typeof useSearchStocksQuery>;
export type SearchStocksLazyQueryHookResult = ReturnType<typeof useSearchStocksLazyQuery>;
export type SearchStocksQueryResult = Apollo.QueryResult<SearchStocksQuery, SearchStocksQueryVariables>;
export const SearchTopicDocument = gql`
    query SearchTopic($search: String!, $take: Int, $skip: Int) {
  getHashtagBySearchText(data: {searchText: $search, skip: $skip, take: $take}) {
    Hashtag {
      hashtagName
      hashtagType
      postCount
      isfollow
      issubscribed
    }
    userAvatars
    followers
  }
}
    `;

/**
 * __useSearchTopicQuery__
 *
 * To run a query within a React component, call `useSearchTopicQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTopicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTopicQuery({
 *   variables: {
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSearchTopicQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchTopicQuery, SearchTopicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchTopicQuery, SearchTopicQueryVariables>(SearchTopicDocument, options);
      }
export function useSearchTopicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTopicQuery, SearchTopicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchTopicQuery, SearchTopicQueryVariables>(SearchTopicDocument, options);
        }
export type SearchTopicQueryHookResult = ReturnType<typeof useSearchTopicQuery>;
export type SearchTopicLazyQueryHookResult = ReturnType<typeof useSearchTopicLazyQuery>;
export type SearchTopicQueryResult = Apollo.QueryResult<SearchTopicQuery, SearchTopicQueryVariables>;
export const SearchUserDocument = gql`
    query SearchUser($search: String!, $take: Int, $skip: Int) {
  getUserList(data: {searchText: $search, skip: $skip, take: $take}) {
    id
    firstName
    lastName
    username
    userTags
    avatar
    cover
    email
    phone
    bio
    isfollow
    isVerified
    greenTick
    tick3
  }
}
    `;

/**
 * __useSearchUserQuery__
 *
 * To run a query within a React component, call `useSearchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserQuery({
 *   variables: {
 *      search: // value for 'search'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSearchUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
      }
export function useSearchUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
        }
export type SearchUserQueryHookResult = ReturnType<typeof useSearchUserQuery>;
export type SearchUserLazyQueryHookResult = ReturnType<typeof useSearchUserLazyQuery>;
export type SearchUserQueryResult = Apollo.QueryResult<SearchUserQuery, SearchUserQueryVariables>;
export const ShowEventsDotDocument = gql`
    query ShowEventsDot {
  showEventsDot
}
    `;

/**
 * __useShowEventsDotQuery__
 *
 * To run a query within a React component, call `useShowEventsDotQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowEventsDotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowEventsDotQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowEventsDotQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ShowEventsDotQuery, ShowEventsDotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ShowEventsDotQuery, ShowEventsDotQueryVariables>(ShowEventsDotDocument, options);
      }
export function useShowEventsDotLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ShowEventsDotQuery, ShowEventsDotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ShowEventsDotQuery, ShowEventsDotQueryVariables>(ShowEventsDotDocument, options);
        }
export type ShowEventsDotQueryHookResult = ReturnType<typeof useShowEventsDotQuery>;
export type ShowEventsDotLazyQueryHookResult = ReturnType<typeof useShowEventsDotLazyQuery>;
export type ShowEventsDotQueryResult = Apollo.QueryResult<ShowEventsDotQuery, ShowEventsDotQueryVariables>;
export const UnifiedSearchDocument = gql`
    query UnifiedSearch($searchText: String!, $type: SearchType!, $limit: Int, $offset: Int) {
  unifiedSearch(
    searchText: $searchText
    type: $type
    limit: $limit
    offset: $offset
  ) {
    hashtag {
      hashtag {
        hashtagName
        postCount
      }
      followers
    }
    user {
      id
      username
      firstName
      lastName
      avatar
      isVerified
      greenTick
      tick3
    }
    club {
      clubId
      clubHandle
      clubName
      avatar
      clubBio
    }
    dollarTag {
      dollarTag {
        dollarTagId
        dollarTagName
        slug
        dollarTagType
      }
    }
  }
}
    `;

/**
 * __useUnifiedSearchQuery__
 *
 * To run a query within a React component, call `useUnifiedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnifiedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnifiedSearchQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      type: // value for 'type'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useUnifiedSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnifiedSearchQuery, UnifiedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnifiedSearchQuery, UnifiedSearchQueryVariables>(UnifiedSearchDocument, options);
      }
export function useUnifiedSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnifiedSearchQuery, UnifiedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnifiedSearchQuery, UnifiedSearchQueryVariables>(UnifiedSearchDocument, options);
        }
export type UnifiedSearchQueryHookResult = ReturnType<typeof useUnifiedSearchQuery>;
export type UnifiedSearchLazyQueryHookResult = ReturnType<typeof useUnifiedSearchLazyQuery>;
export type UnifiedSearchQueryResult = Apollo.QueryResult<UnifiedSearchQuery, UnifiedSearchQueryVariables>;
export const UnifiedSearchV2Document = gql`
    query unifiedSearchV2($searchText: String!, $type: SearchType!, $limit: Int, $offset: Int) {
  unifiedSearchV2(
    searchText: $searchText
    type: $type
    limit: $limit
    offset: $offset
  ) {
    hashtag {
      hashtag {
        hashtagName
        postCount
        TagId
      }
      followers
    }
    user {
      ...UserFields
    }
    club {
      clubId
      clubHandle
      clubName
      avatar
      clubBio
    }
    dollarTag {
      dollarTag {
        dollarTagId
        dollarTagName
        slug
        dollarTagType
      }
    }
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUnifiedSearchV2Query__
 *
 * To run a query within a React component, call `useUnifiedSearchV2Query` and pass it any options that fit your needs.
 * When your component renders, `useUnifiedSearchV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnifiedSearchV2Query({
 *   variables: {
 *      searchText: // value for 'searchText'
 *      type: // value for 'type'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useUnifiedSearchV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>(UnifiedSearchV2Document, options);
      }
export function useUnifiedSearchV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>(UnifiedSearchV2Document, options);
        }
export type UnifiedSearchV2QueryHookResult = ReturnType<typeof useUnifiedSearchV2Query>;
export type UnifiedSearchV2LazyQueryHookResult = ReturnType<typeof useUnifiedSearchV2LazyQuery>;
export type UnifiedSearchV2QueryResult = Apollo.QueryResult<UnifiedSearchV2Query, UnifiedSearchV2QueryVariables>;
export const NewActivityCountDocument = gql`
    subscription NewActivityCount($userId: String!) {
  newActivityCount(userId: $userId)
}
    `;

/**
 * __useNewActivityCountSubscription__
 *
 * To run a query within a React component, call `useNewActivityCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewActivityCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewActivityCountSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNewActivityCountSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<NewActivityCountSubscription, NewActivityCountSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<NewActivityCountSubscription, NewActivityCountSubscriptionVariables>(NewActivityCountDocument, options);
      }
export type NewActivityCountSubscriptionHookResult = ReturnType<typeof useNewActivityCountSubscription>;
export type NewActivityCountSubscriptionResult = Apollo.SubscriptionResult<NewActivityCountSubscription>;
export const NotificationCreatedDocument = gql`
    subscription notificationCreated($userId: String!, $type: type!) {
  notificationCreated(userId: $userId, type: $type) {
    message
    link
    notificationId
    notificationType
    createdAt
    User {
      id
      firstName
      lastName
      avatar
      username
    }
    Club {
      clubId
      clubHandle
      clubName
    }
    userId
    Notifier {
      id
      firstName
      lastName
      avatar
      username
    }
  }
}
    `;

/**
 * __useNotificationCreatedSubscription__
 *
 * To run a query within a React component, call `useNotificationCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCreatedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useNotificationCreatedSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<NotificationCreatedSubscription, NotificationCreatedSubscriptionVariables>(NotificationCreatedDocument, options);
      }
export type NotificationCreatedSubscriptionHookResult = ReturnType<typeof useNotificationCreatedSubscription>;
export type NotificationCreatedSubscriptionResult = Apollo.SubscriptionResult<NotificationCreatedSubscription>;
export const NotificationCountDocument = gql`
    subscription NotificationCount($userId: String!) {
  counts: notificationCount(userId: $userId)
}
    `;

/**
 * __useNotificationCountSubscription__
 *
 * To run a query within a React component, call `useNotificationCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCountSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNotificationCountSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<NotificationCountSubscription, NotificationCountSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<NotificationCountSubscription, NotificationCountSubscriptionVariables>(NotificationCountDocument, options);
      }
export type NotificationCountSubscriptionHookResult = ReturnType<typeof useNotificationCountSubscription>;
export type NotificationCountSubscriptionResult = Apollo.SubscriptionResult<NotificationCountSubscription>;